import { jsx as S, Fragment as ke, jsxs as ee } from "react/jsx-runtime";
import * as g from "react";
import k, { forwardRef as ni, createElement as cn, useLayoutEffect as $I, useState as Je, isValidElement as jt, Children as on, PureComponent as Ft, useRef as Xn, useImperativeHandle as DI, useCallback as Nn, useEffect as mt, useMemo as M1, cloneElement as qe, useContext as bn, createContext as Dr, Component as I1 } from "react";
import * as oi from "react-dom";
import N1 from "react-dom";
import { c as Mi, g as Ae } from "./_commonjsHelpers-DaMA6jEr.js";
function k1(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (r = k1(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function de() {
  for (var e, t, r = 0, n = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (t = k1(e)) && (n && (n += " "), n += t);
  return n;
}
const em = "-", jI = (e) => {
  const t = BI(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (i) => {
      const s = i.split(em);
      return s[0] === "" && s.length !== 1 && s.shift(), $1(s, t) || LI(i);
    },
    getConflictingClassGroupIds: (i, s) => {
      const c = r[i] || [];
      return s && n[i] ? [...c, ...n[i]] : c;
    }
  };
}, $1 = (e, t) => {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], n = t.nextPart.get(r), o = n ? $1(e.slice(1), n) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const a = e.join(em);
  return (i = t.validators.find(({
    validator: s
  }) => s(a))) == null ? void 0 : i.classGroupId;
}, Hg = /^\[(.+)\]$/, LI = (e) => {
  if (Hg.test(e)) {
    const t = Hg.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, BI = (e) => {
  const {
    theme: t,
    prefix: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return qI(Object.entries(e.classGroups), r).forEach(([a, i]) => {
    ah(i, n, a, t);
  }), n;
}, ah = (e, t, r, n) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const a = o === "" ? t : Vg(t, o);
      a.classGroupId = r;
      return;
    }
    if (typeof o == "function") {
      if (FI(o)) {
        ah(o(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: r
      });
      return;
    }
    Object.entries(o).forEach(([a, i]) => {
      ah(i, Vg(t, a), r, n);
    });
  });
}, Vg = (e, t) => {
  let r = e;
  return t.split(em).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, FI = (e) => e.isThemeGetter, qI = (e, t) => t ? e.map(([r, n]) => {
  const o = n.map((a) => typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([i, s]) => [t + i, s])) : a);
  return [r, o];
}) : e, zI = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const o = (a, i) => {
    r.set(a, i), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let i = r.get(a);
      if (i !== void 0)
        return i;
      if ((i = n.get(a)) !== void 0)
        return o(a, i), i;
    },
    set(a, i) {
      r.has(a) ? r.set(a, i) : o(a, i);
    }
  };
}, D1 = "!", WI = (e) => {
  const {
    separator: t,
    experimentalParseClassName: r
  } = e, n = t.length === 1, o = t[0], a = t.length, i = (s) => {
    const c = [];
    let l = 0, f = 0, u;
    for (let p = 0; p < s.length; p++) {
      let b = s[p];
      if (l === 0) {
        if (b === o && (n || s.slice(p, p + a) === t)) {
          c.push(s.slice(f, p)), f = p + a;
          continue;
        }
        if (b === "/") {
          u = p;
          continue;
        }
      }
      b === "[" ? l++ : b === "]" && l--;
    }
    const d = c.length === 0 ? s : s.substring(f), h = d.startsWith(D1), m = h ? d.substring(1) : d, v = u && u > f ? u - f : void 0;
    return {
      modifiers: c,
      hasImportantModifier: h,
      baseClassName: m,
      maybePostfixModifierPosition: v
    };
  };
  return r ? (s) => r({
    className: s,
    parseClassName: i
  }) : i;
}, UI = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let r = [];
  return e.forEach((n) => {
    n[0] === "[" ? (t.push(...r.sort(), n), r = []) : r.push(n);
  }), t.push(...r.sort()), t;
}, HI = (e) => ({
  cache: zI(e.cacheSize),
  parseClassName: WI(e),
  ...jI(e)
}), VI = /\s+/, KI = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: o
  } = t, a = [], i = e.trim().split(VI);
  let s = "";
  for (let c = i.length - 1; c >= 0; c -= 1) {
    const l = i[c], {
      modifiers: f,
      hasImportantModifier: u,
      baseClassName: d,
      maybePostfixModifierPosition: h
    } = r(l);
    let m = !!h, v = n(m ? d.substring(0, h) : d);
    if (!v) {
      if (!m) {
        s = l + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (v = n(d), !v) {
        s = l + (s.length > 0 ? " " + s : s);
        continue;
      }
      m = !1;
    }
    const p = UI(f).join(":"), b = u ? p + D1 : p, w = b + v;
    if (a.includes(w))
      continue;
    a.push(w);
    const x = o(v, m);
    for (let _ = 0; _ < x.length; ++_) {
      const y = x[_];
      a.push(b + y);
    }
    s = l + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function GI() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = j1(t)) && (n && (n += " "), n += r);
  return n;
}
const j1 = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = j1(e[n])) && (r && (r += " "), r += t);
  return r;
};
function YI(e, ...t) {
  let r, n, o, a = i;
  function i(c) {
    const l = t.reduce((f, u) => u(f), e());
    return r = HI(l), n = r.cache.get, o = r.cache.set, a = s, s(c);
  }
  function s(c) {
    const l = n(c);
    if (l)
      return l;
    const f = KI(c, r);
    return o(c, f), f;
  }
  return function() {
    return a(GI.apply(null, arguments));
  };
}
const Ce = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, L1 = /^\[(?:([a-z-]+):)?(.+)\]$/i, XI = /^\d+\/\d+$/, ZI = /* @__PURE__ */ new Set(["px", "full", "screen"]), JI = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, QI = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, eN = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, tN = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, rN = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, ir = (e) => zn(e) || ZI.has(e) || XI.test(e), Ar = (e) => To(e, "length", uN), zn = (e) => !!e && !Number.isNaN(Number(e)), Ll = (e) => To(e, "number", zn), Ko = (e) => !!e && Number.isInteger(Number(e)), nN = (e) => e.endsWith("%") && zn(e.slice(0, -1)), pe = (e) => L1.test(e), Pr = (e) => JI.test(e), oN = /* @__PURE__ */ new Set(["length", "size", "percentage"]), aN = (e) => To(e, oN, B1), iN = (e) => To(e, "position", B1), sN = /* @__PURE__ */ new Set(["image", "url"]), cN = (e) => To(e, sN, dN), lN = (e) => To(e, "", fN), Go = () => !0, To = (e, t, r) => {
  const n = L1.exec(e);
  return n ? n[1] ? typeof t == "string" ? n[1] === t : t.has(n[1]) : r(n[2]) : !1;
}, uN = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  QI.test(e) && !eN.test(e)
), B1 = () => !1, fN = (e) => tN.test(e), dN = (e) => rN.test(e), pN = () => {
  const e = Ce("colors"), t = Ce("spacing"), r = Ce("blur"), n = Ce("brightness"), o = Ce("borderColor"), a = Ce("borderRadius"), i = Ce("borderSpacing"), s = Ce("borderWidth"), c = Ce("contrast"), l = Ce("grayscale"), f = Ce("hueRotate"), u = Ce("invert"), d = Ce("gap"), h = Ce("gradientColorStops"), m = Ce("gradientColorStopPositions"), v = Ce("inset"), p = Ce("margin"), b = Ce("opacity"), w = Ce("padding"), x = Ce("saturate"), _ = Ce("scale"), y = Ce("sepia"), O = Ce("skew"), A = Ce("space"), P = Ce("translate"), T = () => ["auto", "contain", "none"], I = () => ["auto", "hidden", "clip", "visible", "scroll"], E = () => ["auto", pe, t], C = () => [pe, t], R = () => ["", ir, Ar], M = () => ["auto", zn, pe], D = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], $ = () => ["solid", "dashed", "dotted", "double", "none"], q = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], F = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], B = () => ["", "0", pe], L = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], z = () => [zn, pe];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Go],
      spacing: [ir, Ar],
      blur: ["none", "", Pr, pe],
      brightness: z(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Pr, pe],
      borderSpacing: C(),
      borderWidth: R(),
      contrast: z(),
      grayscale: B(),
      hueRotate: z(),
      invert: B(),
      gap: C(),
      gradientColorStops: [e],
      gradientColorStopPositions: [nN, Ar],
      inset: E(),
      margin: E(),
      opacity: z(),
      padding: C(),
      saturate: z(),
      scale: z(),
      sepia: B(),
      skew: z(),
      space: C(),
      translate: C()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", pe]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Pr]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": L()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": L()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...D(), pe]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: I()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": I()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": I()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: T()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": T()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": T()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [v]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [v]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [v]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [v]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [v]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [v]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [v]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [v]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [v]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Ko, pe]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: E()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", pe]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: B()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: B()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Ko, pe]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Go]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Ko, pe]
        }, pe]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": M()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": M()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Go]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Ko, pe]
        }, pe]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": M()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": M()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", pe]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", pe]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [d]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [d]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [d]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...F()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...F(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...F(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [w]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [w]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [w]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [w]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [w]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [w]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [w]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [w]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [w]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [p]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [p]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [p]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [p]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [p]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [p]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [p]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [p]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [p]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [A]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [A]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", pe, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [pe, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [pe, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Pr]
        }, Pr]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [pe, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [pe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [pe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [pe, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Pr, Ar]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ll]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Go]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", pe]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", zn, Ll]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", ir, pe]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", pe]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", pe]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...$(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", ir, Ar]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", ir, pe]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: C()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", pe]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", pe]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...D(), iN]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", aN]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, cN]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...$(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: $()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...$()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [ir, pe]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [ir, Ar]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: R()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [ir, Ar]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Pr, lN]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Go]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...q(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": q()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Pr, pe]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [l]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [u]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [y]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [l]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [u]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [y]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", pe]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: z()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", pe]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: z()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", pe]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [_]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [_]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [_]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Ko, pe]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [P]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [P]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [O]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [O]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", pe]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", pe]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": C()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": C()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": C()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": C()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": C()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": C()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": C()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": C()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": C()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": C()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": C()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": C()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": C()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": C()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": C()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": C()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": C()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": C()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", pe]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [ir, Ar, Ll]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, hN = /* @__PURE__ */ YI(pN);
function re(...e) {
  return hN(de(e));
}
const Kg = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Gg = de, ai = (e, t) => (r) => {
  var n;
  if ((t == null ? void 0 : t.variants) == null) return Gg(e, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
  const { variants: o, defaultVariants: a } = t, i = Object.keys(o).map((l) => {
    const f = r == null ? void 0 : r[l], u = a == null ? void 0 : a[l];
    if (f === null) return null;
    const d = Kg(f) || Kg(u);
    return o[l][d];
  }), s = r && Object.entries(r).reduce((l, f) => {
    let [u, d] = f;
    return d === void 0 || (l[u] = d), l;
  }, {}), c = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((l, f) => {
    let { class: u, className: d, ...h } = f;
    return Object.entries(h).every((m) => {
      let [v, p] = m;
      return Array.isArray(p) ? p.includes({
        ...a,
        ...s
      }[v]) : {
        ...a,
        ...s
      }[v] === p;
    }) ? [
      ...l,
      u,
      d
    ] : l;
  }, []);
  return Gg(e, i, c, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
}, vN = ai(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-1 focus:ring-primary/30 focus:ring-offset-0",
  {
    variants: {
      variant: {
        default: "border-transparent bg-slate-900 text-slate-50 hover:bg-slate-900/80 dark:bg-slate-50 dark:text-slate-900 dark:hover:bg-slate-50/80",
        secondary: "border-transparent bg-slate-100 text-slate-900 hover:bg-slate-100/80 dark:bg-slate-800 dark:text-slate-50 dark:hover:bg-slate-800/80",
        destructive: "border-transparent bg-red-500 text-slate-50 hover:bg-red-500/80 dark:bg-red-900 dark:text-slate-50 dark:hover:bg-red-900/80",
        outline: "text-slate-900 dark:text-slate-50"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function rJ({ className: e, variant: t, ...r }) {
  return /* @__PURE__ */ S("div", { className: re(vN({ variant: t }), e), ...r });
}
function Yg(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Zt(...e) {
  return (t) => {
    let r = !1;
    const n = e.map((o) => {
      const a = Yg(o, t);
      return !r && typeof a == "function" && (r = !0), a;
    });
    if (r)
      return () => {
        for (let o = 0; o < n.length; o++) {
          const a = n[o];
          typeof a == "function" ? a() : Yg(e[o], null);
        }
      };
  };
}
function le(...e) {
  return g.useCallback(Zt(...e), e);
}
var mN = Symbol.for("react.lazy"), as = g[" use ".trim().toString()];
function gN(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function F1(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === mN && "_payload" in e && gN(e._payload);
}
// @__NO_SIDE_EFFECTS__
function q1(e) {
  const t = /* @__PURE__ */ bN(e), r = g.forwardRef((n, o) => {
    let { children: a, ...i } = n;
    F1(a) && typeof as == "function" && (a = as(a._payload));
    const s = g.Children.toArray(a), c = s.find(xN);
    if (c) {
      const l = c.props.children, f = s.map((u) => u === c ? g.Children.count(l) > 1 ? g.Children.only(null) : g.isValidElement(l) ? l.props.children : null : u);
      return /* @__PURE__ */ S(t, { ...i, ref: o, children: g.isValidElement(l) ? g.cloneElement(l, void 0, f) : null });
    }
    return /* @__PURE__ */ S(t, { ...i, ref: o, children: a });
  });
  return r.displayName = `${e}.Slot`, r;
}
var yN = /* @__PURE__ */ q1("Slot");
// @__NO_SIDE_EFFECTS__
function bN(e) {
  const t = g.forwardRef((r, n) => {
    let { children: o, ...a } = r;
    if (F1(o) && typeof as == "function" && (o = as(o._payload)), g.isValidElement(o)) {
      const i = _N(o), s = SN(a, o.props);
      return o.type !== g.Fragment && (s.ref = n ? Zt(n, i) : i), g.cloneElement(o, s);
    }
    return g.Children.count(o) > 1 ? g.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var wN = Symbol("radix.slottable");
function xN(e) {
  return g.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === wN;
}
function SN(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], a = t[n];
    /^on[A-Z]/.test(n) ? o && a ? r[n] = (...s) => {
      const c = a(...s);
      return o(...s), c;
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...a } : n === "className" && (r[n] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function _N(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
const tm = ai(
  // 基础样式（总是应用）
  "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary/30 focus-visible:ring-offset-0 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-slate-900 text-slate-50 hover:bg-slate-900/90 dark:bg-slate-50 dark:text-slate-900 dark:hover:bg-slate-50/90",
        destructive: "bg-red-500 text-slate-50 hover:bg-red-500/90 dark:bg-red-900 dark:text-slate-50 dark:hover:bg-red-900/90",
        outline: "border border-slate-200 bg-white hover:bg-slate-100 hover:text-slate-900 dark:border-slate-800 dark:bg-slate-950 dark:hover:bg-slate-800 dark:hover:text-slate-50",
        secondary: "bg-slate-100 text-slate-900 hover:bg-slate-100/80 dark:bg-slate-800 dark:text-slate-50 dark:hover:bg-slate-800/80",
        ghost: "hover:bg-slate-100 hover:text-slate-900 dark:hover:bg-slate-800 dark:hover:text-slate-50",
        link: "text-slate-900 underline-offset-4 hover:underline dark:text-slate-50"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Dt = g.forwardRef(
  ({ className: e, variant: t, size: r, asChild: n = !1, ...o }, a) => /* @__PURE__ */ S(
    n ? yN : "button",
    {
      className: re(tm({ variant: t, size: r, className: e })),
      ref: a,
      ...o
    }
  )
);
Dt.displayName = "BaseButton";
const ON = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  "div",
  {
    ref: r,
    className: re(
      "rounded-lg border border-slate-200 bg-white text-slate-950 shadow-sm dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50",
      e
    ),
    ...t
  }
));
ON.displayName = "Card";
const AN = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  "div",
  {
    ref: r,
    className: re("flex flex-col space-y-1.5 p-6", e),
    ...t
  }
));
AN.displayName = "CardHeader";
const PN = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  "h3",
  {
    ref: r,
    className: re(
      "text-2xl font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
PN.displayName = "CardTitle";
const EN = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  "p",
  {
    ref: r,
    className: re("text-sm text-slate-500 dark:text-slate-400", e),
    ...t
  }
));
EN.displayName = "CardDescription";
const TN = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S("div", { ref: r, className: re("p-6 pt-0", e), ...t }));
TN.displayName = "CardContent";
const CN = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  "div",
  {
    ref: r,
    className: re("flex items-center p-6 pt-0", e),
    ...t
  }
));
CN.displayName = "CardFooter";
function RN(e, t) {
  const r = g.createContext(t), n = (a) => {
    const { children: i, ...s } = a, c = g.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ S(r.Provider, { value: c, children: i });
  };
  n.displayName = e + "Provider";
  function o(a) {
    const i = g.useContext(r);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [n, o];
}
function at(e, t = []) {
  let r = [];
  function n(a, i) {
    const s = g.createContext(i), c = r.length;
    r = [...r, i];
    const l = (u) => {
      var b;
      const { scope: d, children: h, ...m } = u, v = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || s, p = g.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ S(v.Provider, { value: p, children: h });
    };
    l.displayName = a + "Provider";
    function f(u, d) {
      var v;
      const h = ((v = d == null ? void 0 : d[e]) == null ? void 0 : v[c]) || s, m = g.useContext(h);
      if (m) return m;
      if (i !== void 0) return i;
      throw new Error(`\`${u}\` must be used within \`${a}\``);
    }
    return [l, f];
  }
  const o = () => {
    const a = r.map((i) => g.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return g.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [n, MN(o, ...t)];
}
function MN(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = n.reduce((s, { useScope: c, scopeName: l }) => {
        const u = c(a)[`__scope${l}`];
        return { ...s, ...u };
      }, {});
      return g.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
function Z(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), r === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
var Ue = globalThis != null && globalThis.document ? g.useLayoutEffect : () => {
}, IN = g[" useInsertionEffect ".trim().toString()] || Ue;
function Pt({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  },
  caller: n
}) {
  const [o, a, i] = NN({
    defaultProp: t,
    onChange: r
  }), s = e !== void 0, c = s ? e : o;
  {
    const f = g.useRef(e !== void 0);
    g.useEffect(() => {
      const u = f.current;
      u !== s && console.warn(
        `${n} is changing from ${u ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), f.current = s;
    }, [s, n]);
  }
  const l = g.useCallback(
    (f) => {
      var u;
      if (s) {
        const d = kN(f) ? f(e) : f;
        d !== e && ((u = i.current) == null || u.call(i, d));
      } else
        a(f);
    },
    [s, e, a, i]
  );
  return [c, l];
}
function NN({
  defaultProp: e,
  onChange: t
}) {
  const [r, n] = g.useState(e), o = g.useRef(r), a = g.useRef(t);
  return IN(() => {
    a.current = t;
  }, [t]), g.useEffect(() => {
    var i;
    o.current !== r && ((i = a.current) == null || i.call(a, r), o.current = r);
  }, [r, o]), [r, n, a];
}
function kN(e) {
  return typeof e == "function";
}
function rm(e) {
  const t = g.useRef({ value: e, previous: e });
  return g.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function nm(e) {
  const [t, r] = g.useState(void 0);
  return Ue(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const n = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let i, s;
        if ("borderBoxSize" in a) {
          const c = a.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          i = l.inlineSize, s = l.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        r({ width: i, height: s });
      });
      return n.observe(e, { box: "border-box" }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [e]), t;
}
function $N(e, t) {
  return g.useReducer((r, n) => t[r][n] ?? r, e);
}
var Ge = (e) => {
  const { present: t, children: r } = e, n = DN(t), o = typeof r == "function" ? r({ present: n.isPresent }) : g.Children.only(r), a = le(n.ref, jN(o));
  return typeof r == "function" || n.isPresent ? g.cloneElement(o, { ref: a }) : null;
};
Ge.displayName = "Presence";
function DN(e) {
  const [t, r] = g.useState(), n = g.useRef(null), o = g.useRef(e), a = g.useRef("none"), i = e ? "mounted" : "unmounted", [s, c] = $N(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return g.useEffect(() => {
    const l = Ii(n.current);
    a.current = s === "mounted" ? l : "none";
  }, [s]), Ue(() => {
    const l = n.current, f = o.current;
    if (f !== e) {
      const d = a.current, h = Ii(l);
      e ? c("MOUNT") : h === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(f && d !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, c]), Ue(() => {
    if (t) {
      let l;
      const f = t.ownerDocument.defaultView ?? window, u = (h) => {
        const v = Ii(n.current).includes(CSS.escape(h.animationName));
        if (h.target === t && v && (c("ANIMATION_END"), !o.current)) {
          const p = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = p);
          });
        }
      }, d = (h) => {
        h.target === t && (a.current = Ii(n.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        f.clearTimeout(l), t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: g.useCallback((l) => {
      n.current = l ? getComputedStyle(l) : null, r(l);
    }, [])
  };
}
function Ii(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function jN(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
// @__NO_SIDE_EFFECTS__
function ln(e) {
  const t = /* @__PURE__ */ LN(e), r = g.forwardRef((n, o) => {
    const { children: a, ...i } = n, s = g.Children.toArray(a), c = s.find(BN);
    if (c) {
      const l = c.props.children, f = s.map((u) => u === c ? g.Children.count(l) > 1 ? g.Children.only(null) : g.isValidElement(l) ? l.props.children : null : u);
      return /* @__PURE__ */ S(t, { ...i, ref: o, children: g.isValidElement(l) ? g.cloneElement(l, void 0, f) : null });
    }
    return /* @__PURE__ */ S(t, { ...i, ref: o, children: a });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function LN(e) {
  const t = g.forwardRef((r, n) => {
    const { children: o, ...a } = r;
    if (g.isValidElement(o)) {
      const i = qN(o), s = FN(a, o.props);
      return o.type !== g.Fragment && (s.ref = n ? Zt(n, i) : i), g.cloneElement(o, s);
    }
    return g.Children.count(o) > 1 ? g.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var z1 = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function W1(e) {
  const t = ({ children: r }) => /* @__PURE__ */ S(ke, { children: r });
  return t.displayName = `${e}.Slottable`, t.__radixId = z1, t;
}
function BN(e) {
  return g.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === z1;
}
function FN(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], a = t[n];
    /^on[A-Z]/.test(n) ? o && a ? r[n] = (...s) => {
      const c = a(...s);
      return o(...s), c;
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...a } : n === "className" && (r[n] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function qN(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var zN = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], ae = zN.reduce((e, t) => {
  const r = /* @__PURE__ */ ln(`Primitive.${t}`), n = g.forwardRef((o, a) => {
    const { asChild: i, ...s } = o, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ S(c, { ...s, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function om(e, t) {
  e && oi.flushSync(() => e.dispatchEvent(t));
}
var gc = "Checkbox", [WN] = at(gc), [UN, am] = WN(gc);
function HN(e) {
  const {
    __scopeCheckbox: t,
    checked: r,
    children: n,
    defaultChecked: o,
    disabled: a,
    form: i,
    name: s,
    onCheckedChange: c,
    required: l,
    value: f = "on",
    // @ts-expect-error
    internal_do_not_use_render: u
  } = e, [d, h] = Pt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: c,
    caller: gc
  }), [m, v] = g.useState(null), [p, b] = g.useState(null), w = g.useRef(!1), x = m ? !!i || !!m.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), _ = {
    checked: d,
    disabled: a,
    setChecked: h,
    control: m,
    setControl: v,
    name: s,
    form: i,
    value: f,
    hasConsumerStoppedPropagationRef: w,
    required: l,
    defaultChecked: Mr(o) ? !1 : o,
    isFormControl: x,
    bubbleInput: p,
    setBubbleInput: b
  };
  return /* @__PURE__ */ S(
    UN,
    {
      scope: t,
      ..._,
      children: VN(u) ? u(_) : n
    }
  );
}
var U1 = "CheckboxTrigger", H1 = g.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: r, ...n }, o) => {
    const {
      control: a,
      value: i,
      disabled: s,
      checked: c,
      required: l,
      setControl: f,
      setChecked: u,
      hasConsumerStoppedPropagationRef: d,
      isFormControl: h,
      bubbleInput: m
    } = am(U1, e), v = le(o, f), p = g.useRef(c);
    return g.useEffect(() => {
      const b = a == null ? void 0 : a.form;
      if (b) {
        const w = () => u(p.current);
        return b.addEventListener("reset", w), () => b.removeEventListener("reset", w);
      }
    }, [a, u]), /* @__PURE__ */ S(
      ae.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": Mr(c) ? "mixed" : c,
        "aria-required": l,
        "data-state": X1(c),
        "data-disabled": s ? "" : void 0,
        disabled: s,
        value: i,
        ...n,
        ref: v,
        onKeyDown: Z(t, (b) => {
          b.key === "Enter" && b.preventDefault();
        }),
        onClick: Z(r, (b) => {
          u((w) => Mr(w) ? !0 : !w), m && h && (d.current = b.isPropagationStopped(), d.current || b.stopPropagation());
        })
      }
    );
  }
);
H1.displayName = U1;
var im = g.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: r,
      name: n,
      checked: o,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: c,
      onCheckedChange: l,
      form: f,
      ...u
    } = e;
    return /* @__PURE__ */ S(
      HN,
      {
        __scopeCheckbox: r,
        checked: o,
        defaultChecked: a,
        disabled: s,
        required: i,
        onCheckedChange: l,
        name: n,
        form: f,
        value: c,
        internal_do_not_use_render: ({ isFormControl: d }) => /* @__PURE__ */ ee(ke, { children: [
          /* @__PURE__ */ S(
            H1,
            {
              ...u,
              ref: t,
              __scopeCheckbox: r
            }
          ),
          d && /* @__PURE__ */ S(
            Y1,
            {
              __scopeCheckbox: r
            }
          )
        ] })
      }
    );
  }
);
im.displayName = gc;
var V1 = "CheckboxIndicator", K1 = g.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: r, forceMount: n, ...o } = e, a = am(V1, r);
    return /* @__PURE__ */ S(
      Ge,
      {
        present: n || Mr(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ S(
          ae.span,
          {
            "data-state": X1(a.checked),
            "data-disabled": a.disabled ? "" : void 0,
            ...o,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
K1.displayName = V1;
var G1 = "CheckboxBubbleInput", Y1 = g.forwardRef(
  ({ __scopeCheckbox: e, ...t }, r) => {
    const {
      control: n,
      hasConsumerStoppedPropagationRef: o,
      checked: a,
      defaultChecked: i,
      required: s,
      disabled: c,
      name: l,
      value: f,
      form: u,
      bubbleInput: d,
      setBubbleInput: h
    } = am(G1, e), m = le(r, h), v = rm(a), p = nm(n);
    g.useEffect(() => {
      const w = d;
      if (!w) return;
      const x = window.HTMLInputElement.prototype, y = Object.getOwnPropertyDescriptor(
        x,
        "checked"
      ).set, O = !o.current;
      if (v !== a && y) {
        const A = new Event("click", { bubbles: O });
        w.indeterminate = Mr(a), y.call(w, Mr(a) ? !1 : a), w.dispatchEvent(A);
      }
    }, [d, v, a, o]);
    const b = g.useRef(Mr(a) ? !1 : a);
    return /* @__PURE__ */ S(
      ae.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: i ?? b.current,
        required: s,
        disabled: c,
        name: l,
        value: f,
        form: u,
        ...t,
        tabIndex: -1,
        ref: m,
        style: {
          ...t.style,
          ...p,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
Y1.displayName = G1;
function VN(e) {
  return typeof e == "function";
}
function Mr(e) {
  return e === "indeterminate";
}
function X1(e) {
  return Mr(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KN = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Z1 = (...e) => e.filter((t, r, n) => !!t && t.trim() !== "" && n.indexOf(t) === r).join(" ").trim();
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var GN = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YN = ni(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: n,
    className: o = "",
    children: a,
    iconNode: i,
    ...s
  }, c) => cn(
    "svg",
    {
      ref: c,
      ...GN,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: n ? Number(r) * 24 / Number(t) : r,
      className: Z1("lucide", o),
      ...s
    },
    [
      ...i.map(([l, f]) => cn(l, f)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ye = (e, t) => {
  const r = ni(
    ({ className: n, ...o }, a) => cn(YN, {
      ref: a,
      iconNode: t,
      className: Z1(`lucide-${KN(e)}`, n),
      ...o
    })
  );
  return r.displayName = `${e}`, r;
};
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XN = Ye("Bot", [
  ["path", { d: "M12 8V4H8", key: "hb8ula" }],
  ["rect", { width: "16", height: "12", x: "4", y: "8", rx: "2", key: "enze0r" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M15 13v2", key: "1xurst" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yc = Ye("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J1 = Ye("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZN = Ye("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JN = Ye("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QN = Ye("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ek = Ye("GripVertical", [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sm = Ye("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tk = Ye("LogOut", [
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }],
  ["polyline", { points: "16 17 21 12 16 7", key: "1gabdz" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xg = Ye("MessageSquare", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rk = Ye("Mic", [
  ["path", { d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z", key: "131961" }],
  ["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2", key: "1vc78b" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nk = Ye("SendHorizontal", [
  [
    "path",
    {
      d: "M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z",
      key: "117uat"
    }
  ],
  ["path", { d: "M6 12h16", key: "s4cdu5" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q1 = Ye("Sparkles", [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }],
  ["path", { d: "M4 17v2", key: "vumght" }],
  ["path", { d: "M5 18H3", key: "zchphs" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ok = Ye("Square", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eO = Ye("User", [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zg = Ye("Workflow", [
  ["rect", { width: "8", height: "8", x: "3", y: "3", rx: "2", key: "by2w9f" }],
  ["path", { d: "M7 11v4a2 2 0 0 0 2 2h4", key: "xkn7yn" }],
  ["rect", { width: "8", height: "8", x: "13", y: "13", rx: "2", key: "1cgmvn" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Co = Ye("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ak = Ye("Zap", [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
]), ik = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  im,
  {
    ref: r,
    className: re(
      "peer h-4 w-4 shrink-0 rounded-sm border border-slate-900 ring-offset-white focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary/30 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-slate-900 data-[state=checked]:text-slate-50 dark:border-slate-50 dark:ring-offset-slate-950 dark:data-[state=checked]:bg-slate-50 dark:data-[state=checked]:text-slate-900",
      e
    ),
    ...t,
    children: /* @__PURE__ */ S(
      K1,
      {
        className: re("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ S(yc, { className: "h-4 w-4" })
      }
    )
  }
));
ik.displayName = im.displayName;
const sk = g.forwardRef(
  ({ className: e, type: t, ...r }, n) => /* @__PURE__ */ S(
    "input",
    {
      type: t,
      className: re(
        "flex h-10 w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary/30 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-800 dark:bg-slate-950 dark:ring-offset-slate-950 dark:placeholder:text-slate-400",
        e
      ),
      ref: n,
      ...r
    }
  )
);
sk.displayName = "Input";
var ck = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], qt = ck.reduce((e, t) => {
  const r = /* @__PURE__ */ q1(`Primitive.${t}`), n = g.forwardRef((o, a) => {
    const { asChild: i, ...s } = o, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ S(c, { ...s, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), lk = "Label", tO = g.forwardRef((e, t) => /* @__PURE__ */ S(
  qt.label,
  {
    ...e,
    ref: t,
    onMouseDown: (r) => {
      var o;
      r.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, r), !r.defaultPrevented && r.detail > 1 && r.preventDefault());
    }
  }
));
tO.displayName = lk;
var rO = tO;
const uk = ai(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), fk = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  rO,
  {
    ref: r,
    className: re(uk(), e),
    ...t
  }
));
fk.displayName = rO.displayName;
var dk = "Separator", Jg = "horizontal", pk = ["horizontal", "vertical"], nO = g.forwardRef((e, t) => {
  const { decorative: r, orientation: n = Jg, ...o } = e, a = hk(n) ? n : Jg, s = r ? { role: "none" } : { "aria-orientation": a === "vertical" ? a : void 0, role: "separator" };
  return /* @__PURE__ */ S(
    qt.div,
    {
      "data-orientation": a,
      ...s,
      ...o,
      ref: t
    }
  );
});
nO.displayName = dk;
function hk(e) {
  return pk.includes(e);
}
var oO = nO;
const vk = g.forwardRef(({ className: e, orientation: t = "horizontal", decorative: r = !0, ...n }, o) => /* @__PURE__ */ S(
  oO,
  {
    ref: o,
    decorative: r,
    orientation: t,
    className: re(
      "shrink-0 bg-slate-200 dark:bg-slate-800",
      t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
      e
    ),
    ...n
  }
));
vk.displayName = oO.displayName;
function ga(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
var mk = g.createContext(void 0);
function Ro(e) {
  const t = g.useContext(mk);
  return e || t || "ltr";
}
function ii(e) {
  const t = e + "CollectionProvider", [r, n] = at(t), [o, a] = r(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (v) => {
    const { scope: p, children: b } = v, w = k.useRef(null), x = k.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ S(o, { scope: p, itemMap: x, collectionRef: w, children: b });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", c = /* @__PURE__ */ ln(s), l = k.forwardRef(
    (v, p) => {
      const { scope: b, children: w } = v, x = a(s, b), _ = le(p, x.collectionRef);
      return /* @__PURE__ */ S(c, { ref: _, children: w });
    }
  );
  l.displayName = s;
  const f = e + "CollectionItemSlot", u = "data-radix-collection-item", d = /* @__PURE__ */ ln(f), h = k.forwardRef(
    (v, p) => {
      const { scope: b, children: w, ...x } = v, _ = k.useRef(null), y = le(p, _), O = a(f, b);
      return k.useEffect(() => (O.itemMap.set(_, { ref: _, ...x }), () => void O.itemMap.delete(_))), /* @__PURE__ */ S(d, { [u]: "", ref: y, children: w });
    }
  );
  h.displayName = f;
  function m(v) {
    const p = a(e + "CollectionConsumer", v);
    return k.useCallback(() => {
      const w = p.collectionRef.current;
      if (!w) return [];
      const x = Array.from(w.querySelectorAll(`[${u}]`));
      return Array.from(p.itemMap.values()).sort(
        (O, A) => x.indexOf(O.ref.current) - x.indexOf(A.ref.current)
      );
    }, [p.collectionRef, p.itemMap]);
  }
  return [
    { Provider: i, Slot: l, ItemSlot: h },
    m,
    n
  ];
}
var aO = ["PageUp", "PageDown"], iO = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], sO = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, Mo = "Slider", [ih, gk, yk] = ii(Mo), [cO] = at(Mo, [
  yk
]), [bk, bc] = cO(Mo), lO = g.forwardRef(
  (e, t) => {
    const {
      name: r,
      min: n = 0,
      max: o = 100,
      step: a = 1,
      orientation: i = "horizontal",
      disabled: s = !1,
      minStepsBetweenThumbs: c = 0,
      defaultValue: l = [n],
      value: f,
      onValueChange: u = () => {
      },
      onValueCommit: d = () => {
      },
      inverted: h = !1,
      form: m,
      ...v
    } = e, p = g.useRef(/* @__PURE__ */ new Set()), b = g.useRef(0), x = i === "horizontal" ? wk : xk, [_ = [], y] = Pt({
      prop: f,
      defaultProp: l,
      onChange: (E) => {
        var R;
        (R = [...p.current][b.current]) == null || R.focus(), u(E);
      }
    }), O = g.useRef(_);
    function A(E) {
      const C = Pk(_, E);
      I(E, C);
    }
    function P(E) {
      I(E, b.current);
    }
    function T() {
      const E = O.current[b.current];
      _[b.current] !== E && d(_);
    }
    function I(E, C, { commit: R } = { commit: !1 }) {
      const M = Rk(a), D = Mk(Math.round((E - n) / a) * a + n, M), $ = ga(D, [n, o]);
      y((q = []) => {
        const F = Ok(q, $, C);
        if (Ck(F, c * a)) {
          b.current = F.indexOf($);
          const B = String(F) !== String(q);
          return B && R && d(F), B ? F : q;
        } else
          return q;
      });
    }
    return /* @__PURE__ */ S(
      bk,
      {
        scope: e.__scopeSlider,
        name: r,
        disabled: s,
        min: n,
        max: o,
        valueIndexToChangeRef: b,
        thumbs: p.current,
        values: _,
        orientation: i,
        form: m,
        children: /* @__PURE__ */ S(ih.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ S(ih.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ S(
          x,
          {
            "aria-disabled": s,
            "data-disabled": s ? "" : void 0,
            ...v,
            ref: t,
            onPointerDown: Z(v.onPointerDown, () => {
              s || (O.current = _);
            }),
            min: n,
            max: o,
            inverted: h,
            onSlideStart: s ? void 0 : A,
            onSlideMove: s ? void 0 : P,
            onSlideEnd: s ? void 0 : T,
            onHomeKeyDown: () => !s && I(n, 0, { commit: !0 }),
            onEndKeyDown: () => !s && I(o, _.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: E, direction: C }) => {
              if (!s) {
                const D = aO.includes(E.key) || E.shiftKey && iO.includes(E.key) ? 10 : 1, $ = b.current, q = _[$], F = a * D * C;
                I(q + F, $, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
lO.displayName = Mo;
var [uO, fO] = cO(Mo, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), wk = g.forwardRef(
  (e, t) => {
    const {
      min: r,
      max: n,
      dir: o,
      inverted: a,
      onSlideStart: i,
      onSlideMove: s,
      onSlideEnd: c,
      onStepKeyDown: l,
      ...f
    } = e, [u, d] = g.useState(null), h = le(t, (x) => d(x)), m = g.useRef(void 0), v = Ro(o), p = v === "ltr", b = p && !a || !p && a;
    function w(x) {
      const _ = m.current || u.getBoundingClientRect(), y = [0, _.width], A = cm(y, b ? [r, n] : [n, r]);
      return m.current = _, A(x - _.left);
    }
    return /* @__PURE__ */ S(
      uO,
      {
        scope: e.__scopeSlider,
        startEdge: b ? "left" : "right",
        endEdge: b ? "right" : "left",
        direction: b ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ S(
          dO,
          {
            dir: v,
            "data-orientation": "horizontal",
            ...f,
            ref: h,
            style: {
              ...f.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (x) => {
              const _ = w(x.clientX);
              i == null || i(_);
            },
            onSlideMove: (x) => {
              const _ = w(x.clientX);
              s == null || s(_);
            },
            onSlideEnd: () => {
              m.current = void 0, c == null || c();
            },
            onStepKeyDown: (x) => {
              const y = sO[b ? "from-left" : "from-right"].includes(x.key);
              l == null || l({ event: x, direction: y ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), xk = g.forwardRef(
  (e, t) => {
    const {
      min: r,
      max: n,
      inverted: o,
      onSlideStart: a,
      onSlideMove: i,
      onSlideEnd: s,
      onStepKeyDown: c,
      ...l
    } = e, f = g.useRef(null), u = le(t, f), d = g.useRef(void 0), h = !o;
    function m(v) {
      const p = d.current || f.current.getBoundingClientRect(), b = [0, p.height], x = cm(b, h ? [n, r] : [r, n]);
      return d.current = p, x(v - p.top);
    }
    return /* @__PURE__ */ S(
      uO,
      {
        scope: e.__scopeSlider,
        startEdge: h ? "bottom" : "top",
        endEdge: h ? "top" : "bottom",
        size: "height",
        direction: h ? 1 : -1,
        children: /* @__PURE__ */ S(
          dO,
          {
            "data-orientation": "vertical",
            ...l,
            ref: u,
            style: {
              ...l.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (v) => {
              const p = m(v.clientY);
              a == null || a(p);
            },
            onSlideMove: (v) => {
              const p = m(v.clientY);
              i == null || i(p);
            },
            onSlideEnd: () => {
              d.current = void 0, s == null || s();
            },
            onStepKeyDown: (v) => {
              const b = sO[h ? "from-bottom" : "from-top"].includes(v.key);
              c == null || c({ event: v, direction: b ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), dO = g.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: r,
      onSlideStart: n,
      onSlideMove: o,
      onSlideEnd: a,
      onHomeKeyDown: i,
      onEndKeyDown: s,
      onStepKeyDown: c,
      ...l
    } = e, f = bc(Mo, r);
    return /* @__PURE__ */ S(
      ae.span,
      {
        ...l,
        ref: t,
        onKeyDown: Z(e.onKeyDown, (u) => {
          u.key === "Home" ? (i(u), u.preventDefault()) : u.key === "End" ? (s(u), u.preventDefault()) : aO.concat(iO).includes(u.key) && (c(u), u.preventDefault());
        }),
        onPointerDown: Z(e.onPointerDown, (u) => {
          const d = u.target;
          d.setPointerCapture(u.pointerId), u.preventDefault(), f.thumbs.has(d) ? d.focus() : n(u);
        }),
        onPointerMove: Z(e.onPointerMove, (u) => {
          u.target.hasPointerCapture(u.pointerId) && o(u);
        }),
        onPointerUp: Z(e.onPointerUp, (u) => {
          const d = u.target;
          d.hasPointerCapture(u.pointerId) && (d.releasePointerCapture(u.pointerId), a(u));
        })
      }
    );
  }
), pO = "SliderTrack", hO = g.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, ...n } = e, o = bc(pO, r);
    return /* @__PURE__ */ S(
      ae.span,
      {
        "data-disabled": o.disabled ? "" : void 0,
        "data-orientation": o.orientation,
        ...n,
        ref: t
      }
    );
  }
);
hO.displayName = pO;
var sh = "SliderRange", vO = g.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, ...n } = e, o = bc(sh, r), a = fO(sh, r), i = g.useRef(null), s = le(t, i), c = o.values.length, l = o.values.map(
      (d) => yO(d, o.min, o.max)
    ), f = c > 1 ? Math.min(...l) : 0, u = 100 - Math.max(...l);
    return /* @__PURE__ */ S(
      ae.span,
      {
        "data-orientation": o.orientation,
        "data-disabled": o.disabled ? "" : void 0,
        ...n,
        ref: s,
        style: {
          ...e.style,
          [a.startEdge]: f + "%",
          [a.endEdge]: u + "%"
        }
      }
    );
  }
);
vO.displayName = sh;
var ch = "SliderThumb", mO = g.forwardRef(
  (e, t) => {
    const r = gk(e.__scopeSlider), [n, o] = g.useState(null), a = le(t, (s) => o(s)), i = g.useMemo(
      () => n ? r().findIndex((s) => s.ref.current === n) : -1,
      [r, n]
    );
    return /* @__PURE__ */ S(Sk, { ...e, ref: a, index: i });
  }
), Sk = g.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, index: n, name: o, ...a } = e, i = bc(ch, r), s = fO(ch, r), [c, l] = g.useState(null), f = le(t, (w) => l(w)), u = c ? i.form || !!c.closest("form") : !0, d = nm(c), h = i.values[n], m = h === void 0 ? 0 : yO(h, i.min, i.max), v = Ak(n, i.values.length), p = d == null ? void 0 : d[s.size], b = p ? Ek(p, m, s.direction) : 0;
    return g.useEffect(() => {
      if (c)
        return i.thumbs.add(c), () => {
          i.thumbs.delete(c);
        };
    }, [c, i.thumbs]), /* @__PURE__ */ ee(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [s.startEdge]: `calc(${m}% + ${b}px)`
        },
        children: [
          /* @__PURE__ */ S(ih.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ S(
            ae.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || v,
              "aria-valuemin": i.min,
              "aria-valuenow": h,
              "aria-valuemax": i.max,
              "aria-orientation": i.orientation,
              "data-orientation": i.orientation,
              "data-disabled": i.disabled ? "" : void 0,
              tabIndex: i.disabled ? void 0 : 0,
              ...a,
              ref: f,
              style: h === void 0 ? { display: "none" } : e.style,
              onFocus: Z(e.onFocus, () => {
                i.valueIndexToChangeRef.current = n;
              })
            }
          ) }),
          u && /* @__PURE__ */ S(
            gO,
            {
              name: o ?? (i.name ? i.name + (i.values.length > 1 ? "[]" : "") : void 0),
              form: i.form,
              value: h
            },
            n
          )
        ]
      }
    );
  }
);
mO.displayName = ch;
var _k = "RadioBubbleInput", gO = g.forwardRef(
  ({ __scopeSlider: e, value: t, ...r }, n) => {
    const o = g.useRef(null), a = le(o, n), i = rm(t);
    return g.useEffect(() => {
      const s = o.current;
      if (!s) return;
      const c = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(c, "value").set;
      if (i !== t && f) {
        const u = new Event("input", { bubbles: !0 });
        f.call(s, t), s.dispatchEvent(u);
      }
    }, [i, t]), /* @__PURE__ */ S(
      ae.input,
      {
        style: { display: "none" },
        ...r,
        ref: a,
        defaultValue: t
      }
    );
  }
);
gO.displayName = _k;
function Ok(e = [], t, r) {
  const n = [...e];
  return n[r] = t, n.sort((o, a) => o - a);
}
function yO(e, t, r) {
  const a = 100 / (r - t) * (e - t);
  return ga(a, [0, 100]);
}
function Ak(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function Pk(e, t) {
  if (e.length === 1) return 0;
  const r = e.map((o) => Math.abs(o - t)), n = Math.min(...r);
  return r.indexOf(n);
}
function Ek(e, t, r) {
  const n = e / 2, a = cm([0, 50], [0, n]);
  return (n - a(t) * r) * r;
}
function Tk(e) {
  return e.slice(0, -1).map((t, r) => e[r + 1] - t);
}
function Ck(e, t) {
  if (t > 0) {
    const r = Tk(e);
    return Math.min(...r) >= t;
  }
  return !0;
}
function cm(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const n = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + n * (r - e[0]);
  };
}
function Rk(e) {
  return (String(e).split(".")[1] || "").length;
}
function Mk(e, t) {
  const r = Math.pow(10, t);
  return Math.round(e * r) / r;
}
var bO = lO, Ik = hO, Nk = vO, kk = mO;
const $k = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ ee(
  bO,
  {
    ref: r,
    className: re(
      "relative flex w-full touch-none select-none items-center",
      e
    ),
    ...t,
    children: [
      /* @__PURE__ */ S(Ik, { className: "relative h-2 w-full grow overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800", children: /* @__PURE__ */ S(Nk, { className: "absolute h-full bg-slate-900 dark:bg-slate-50" }) }),
      /* @__PURE__ */ S(kk, { className: "block h-5 w-5 rounded-full border-2 border-slate-900 bg-white ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary/30 focus-visible:ring-offset-0 disabled:pointer-events-none disabled:opacity-50 dark:border-slate-50 dark:bg-slate-950 dark:ring-offset-slate-950" })
    ]
  }
));
$k.displayName = bO.displayName;
const wO = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  "textarea",
  {
    className: re(
      "flex min-h-[80px] w-full rounded-md border border-border bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
      e
    ),
    ref: r,
    ...t
  }
));
wO.displayName = "Textarea";
function $e(e) {
  const t = g.useRef(e);
  return g.useEffect(() => {
    t.current = e;
  }), g.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
function Dk(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = $e(e);
  g.useEffect(() => {
    const n = (o) => {
      o.key === "Escape" && r(o);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [r, t]);
}
var jk = "DismissableLayer", lh = "dismissableLayer.update", Lk = "dismissableLayer.pointerDownOutside", Bk = "dismissableLayer.focusOutside", Qg, xO = g.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), wn = g.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...c
    } = e, l = g.useContext(xO), [f, u] = g.useState(null), d = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = g.useState({}), m = le(t, (A) => u(A)), v = Array.from(l.layers), [p] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), b = v.indexOf(p), w = f ? v.indexOf(f) : -1, x = l.layersWithOutsidePointerEventsDisabled.size > 0, _ = w >= b, y = qk((A) => {
      const P = A.target, T = [...l.branches].some((I) => I.contains(P));
      !_ || T || (o == null || o(A), i == null || i(A), A.defaultPrevented || s == null || s());
    }, d), O = zk((A) => {
      const P = A.target;
      [...l.branches].some((I) => I.contains(P)) || (a == null || a(A), i == null || i(A), A.defaultPrevented || s == null || s());
    }, d);
    return Dk((A) => {
      w === l.layers.size - 1 && (n == null || n(A), !A.defaultPrevented && s && (A.preventDefault(), s()));
    }, d), g.useEffect(() => {
      if (f)
        return r && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Qg = d.body.style.pointerEvents, d.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(f)), l.layers.add(f), ey(), () => {
          r && l.layersWithOutsidePointerEventsDisabled.size === 1 && (d.body.style.pointerEvents = Qg);
        };
    }, [f, d, r, l]), g.useEffect(() => () => {
      f && (l.layers.delete(f), l.layersWithOutsidePointerEventsDisabled.delete(f), ey());
    }, [f, l]), g.useEffect(() => {
      const A = () => h({});
      return document.addEventListener(lh, A), () => document.removeEventListener(lh, A);
    }, []), /* @__PURE__ */ S(
      ae.div,
      {
        ...c,
        ref: m,
        style: {
          pointerEvents: x ? _ ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Z(e.onFocusCapture, O.onFocusCapture),
        onBlurCapture: Z(e.onBlurCapture, O.onBlurCapture),
        onPointerDownCapture: Z(
          e.onPointerDownCapture,
          y.onPointerDownCapture
        )
      }
    );
  }
);
wn.displayName = jk;
var Fk = "DismissableLayerBranch", SO = g.forwardRef((e, t) => {
  const r = g.useContext(xO), n = g.useRef(null), o = le(t, n);
  return g.useEffect(() => {
    const a = n.current;
    if (a)
      return r.branches.add(a), () => {
        r.branches.delete(a);
      };
  }, [r.branches]), /* @__PURE__ */ S(ae.div, { ...e, ref: o });
});
SO.displayName = Fk;
function qk(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = $e(e), n = g.useRef(!1), o = g.useRef(() => {
  });
  return g.useEffect(() => {
    const a = (s) => {
      if (s.target && !n.current) {
        let c = function() {
          _O(
            Lk,
            r,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = c, t.addEventListener("click", o.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", o.current);
      n.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function zk(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = $e(e), n = g.useRef(!1);
  return g.useEffect(() => {
    const o = (a) => {
      a.target && !n.current && _O(Bk, r, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function ey() {
  const e = new CustomEvent(lh);
  document.dispatchEvent(e);
}
function _O(e, t, r, { discrete: n }) {
  const o = r.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && o.addEventListener(e, t, { once: !0 }), n ? om(o, a) : o.dispatchEvent(a);
}
var Wk = wn, Uk = SO, Hk = g[" useId ".trim().toString()] || (() => {
}), Vk = 0;
function je(e) {
  const [t, r] = g.useState(Hk());
  return Ue(() => {
    r((n) => n ?? String(Vk++));
  }, [e]), t ? `radix-${t}` : "";
}
const Kk = ["top", "right", "bottom", "left"], Nr = Math.min, pt = Math.max, is = Math.round, Ni = Math.floor, Gt = (e) => ({
  x: e,
  y: e
}), Gk = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Yk = {
  start: "end",
  end: "start"
};
function uh(e, t, r) {
  return pt(e, Nr(t, r));
}
function mr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function gr(e) {
  return e.split("-")[0];
}
function Io(e) {
  return e.split("-")[1];
}
function lm(e) {
  return e === "x" ? "y" : "x";
}
function um(e) {
  return e === "y" ? "height" : "width";
}
const Xk = /* @__PURE__ */ new Set(["top", "bottom"]);
function Vt(e) {
  return Xk.has(gr(e)) ? "y" : "x";
}
function fm(e) {
  return lm(Vt(e));
}
function Zk(e, t, r) {
  r === void 0 && (r = !1);
  const n = Io(e), o = fm(e), a = um(o);
  let i = o === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = ss(i)), [i, ss(i)];
}
function Jk(e) {
  const t = ss(e);
  return [fh(e), t, fh(t)];
}
function fh(e) {
  return e.replace(/start|end/g, (t) => Yk[t]);
}
const ty = ["left", "right"], ry = ["right", "left"], Qk = ["top", "bottom"], e$ = ["bottom", "top"];
function t$(e, t, r) {
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? ry : ty : t ? ty : ry;
    case "left":
    case "right":
      return t ? Qk : e$;
    default:
      return [];
  }
}
function r$(e, t, r, n) {
  const o = Io(e);
  let a = t$(gr(e), r === "start", n);
  return o && (a = a.map((i) => i + "-" + o), t && (a = a.concat(a.map(fh)))), a;
}
function ss(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Gk[t]);
}
function n$(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function OO(e) {
  return typeof e != "number" ? n$(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function cs(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: o
  } = e;
  return {
    width: n,
    height: o,
    top: r,
    left: t,
    right: t + n,
    bottom: r + o,
    x: t,
    y: r
  };
}
function ny(e, t, r) {
  let {
    reference: n,
    floating: o
  } = e;
  const a = Vt(t), i = fm(t), s = um(i), c = gr(t), l = a === "y", f = n.x + n.width / 2 - o.width / 2, u = n.y + n.height / 2 - o.height / 2, d = n[s] / 2 - o[s] / 2;
  let h;
  switch (c) {
    case "top":
      h = {
        x: f,
        y: n.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: f,
        y: n.y + n.height
      };
      break;
    case "right":
      h = {
        x: n.x + n.width,
        y: u
      };
      break;
    case "left":
      h = {
        x: n.x - o.width,
        y: u
      };
      break;
    default:
      h = {
        x: n.x,
        y: n.y
      };
  }
  switch (Io(t)) {
    case "start":
      h[i] -= d * (r && l ? -1 : 1);
      break;
    case "end":
      h[i] += d * (r && l ? -1 : 1);
      break;
  }
  return h;
}
const o$ = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = r, s = a.filter(Boolean), c = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let l = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: f,
    y: u
  } = ny(l, n, c), d = n, h = {}, m = 0;
  for (let v = 0; v < s.length; v++) {
    const {
      name: p,
      fn: b
    } = s[v], {
      x: w,
      y: x,
      data: _,
      reset: y
    } = await b({
      x: f,
      y: u,
      initialPlacement: n,
      placement: d,
      strategy: o,
      middlewareData: h,
      rects: l,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = w ?? f, u = x ?? u, h = {
      ...h,
      [p]: {
        ...h[p],
        ..._
      }
    }, y && m <= 50 && (m++, typeof y == "object" && (y.placement && (d = y.placement), y.rects && (l = y.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : y.rects), {
      x: f,
      y: u
    } = ny(l, d, c)), v = -1);
  }
  return {
    x: f,
    y: u,
    placement: d,
    strategy: o,
    middlewareData: h
  };
};
async function ya(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: o,
    platform: a,
    rects: i,
    elements: s,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: u = "floating",
    altBoundary: d = !1,
    padding: h = 0
  } = mr(t, e), m = OO(h), p = s[d ? u === "floating" ? "reference" : "floating" : u], b = cs(await a.getClippingRect({
    element: (r = await (a.isElement == null ? void 0 : a.isElement(p))) == null || r ? p : p.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: f,
    strategy: c
  })), w = u === "floating" ? {
    x: n,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, x = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), _ = await (a.isElement == null ? void 0 : a.isElement(x)) ? await (a.getScale == null ? void 0 : a.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, y = cs(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: w,
    offsetParent: x,
    strategy: c
  }) : w);
  return {
    top: (b.top - y.top + m.top) / _.y,
    bottom: (y.bottom - b.bottom + m.bottom) / _.y,
    left: (b.left - y.left + m.left) / _.x,
    right: (y.right - b.right + m.right) / _.x
  };
}
const a$ = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: o,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: c
    } = t, {
      element: l,
      padding: f = 0
    } = mr(e, t) || {};
    if (l == null)
      return {};
    const u = OO(f), d = {
      x: r,
      y: n
    }, h = fm(o), m = um(h), v = await i.getDimensions(l), p = h === "y", b = p ? "top" : "left", w = p ? "bottom" : "right", x = p ? "clientHeight" : "clientWidth", _ = a.reference[m] + a.reference[h] - d[h] - a.floating[m], y = d[h] - a.reference[h], O = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l));
    let A = O ? O[x] : 0;
    (!A || !await (i.isElement == null ? void 0 : i.isElement(O))) && (A = s.floating[x] || a.floating[m]);
    const P = _ / 2 - y / 2, T = A / 2 - v[m] / 2 - 1, I = Nr(u[b], T), E = Nr(u[w], T), C = I, R = A - v[m] - E, M = A / 2 - v[m] / 2 + P, D = uh(C, M, R), $ = !c.arrow && Io(o) != null && M !== D && a.reference[m] / 2 - (M < C ? I : E) - v[m] / 2 < 0, q = $ ? M < C ? M - C : M - R : 0;
    return {
      [h]: d[h] + q,
      data: {
        [h]: D,
        centerOffset: M - D - q,
        ...$ && {
          alignmentOffset: q
        }
      },
      reset: $
    };
  }
}), i$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: c,
        elements: l
      } = t, {
        mainAxis: f = !0,
        crossAxis: u = !0,
        fallbackPlacements: d,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: v = !0,
        ...p
      } = mr(e, t);
      if ((r = a.arrow) != null && r.alignmentOffset)
        return {};
      const b = gr(o), w = Vt(s), x = gr(s) === s, _ = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), y = d || (x || !v ? [ss(s)] : Jk(s)), O = m !== "none";
      !d && O && y.push(...r$(s, v, m, _));
      const A = [s, ...y], P = await ya(t, p), T = [];
      let I = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (f && T.push(P[b]), u) {
        const M = Zk(o, i, _);
        T.push(P[M[0]], P[M[1]]);
      }
      if (I = [...I, {
        placement: o,
        overflows: T
      }], !T.every((M) => M <= 0)) {
        var E, C;
        const M = (((E = a.flip) == null ? void 0 : E.index) || 0) + 1, D = A[M];
        if (D && (!(u === "alignment" ? w !== Vt(D) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        I.every((F) => Vt(F.placement) === w ? F.overflows[0] > 0 : !0)))
          return {
            data: {
              index: M,
              overflows: I
            },
            reset: {
              placement: D
            }
          };
        let $ = (C = I.filter((q) => q.overflows[0] <= 0).sort((q, F) => q.overflows[1] - F.overflows[1])[0]) == null ? void 0 : C.placement;
        if (!$)
          switch (h) {
            case "bestFit": {
              var R;
              const q = (R = I.filter((F) => {
                if (O) {
                  const B = Vt(F.placement);
                  return B === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  B === "y";
                }
                return !0;
              }).map((F) => [F.placement, F.overflows.filter((B) => B > 0).reduce((B, L) => B + L, 0)]).sort((F, B) => F[1] - B[1])[0]) == null ? void 0 : R[0];
              q && ($ = q);
              break;
            }
            case "initialPlacement":
              $ = s;
              break;
          }
        if (o !== $)
          return {
            reset: {
              placement: $
            }
          };
      }
      return {};
    }
  };
};
function oy(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function ay(e) {
  return Kk.some((t) => e[t] >= 0);
}
const s$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: n = "referenceHidden",
        ...o
      } = mr(e, t);
      switch (n) {
        case "referenceHidden": {
          const a = await ya(t, {
            ...o,
            elementContext: "reference"
          }), i = oy(a, r.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: ay(i)
            }
          };
        }
        case "escaped": {
          const a = await ya(t, {
            ...o,
            altBoundary: !0
          }), i = oy(a, r.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: ay(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, AO = /* @__PURE__ */ new Set(["left", "top"]);
async function c$(e, t) {
  const {
    placement: r,
    platform: n,
    elements: o
  } = e, a = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), i = gr(r), s = Io(r), c = Vt(r) === "y", l = AO.has(i) ? -1 : 1, f = a && c ? -1 : 1, u = mr(t, e);
  let {
    mainAxis: d,
    crossAxis: h,
    alignmentAxis: m
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return s && typeof m == "number" && (h = s === "end" ? m * -1 : m), c ? {
    x: h * f,
    y: d * l
  } : {
    x: d * l,
    y: h * f
  };
}
const l$ = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: o,
        y: a,
        placement: i,
        middlewareData: s
      } = t, c = await c$(t, e);
      return i === ((r = s.offset) == null ? void 0 : r.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: o + c.x,
        y: a + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, u$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (p) => {
            let {
              x: b,
              y: w
            } = p;
            return {
              x: b,
              y: w
            };
          }
        },
        ...c
      } = mr(e, t), l = {
        x: r,
        y: n
      }, f = await ya(t, c), u = Vt(gr(o)), d = lm(u);
      let h = l[d], m = l[u];
      if (a) {
        const p = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", w = h + f[p], x = h - f[b];
        h = uh(w, h, x);
      }
      if (i) {
        const p = u === "y" ? "top" : "left", b = u === "y" ? "bottom" : "right", w = m + f[p], x = m - f[b];
        m = uh(w, m, x);
      }
      const v = s.fn({
        ...t,
        [d]: h,
        [u]: m
      });
      return {
        ...v,
        data: {
          x: v.x - r,
          y: v.y - n,
          enabled: {
            [d]: a,
            [u]: i
          }
        }
      };
    }
  };
}, f$ = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: n,
        placement: o,
        rects: a,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = mr(e, t), f = {
        x: r,
        y: n
      }, u = Vt(o), d = lm(u);
      let h = f[d], m = f[u];
      const v = mr(s, t), p = typeof v == "number" ? {
        mainAxis: v,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...v
      };
      if (c) {
        const x = d === "y" ? "height" : "width", _ = a.reference[d] - a.floating[x] + p.mainAxis, y = a.reference[d] + a.reference[x] - p.mainAxis;
        h < _ ? h = _ : h > y && (h = y);
      }
      if (l) {
        var b, w;
        const x = d === "y" ? "width" : "height", _ = AO.has(gr(o)), y = a.reference[u] - a.floating[x] + (_ && ((b = i.offset) == null ? void 0 : b[u]) || 0) + (_ ? 0 : p.crossAxis), O = a.reference[u] + a.reference[x] + (_ ? 0 : ((w = i.offset) == null ? void 0 : w[u]) || 0) - (_ ? p.crossAxis : 0);
        m < y ? m = y : m > O && (m = O);
      }
      return {
        [d]: h,
        [u]: m
      };
    }
  };
}, d$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        rects: a,
        platform: i,
        elements: s
      } = t, {
        apply: c = () => {
        },
        ...l
      } = mr(e, t), f = await ya(t, l), u = gr(o), d = Io(o), h = Vt(o) === "y", {
        width: m,
        height: v
      } = a.floating;
      let p, b;
      u === "top" || u === "bottom" ? (p = u, b = d === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (b = u, p = d === "end" ? "top" : "bottom");
      const w = v - f.top - f.bottom, x = m - f.left - f.right, _ = Nr(v - f[p], w), y = Nr(m - f[b], x), O = !t.middlewareData.shift;
      let A = _, P = y;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (P = x), (n = t.middlewareData.shift) != null && n.enabled.y && (A = w), O && !d) {
        const I = pt(f.left, 0), E = pt(f.right, 0), C = pt(f.top, 0), R = pt(f.bottom, 0);
        h ? P = m - 2 * (I !== 0 || E !== 0 ? I + E : pt(f.left, f.right)) : A = v - 2 * (C !== 0 || R !== 0 ? C + R : pt(f.top, f.bottom));
      }
      await c({
        ...t,
        availableWidth: P,
        availableHeight: A
      });
      const T = await i.getDimensions(s.floating);
      return m !== T.width || v !== T.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function wc() {
  return typeof window < "u";
}
function No(e) {
  return PO(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function gt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function tr(e) {
  var t;
  return (t = (PO(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function PO(e) {
  return wc() ? e instanceof Node || e instanceof gt(e).Node : !1;
}
function Lt(e) {
  return wc() ? e instanceof Element || e instanceof gt(e).Element : !1;
}
function Jt(e) {
  return wc() ? e instanceof HTMLElement || e instanceof gt(e).HTMLElement : !1;
}
function iy(e) {
  return !wc() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof gt(e).ShadowRoot;
}
const p$ = /* @__PURE__ */ new Set(["inline", "contents"]);
function si(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: o
  } = Bt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !p$.has(o);
}
const h$ = /* @__PURE__ */ new Set(["table", "td", "th"]);
function v$(e) {
  return h$.has(No(e));
}
const m$ = [":popover-open", ":modal"];
function xc(e) {
  return m$.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const g$ = ["transform", "translate", "scale", "rotate", "perspective"], y$ = ["transform", "translate", "scale", "rotate", "perspective", "filter"], b$ = ["paint", "layout", "strict", "content"];
function dm(e) {
  const t = pm(), r = Lt(e) ? Bt(e) : e;
  return g$.some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || y$.some((n) => (r.willChange || "").includes(n)) || b$.some((n) => (r.contain || "").includes(n));
}
function w$(e) {
  let t = kr(e);
  for (; Jt(t) && !Zn(t); ) {
    if (dm(t))
      return t;
    if (xc(t))
      return null;
    t = kr(t);
  }
  return null;
}
function pm() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const x$ = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Zn(e) {
  return x$.has(No(e));
}
function Bt(e) {
  return gt(e).getComputedStyle(e);
}
function Sc(e) {
  return Lt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function kr(e) {
  if (No(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    iy(e) && e.host || // Fallback.
    tr(e)
  );
  return iy(t) ? t.host : t;
}
function EO(e) {
  const t = kr(e);
  return Zn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Jt(t) && si(t) ? t : EO(t);
}
function ba(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const o = EO(e), a = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = gt(o);
  if (a) {
    const s = dh(i);
    return t.concat(i, i.visualViewport || [], si(o) ? o : [], s && r ? ba(s) : []);
  }
  return t.concat(o, ba(o, [], r));
}
function dh(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function TO(e) {
  const t = Bt(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const o = Jt(e), a = o ? e.offsetWidth : r, i = o ? e.offsetHeight : n, s = is(r) !== a || is(n) !== i;
  return s && (r = a, n = i), {
    width: r,
    height: n,
    $: s
  };
}
function hm(e) {
  return Lt(e) ? e : e.contextElement;
}
function Wn(e) {
  const t = hm(e);
  if (!Jt(t))
    return Gt(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: o,
    $: a
  } = TO(t);
  let i = (a ? is(r.width) : r.width) / n, s = (a ? is(r.height) : r.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const S$ = /* @__PURE__ */ Gt(0);
function CO(e) {
  const t = gt(e);
  return !pm() || !t.visualViewport ? S$ : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function _$(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== gt(e) ? !1 : t;
}
function un(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const o = e.getBoundingClientRect(), a = hm(e);
  let i = Gt(1);
  t && (n ? Lt(n) && (i = Wn(n)) : i = Wn(e));
  const s = _$(a, r, n) ? CO(a) : Gt(0);
  let c = (o.left + s.x) / i.x, l = (o.top + s.y) / i.y, f = o.width / i.x, u = o.height / i.y;
  if (a) {
    const d = gt(a), h = n && Lt(n) ? gt(n) : n;
    let m = d, v = dh(m);
    for (; v && n && h !== m; ) {
      const p = Wn(v), b = v.getBoundingClientRect(), w = Bt(v), x = b.left + (v.clientLeft + parseFloat(w.paddingLeft)) * p.x, _ = b.top + (v.clientTop + parseFloat(w.paddingTop)) * p.y;
      c *= p.x, l *= p.y, f *= p.x, u *= p.y, c += x, l += _, m = gt(v), v = dh(m);
    }
  }
  return cs({
    width: f,
    height: u,
    x: c,
    y: l
  });
}
function _c(e, t) {
  const r = Sc(e).scrollLeft;
  return t ? t.left + r : un(tr(e)).left + r;
}
function RO(e, t) {
  const r = e.getBoundingClientRect(), n = r.left + t.scrollLeft - _c(e, r), o = r.top + t.scrollTop;
  return {
    x: n,
    y: o
  };
}
function O$(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: o
  } = e;
  const a = o === "fixed", i = tr(n), s = t ? xc(t.floating) : !1;
  if (n === i || s && a)
    return r;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = Gt(1);
  const f = Gt(0), u = Jt(n);
  if ((u || !u && !a) && ((No(n) !== "body" || si(i)) && (c = Sc(n)), Jt(n))) {
    const h = un(n);
    l = Wn(n), f.x = h.x + n.clientLeft, f.y = h.y + n.clientTop;
  }
  const d = i && !u && !a ? RO(i, c) : Gt(0);
  return {
    width: r.width * l.x,
    height: r.height * l.y,
    x: r.x * l.x - c.scrollLeft * l.x + f.x + d.x,
    y: r.y * l.y - c.scrollTop * l.y + f.y + d.y
  };
}
function A$(e) {
  return Array.from(e.getClientRects());
}
function P$(e) {
  const t = tr(e), r = Sc(e), n = e.ownerDocument.body, o = pt(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), a = pt(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -r.scrollLeft + _c(e);
  const s = -r.scrollTop;
  return Bt(n).direction === "rtl" && (i += pt(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: s
  };
}
const sy = 25;
function E$(e, t) {
  const r = gt(e), n = tr(e), o = r.visualViewport;
  let a = n.clientWidth, i = n.clientHeight, s = 0, c = 0;
  if (o) {
    a = o.width, i = o.height;
    const f = pm();
    (!f || f && t === "fixed") && (s = o.offsetLeft, c = o.offsetTop);
  }
  const l = _c(n);
  if (l <= 0) {
    const f = n.ownerDocument, u = f.body, d = getComputedStyle(u), h = f.compatMode === "CSS1Compat" && parseFloat(d.marginLeft) + parseFloat(d.marginRight) || 0, m = Math.abs(n.clientWidth - u.clientWidth - h);
    m <= sy && (a -= m);
  } else l <= sy && (a += l);
  return {
    width: a,
    height: i,
    x: s,
    y: c
  };
}
const T$ = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function C$(e, t) {
  const r = un(e, !0, t === "fixed"), n = r.top + e.clientTop, o = r.left + e.clientLeft, a = Jt(e) ? Wn(e) : Gt(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, c = o * a.x, l = n * a.y;
  return {
    width: i,
    height: s,
    x: c,
    y: l
  };
}
function cy(e, t, r) {
  let n;
  if (t === "viewport")
    n = E$(e, r);
  else if (t === "document")
    n = P$(tr(e));
  else if (Lt(t))
    n = C$(t, r);
  else {
    const o = CO(e);
    n = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return cs(n);
}
function MO(e, t) {
  const r = kr(e);
  return r === t || !Lt(r) || Zn(r) ? !1 : Bt(r).position === "fixed" || MO(r, t);
}
function R$(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = ba(e, [], !1).filter((s) => Lt(s) && No(s) !== "body"), o = null;
  const a = Bt(e).position === "fixed";
  let i = a ? kr(e) : e;
  for (; Lt(i) && !Zn(i); ) {
    const s = Bt(i), c = dm(i);
    !c && s.position === "fixed" && (o = null), (a ? !c && !o : !c && s.position === "static" && !!o && T$.has(o.position) || si(i) && !c && MO(e, i)) ? n = n.filter((f) => f !== i) : o = s, i = kr(i);
  }
  return t.set(e, n), n;
}
function M$(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: o
  } = e;
  const i = [...r === "clippingAncestors" ? xc(t) ? [] : R$(t, this._c) : [].concat(r), n], s = i[0], c = i.reduce((l, f) => {
    const u = cy(t, f, o);
    return l.top = pt(u.top, l.top), l.right = Nr(u.right, l.right), l.bottom = Nr(u.bottom, l.bottom), l.left = pt(u.left, l.left), l;
  }, cy(t, s, o));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function I$(e) {
  const {
    width: t,
    height: r
  } = TO(e);
  return {
    width: t,
    height: r
  };
}
function N$(e, t, r) {
  const n = Jt(t), o = tr(t), a = r === "fixed", i = un(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Gt(0);
  function l() {
    c.x = _c(o);
  }
  if (n || !n && !a)
    if ((No(t) !== "body" || si(o)) && (s = Sc(t)), n) {
      const h = un(t, !0, a, t);
      c.x = h.x + t.clientLeft, c.y = h.y + t.clientTop;
    } else o && l();
  a && !n && o && l();
  const f = o && !n && !a ? RO(o, s) : Gt(0), u = i.left + s.scrollLeft - c.x - f.x, d = i.top + s.scrollTop - c.y - f.y;
  return {
    x: u,
    y: d,
    width: i.width,
    height: i.height
  };
}
function Bl(e) {
  return Bt(e).position === "static";
}
function ly(e, t) {
  if (!Jt(e) || Bt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return tr(e) === r && (r = r.ownerDocument.body), r;
}
function IO(e, t) {
  const r = gt(e);
  if (xc(e))
    return r;
  if (!Jt(e)) {
    let o = kr(e);
    for (; o && !Zn(o); ) {
      if (Lt(o) && !Bl(o))
        return o;
      o = kr(o);
    }
    return r;
  }
  let n = ly(e, t);
  for (; n && v$(n) && Bl(n); )
    n = ly(n, t);
  return n && Zn(n) && Bl(n) && !dm(n) ? r : n || w$(e) || r;
}
const k$ = async function(e) {
  const t = this.getOffsetParent || IO, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: N$(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function $$(e) {
  return Bt(e).direction === "rtl";
}
const D$ = {
  convertOffsetParentRelativeRectToViewportRelativeRect: O$,
  getDocumentElement: tr,
  getClippingRect: M$,
  getOffsetParent: IO,
  getElementRects: k$,
  getClientRects: A$,
  getDimensions: I$,
  getScale: Wn,
  isElement: Lt,
  isRTL: $$
};
function NO(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function j$(e, t) {
  let r = null, n;
  const o = tr(e);
  function a() {
    var s;
    clearTimeout(n), (s = r) == null || s.disconnect(), r = null;
  }
  function i(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), a();
    const l = e.getBoundingClientRect(), {
      left: f,
      top: u,
      width: d,
      height: h
    } = l;
    if (s || t(), !d || !h)
      return;
    const m = Ni(u), v = Ni(o.clientWidth - (f + d)), p = Ni(o.clientHeight - (u + h)), b = Ni(f), x = {
      rootMargin: -m + "px " + -v + "px " + -p + "px " + -b + "px",
      threshold: pt(0, Nr(1, c)) || 1
    };
    let _ = !0;
    function y(O) {
      const A = O[0].intersectionRatio;
      if (A !== c) {
        if (!_)
          return i();
        A ? i(!1, A) : n = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      A === 1 && !NO(l, e.getBoundingClientRect()) && i(), _ = !1;
    }
    try {
      r = new IntersectionObserver(y, {
        ...x,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(y, x);
    }
    r.observe(e);
  }
  return i(!0), a;
}
function L$(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, l = hm(e), f = o || a ? [...l ? ba(l) : [], ...ba(t)] : [];
  f.forEach((b) => {
    o && b.addEventListener("scroll", r, {
      passive: !0
    }), a && b.addEventListener("resize", r);
  });
  const u = l && s ? j$(l, r) : null;
  let d = -1, h = null;
  i && (h = new ResizeObserver((b) => {
    let [w] = b;
    w && w.target === l && h && (h.unobserve(t), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      var x;
      (x = h) == null || x.observe(t);
    })), r();
  }), l && !c && h.observe(l), h.observe(t));
  let m, v = c ? un(e) : null;
  c && p();
  function p() {
    const b = un(e);
    v && !NO(v, b) && r(), v = b, m = requestAnimationFrame(p);
  }
  return r(), () => {
    var b;
    f.forEach((w) => {
      o && w.removeEventListener("scroll", r), a && w.removeEventListener("resize", r);
    }), u == null || u(), (b = h) == null || b.disconnect(), h = null, c && cancelAnimationFrame(m);
  };
}
const B$ = l$, F$ = u$, q$ = i$, z$ = d$, W$ = s$, uy = a$, U$ = f$, H$ = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: D$,
    ...r
  }, a = {
    ...o.platform,
    _c: n
  };
  return o$(e, t, {
    ...o,
    platform: a
  });
};
var V$ = typeof document < "u", K$ = function() {
}, ts = V$ ? $I : K$;
function ls(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!ls(e[n], t[n]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), r = o.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const a = o[n];
      if (!(a === "_owner" && e.$$typeof) && !ls(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function kO(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function fy(e, t) {
  const r = kO(e);
  return Math.round(t * r) / r;
}
function Fl(e) {
  const t = g.useRef(e);
  return ts(() => {
    t.current = e;
  }), t;
}
function G$(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: o,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: l
  } = e, [f, u] = g.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [d, h] = g.useState(n);
  ls(d, n) || h(n);
  const [m, v] = g.useState(null), [p, b] = g.useState(null), w = g.useCallback((F) => {
    F !== O.current && (O.current = F, v(F));
  }, []), x = g.useCallback((F) => {
    F !== A.current && (A.current = F, b(F));
  }, []), _ = a || m, y = i || p, O = g.useRef(null), A = g.useRef(null), P = g.useRef(f), T = c != null, I = Fl(c), E = Fl(o), C = Fl(l), R = g.useCallback(() => {
    if (!O.current || !A.current)
      return;
    const F = {
      placement: t,
      strategy: r,
      middleware: d
    };
    E.current && (F.platform = E.current), H$(O.current, A.current, F).then((B) => {
      const L = {
        ...B,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: C.current !== !1
      };
      M.current && !ls(P.current, L) && (P.current = L, oi.flushSync(() => {
        u(L);
      }));
    });
  }, [d, t, r, E, C]);
  ts(() => {
    l === !1 && P.current.isPositioned && (P.current.isPositioned = !1, u((F) => ({
      ...F,
      isPositioned: !1
    })));
  }, [l]);
  const M = g.useRef(!1);
  ts(() => (M.current = !0, () => {
    M.current = !1;
  }), []), ts(() => {
    if (_ && (O.current = _), y && (A.current = y), _ && y) {
      if (I.current)
        return I.current(_, y, R);
      R();
    }
  }, [_, y, R, I, T]);
  const D = g.useMemo(() => ({
    reference: O,
    floating: A,
    setReference: w,
    setFloating: x
  }), [w, x]), $ = g.useMemo(() => ({
    reference: _,
    floating: y
  }), [_, y]), q = g.useMemo(() => {
    const F = {
      position: r,
      left: 0,
      top: 0
    };
    if (!$.floating)
      return F;
    const B = fy($.floating, f.x), L = fy($.floating, f.y);
    return s ? {
      ...F,
      transform: "translate(" + B + "px, " + L + "px)",
      ...kO($.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: B,
      top: L
    };
  }, [r, s, $.floating, f.x, f.y]);
  return g.useMemo(() => ({
    ...f,
    update: R,
    refs: D,
    elements: $,
    floatingStyles: q
  }), [f, R, D, $, q]);
}
const Y$ = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: n,
        padding: o
      } = typeof e == "function" ? e(r) : e;
      return n && t(n) ? n.current != null ? uy({
        element: n.current,
        padding: o
      }).fn(r) : {} : n ? uy({
        element: n,
        padding: o
      }).fn(r) : {};
    }
  };
}, X$ = (e, t) => ({
  ...B$(e),
  options: [e, t]
}), Z$ = (e, t) => ({
  ...F$(e),
  options: [e, t]
}), J$ = (e, t) => ({
  ...U$(e),
  options: [e, t]
}), Q$ = (e, t) => ({
  ...q$(e),
  options: [e, t]
}), eD = (e, t) => ({
  ...z$(e),
  options: [e, t]
}), tD = (e, t) => ({
  ...W$(e),
  options: [e, t]
}), rD = (e, t) => ({
  ...Y$(e),
  options: [e, t]
});
var nD = "Arrow", $O = g.forwardRef((e, t) => {
  const { children: r, width: n = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ S(
    ae.svg,
    {
      ...a,
      ref: t,
      width: n,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? r : /* @__PURE__ */ S("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
$O.displayName = nD;
var oD = $O, vm = "Popper", [DO, jr] = at(vm), [aD, jO] = DO(vm), LO = (e) => {
  const { __scopePopper: t, children: r } = e, [n, o] = g.useState(null);
  return /* @__PURE__ */ S(aD, { scope: t, anchor: n, onAnchorChange: o, children: r });
};
LO.displayName = vm;
var BO = "PopperAnchor", FO = g.forwardRef(
  (e, t) => {
    const { __scopePopper: r, virtualRef: n, ...o } = e, a = jO(BO, r), i = g.useRef(null), s = le(t, i), c = g.useRef(null);
    return g.useEffect(() => {
      const l = c.current;
      c.current = (n == null ? void 0 : n.current) || i.current, l !== c.current && a.onAnchorChange(c.current);
    }), n ? null : /* @__PURE__ */ S(ae.div, { ...o, ref: s });
  }
);
FO.displayName = BO;
var mm = "PopperContent", [iD, sD] = DO(mm), qO = g.forwardRef(
  (e, t) => {
    var V, Q, W, Y, te, j;
    const {
      __scopePopper: r,
      side: n = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: c = !0,
      collisionBoundary: l = [],
      collisionPadding: f = 0,
      sticky: u = "partial",
      hideWhenDetached: d = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: m,
      ...v
    } = e, p = jO(mm, r), [b, w] = g.useState(null), x = le(t, (ce) => w(ce)), [_, y] = g.useState(null), O = nm(_), A = (O == null ? void 0 : O.width) ?? 0, P = (O == null ? void 0 : O.height) ?? 0, T = n + (a !== "center" ? "-" + a : ""), I = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, E = Array.isArray(l) ? l : [l], C = E.length > 0, R = {
      padding: I,
      boundary: E.filter(lD),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: C
    }, { refs: M, floatingStyles: D, placement: $, isPositioned: q, middlewareData: F } = G$({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: T,
      whileElementsMounted: (...ce) => L$(...ce, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: p.anchor
      },
      middleware: [
        X$({ mainAxis: o + P, alignmentAxis: i }),
        c && Z$({
          mainAxis: !0,
          crossAxis: !1,
          limiter: u === "partial" ? J$() : void 0,
          ...R
        }),
        c && Q$({ ...R }),
        eD({
          ...R,
          apply: ({ elements: ce, rects: X, availableWidth: he, availableHeight: ge }) => {
            const { width: Ie, height: Ut } = X.reference, Rt = ce.floating.style;
            Rt.setProperty("--radix-popper-available-width", `${he}px`), Rt.setProperty("--radix-popper-available-height", `${ge}px`), Rt.setProperty("--radix-popper-anchor-width", `${Ie}px`), Rt.setProperty("--radix-popper-anchor-height", `${Ut}px`);
          }
        }),
        _ && rD({ element: _, padding: s }),
        uD({ arrowWidth: A, arrowHeight: P }),
        d && tD({ strategy: "referenceHidden", ...R })
      ]
    }), [B, L] = UO($), z = $e(m);
    Ue(() => {
      q && (z == null || z());
    }, [q, z]);
    const N = (V = F.arrow) == null ? void 0 : V.x, U = (Q = F.arrow) == null ? void 0 : Q.y, K = ((W = F.arrow) == null ? void 0 : W.centerOffset) !== 0, [G, J] = g.useState();
    return Ue(() => {
      b && J(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ S(
      "div",
      {
        ref: M.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...D,
          transform: q ? D.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: G,
          "--radix-popper-transform-origin": [
            (Y = F.transformOrigin) == null ? void 0 : Y.x,
            (te = F.transformOrigin) == null ? void 0 : te.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((j = F.hide) == null ? void 0 : j.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ S(
          iD,
          {
            scope: r,
            placedSide: B,
            onArrowChange: y,
            arrowX: N,
            arrowY: U,
            shouldHideArrow: K,
            children: /* @__PURE__ */ S(
              ae.div,
              {
                "data-side": B,
                "data-align": L,
                ...v,
                ref: x,
                style: {
                  ...v.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: q ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
qO.displayName = mm;
var zO = "PopperArrow", cD = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, WO = g.forwardRef(function(t, r) {
  const { __scopePopper: n, ...o } = t, a = sD(zO, n), i = cD[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ S(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ S(
          oD,
          {
            ...o,
            ref: r,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
WO.displayName = zO;
function lD(e) {
  return e !== null;
}
var uD = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var p, b, w;
    const { placement: r, rects: n, middlewareData: o } = t, i = ((p = o.arrow) == null ? void 0 : p.centerOffset) !== 0, s = i ? 0 : e.arrowWidth, c = i ? 0 : e.arrowHeight, [l, f] = UO(r), u = { start: "0%", center: "50%", end: "100%" }[f], d = (((b = o.arrow) == null ? void 0 : b.x) ?? 0) + s / 2, h = (((w = o.arrow) == null ? void 0 : w.y) ?? 0) + c / 2;
    let m = "", v = "";
    return l === "bottom" ? (m = i ? u : `${d}px`, v = `${-c}px`) : l === "top" ? (m = i ? u : `${d}px`, v = `${n.floating.height + c}px`) : l === "right" ? (m = `${-c}px`, v = i ? u : `${h}px`) : l === "left" && (m = `${n.floating.width + c}px`, v = i ? u : `${h}px`), { data: { x: m, y: v } };
  }
});
function UO(e) {
  const [t, r = "center"] = e.split("-");
  return [t, r];
}
var ci = LO, li = FO, Oc = qO, Ac = WO, fD = "Portal", ko = g.forwardRef((e, t) => {
  var s;
  const { container: r, ...n } = e, [o, a] = g.useState(!1);
  Ue(() => a(!0), []);
  const i = r || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return i ? N1.createPortal(/* @__PURE__ */ S(ae.div, { ...n, ref: t }), i) : null;
});
ko.displayName = fD;
var HO = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), dD = "VisuallyHidden", Pc = g.forwardRef(
  (e, t) => /* @__PURE__ */ S(
    ae.span,
    {
      ...e,
      ref: t,
      style: { ...HO, ...e.style }
    }
  )
);
Pc.displayName = dD;
var pD = Pc, [Ec] = at("Tooltip", [
  jr
]), Tc = jr(), VO = "TooltipProvider", hD = 700, ph = "tooltip.open", [vD, gm] = Ec(VO), KO = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: r = hD,
    skipDelayDuration: n = 300,
    disableHoverableContent: o = !1,
    children: a
  } = e, i = g.useRef(!0), s = g.useRef(!1), c = g.useRef(0);
  return g.useEffect(() => {
    const l = c.current;
    return () => window.clearTimeout(l);
  }, []), /* @__PURE__ */ S(
    vD,
    {
      scope: t,
      isOpenDelayedRef: i,
      delayDuration: r,
      onOpen: g.useCallback(() => {
        window.clearTimeout(c.current), i.current = !1;
      }, []),
      onClose: g.useCallback(() => {
        window.clearTimeout(c.current), c.current = window.setTimeout(
          () => i.current = !0,
          n
        );
      }, [n]),
      isPointerInTransitRef: s,
      onPointerInTransitChange: g.useCallback((l) => {
        s.current = l;
      }, []),
      disableHoverableContent: o,
      children: a
    }
  );
};
KO.displayName = VO;
var wa = "Tooltip", [mD, Cc] = Ec(wa), GO = (e) => {
  const {
    __scopeTooltip: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: a,
    disableHoverableContent: i,
    delayDuration: s
  } = e, c = gm(wa, e.__scopeTooltip), l = Tc(t), [f, u] = g.useState(null), d = je(), h = g.useRef(0), m = i ?? c.disableHoverableContent, v = s ?? c.delayDuration, p = g.useRef(!1), [b, w] = Pt({
    prop: n,
    defaultProp: o ?? !1,
    onChange: (A) => {
      A ? (c.onOpen(), document.dispatchEvent(new CustomEvent(ph))) : c.onClose(), a == null || a(A);
    },
    caller: wa
  }), x = g.useMemo(() => b ? p.current ? "delayed-open" : "instant-open" : "closed", [b]), _ = g.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, p.current = !1, w(!0);
  }, [w]), y = g.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, w(!1);
  }, [w]), O = g.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      p.current = !0, w(!0), h.current = 0;
    }, v);
  }, [v, w]);
  return g.useEffect(() => () => {
    h.current && (window.clearTimeout(h.current), h.current = 0);
  }, []), /* @__PURE__ */ S(ci, { ...l, children: /* @__PURE__ */ S(
    mD,
    {
      scope: t,
      contentId: d,
      open: b,
      stateAttribute: x,
      trigger: f,
      onTriggerChange: u,
      onTriggerEnter: g.useCallback(() => {
        c.isOpenDelayedRef.current ? O() : _();
      }, [c.isOpenDelayedRef, O, _]),
      onTriggerLeave: g.useCallback(() => {
        m ? y() : (window.clearTimeout(h.current), h.current = 0);
      }, [y, m]),
      onOpen: _,
      onClose: y,
      disableHoverableContent: m,
      children: r
    }
  ) });
};
GO.displayName = wa;
var hh = "TooltipTrigger", YO = g.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...n } = e, o = Cc(hh, r), a = gm(hh, r), i = Tc(r), s = g.useRef(null), c = le(t, s, o.onTriggerChange), l = g.useRef(!1), f = g.useRef(!1), u = g.useCallback(() => l.current = !1, []);
    return g.useEffect(() => () => document.removeEventListener("pointerup", u), [u]), /* @__PURE__ */ S(li, { asChild: !0, ...i, children: /* @__PURE__ */ S(
      ae.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...n,
        ref: c,
        onPointerMove: Z(e.onPointerMove, (d) => {
          d.pointerType !== "touch" && !f.current && !a.isPointerInTransitRef.current && (o.onTriggerEnter(), f.current = !0);
        }),
        onPointerLeave: Z(e.onPointerLeave, () => {
          o.onTriggerLeave(), f.current = !1;
        }),
        onPointerDown: Z(e.onPointerDown, () => {
          o.open && o.onClose(), l.current = !0, document.addEventListener("pointerup", u, { once: !0 });
        }),
        onFocus: Z(e.onFocus, () => {
          l.current || o.onOpen();
        }),
        onBlur: Z(e.onBlur, o.onClose),
        onClick: Z(e.onClick, o.onClose)
      }
    ) });
  }
);
YO.displayName = hh;
var gD = "TooltipPortal", [nJ, yD] = Ec(gD, {
  forceMount: void 0
}), Jn = "TooltipContent", XO = g.forwardRef(
  (e, t) => {
    const r = yD(Jn, e.__scopeTooltip), { forceMount: n = r.forceMount, side: o = "top", ...a } = e, i = Cc(Jn, e.__scopeTooltip);
    return /* @__PURE__ */ S(Ge, { present: n || i.open, children: i.disableHoverableContent ? /* @__PURE__ */ S(ZO, { side: o, ...a, ref: t }) : /* @__PURE__ */ S(bD, { side: o, ...a, ref: t }) });
  }
), bD = g.forwardRef((e, t) => {
  const r = Cc(Jn, e.__scopeTooltip), n = gm(Jn, e.__scopeTooltip), o = g.useRef(null), a = le(t, o), [i, s] = g.useState(null), { trigger: c, onClose: l } = r, f = o.current, { onPointerInTransitChange: u } = n, d = g.useCallback(() => {
    s(null), u(!1);
  }, [u]), h = g.useCallback(
    (m, v) => {
      const p = m.currentTarget, b = { x: m.clientX, y: m.clientY }, w = OD(b, p.getBoundingClientRect()), x = AD(b, w), _ = PD(v.getBoundingClientRect()), y = TD([...x, ..._]);
      s(y), u(!0);
    },
    [u]
  );
  return g.useEffect(() => () => d(), [d]), g.useEffect(() => {
    if (c && f) {
      const m = (p) => h(p, f), v = (p) => h(p, c);
      return c.addEventListener("pointerleave", m), f.addEventListener("pointerleave", v), () => {
        c.removeEventListener("pointerleave", m), f.removeEventListener("pointerleave", v);
      };
    }
  }, [c, f, h, d]), g.useEffect(() => {
    if (i) {
      const m = (v) => {
        const p = v.target, b = { x: v.clientX, y: v.clientY }, w = (c == null ? void 0 : c.contains(p)) || (f == null ? void 0 : f.contains(p)), x = !ED(b, i);
        w ? d() : x && (d(), l());
      };
      return document.addEventListener("pointermove", m), () => document.removeEventListener("pointermove", m);
    }
  }, [c, f, i, l, d]), /* @__PURE__ */ S(ZO, { ...e, ref: a });
}), [wD, xD] = Ec(wa, { isInside: !1 }), SD = /* @__PURE__ */ W1("TooltipContent"), ZO = g.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: r,
      children: n,
      "aria-label": o,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      ...s
    } = e, c = Cc(Jn, r), l = Tc(r), { onClose: f } = c;
    return g.useEffect(() => (document.addEventListener(ph, f), () => document.removeEventListener(ph, f)), [f]), g.useEffect(() => {
      if (c.trigger) {
        const u = (d) => {
          const h = d.target;
          h != null && h.contains(c.trigger) && f();
        };
        return window.addEventListener("scroll", u, { capture: !0 }), () => window.removeEventListener("scroll", u, { capture: !0 });
      }
    }, [c.trigger, f]), /* @__PURE__ */ S(
      wn,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: i,
        onFocusOutside: (u) => u.preventDefault(),
        onDismiss: f,
        children: /* @__PURE__ */ ee(
          Oc,
          {
            "data-state": c.stateAttribute,
            ...l,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ S(SD, { children: n }),
              /* @__PURE__ */ S(wD, { scope: r, isInside: !0, children: /* @__PURE__ */ S(pD, { id: c.contentId, role: "tooltip", children: o || n }) })
            ]
          }
        )
      }
    );
  }
);
XO.displayName = Jn;
var JO = "TooltipArrow", _D = g.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...n } = e, o = Tc(r);
    return xD(
      JO,
      r
    ).isInside ? null : /* @__PURE__ */ S(Ac, { ...o, ...n, ref: t });
  }
);
_D.displayName = JO;
function OD(e, t) {
  const r = Math.abs(t.top - e.y), n = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(r, n, o, a)) {
    case a:
      return "left";
    case o:
      return "right";
    case r:
      return "top";
    case n:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function AD(e, t, r = 5) {
  const n = [];
  switch (t) {
    case "top":
      n.push(
        { x: e.x - r, y: e.y + r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "bottom":
      n.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x + r, y: e.y - r }
      );
      break;
    case "left":
      n.push(
        { x: e.x + r, y: e.y - r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "right":
      n.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x - r, y: e.y + r }
      );
      break;
  }
  return n;
}
function PD(e) {
  const { top: t, right: r, bottom: n, left: o } = e;
  return [
    { x: o, y: t },
    { x: r, y: t },
    { x: r, y: n },
    { x: o, y: n }
  ];
}
function ED(e, t) {
  const { x: r, y: n } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a], c = t[i], l = s.x, f = s.y, u = c.x, d = c.y;
    f > n != d > n && r < (u - l) * (n - f) / (d - f) + l && (o = !o);
  }
  return o;
}
function TD(e) {
  const t = e.slice();
  return t.sort((r, n) => r.x < n.x ? -1 : r.x > n.x ? 1 : r.y < n.y ? -1 : r.y > n.y ? 1 : 0), CD(t);
}
function CD(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], i = t[t.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const r = [];
  for (let n = e.length - 1; n >= 0; n--) {
    const o = e[n];
    for (; r.length >= 2; ) {
      const a = r[r.length - 1], i = r[r.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x)) r.pop();
      else break;
    }
    r.push(o);
  }
  return r.pop(), t.length === 1 && r.length === 1 && t[0].x === r[0].x && t[0].y === r[0].y ? t : t.concat(r);
}
var RD = KO, MD = GO, ID = YO, QO = XO;
const eA = RD, tA = MD, rA = ID, ym = g.forwardRef(({ className: e, sideOffset: t = 4, ...r }, n) => /* @__PURE__ */ S(
  QO,
  {
    ref: n,
    sideOffset: t,
    className: re(
      "z-50 overflow-hidden rounded-md border border-slate-200 bg-white px-3 py-1.5 text-sm text-slate-950 shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50",
      e
    ),
    ...r
  }
));
ym.displayName = QO.displayName;
const vh = g.forwardRef(
  ({
    mode: e = "icon",
    variant: t = "ghost",
    icon: r,
    text: n,
    gap: o = "gap-2",
    showTooltip: a = !0,
    tooltipContent: i,
    tooltipSide: s = "bottom",
    className: c,
    ...l
  }, f) => {
    const u = () => {
      switch (e) {
        case "icon":
          return r;
        case "text":
          return /* @__PURE__ */ S("span", { children: n });
        case "icon-text":
          return /* @__PURE__ */ ee(ke, { children: [
            r,
            n && /* @__PURE__ */ S("span", { className: "truncate", children: n })
          ] });
        case "text-icon":
          return /* @__PURE__ */ ee(ke, { children: [
            n && /* @__PURE__ */ S("span", { className: "truncate", children: n }),
            r
          ] });
        default:
          return null;
      }
    }, d = /* @__PURE__ */ S(
      Dt,
      {
        ref: f,
        variant: t,
        className: re(
          e !== "icon" && e !== "text" && o,
          c
        ),
        ...l,
        children: u()
      }
    );
    return e === "icon" && a && (i || n) ? /* @__PURE__ */ S(eA, { children: /* @__PURE__ */ ee(tA, { children: [
      /* @__PURE__ */ S(rA, { asChild: !0, children: d }),
      /* @__PURE__ */ S(ym, { side: s, className: "px-3 py-1.5", children: /* @__PURE__ */ S("p", { className: "text-xs font-medium", children: i || n }) })
    ] }) }) : d;
  }
);
vh.displayName = "IconTextButton";
var ql = "focusScope.autoFocusOnMount", zl = "focusScope.autoFocusOnUnmount", dy = { bubbles: !1, cancelable: !0 }, ND = "FocusScope", ui = g.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...i
  } = e, [s, c] = g.useState(null), l = $e(o), f = $e(a), u = g.useRef(null), d = le(t, (v) => c(v)), h = g.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  g.useEffect(() => {
    if (n) {
      let v = function(x) {
        if (h.paused || !s) return;
        const _ = x.target;
        s.contains(_) ? u.current = _ : Er(u.current, { select: !0 });
      }, p = function(x) {
        if (h.paused || !s) return;
        const _ = x.relatedTarget;
        _ !== null && (s.contains(_) || Er(u.current, { select: !0 }));
      }, b = function(x) {
        if (document.activeElement === document.body)
          for (const y of x)
            y.removedNodes.length > 0 && Er(s);
      };
      document.addEventListener("focusin", v), document.addEventListener("focusout", p);
      const w = new MutationObserver(b);
      return s && w.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", v), document.removeEventListener("focusout", p), w.disconnect();
      };
    }
  }, [n, s, h.paused]), g.useEffect(() => {
    if (s) {
      hy.add(h);
      const v = document.activeElement;
      if (!s.contains(v)) {
        const b = new CustomEvent(ql, dy);
        s.addEventListener(ql, l), s.dispatchEvent(b), b.defaultPrevented || (kD(BD(nA(s)), { select: !0 }), document.activeElement === v && Er(s));
      }
      return () => {
        s.removeEventListener(ql, l), setTimeout(() => {
          const b = new CustomEvent(zl, dy);
          s.addEventListener(zl, f), s.dispatchEvent(b), b.defaultPrevented || Er(v ?? document.body, { select: !0 }), s.removeEventListener(zl, f), hy.remove(h);
        }, 0);
      };
    }
  }, [s, l, f, h]);
  const m = g.useCallback(
    (v) => {
      if (!r && !n || h.paused) return;
      const p = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey, b = document.activeElement;
      if (p && b) {
        const w = v.currentTarget, [x, _] = $D(w);
        x && _ ? !v.shiftKey && b === _ ? (v.preventDefault(), r && Er(x, { select: !0 })) : v.shiftKey && b === x && (v.preventDefault(), r && Er(_, { select: !0 })) : b === w && v.preventDefault();
      }
    },
    [r, n, h.paused]
  );
  return /* @__PURE__ */ S(ae.div, { tabIndex: -1, ...i, ref: d, onKeyDown: m });
});
ui.displayName = ND;
function kD(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (Er(n, { select: t }), document.activeElement !== r) return;
}
function $D(e) {
  const t = nA(e), r = py(t, e), n = py(t.reverse(), e);
  return [r, n];
}
function nA(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function py(e, t) {
  for (const r of e)
    if (!DD(r, { upTo: t })) return r;
}
function DD(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function jD(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Er(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && jD(e) && t && e.select();
  }
}
var hy = LD();
function LD() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = vy(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = vy(e, t), (r = e[0]) == null || r.resume();
    }
  };
}
function vy(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function BD(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Wl = 0;
function Rc() {
  g.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? my()), document.body.insertAdjacentElement("beforeend", e[1] ?? my()), Wl++, () => {
      Wl === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Wl--;
    };
  }, []);
}
function my() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ht = function() {
  return Ht = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, Ht.apply(this, arguments);
};
function oA(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function FD(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, o = t.length, a; n < o; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var rs = "right-scroll-bar-position", ns = "width-before-scroll-bar", qD = "with-scroll-bars-hidden", zD = "--removed-body-scroll-bar-size";
function Ul(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function WD(e, t) {
  var r = Je(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var o = r.value;
          o !== n && (r.value = n, r.callback(n, o));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var UD = typeof window < "u" ? g.useLayoutEffect : g.useEffect, gy = /* @__PURE__ */ new WeakMap();
function HD(e, t) {
  var r = WD(null, function(n) {
    return e.forEach(function(o) {
      return Ul(o, n);
    });
  });
  return UD(function() {
    var n = gy.get(r);
    if (n) {
      var o = new Set(n), a = new Set(e), i = r.current;
      o.forEach(function(s) {
        a.has(s) || Ul(s, null);
      }), a.forEach(function(s) {
        o.has(s) || Ul(s, i);
      });
    }
    gy.set(r, e);
  }, [e]), r;
}
function VD(e) {
  return e;
}
function KD(e, t) {
  t === void 0 && (t = VD);
  var r = [], n = !1, o = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(a) {
      var i = t(a, n);
      return r.push(i), function() {
        r = r.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (n = !0; r.length; ) {
        var i = r;
        r = [], i.forEach(a);
      }
      r = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(a) {
      n = !0;
      var i = [];
      if (r.length) {
        var s = r;
        r = [], s.forEach(a), i = r;
      }
      var c = function() {
        var f = i;
        i = [], f.forEach(a);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), r = {
        push: function(f) {
          i.push(f), l();
        },
        filter: function(f) {
          return i = i.filter(f), r;
        }
      };
    }
  };
  return o;
}
function GD(e) {
  e === void 0 && (e = {});
  var t = KD(null);
  return t.options = Ht({ async: !0, ssr: !1 }, e), t;
}
var aA = function(e) {
  var t = e.sideCar, r = oA(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return g.createElement(n, Ht({}, r));
};
aA.isSideCarExport = !0;
function YD(e, t) {
  return e.useMedium(t), aA;
}
var iA = GD(), Hl = function() {
}, Mc = g.forwardRef(function(e, t) {
  var r = g.useRef(null), n = g.useState({
    onScrollCapture: Hl,
    onWheelCapture: Hl,
    onTouchMoveCapture: Hl
  }), o = n[0], a = n[1], i = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, f = e.enabled, u = e.shards, d = e.sideCar, h = e.noRelative, m = e.noIsolation, v = e.inert, p = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, x = e.gapMode, _ = oA(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), y = d, O = HD([r, t]), A = Ht(Ht({}, _), o);
  return g.createElement(
    g.Fragment,
    null,
    f && g.createElement(y, { sideCar: iA, removeScrollBar: l, shards: u, noRelative: h, noIsolation: m, inert: v, setCallbacks: a, allowPinchZoom: !!p, lockRef: r, gapMode: x }),
    i ? g.cloneElement(g.Children.only(s), Ht(Ht({}, A), { ref: O })) : g.createElement(w, Ht({}, A, { className: c, ref: O }), s)
  );
});
Mc.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Mc.classNames = {
  fullWidth: ns,
  zeroRight: rs
};
var XD = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function ZD() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = XD();
  return t && e.setAttribute("nonce", t), e;
}
function JD(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function QD(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var ej = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = ZD()) && (JD(t, r), QD(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, tj = function() {
  var e = ej();
  return function(t, r) {
    g.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, sA = function() {
  var e = tj(), t = function(r) {
    var n = r.styles, o = r.dynamic;
    return e(n, o), null;
  };
  return t;
}, rj = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Vl = function(e) {
  return parseInt(e || "", 10) || 0;
}, nj = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Vl(r), Vl(n), Vl(o)];
}, oj = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return rj;
  var t = nj(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, aj = sA(), Un = "data-scroll-locked", ij = function(e, t, r, n) {
  var o = e.left, a = e.top, i = e.right, s = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(qD, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(s, "px ").concat(n, `;
  }
  body[`).concat(Un, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(s, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(rs, ` {
    right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(ns, ` {
    margin-right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(rs, " .").concat(rs, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(ns, " .").concat(ns, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(Un, `] {
    `).concat(zD, ": ").concat(s, `px;
  }
`);
}, yy = function() {
  var e = parseInt(document.body.getAttribute(Un) || "0", 10);
  return isFinite(e) ? e : 0;
}, sj = function() {
  g.useEffect(function() {
    return document.body.setAttribute(Un, (yy() + 1).toString()), function() {
      var e = yy() - 1;
      e <= 0 ? document.body.removeAttribute(Un) : document.body.setAttribute(Un, e.toString());
    };
  }, []);
}, cj = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, o = n === void 0 ? "margin" : n;
  sj();
  var a = g.useMemo(function() {
    return oj(o);
  }, [o]);
  return g.createElement(aj, { styles: ij(a, !t, o, r ? "" : "!important") });
}, mh = !1;
if (typeof window < "u")
  try {
    var ki = Object.defineProperty({}, "passive", {
      get: function() {
        return mh = !0, !0;
      }
    });
    window.addEventListener("test", ki, ki), window.removeEventListener("test", ki, ki);
  } catch {
    mh = !1;
  }
var En = mh ? { passive: !1 } : !1, lj = function(e) {
  return e.tagName === "TEXTAREA";
}, cA = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !lj(e) && r[t] === "visible")
  );
}, uj = function(e) {
  return cA(e, "overflowY");
}, fj = function(e) {
  return cA(e, "overflowX");
}, by = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = lA(e, n);
    if (o) {
      var a = uA(e, n), i = a[1], s = a[2];
      if (i > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, dj = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, pj = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, lA = function(e, t) {
  return e === "v" ? uj(t) : fj(t);
}, uA = function(e, t) {
  return e === "v" ? dj(t) : pj(t);
}, hj = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, vj = function(e, t, r, n, o) {
  var a = hj(e, window.getComputedStyle(t).direction), i = a * n, s = r.target, c = t.contains(s), l = !1, f = i > 0, u = 0, d = 0;
  do {
    if (!s)
      break;
    var h = uA(e, s), m = h[0], v = h[1], p = h[2], b = v - p - a * m;
    (m || b) && lA(e, s) && (u += b, d += m);
    var w = s.parentNode;
    s = w && w.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? w.host : w;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (f && Math.abs(u) < 1 || !f && Math.abs(d) < 1) && (l = !0), l;
}, $i = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, wy = function(e) {
  return [e.deltaX, e.deltaY];
}, xy = function(e) {
  return e && "current" in e ? e.current : e;
}, mj = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, gj = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, yj = 0, Tn = [];
function bj(e) {
  var t = g.useRef([]), r = g.useRef([0, 0]), n = g.useRef(), o = g.useState(yj++)[0], a = g.useState(sA)[0], i = g.useRef(e);
  g.useEffect(function() {
    i.current = e;
  }, [e]), g.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var v = FD([e.lockRef.current], (e.shards || []).map(xy), !0).filter(Boolean);
      return v.forEach(function(p) {
        return p.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), v.forEach(function(p) {
          return p.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = g.useCallback(function(v, p) {
    if ("touches" in v && v.touches.length === 2 || v.type === "wheel" && v.ctrlKey)
      return !i.current.allowPinchZoom;
    var b = $i(v), w = r.current, x = "deltaX" in v ? v.deltaX : w[0] - b[0], _ = "deltaY" in v ? v.deltaY : w[1] - b[1], y, O = v.target, A = Math.abs(x) > Math.abs(_) ? "h" : "v";
    if ("touches" in v && A === "h" && O.type === "range")
      return !1;
    var P = window.getSelection(), T = P && P.anchorNode, I = T ? T === O || T.contains(O) : !1;
    if (I)
      return !1;
    var E = by(A, O);
    if (!E)
      return !0;
    if (E ? y = A : (y = A === "v" ? "h" : "v", E = by(A, O)), !E)
      return !1;
    if (!n.current && "changedTouches" in v && (x || _) && (n.current = y), !y)
      return !0;
    var C = n.current || y;
    return vj(C, p, v, C === "h" ? x : _);
  }, []), c = g.useCallback(function(v) {
    var p = v;
    if (!(!Tn.length || Tn[Tn.length - 1] !== a)) {
      var b = "deltaY" in p ? wy(p) : $i(p), w = t.current.filter(function(y) {
        return y.name === p.type && (y.target === p.target || p.target === y.shadowParent) && mj(y.delta, b);
      })[0];
      if (w && w.should) {
        p.cancelable && p.preventDefault();
        return;
      }
      if (!w) {
        var x = (i.current.shards || []).map(xy).filter(Boolean).filter(function(y) {
          return y.contains(p.target);
        }), _ = x.length > 0 ? s(p, x[0]) : !i.current.noIsolation;
        _ && p.cancelable && p.preventDefault();
      }
    }
  }, []), l = g.useCallback(function(v, p, b, w) {
    var x = { name: v, delta: p, target: b, should: w, shadowParent: wj(b) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(_) {
        return _ !== x;
      });
    }, 1);
  }, []), f = g.useCallback(function(v) {
    r.current = $i(v), n.current = void 0;
  }, []), u = g.useCallback(function(v) {
    l(v.type, wy(v), v.target, s(v, e.lockRef.current));
  }, []), d = g.useCallback(function(v) {
    l(v.type, $i(v), v.target, s(v, e.lockRef.current));
  }, []);
  g.useEffect(function() {
    return Tn.push(a), e.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: d
    }), document.addEventListener("wheel", c, En), document.addEventListener("touchmove", c, En), document.addEventListener("touchstart", f, En), function() {
      Tn = Tn.filter(function(v) {
        return v !== a;
      }), document.removeEventListener("wheel", c, En), document.removeEventListener("touchmove", c, En), document.removeEventListener("touchstart", f, En);
    };
  }, []);
  var h = e.removeScrollBar, m = e.inert;
  return g.createElement(
    g.Fragment,
    null,
    m ? g.createElement(a, { styles: gj(o) }) : null,
    h ? g.createElement(cj, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function wj(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const xj = YD(iA, bj);
var fi = g.forwardRef(function(e, t) {
  return g.createElement(Mc, Ht({}, e, { ref: t, sideCar: xj }));
});
fi.classNames = Mc.classNames;
var Sj = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Cn = /* @__PURE__ */ new WeakMap(), Di = /* @__PURE__ */ new WeakMap(), ji = {}, Kl = 0, fA = function(e) {
  return e && (e.host || fA(e.parentNode));
}, _j = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = fA(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, Oj = function(e, t, r, n) {
  var o = _j(t, Array.isArray(e) ? e : [e]);
  ji[r] || (ji[r] = /* @__PURE__ */ new WeakMap());
  var a = ji[r], i = [], s = /* @__PURE__ */ new Set(), c = new Set(o), l = function(u) {
    !u || s.has(u) || (s.add(u), l(u.parentNode));
  };
  o.forEach(l);
  var f = function(u) {
    !u || c.has(u) || Array.prototype.forEach.call(u.children, function(d) {
      if (s.has(d))
        f(d);
      else
        try {
          var h = d.getAttribute(n), m = h !== null && h !== "false", v = (Cn.get(d) || 0) + 1, p = (a.get(d) || 0) + 1;
          Cn.set(d, v), a.set(d, p), i.push(d), v === 1 && m && Di.set(d, !0), p === 1 && d.setAttribute(r, "true"), m || d.setAttribute(n, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", d, b);
        }
    });
  };
  return f(t), s.clear(), Kl++, function() {
    i.forEach(function(u) {
      var d = Cn.get(u) - 1, h = a.get(u) - 1;
      Cn.set(u, d), a.set(u, h), d || (Di.has(u) || u.removeAttribute(n), Di.delete(u)), h || u.removeAttribute(r);
    }), Kl--, Kl || (Cn = /* @__PURE__ */ new WeakMap(), Cn = /* @__PURE__ */ new WeakMap(), Di = /* @__PURE__ */ new WeakMap(), ji = {});
  };
}, Ic = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), o = Sj(e);
  return o ? (n.push.apply(n, Array.from(o.querySelectorAll("[aria-live], script"))), Oj(n, o, r, "aria-hidden")) : function() {
    return null;
  };
}, Nc = "Dialog", [dA, pA] = at(Nc), [Aj, zt] = dA(Nc), hA = (e) => {
  const {
    __scopeDialog: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: a,
    modal: i = !0
  } = e, s = g.useRef(null), c = g.useRef(null), [l, f] = Pt({
    prop: n,
    defaultProp: o ?? !1,
    onChange: a,
    caller: Nc
  });
  return /* @__PURE__ */ S(
    Aj,
    {
      scope: t,
      triggerRef: s,
      contentRef: c,
      contentId: je(),
      titleId: je(),
      descriptionId: je(),
      open: l,
      onOpenChange: f,
      onOpenToggle: g.useCallback(() => f((u) => !u), [f]),
      modal: i,
      children: r
    }
  );
};
hA.displayName = Nc;
var vA = "DialogTrigger", mA = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = zt(vA, r), a = le(t, o.triggerRef);
    return /* @__PURE__ */ S(
      ae.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": xm(o.open),
        ...n,
        ref: a,
        onClick: Z(e.onClick, o.onOpenToggle)
      }
    );
  }
);
mA.displayName = vA;
var bm = "DialogPortal", [Pj, gA] = dA(bm, {
  forceMount: void 0
}), yA = (e) => {
  const { __scopeDialog: t, forceMount: r, children: n, container: o } = e, a = zt(bm, t);
  return /* @__PURE__ */ S(Pj, { scope: t, forceMount: r, children: g.Children.map(n, (i) => /* @__PURE__ */ S(Ge, { present: r || a.open, children: /* @__PURE__ */ S(ko, { asChild: !0, container: o, children: i }) })) });
};
yA.displayName = bm;
var us = "DialogOverlay", bA = g.forwardRef(
  (e, t) => {
    const r = gA(us, e.__scopeDialog), { forceMount: n = r.forceMount, ...o } = e, a = zt(us, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ S(Ge, { present: n || a.open, children: /* @__PURE__ */ S(Tj, { ...o, ref: t }) }) : null;
  }
);
bA.displayName = us;
var Ej = /* @__PURE__ */ ln("DialogOverlay.RemoveScroll"), Tj = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = zt(us, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ S(fi, { as: Ej, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ S(
        ae.div,
        {
          "data-state": xm(o.open),
          ...n,
          ref: t,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), fn = "DialogContent", wA = g.forwardRef(
  (e, t) => {
    const r = gA(fn, e.__scopeDialog), { forceMount: n = r.forceMount, ...o } = e, a = zt(fn, e.__scopeDialog);
    return /* @__PURE__ */ S(Ge, { present: n || a.open, children: a.modal ? /* @__PURE__ */ S(Cj, { ...o, ref: t }) : /* @__PURE__ */ S(Rj, { ...o, ref: t }) });
  }
);
wA.displayName = fn;
var Cj = g.forwardRef(
  (e, t) => {
    const r = zt(fn, e.__scopeDialog), n = g.useRef(null), o = le(t, r.contentRef, n);
    return g.useEffect(() => {
      const a = n.current;
      if (a) return Ic(a);
    }, []), /* @__PURE__ */ S(
      xA,
      {
        ...e,
        ref: o,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Z(e.onCloseAutoFocus, (a) => {
          var i;
          a.preventDefault(), (i = r.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: Z(e.onPointerDownOutside, (a) => {
          const i = a.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && a.preventDefault();
        }),
        onFocusOutside: Z(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), Rj = g.forwardRef(
  (e, t) => {
    const r = zt(fn, e.__scopeDialog), n = g.useRef(!1), o = g.useRef(!1);
    return /* @__PURE__ */ S(
      xA,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (n.current || (s = r.triggerRef.current) == null || s.focus(), a.preventDefault()), n.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var c, l;
          (c = e.onInteractOutside) == null || c.call(e, a), a.defaultPrevented || (n.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const i = a.target;
          ((l = r.triggerRef.current) == null ? void 0 : l.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), xA = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: o, onCloseAutoFocus: a, ...i } = e, s = zt(fn, r), c = g.useRef(null), l = le(t, c);
    return Rc(), /* @__PURE__ */ ee(ke, { children: [
      /* @__PURE__ */ S(
        ui,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: o,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ S(
            wn,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": xm(s.open),
              ...i,
              ref: l,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ ee(ke, { children: [
        /* @__PURE__ */ S(Ij, { titleId: s.titleId }),
        /* @__PURE__ */ S(kj, { contentRef: c, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), wm = "DialogTitle", SA = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = zt(wm, r);
    return /* @__PURE__ */ S(ae.h2, { id: o.titleId, ...n, ref: t });
  }
);
SA.displayName = wm;
var _A = "DialogDescription", OA = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = zt(_A, r);
    return /* @__PURE__ */ S(ae.p, { id: o.descriptionId, ...n, ref: t });
  }
);
OA.displayName = _A;
var AA = "DialogClose", PA = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = zt(AA, r);
    return /* @__PURE__ */ S(
      ae.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: Z(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
PA.displayName = AA;
function xm(e) {
  return e ? "open" : "closed";
}
var EA = "DialogTitleWarning", [Mj, TA] = RN(EA, {
  contentName: fn,
  titleName: wm,
  docsSlug: "dialog"
}), Ij = ({ titleId: e }) => {
  const t = TA(EA), r = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return g.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, Nj = "DialogDescriptionWarning", kj = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${TA(Nj).contentName}}.`;
  return g.useEffect(() => {
    var a;
    const o = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, kc = hA, Sm = mA, $c = yA, $o = bA, Do = wA, di = SA, pi = OA, jo = PA, CA = "AlertDialog", [$j] = at(CA, [
  pA
]), xr = pA(), RA = (e) => {
  const { __scopeAlertDialog: t, ...r } = e, n = xr(t);
  return /* @__PURE__ */ S(kc, { ...n, ...r, modal: !0 });
};
RA.displayName = CA;
var Dj = "AlertDialogTrigger", MA = g.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: r, ...n } = e, o = xr(r);
    return /* @__PURE__ */ S(Sm, { ...o, ...n, ref: t });
  }
);
MA.displayName = Dj;
var jj = "AlertDialogPortal", IA = (e) => {
  const { __scopeAlertDialog: t, ...r } = e, n = xr(t);
  return /* @__PURE__ */ S($c, { ...n, ...r });
};
IA.displayName = jj;
var Lj = "AlertDialogOverlay", NA = g.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: r, ...n } = e, o = xr(r);
    return /* @__PURE__ */ S($o, { ...o, ...n, ref: t });
  }
);
NA.displayName = Lj;
var Hn = "AlertDialogContent", [Bj, Fj] = $j(Hn), qj = /* @__PURE__ */ W1("AlertDialogContent"), kA = g.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: r, children: n, ...o } = e, a = xr(r), i = g.useRef(null), s = le(t, i), c = g.useRef(null);
    return /* @__PURE__ */ S(
      Mj,
      {
        contentName: Hn,
        titleName: $A,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ S(Bj, { scope: r, cancelRef: c, children: /* @__PURE__ */ ee(
          Do,
          {
            role: "alertdialog",
            ...a,
            ...o,
            ref: s,
            onOpenAutoFocus: Z(o.onOpenAutoFocus, (l) => {
              var f;
              l.preventDefault(), (f = c.current) == null || f.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (l) => l.preventDefault(),
            onInteractOutside: (l) => l.preventDefault(),
            children: [
              /* @__PURE__ */ S(qj, { children: n }),
              /* @__PURE__ */ S(Wj, { contentRef: i })
            ]
          }
        ) })
      }
    );
  }
);
kA.displayName = Hn;
var $A = "AlertDialogTitle", DA = g.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: r, ...n } = e, o = xr(r);
    return /* @__PURE__ */ S(di, { ...o, ...n, ref: t });
  }
);
DA.displayName = $A;
var jA = "AlertDialogDescription", LA = g.forwardRef((e, t) => {
  const { __scopeAlertDialog: r, ...n } = e, o = xr(r);
  return /* @__PURE__ */ S(pi, { ...o, ...n, ref: t });
});
LA.displayName = jA;
var zj = "AlertDialogAction", BA = g.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: r, ...n } = e, o = xr(r);
    return /* @__PURE__ */ S(jo, { ...o, ...n, ref: t });
  }
);
BA.displayName = zj;
var FA = "AlertDialogCancel", qA = g.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: r, ...n } = e, { cancelRef: o } = Fj(FA, r), a = xr(r), i = le(t, o);
    return /* @__PURE__ */ S(jo, { ...a, ...n, ref: i });
  }
);
qA.displayName = FA;
var Wj = ({ contentRef: e }) => {
  const t = `\`${Hn}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${Hn}\` by passing a \`${jA}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${Hn}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return g.useEffect(() => {
    var n;
    document.getElementById(
      (n = e.current) == null ? void 0 : n.getAttribute("aria-describedby")
    ) || console.warn(t);
  }, [t, e]), null;
}, Uj = RA, Hj = MA, Vj = IA, zA = NA, WA = kA, UA = BA, HA = qA, VA = DA, KA = LA;
const oJ = Uj, aJ = Hj, Kj = Vj, GA = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  zA,
  {
    className: re(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: r
  }
));
GA.displayName = zA.displayName;
const Gj = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ ee(Kj, { children: [
  /* @__PURE__ */ S(GA, {}),
  /* @__PURE__ */ S(
    WA,
    {
      ref: r,
      className: re(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border border-slate-200 bg-white p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] dark:border-slate-800 dark:bg-slate-950 sm:rounded-lg",
        e
      ),
      ...t
    }
  )
] }));
Gj.displayName = WA.displayName;
const Yj = ({
  className: e,
  ...t
}) => /* @__PURE__ */ S(
  "div",
  {
    className: re(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
);
Yj.displayName = "AlertDialogHeader";
const Xj = ({
  className: e,
  ...t
}) => /* @__PURE__ */ S(
  "div",
  {
    className: re(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
Xj.displayName = "AlertDialogFooter";
const Zj = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  VA,
  {
    ref: r,
    className: re("text-lg font-semibold", e),
    ...t
  }
));
Zj.displayName = VA.displayName;
const Jj = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  KA,
  {
    ref: r,
    className: re("text-sm text-slate-500 dark:text-slate-400", e),
    ...t
  }
));
Jj.displayName = KA.displayName;
const Qj = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  UA,
  {
    ref: r,
    className: re(tm(), e),
    ...t
  }
));
Qj.displayName = UA.displayName;
const e2 = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  HA,
  {
    ref: r,
    className: re(
      tm({ variant: "outline" }),
      "mt-2 sm:mt-0",
      e
    ),
    ...t
  }
));
e2.displayName = HA.displayName;
const t2 = kc, iJ = Sm, r2 = $c, sJ = jo, YA = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  $o,
  {
    ref: r,
    className: re(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
YA.displayName = $o.displayName;
const XA = g.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ ee(r2, { children: [
  /* @__PURE__ */ S(YA, {}),
  /* @__PURE__ */ ee(
    Do,
    {
      ref: n,
      className: re(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border border-slate-200 bg-white p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] dark:border-slate-800 dark:bg-slate-950 sm:rounded-lg",
        e
      ),
      ...r,
      children: [
        t,
        /* @__PURE__ */ ee(jo, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-slate-100 data-[state=open]:text-slate-500 dark:ring-offset-slate-950 dark:focus:ring-slate-300 dark:data-[state=open]:bg-slate-800 dark:data-[state=open]:text-slate-400", children: [
          /* @__PURE__ */ S(Co, { className: "h-4 w-4" }),
          /* @__PURE__ */ S("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
XA.displayName = Do.displayName;
const n2 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ S(
  "div",
  {
    className: re(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      e
    ),
    ...t
  }
);
n2.displayName = "DialogHeader";
const o2 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ S(
  "div",
  {
    className: re(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
o2.displayName = "DialogFooter";
const a2 = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  di,
  {
    ref: r,
    className: re(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
a2.displayName = di.displayName;
const i2 = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  pi,
  {
    ref: r,
    className: re("text-sm text-slate-500 dark:text-slate-400", e),
    ...t
  }
));
i2.displayName = pi.displayName;
var Dc = "Popover", [ZA] = at(Dc, [
  jr
]), hi = jr(), [s2, Lr] = ZA(Dc), JA = (e) => {
  const {
    __scopePopover: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: a,
    modal: i = !1
  } = e, s = hi(t), c = g.useRef(null), [l, f] = g.useState(!1), [u, d] = Pt({
    prop: n,
    defaultProp: o ?? !1,
    onChange: a,
    caller: Dc
  });
  return /* @__PURE__ */ S(ci, { ...s, children: /* @__PURE__ */ S(
    s2,
    {
      scope: t,
      contentId: je(),
      triggerRef: c,
      open: u,
      onOpenChange: d,
      onOpenToggle: g.useCallback(() => d((h) => !h), [d]),
      hasCustomAnchor: l,
      onCustomAnchorAdd: g.useCallback(() => f(!0), []),
      onCustomAnchorRemove: g.useCallback(() => f(!1), []),
      modal: i,
      children: r
    }
  ) });
};
JA.displayName = Dc;
var QA = "PopoverAnchor", c2 = g.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Lr(QA, r), a = hi(r), { onCustomAnchorAdd: i, onCustomAnchorRemove: s } = o;
    return g.useEffect(() => (i(), () => s()), [i, s]), /* @__PURE__ */ S(li, { ...a, ...n, ref: t });
  }
);
c2.displayName = QA;
var eP = "PopoverTrigger", tP = g.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Lr(eP, r), a = hi(r), i = le(t, o.triggerRef), s = /* @__PURE__ */ S(
      ae.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": iP(o.open),
        ...n,
        ref: i,
        onClick: Z(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? s : /* @__PURE__ */ S(li, { asChild: !0, ...a, children: s });
  }
);
tP.displayName = eP;
var _m = "PopoverPortal", [l2, u2] = ZA(_m, {
  forceMount: void 0
}), rP = (e) => {
  const { __scopePopover: t, forceMount: r, children: n, container: o } = e, a = Lr(_m, t);
  return /* @__PURE__ */ S(l2, { scope: t, forceMount: r, children: /* @__PURE__ */ S(Ge, { present: r || a.open, children: /* @__PURE__ */ S(ko, { asChild: !0, container: o, children: n }) }) });
};
rP.displayName = _m;
var Qn = "PopoverContent", nP = g.forwardRef(
  (e, t) => {
    const r = u2(Qn, e.__scopePopover), { forceMount: n = r.forceMount, ...o } = e, a = Lr(Qn, e.__scopePopover);
    return /* @__PURE__ */ S(Ge, { present: n || a.open, children: a.modal ? /* @__PURE__ */ S(d2, { ...o, ref: t }) : /* @__PURE__ */ S(p2, { ...o, ref: t }) });
  }
);
nP.displayName = Qn;
var f2 = /* @__PURE__ */ ln("PopoverContent.RemoveScroll"), d2 = g.forwardRef(
  (e, t) => {
    const r = Lr(Qn, e.__scopePopover), n = g.useRef(null), o = le(t, n), a = g.useRef(!1);
    return g.useEffect(() => {
      const i = n.current;
      if (i) return Ic(i);
    }, []), /* @__PURE__ */ S(fi, { as: f2, allowPinchZoom: !0, children: /* @__PURE__ */ S(
      oP,
      {
        ...e,
        ref: o,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Z(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), a.current || (s = r.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: Z(
          e.onPointerDownOutside,
          (i) => {
            const s = i.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, l = s.button === 2 || c;
            a.current = l;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: Z(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), p2 = g.forwardRef(
  (e, t) => {
    const r = Lr(Qn, e.__scopePopover), n = g.useRef(!1), o = g.useRef(!1);
    return /* @__PURE__ */ S(
      oP,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (n.current || (s = r.triggerRef.current) == null || s.focus(), a.preventDefault()), n.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var c, l;
          (c = e.onInteractOutside) == null || c.call(e, a), a.defaultPrevented || (n.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const i = a.target;
          ((l = r.triggerRef.current) == null ? void 0 : l.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), oP = g.forwardRef(
  (e, t) => {
    const {
      __scopePopover: r,
      trapFocus: n,
      onOpenAutoFocus: o,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: s,
      onPointerDownOutside: c,
      onFocusOutside: l,
      onInteractOutside: f,
      ...u
    } = e, d = Lr(Qn, r), h = hi(r);
    return Rc(), /* @__PURE__ */ S(
      ui,
      {
        asChild: !0,
        loop: !0,
        trapped: n,
        onMountAutoFocus: o,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ S(
          wn,
          {
            asChild: !0,
            disableOutsidePointerEvents: i,
            onInteractOutside: f,
            onEscapeKeyDown: s,
            onPointerDownOutside: c,
            onFocusOutside: l,
            onDismiss: () => d.onOpenChange(!1),
            children: /* @__PURE__ */ S(
              Oc,
              {
                "data-state": iP(d.open),
                role: "dialog",
                id: d.contentId,
                ...h,
                ...u,
                ref: t,
                style: {
                  ...u.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), aP = "PopoverClose", h2 = g.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Lr(aP, r);
    return /* @__PURE__ */ S(
      ae.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: Z(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
h2.displayName = aP;
var v2 = "PopoverArrow", m2 = g.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = hi(r);
    return /* @__PURE__ */ S(Ac, { ...o, ...n, ref: t });
  }
);
m2.displayName = v2;
function iP(e) {
  return e ? "open" : "closed";
}
var g2 = JA, y2 = tP, b2 = rP, sP = nP;
const cJ = g2, lJ = y2, w2 = g.forwardRef(({ className: e, align: t = "center", sideOffset: r = 4, ...n }, o) => /* @__PURE__ */ S(b2, { children: /* @__PURE__ */ S(
  sP,
  {
    ref: o,
    align: t,
    sideOffset: r,
    className: re(
      "z-50 w-72 rounded-md border border-slate-200 bg-white p-4 text-slate-950 shadow-md outline-none animate-in data-[state=open]:fade-in data-[state=open]:zoom-in-95 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50",
      e
    ),
    ...n
  }
) }));
w2.displayName = sP.displayName;
var x2 = "Portal", cP = g.forwardRef((e, t) => {
  var s;
  const { container: r, ...n } = e, [o, a] = g.useState(!1);
  Ue(() => a(!0), []);
  const i = r || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return i ? N1.createPortal(/* @__PURE__ */ S(qt.div, { ...n, ref: t }), i) : null;
});
cP.displayName = x2;
var lP = cP;
const S2 = g.forwardRef(({ className: e, container: t, children: r, ...n }, o) => /* @__PURE__ */ S(
  lP,
  {
    ref: o,
    container: t,
    ...n,
    children: e ? /* @__PURE__ */ S("div", { className: re(e), children: r }) : r
  }
));
S2.displayName = lP.displayName;
var Om = "ToastProvider", [Am, _2, O2] = ii("Toast"), [uP] = at("Toast", [O2]), [A2, jc] = uP(Om), fP = (e) => {
  const {
    __scopeToast: t,
    label: r = "Notification",
    duration: n = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: a = 50,
    children: i
  } = e, [s, c] = g.useState(null), [l, f] = g.useState(0), u = g.useRef(!1), d = g.useRef(!1);
  return r.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${Om}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ S(Am.Provider, { scope: t, children: /* @__PURE__ */ S(
    A2,
    {
      scope: t,
      label: r,
      duration: n,
      swipeDirection: o,
      swipeThreshold: a,
      toastCount: l,
      viewport: s,
      onViewportChange: c,
      onToastAdd: g.useCallback(() => f((h) => h + 1), []),
      onToastRemove: g.useCallback(() => f((h) => h - 1), []),
      isFocusedToastEscapeKeyDownRef: u,
      isClosePausedRef: d,
      children: i
    }
  ) });
};
fP.displayName = Om;
var dP = "ToastViewport", P2 = ["F8"], gh = "toast.viewportPause", yh = "toast.viewportResume", pP = g.forwardRef(
  (e, t) => {
    const {
      __scopeToast: r,
      hotkey: n = P2,
      label: o = "Notifications ({hotkey})",
      ...a
    } = e, i = jc(dP, r), s = _2(r), c = g.useRef(null), l = g.useRef(null), f = g.useRef(null), u = g.useRef(null), d = le(t, u, i.onViewportChange), h = n.join("+").replace(/Key/g, "").replace(/Digit/g, ""), m = i.toastCount > 0;
    g.useEffect(() => {
      const p = (b) => {
        var x;
        n.length !== 0 && n.every((_) => b[_] || b.code === _) && ((x = u.current) == null || x.focus());
      };
      return document.addEventListener("keydown", p), () => document.removeEventListener("keydown", p);
    }, [n]), g.useEffect(() => {
      const p = c.current, b = u.current;
      if (m && p && b) {
        const w = () => {
          if (!i.isClosePausedRef.current) {
            const O = new CustomEvent(gh);
            b.dispatchEvent(O), i.isClosePausedRef.current = !0;
          }
        }, x = () => {
          if (i.isClosePausedRef.current) {
            const O = new CustomEvent(yh);
            b.dispatchEvent(O), i.isClosePausedRef.current = !1;
          }
        }, _ = (O) => {
          !p.contains(O.relatedTarget) && x();
        }, y = () => {
          p.contains(document.activeElement) || x();
        };
        return p.addEventListener("focusin", w), p.addEventListener("focusout", _), p.addEventListener("pointermove", w), p.addEventListener("pointerleave", y), window.addEventListener("blur", w), window.addEventListener("focus", x), () => {
          p.removeEventListener("focusin", w), p.removeEventListener("focusout", _), p.removeEventListener("pointermove", w), p.removeEventListener("pointerleave", y), window.removeEventListener("blur", w), window.removeEventListener("focus", x);
        };
      }
    }, [m, i.isClosePausedRef]);
    const v = g.useCallback(
      ({ tabbingDirection: p }) => {
        const w = s().map((x) => {
          const _ = x.ref.current, y = [_, ...B2(_)];
          return p === "forwards" ? y : y.reverse();
        });
        return (p === "forwards" ? w.reverse() : w).flat();
      },
      [s]
    );
    return g.useEffect(() => {
      const p = u.current;
      if (p) {
        const b = (w) => {
          var y, O, A;
          const x = w.altKey || w.ctrlKey || w.metaKey;
          if (w.key === "Tab" && !x) {
            const P = document.activeElement, T = w.shiftKey;
            if (w.target === p && T) {
              (y = l.current) == null || y.focus();
              return;
            }
            const C = v({ tabbingDirection: T ? "backwards" : "forwards" }), R = C.findIndex((M) => M === P);
            Gl(C.slice(R + 1)) ? w.preventDefault() : T ? (O = l.current) == null || O.focus() : (A = f.current) == null || A.focus();
          }
        };
        return p.addEventListener("keydown", b), () => p.removeEventListener("keydown", b);
      }
    }, [s, v]), /* @__PURE__ */ ee(
      Uk,
      {
        ref: c,
        role: "region",
        "aria-label": o.replace("{hotkey}", h),
        tabIndex: -1,
        style: { pointerEvents: m ? void 0 : "none" },
        children: [
          m && /* @__PURE__ */ S(
            bh,
            {
              ref: l,
              onFocusFromOutsideViewport: () => {
                const p = v({
                  tabbingDirection: "forwards"
                });
                Gl(p);
              }
            }
          ),
          /* @__PURE__ */ S(Am.Slot, { scope: r, children: /* @__PURE__ */ S(ae.ol, { tabIndex: -1, ...a, ref: d }) }),
          m && /* @__PURE__ */ S(
            bh,
            {
              ref: f,
              onFocusFromOutsideViewport: () => {
                const p = v({
                  tabbingDirection: "backwards"
                });
                Gl(p);
              }
            }
          )
        ]
      }
    );
  }
);
pP.displayName = dP;
var hP = "ToastFocusProxy", bh = g.forwardRef(
  (e, t) => {
    const { __scopeToast: r, onFocusFromOutsideViewport: n, ...o } = e, a = jc(hP, r);
    return /* @__PURE__ */ S(
      Pc,
      {
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (i) => {
          var l;
          const s = i.relatedTarget;
          !((l = a.viewport) != null && l.contains(s)) && n();
        }
      }
    );
  }
);
bh.displayName = hP;
var vi = "Toast", E2 = "toast.swipeStart", T2 = "toast.swipeMove", C2 = "toast.swipeCancel", R2 = "toast.swipeEnd", vP = g.forwardRef(
  (e, t) => {
    const { forceMount: r, open: n, defaultOpen: o, onOpenChange: a, ...i } = e, [s, c] = Pt({
      prop: n,
      defaultProp: o ?? !0,
      onChange: a,
      caller: vi
    });
    return /* @__PURE__ */ S(Ge, { present: r || s, children: /* @__PURE__ */ S(
      N2,
      {
        open: s,
        ...i,
        ref: t,
        onClose: () => c(!1),
        onPause: $e(e.onPause),
        onResume: $e(e.onResume),
        onSwipeStart: Z(e.onSwipeStart, (l) => {
          l.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: Z(e.onSwipeMove, (l) => {
          const { x: f, y: u } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "move"), l.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${f}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${u}px`);
        }),
        onSwipeCancel: Z(e.onSwipeCancel, (l) => {
          l.currentTarget.setAttribute("data-swipe", "cancel"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: Z(e.onSwipeEnd, (l) => {
          const { x: f, y: u } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "end"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${f}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${u}px`), c(!1);
        })
      }
    ) });
  }
);
vP.displayName = vi;
var [M2, I2] = uP(vi, {
  onClose() {
  }
}), N2 = g.forwardRef(
  (e, t) => {
    const {
      __scopeToast: r,
      type: n = "foreground",
      duration: o,
      open: a,
      onClose: i,
      onEscapeKeyDown: s,
      onPause: c,
      onResume: l,
      onSwipeStart: f,
      onSwipeMove: u,
      onSwipeCancel: d,
      onSwipeEnd: h,
      ...m
    } = e, v = jc(vi, r), [p, b] = g.useState(null), w = le(t, (M) => b(M)), x = g.useRef(null), _ = g.useRef(null), y = o || v.duration, O = g.useRef(0), A = g.useRef(y), P = g.useRef(0), { onToastAdd: T, onToastRemove: I } = v, E = $e(() => {
      var D;
      (p == null ? void 0 : p.contains(document.activeElement)) && ((D = v.viewport) == null || D.focus()), i();
    }), C = g.useCallback(
      (M) => {
        !M || M === 1 / 0 || (window.clearTimeout(P.current), O.current = (/* @__PURE__ */ new Date()).getTime(), P.current = window.setTimeout(E, M));
      },
      [E]
    );
    g.useEffect(() => {
      const M = v.viewport;
      if (M) {
        const D = () => {
          C(A.current), l == null || l();
        }, $ = () => {
          const q = (/* @__PURE__ */ new Date()).getTime() - O.current;
          A.current = A.current - q, window.clearTimeout(P.current), c == null || c();
        };
        return M.addEventListener(gh, $), M.addEventListener(yh, D), () => {
          M.removeEventListener(gh, $), M.removeEventListener(yh, D);
        };
      }
    }, [v.viewport, y, c, l, C]), g.useEffect(() => {
      a && !v.isClosePausedRef.current && C(y);
    }, [a, y, v.isClosePausedRef, C]), g.useEffect(() => (T(), () => I()), [T, I]);
    const R = g.useMemo(() => p ? SP(p) : null, [p]);
    return v.viewport ? /* @__PURE__ */ ee(ke, { children: [
      R && /* @__PURE__ */ S(
        k2,
        {
          __scopeToast: r,
          role: "status",
          "aria-live": n === "foreground" ? "assertive" : "polite",
          children: R
        }
      ),
      /* @__PURE__ */ S(M2, { scope: r, onClose: E, children: oi.createPortal(
        /* @__PURE__ */ S(Am.ItemSlot, { scope: r, children: /* @__PURE__ */ S(
          Wk,
          {
            asChild: !0,
            onEscapeKeyDown: Z(s, () => {
              v.isFocusedToastEscapeKeyDownRef.current || E(), v.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ S(
              ae.li,
              {
                tabIndex: 0,
                "data-state": a ? "open" : "closed",
                "data-swipe-direction": v.swipeDirection,
                ...m,
                ref: w,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: Z(e.onKeyDown, (M) => {
                  M.key === "Escape" && (s == null || s(M.nativeEvent), M.nativeEvent.defaultPrevented || (v.isFocusedToastEscapeKeyDownRef.current = !0, E()));
                }),
                onPointerDown: Z(e.onPointerDown, (M) => {
                  M.button === 0 && (x.current = { x: M.clientX, y: M.clientY });
                }),
                onPointerMove: Z(e.onPointerMove, (M) => {
                  if (!x.current) return;
                  const D = M.clientX - x.current.x, $ = M.clientY - x.current.y, q = !!_.current, F = ["left", "right"].includes(v.swipeDirection), B = ["left", "up"].includes(v.swipeDirection) ? Math.min : Math.max, L = F ? B(0, D) : 0, z = F ? 0 : B(0, $), N = M.pointerType === "touch" ? 10 : 2, U = { x: L, y: z }, K = { originalEvent: M, delta: U };
                  q ? (_.current = U, Li(T2, u, K, {
                    discrete: !1
                  })) : Sy(U, v.swipeDirection, N) ? (_.current = U, Li(E2, f, K, {
                    discrete: !1
                  }), M.target.setPointerCapture(M.pointerId)) : (Math.abs(D) > N || Math.abs($) > N) && (x.current = null);
                }),
                onPointerUp: Z(e.onPointerUp, (M) => {
                  const D = _.current, $ = M.target;
                  if ($.hasPointerCapture(M.pointerId) && $.releasePointerCapture(M.pointerId), _.current = null, x.current = null, D) {
                    const q = M.currentTarget, F = { originalEvent: M, delta: D };
                    Sy(D, v.swipeDirection, v.swipeThreshold) ? Li(R2, h, F, {
                      discrete: !0
                    }) : Li(
                      C2,
                      d,
                      F,
                      {
                        discrete: !0
                      }
                    ), q.addEventListener("click", (B) => B.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        v.viewport
      ) })
    ] }) : null;
  }
), k2 = (e) => {
  const { __scopeToast: t, children: r, ...n } = e, o = jc(vi, t), [a, i] = g.useState(!1), [s, c] = g.useState(!1);
  return j2(() => i(!0)), g.useEffect(() => {
    const l = window.setTimeout(() => c(!0), 1e3);
    return () => window.clearTimeout(l);
  }, []), s ? null : /* @__PURE__ */ S(ko, { asChild: !0, children: /* @__PURE__ */ S(Pc, { ...n, children: a && /* @__PURE__ */ ee(ke, { children: [
    o.label,
    " ",
    r
  ] }) }) });
}, $2 = "ToastTitle", mP = g.forwardRef(
  (e, t) => {
    const { __scopeToast: r, ...n } = e;
    return /* @__PURE__ */ S(ae.div, { ...n, ref: t });
  }
);
mP.displayName = $2;
var D2 = "ToastDescription", gP = g.forwardRef(
  (e, t) => {
    const { __scopeToast: r, ...n } = e;
    return /* @__PURE__ */ S(ae.div, { ...n, ref: t });
  }
);
gP.displayName = D2;
var yP = "ToastAction", bP = g.forwardRef(
  (e, t) => {
    const { altText: r, ...n } = e;
    return r.trim() ? /* @__PURE__ */ S(xP, { altText: r, asChild: !0, children: /* @__PURE__ */ S(Pm, { ...n, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${yP}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
bP.displayName = yP;
var wP = "ToastClose", Pm = g.forwardRef(
  (e, t) => {
    const { __scopeToast: r, ...n } = e, o = I2(wP, r);
    return /* @__PURE__ */ S(xP, { asChild: !0, children: /* @__PURE__ */ S(
      ae.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: Z(e.onClick, o.onClose)
      }
    ) });
  }
);
Pm.displayName = wP;
var xP = g.forwardRef((e, t) => {
  const { __scopeToast: r, altText: n, ...o } = e;
  return /* @__PURE__ */ S(
    ae.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": n || void 0,
      ...o,
      ref: t
    }
  );
});
function SP(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((n) => {
    if (n.nodeType === n.TEXT_NODE && n.textContent && t.push(n.textContent), L2(n)) {
      const o = n.ariaHidden || n.hidden || n.style.display === "none", a = n.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (a) {
          const i = n.dataset.radixToastAnnounceAlt;
          i && t.push(i);
        } else
          t.push(...SP(n));
    }
  }), t;
}
function Li(e, t, r, { discrete: n }) {
  const o = r.originalEvent.currentTarget, a = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: r });
  t && o.addEventListener(e, t, { once: !0 }), n ? om(o, a) : o.dispatchEvent(a);
}
var Sy = (e, t, r = 0) => {
  const n = Math.abs(e.x), o = Math.abs(e.y), a = n > o;
  return t === "left" || t === "right" ? a && n > r : !a && o > r;
};
function j2(e = () => {
}) {
  const t = $e(e);
  Ue(() => {
    let r = 0, n = 0;
    return r = window.requestAnimationFrame(() => n = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(r), window.cancelAnimationFrame(n);
    };
  }, [t]);
}
function L2(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function B2(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Gl(e) {
  const t = document.activeElement;
  return e.some((r) => r === t ? !0 : (r.focus(), document.activeElement !== t));
}
var F2 = fP, _P = pP, OP = vP, AP = mP, PP = gP, EP = bP, TP = Pm;
const uJ = F2, q2 = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  _P,
  {
    ref: r,
    className: re(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
q2.displayName = _P.displayName;
const z2 = ai(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border border-slate-200 p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full dark:border-slate-800",
  {
    variants: {
      variant: {
        default: "border bg-white text-slate-950 dark:bg-slate-950 dark:text-slate-50",
        destructive: "destructive group border-red-500 bg-red-600 text-slate-50 dark:border-red-900 dark:bg-red-900 dark:text-slate-50"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), W2 = g.forwardRef(({ className: e, variant: t, ...r }, n) => /* @__PURE__ */ S(
  OP,
  {
    ref: n,
    className: re(z2({ variant: t }), e),
    ...r
  }
));
W2.displayName = OP.displayName;
const U2 = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  EP,
  {
    ref: r,
    className: re(
      "inline-flex h-8 shrink-0 items-center justify-center rounded-md border border-slate-200 bg-transparent px-3 text-sm font-medium ring-offset-white transition-colors hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-slate-100/40 group-[.destructive]:hover:border-red-500/30 group-[.destructive]:hover:bg-red-500 group-[.destructive]:hover:text-slate-50 group-[.destructive]:focus:ring-red-500 dark:border-slate-800 dark:ring-offset-slate-950 dark:hover:bg-slate-800 dark:focus:ring-slate-300 dark:group-[.destructive]:border-slate-800/40 dark:group-[.destructive]:hover:border-red-900/30 dark:group-[.destructive]:hover:bg-red-900 dark:group-[.destructive]:hover:text-slate-50 dark:group-[.destructive]:focus:ring-red-900",
      e
    ),
    ...t
  }
));
U2.displayName = EP.displayName;
const H2 = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  TP,
  {
    ref: r,
    className: re(
      "absolute right-2 top-2 rounded-md p-1 text-slate-950/50 opacity-0 transition-opacity hover:text-slate-950 focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600 dark:text-slate-50/50 dark:hover:text-slate-50",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ S(Co, { className: "h-4 w-4" })
  }
));
H2.displayName = TP.displayName;
const V2 = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  AP,
  {
    ref: r,
    className: re("text-sm font-semibold", e),
    ...t
  }
));
V2.displayName = AP.displayName;
const K2 = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  PP,
  {
    ref: r,
    className: re("text-sm opacity-90", e),
    ...t
  }
));
K2.displayName = PP.displayName;
function G2(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), o, a;
  for (a = 0; a < n.length; a++)
    o = n[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
var Y2 = ["color"], X2 = /* @__PURE__ */ ni(function(e, t) {
  var r = e.color, n = r === void 0 ? "currentColor" : r, o = G2(e, Y2);
  return cn("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: t
  }), cn("path", {
    d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159Z",
    fill: n,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), _y = 1, Z2 = 0.9, J2 = 0.8, Q2 = 0.17, Yl = 0.1, Xl = 0.999, eL = 0.9999, tL = 0.99, rL = /[\\\/_+.#"@\[\(\{&]/, nL = /[\\\/_+.#"@\[\(\{&]/g, oL = /[\s-]/, CP = /[\s-]/g;
function wh(e, t, r, n, o, a, i) {
  if (a === t.length) return o === e.length ? _y : tL;
  var s = `${o},${a}`;
  if (i[s] !== void 0) return i[s];
  for (var c = n.charAt(a), l = r.indexOf(c, o), f = 0, u, d, h, m; l >= 0; ) u = wh(e, t, r, n, l + 1, a + 1, i), u > f && (l === o ? u *= _y : rL.test(e.charAt(l - 1)) ? (u *= J2, h = e.slice(o, l - 1).match(nL), h && o > 0 && (u *= Math.pow(Xl, h.length))) : oL.test(e.charAt(l - 1)) ? (u *= Z2, m = e.slice(o, l - 1).match(CP), m && o > 0 && (u *= Math.pow(Xl, m.length))) : (u *= Q2, o > 0 && (u *= Math.pow(Xl, l - o))), e.charAt(l) !== t.charAt(a) && (u *= eL)), (u < Yl && r.charAt(l - 1) === n.charAt(a + 1) || n.charAt(a + 1) === n.charAt(a) && r.charAt(l - 1) !== n.charAt(a)) && (d = wh(e, t, r, n, l + 1, a + 2, i), d * Yl > u && (u = d * Yl)), u > f && (f = u), l = r.indexOf(c, l + 1);
  return i[s] = f, f;
}
function Oy(e) {
  return e.toLowerCase().replace(CP, " ");
}
function aL(e, t, r) {
  return e = r && r.length > 0 ? `${e + " " + r.join(" ")}` : e, wh(e, t, Oy(e), Oy(t), 0, 0, {});
}
var Yo = '[cmdk-group=""]', Zl = '[cmdk-group-items=""]', iL = '[cmdk-group-heading=""]', RP = '[cmdk-item=""]', Ay = `${RP}:not([aria-disabled="true"])`, xh = "cmdk-item-select", kn = "data-value", sL = (e, t, r) => aL(e, t, r), MP = g.createContext(void 0), mi = () => g.useContext(MP), IP = g.createContext(void 0), Em = () => g.useContext(IP), NP = g.createContext(void 0), kP = g.forwardRef((e, t) => {
  let r = $n(() => {
    var N, U;
    return { search: "", value: (U = (N = e.value) != null ? N : e.defaultValue) != null ? U : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), n = $n(() => /* @__PURE__ */ new Set()), o = $n(() => /* @__PURE__ */ new Map()), a = $n(() => /* @__PURE__ */ new Map()), i = $n(() => /* @__PURE__ */ new Set()), s = $P(e), { label: c, children: l, value: f, onValueChange: u, filter: d, shouldFilter: h, loop: m, disablePointerSelection: v = !1, vimBindings: p = !0, ...b } = e, w = je(), x = je(), _ = je(), y = g.useRef(null), O = yL();
  dn(() => {
    if (f !== void 0) {
      let N = f.trim();
      r.current.value = N, A.emit();
    }
  }, [f]), dn(() => {
    O(6, R);
  }, []);
  let A = g.useMemo(() => ({ subscribe: (N) => (i.current.add(N), () => i.current.delete(N)), snapshot: () => r.current, setState: (N, U, K) => {
    var G, J, V, Q;
    if (!Object.is(r.current[N], U)) {
      if (r.current[N] = U, N === "search") C(), I(), O(1, E);
      else if (N === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let W = document.getElementById(_);
          W ? W.focus() : (G = document.getElementById(w)) == null || G.focus();
        }
        if (O(7, () => {
          var W;
          r.current.selectedItemId = (W = M()) == null ? void 0 : W.id, A.emit();
        }), K || O(5, R), ((J = s.current) == null ? void 0 : J.value) !== void 0) {
          let W = U ?? "";
          (Q = (V = s.current).onValueChange) == null || Q.call(V, W);
          return;
        }
      }
      A.emit();
    }
  }, emit: () => {
    i.current.forEach((N) => N());
  } }), []), P = g.useMemo(() => ({ value: (N, U, K) => {
    var G;
    U !== ((G = a.current.get(N)) == null ? void 0 : G.value) && (a.current.set(N, { value: U, keywords: K }), r.current.filtered.items.set(N, T(U, K)), O(2, () => {
      I(), A.emit();
    }));
  }, item: (N, U) => (n.current.add(N), U && (o.current.has(U) ? o.current.get(U).add(N) : o.current.set(U, /* @__PURE__ */ new Set([N]))), O(3, () => {
    C(), I(), r.current.value || E(), A.emit();
  }), () => {
    a.current.delete(N), n.current.delete(N), r.current.filtered.items.delete(N);
    let K = M();
    O(4, () => {
      C(), (K == null ? void 0 : K.getAttribute("id")) === N && E(), A.emit();
    });
  }), group: (N) => (o.current.has(N) || o.current.set(N, /* @__PURE__ */ new Set()), () => {
    a.current.delete(N), o.current.delete(N);
  }), filter: () => s.current.shouldFilter, label: c || e["aria-label"], getDisablePointerSelection: () => s.current.disablePointerSelection, listId: w, inputId: _, labelId: x, listInnerRef: y }), []);
  function T(N, U) {
    var K, G;
    let J = (G = (K = s.current) == null ? void 0 : K.filter) != null ? G : sL;
    return N ? J(N, r.current.search, U) : 0;
  }
  function I() {
    if (!r.current.search || s.current.shouldFilter === !1) return;
    let N = r.current.filtered.items, U = [];
    r.current.filtered.groups.forEach((G) => {
      let J = o.current.get(G), V = 0;
      J.forEach((Q) => {
        let W = N.get(Q);
        V = Math.max(W, V);
      }), U.push([G, V]);
    });
    let K = y.current;
    D().sort((G, J) => {
      var V, Q;
      let W = G.getAttribute("id"), Y = J.getAttribute("id");
      return ((V = N.get(Y)) != null ? V : 0) - ((Q = N.get(W)) != null ? Q : 0);
    }).forEach((G) => {
      let J = G.closest(Zl);
      J ? J.appendChild(G.parentElement === J ? G : G.closest(`${Zl} > *`)) : K.appendChild(G.parentElement === K ? G : G.closest(`${Zl} > *`));
    }), U.sort((G, J) => J[1] - G[1]).forEach((G) => {
      var J;
      let V = (J = y.current) == null ? void 0 : J.querySelector(`${Yo}[${kn}="${encodeURIComponent(G[0])}"]`);
      V == null || V.parentElement.appendChild(V);
    });
  }
  function E() {
    let N = D().find((K) => K.getAttribute("aria-disabled") !== "true"), U = N == null ? void 0 : N.getAttribute(kn);
    A.setState("value", U || void 0);
  }
  function C() {
    var N, U, K, G;
    if (!r.current.search || s.current.shouldFilter === !1) {
      r.current.filtered.count = n.current.size;
      return;
    }
    r.current.filtered.groups = /* @__PURE__ */ new Set();
    let J = 0;
    for (let V of n.current) {
      let Q = (U = (N = a.current.get(V)) == null ? void 0 : N.value) != null ? U : "", W = (G = (K = a.current.get(V)) == null ? void 0 : K.keywords) != null ? G : [], Y = T(Q, W);
      r.current.filtered.items.set(V, Y), Y > 0 && J++;
    }
    for (let [V, Q] of o.current) for (let W of Q) if (r.current.filtered.items.get(W) > 0) {
      r.current.filtered.groups.add(V);
      break;
    }
    r.current.filtered.count = J;
  }
  function R() {
    var N, U, K;
    let G = M();
    G && (((N = G.parentElement) == null ? void 0 : N.firstChild) === G && ((K = (U = G.closest(Yo)) == null ? void 0 : U.querySelector(iL)) == null || K.scrollIntoView({ block: "nearest" })), G.scrollIntoView({ block: "nearest" }));
  }
  function M() {
    var N;
    return (N = y.current) == null ? void 0 : N.querySelector(`${RP}[aria-selected="true"]`);
  }
  function D() {
    var N;
    return Array.from(((N = y.current) == null ? void 0 : N.querySelectorAll(Ay)) || []);
  }
  function $(N) {
    let U = D()[N];
    U && A.setState("value", U.getAttribute(kn));
  }
  function q(N) {
    var U;
    let K = M(), G = D(), J = G.findIndex((Q) => Q === K), V = G[J + N];
    (U = s.current) != null && U.loop && (V = J + N < 0 ? G[G.length - 1] : J + N === G.length ? G[0] : G[J + N]), V && A.setState("value", V.getAttribute(kn));
  }
  function F(N) {
    let U = M(), K = U == null ? void 0 : U.closest(Yo), G;
    for (; K && !G; ) K = N > 0 ? mL(K, Yo) : gL(K, Yo), G = K == null ? void 0 : K.querySelector(Ay);
    G ? A.setState("value", G.getAttribute(kn)) : q(N);
  }
  let B = () => $(D().length - 1), L = (N) => {
    N.preventDefault(), N.metaKey ? B() : N.altKey ? F(1) : q(1);
  }, z = (N) => {
    N.preventDefault(), N.metaKey ? $(0) : N.altKey ? F(-1) : q(-1);
  };
  return g.createElement(qt.div, { ref: t, tabIndex: -1, ...b, "cmdk-root": "", onKeyDown: (N) => {
    var U;
    (U = b.onKeyDown) == null || U.call(b, N);
    let K = N.nativeEvent.isComposing || N.keyCode === 229;
    if (!(N.defaultPrevented || K)) switch (N.key) {
      case "n":
      case "j": {
        p && N.ctrlKey && L(N);
        break;
      }
      case "ArrowDown": {
        L(N);
        break;
      }
      case "p":
      case "k": {
        p && N.ctrlKey && z(N);
        break;
      }
      case "ArrowUp": {
        z(N);
        break;
      }
      case "Home": {
        N.preventDefault(), $(0);
        break;
      }
      case "End": {
        N.preventDefault(), B();
        break;
      }
      case "Enter": {
        N.preventDefault();
        let G = M();
        if (G) {
          let J = new Event(xh);
          G.dispatchEvent(J);
        }
      }
    }
  } }, g.createElement("label", { "cmdk-label": "", htmlFor: P.inputId, id: P.labelId, style: wL }, c), Lc(e, (N) => g.createElement(IP.Provider, { value: A }, g.createElement(MP.Provider, { value: P }, N))));
}), cL = g.forwardRef((e, t) => {
  var r, n;
  let o = je(), a = g.useRef(null), i = g.useContext(NP), s = mi(), c = $P(e), l = (n = (r = c.current) == null ? void 0 : r.forceMount) != null ? n : i == null ? void 0 : i.forceMount;
  dn(() => {
    if (!l) return s.item(o, i == null ? void 0 : i.id);
  }, [l]);
  let f = DP(o, a, [e.value, e.children, a], e.keywords), u = Em(), d = $r((O) => O.value && O.value === f.current), h = $r((O) => l || s.filter() === !1 ? !0 : O.search ? O.filtered.items.get(o) > 0 : !0);
  g.useEffect(() => {
    let O = a.current;
    if (!(!O || e.disabled)) return O.addEventListener(xh, m), () => O.removeEventListener(xh, m);
  }, [h, e.onSelect, e.disabled]);
  function m() {
    var O, A;
    v(), (A = (O = c.current).onSelect) == null || A.call(O, f.current);
  }
  function v() {
    u.setState("value", f.current, !0);
  }
  if (!h) return null;
  let { disabled: p, value: b, onSelect: w, forceMount: x, keywords: _, ...y } = e;
  return g.createElement(qt.div, { ref: Zt(a, t), ...y, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!p, "aria-selected": !!d, "data-disabled": !!p, "data-selected": !!d, onPointerMove: p || s.getDisablePointerSelection() ? void 0 : v, onClick: p ? void 0 : m }, e.children);
}), lL = g.forwardRef((e, t) => {
  let { heading: r, children: n, forceMount: o, ...a } = e, i = je(), s = g.useRef(null), c = g.useRef(null), l = je(), f = mi(), u = $r((h) => o || f.filter() === !1 ? !0 : h.search ? h.filtered.groups.has(i) : !0);
  dn(() => f.group(i), []), DP(i, s, [e.value, e.heading, c]);
  let d = g.useMemo(() => ({ id: i, forceMount: o }), [o]);
  return g.createElement(qt.div, { ref: Zt(s, t), ...a, "cmdk-group": "", role: "presentation", hidden: u ? void 0 : !0 }, r && g.createElement("div", { ref: c, "cmdk-group-heading": "", "aria-hidden": !0, id: l }, r), Lc(e, (h) => g.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": r ? l : void 0 }, g.createElement(NP.Provider, { value: d }, h))));
}), uL = g.forwardRef((e, t) => {
  let { alwaysRender: r, ...n } = e, o = g.useRef(null), a = $r((i) => !i.search);
  return !r && !a ? null : g.createElement(qt.div, { ref: Zt(o, t), ...n, "cmdk-separator": "", role: "separator" });
}), fL = g.forwardRef((e, t) => {
  let { onValueChange: r, ...n } = e, o = e.value != null, a = Em(), i = $r((l) => l.search), s = $r((l) => l.selectedItemId), c = mi();
  return g.useEffect(() => {
    e.value != null && a.setState("search", e.value);
  }, [e.value]), g.createElement(qt.input, { ref: t, ...n, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": c.listId, "aria-labelledby": c.labelId, "aria-activedescendant": s, id: c.inputId, type: "text", value: o ? e.value : i, onChange: (l) => {
    o || a.setState("search", l.target.value), r == null || r(l.target.value);
  } });
}), dL = g.forwardRef((e, t) => {
  let { children: r, label: n = "Suggestions", ...o } = e, a = g.useRef(null), i = g.useRef(null), s = $r((l) => l.selectedItemId), c = mi();
  return g.useEffect(() => {
    if (i.current && a.current) {
      let l = i.current, f = a.current, u, d = new ResizeObserver(() => {
        u = requestAnimationFrame(() => {
          let h = l.offsetHeight;
          f.style.setProperty("--cmdk-list-height", h.toFixed(1) + "px");
        });
      });
      return d.observe(l), () => {
        cancelAnimationFrame(u), d.unobserve(l);
      };
    }
  }, []), g.createElement(qt.div, { ref: Zt(a, t), ...o, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": s, "aria-label": n, id: c.listId }, Lc(e, (l) => g.createElement("div", { ref: Zt(i, c.listInnerRef), "cmdk-list-sizer": "" }, l)));
}), pL = g.forwardRef((e, t) => {
  let { open: r, onOpenChange: n, overlayClassName: o, contentClassName: a, container: i, ...s } = e;
  return g.createElement(kc, { open: r, onOpenChange: n }, g.createElement($c, { container: i }, g.createElement($o, { "cmdk-overlay": "", className: o }), g.createElement(Do, { "aria-label": e.label, "cmdk-dialog": "", className: a }, g.createElement(kP, { ref: t, ...s }))));
}), hL = g.forwardRef((e, t) => $r((r) => r.filtered.count === 0) ? g.createElement(qt.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), vL = g.forwardRef((e, t) => {
  let { progress: r, children: n, label: o = "Loading...", ...a } = e;
  return g.createElement(qt.div, { ref: t, ...a, "cmdk-loading": "", role: "progressbar", "aria-valuenow": r, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, Lc(e, (i) => g.createElement("div", { "aria-hidden": !0 }, i)));
}), ct = Object.assign(kP, { List: dL, Item: cL, Input: fL, Group: lL, Separator: uL, Dialog: pL, Empty: hL, Loading: vL });
function mL(e, t) {
  let r = e.nextElementSibling;
  for (; r; ) {
    if (r.matches(t)) return r;
    r = r.nextElementSibling;
  }
}
function gL(e, t) {
  let r = e.previousElementSibling;
  for (; r; ) {
    if (r.matches(t)) return r;
    r = r.previousElementSibling;
  }
}
function $P(e) {
  let t = g.useRef(e);
  return dn(() => {
    t.current = e;
  }), t;
}
var dn = typeof window > "u" ? g.useEffect : g.useLayoutEffect;
function $n(e) {
  let t = g.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function $r(e) {
  let t = Em(), r = () => e(t.snapshot());
  return g.useSyncExternalStore(t.subscribe, r, r);
}
function DP(e, t, r, n = []) {
  let o = g.useRef(), a = mi();
  return dn(() => {
    var i;
    let s = (() => {
      var l;
      for (let f of r) {
        if (typeof f == "string") return f.trim();
        if (typeof f == "object" && "current" in f) return f.current ? (l = f.current.textContent) == null ? void 0 : l.trim() : o.current;
      }
    })(), c = n.map((l) => l.trim());
    a.value(e, s, c), (i = t.current) == null || i.setAttribute(kn, s), o.current = s;
  }), o;
}
var yL = () => {
  let [e, t] = g.useState(), r = $n(() => /* @__PURE__ */ new Map());
  return dn(() => {
    r.current.forEach((n) => n()), r.current = /* @__PURE__ */ new Map();
  }, [e]), (n, o) => {
    r.current.set(n, o), t({});
  };
};
function bL(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function Lc({ asChild: e, children: t }, r) {
  return e && g.isValidElement(t) ? g.cloneElement(bL(t), { ref: t.ref }, r(t.props.children)) : r(t);
}
var wL = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const jP = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  ct,
  {
    ref: r,
    className: re(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-white text-slate-950 dark:bg-slate-950 dark:text-slate-50",
      e
    ),
    ...t
  }
));
jP.displayName = ct.displayName;
const fJ = ({ children: e, ...t }) => /* @__PURE__ */ S(t2, { ...t, children: /* @__PURE__ */ S(XA, { className: "overflow-hidden p-0", children: /* @__PURE__ */ S(jP, { className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-slate-500 [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5 dark:[&_[cmdk-group-heading]]:text-slate-400", children: e }) }) }), xL = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ ee("div", { className: "flex items-center border-b border-slate-200 px-3 dark:border-slate-800", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ S(X2, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
  /* @__PURE__ */ S(
    ct.Input,
    {
      ref: r,
      className: re(
        "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-slate-500 disabled:cursor-not-allowed disabled:opacity-50 dark:placeholder:text-slate-400",
        e
      ),
      ...t
    }
  )
] }));
xL.displayName = ct.Input.displayName;
const SL = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  ct.List,
  {
    ref: r,
    className: re("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
    ...t
  }
));
SL.displayName = ct.List.displayName;
const _L = g.forwardRef((e, t) => /* @__PURE__ */ S(
  ct.Empty,
  {
    ref: t,
    className: "py-6 text-center text-sm",
    ...e
  }
));
_L.displayName = ct.Empty.displayName;
const OL = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  ct.Group,
  {
    ref: r,
    className: re(
      "overflow-hidden p-1 text-slate-950 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-slate-500 dark:text-slate-50 dark:[&_[cmdk-group-heading]]:text-slate-400",
      e
    ),
    ...t
  }
));
OL.displayName = ct.Group.displayName;
const AL = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  ct.Separator,
  {
    ref: r,
    className: re("-mx-1 h-px bg-slate-200 dark:bg-slate-800", e),
    ...t
  }
));
AL.displayName = ct.Separator.displayName;
const PL = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  ct.Item,
  {
    ref: r,
    className: re(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none aria-selected:bg-slate-100 aria-selected:text-slate-900 data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50 dark:aria-selected:bg-slate-800 dark:aria-selected:text-slate-50",
      e
    ),
    ...t
  }
));
PL.displayName = ct.Item.displayName;
const EL = ({
  className: e,
  ...t
}) => /* @__PURE__ */ S(
  "span",
  {
    className: re(
      "ml-auto text-xs tracking-widest text-slate-500 dark:text-slate-400",
      e
    ),
    ...t
  }
);
EL.displayName = "CommandShortcut";
var Jl = "rovingFocusGroup.onEntryFocus", TL = { bubbles: !1, cancelable: !0 }, gi = "RovingFocusGroup", [Sh, LP, CL] = ii(gi), [RL, Bc] = at(
  gi,
  [CL]
), [ML, IL] = RL(gi), BP = g.forwardRef(
  (e, t) => /* @__PURE__ */ S(Sh.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ S(Sh.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ S(NL, { ...e, ref: t }) }) })
);
BP.displayName = gi;
var NL = g.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: r,
    orientation: n,
    loop: o = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: c,
    onEntryFocus: l,
    preventScrollOnEntryFocus: f = !1,
    ...u
  } = e, d = g.useRef(null), h = le(t, d), m = Ro(a), [v, p] = Pt({
    prop: i,
    defaultProp: s ?? null,
    onChange: c,
    caller: gi
  }), [b, w] = g.useState(!1), x = $e(l), _ = LP(r), y = g.useRef(!1), [O, A] = g.useState(0);
  return g.useEffect(() => {
    const P = d.current;
    if (P)
      return P.addEventListener(Jl, x), () => P.removeEventListener(Jl, x);
  }, [x]), /* @__PURE__ */ S(
    ML,
    {
      scope: r,
      orientation: n,
      dir: m,
      loop: o,
      currentTabStopId: v,
      onItemFocus: g.useCallback(
        (P) => p(P),
        [p]
      ),
      onItemShiftTab: g.useCallback(() => w(!0), []),
      onFocusableItemAdd: g.useCallback(
        () => A((P) => P + 1),
        []
      ),
      onFocusableItemRemove: g.useCallback(
        () => A((P) => P - 1),
        []
      ),
      children: /* @__PURE__ */ S(
        ae.div,
        {
          tabIndex: b || O === 0 ? -1 : 0,
          "data-orientation": n,
          ...u,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: Z(e.onMouseDown, () => {
            y.current = !0;
          }),
          onFocus: Z(e.onFocus, (P) => {
            const T = !y.current;
            if (P.target === P.currentTarget && T && !b) {
              const I = new CustomEvent(Jl, TL);
              if (P.currentTarget.dispatchEvent(I), !I.defaultPrevented) {
                const E = _().filter(($) => $.focusable), C = E.find(($) => $.active), R = E.find(($) => $.id === v), D = [C, R, ...E].filter(
                  Boolean
                ).map(($) => $.ref.current);
                zP(D, f);
              }
            }
            y.current = !1;
          }),
          onBlur: Z(e.onBlur, () => w(!1))
        }
      )
    }
  );
}), FP = "RovingFocusGroupItem", qP = g.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: r,
      focusable: n = !0,
      active: o = !1,
      tabStopId: a,
      children: i,
      ...s
    } = e, c = je(), l = a || c, f = IL(FP, r), u = f.currentTabStopId === l, d = LP(r), { onFocusableItemAdd: h, onFocusableItemRemove: m, currentTabStopId: v } = f;
    return g.useEffect(() => {
      if (n)
        return h(), () => m();
    }, [n, h, m]), /* @__PURE__ */ S(
      Sh.ItemSlot,
      {
        scope: r,
        id: l,
        focusable: n,
        active: o,
        children: /* @__PURE__ */ S(
          ae.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": f.orientation,
            ...s,
            ref: t,
            onMouseDown: Z(e.onMouseDown, (p) => {
              n ? f.onItemFocus(l) : p.preventDefault();
            }),
            onFocus: Z(e.onFocus, () => f.onItemFocus(l)),
            onKeyDown: Z(e.onKeyDown, (p) => {
              if (p.key === "Tab" && p.shiftKey) {
                f.onItemShiftTab();
                return;
              }
              if (p.target !== p.currentTarget) return;
              const b = DL(p, f.orientation, f.dir);
              if (b !== void 0) {
                if (p.metaKey || p.ctrlKey || p.altKey || p.shiftKey) return;
                p.preventDefault();
                let x = d().filter((_) => _.focusable).map((_) => _.ref.current);
                if (b === "last") x.reverse();
                else if (b === "prev" || b === "next") {
                  b === "prev" && x.reverse();
                  const _ = x.indexOf(p.currentTarget);
                  x = f.loop ? jL(x, _ + 1) : x.slice(_ + 1);
                }
                setTimeout(() => zP(x));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: u, hasTabStop: v != null }) : i
          }
        )
      }
    );
  }
);
qP.displayName = FP;
var kL = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function $L(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function DL(e, t, r) {
  const n = $L(e.key, r);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(n)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(n)))
    return kL[n];
}
function zP(e, t = !1) {
  const r = document.activeElement;
  for (const n of e)
    if (n === r || (n.focus({ preventScroll: t }), document.activeElement !== r)) return;
}
function jL(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
var WP = BP, UP = qP, _h = ["Enter", " "], LL = ["ArrowDown", "PageUp", "Home"], HP = ["ArrowUp", "PageDown", "End"], BL = [...LL, ...HP], FL = {
  ltr: [..._h, "ArrowRight"],
  rtl: [..._h, "ArrowLeft"]
}, qL = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, yi = "Menu", [xa, zL, WL] = ii(yi), [xn, VP] = at(yi, [
  WL,
  jr,
  Bc
]), bi = jr(), KP = Bc(), [GP, Br] = xn(yi), [UL, wi] = xn(yi), YP = (e) => {
  const { __scopeMenu: t, open: r = !1, children: n, dir: o, onOpenChange: a, modal: i = !0 } = e, s = bi(t), [c, l] = g.useState(null), f = g.useRef(!1), u = $e(a), d = Ro(o);
  return g.useEffect(() => {
    const h = () => {
      f.current = !0, document.addEventListener("pointerdown", m, { capture: !0, once: !0 }), document.addEventListener("pointermove", m, { capture: !0, once: !0 });
    }, m = () => f.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", m, { capture: !0 }), document.removeEventListener("pointermove", m, { capture: !0 });
    };
  }, []), /* @__PURE__ */ S(ci, { ...s, children: /* @__PURE__ */ S(
    GP,
    {
      scope: t,
      open: r,
      onOpenChange: u,
      content: c,
      onContentChange: l,
      children: /* @__PURE__ */ S(
        UL,
        {
          scope: t,
          onClose: g.useCallback(() => u(!1), [u]),
          isUsingKeyboardRef: f,
          dir: d,
          modal: i,
          children: n
        }
      )
    }
  ) });
};
YP.displayName = yi;
var HL = "MenuAnchor", Tm = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e, o = bi(r);
    return /* @__PURE__ */ S(li, { ...o, ...n, ref: t });
  }
);
Tm.displayName = HL;
var Cm = "MenuPortal", [VL, XP] = xn(Cm, {
  forceMount: void 0
}), ZP = (e) => {
  const { __scopeMenu: t, forceMount: r, children: n, container: o } = e, a = Br(Cm, t);
  return /* @__PURE__ */ S(VL, { scope: t, forceMount: r, children: /* @__PURE__ */ S(Ge, { present: r || a.open, children: /* @__PURE__ */ S(ko, { asChild: !0, container: o, children: n }) }) });
};
ZP.displayName = Cm;
var At = "MenuContent", [KL, Rm] = xn(At), JP = g.forwardRef(
  (e, t) => {
    const r = XP(At, e.__scopeMenu), { forceMount: n = r.forceMount, ...o } = e, a = Br(At, e.__scopeMenu), i = wi(At, e.__scopeMenu);
    return /* @__PURE__ */ S(xa.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ S(Ge, { present: n || a.open, children: /* @__PURE__ */ S(xa.Slot, { scope: e.__scopeMenu, children: i.modal ? /* @__PURE__ */ S(GL, { ...o, ref: t }) : /* @__PURE__ */ S(YL, { ...o, ref: t }) }) }) });
  }
), GL = g.forwardRef(
  (e, t) => {
    const r = Br(At, e.__scopeMenu), n = g.useRef(null), o = le(t, n);
    return g.useEffect(() => {
      const a = n.current;
      if (a) return Ic(a);
    }, []), /* @__PURE__ */ S(
      Mm,
      {
        ...e,
        ref: o,
        trapFocus: r.open,
        disableOutsidePointerEvents: r.open,
        disableOutsideScroll: !0,
        onFocusOutside: Z(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => r.onOpenChange(!1)
      }
    );
  }
), YL = g.forwardRef((e, t) => {
  const r = Br(At, e.__scopeMenu);
  return /* @__PURE__ */ S(
    Mm,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => r.onOpenChange(!1)
    }
  );
}), XL = /* @__PURE__ */ ln("MenuContent.ScrollLock"), Mm = g.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: r,
      loop: n = !1,
      trapFocus: o,
      onOpenAutoFocus: a,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEntryFocus: c,
      onEscapeKeyDown: l,
      onPointerDownOutside: f,
      onFocusOutside: u,
      onInteractOutside: d,
      onDismiss: h,
      disableOutsideScroll: m,
      ...v
    } = e, p = Br(At, r), b = wi(At, r), w = bi(r), x = KP(r), _ = zL(r), [y, O] = g.useState(null), A = g.useRef(null), P = le(t, A, p.onContentChange), T = g.useRef(0), I = g.useRef(""), E = g.useRef(0), C = g.useRef(null), R = g.useRef("right"), M = g.useRef(0), D = m ? fi : g.Fragment, $ = m ? { as: XL, allowPinchZoom: !0 } : void 0, q = (B) => {
      var V, Q;
      const L = I.current + B, z = _().filter((W) => !W.disabled), N = document.activeElement, U = (V = z.find((W) => W.ref.current === N)) == null ? void 0 : V.textValue, K = z.map((W) => W.textValue), G = cB(K, L, U), J = (Q = z.find((W) => W.textValue === G)) == null ? void 0 : Q.ref.current;
      (function W(Y) {
        I.current = Y, window.clearTimeout(T.current), Y !== "" && (T.current = window.setTimeout(() => W(""), 1e3));
      })(L), J && setTimeout(() => J.focus());
    };
    g.useEffect(() => () => window.clearTimeout(T.current), []), Rc();
    const F = g.useCallback((B) => {
      var z, N;
      return R.current === ((z = C.current) == null ? void 0 : z.side) && uB(B, (N = C.current) == null ? void 0 : N.area);
    }, []);
    return /* @__PURE__ */ S(
      KL,
      {
        scope: r,
        searchRef: I,
        onItemEnter: g.useCallback(
          (B) => {
            F(B) && B.preventDefault();
          },
          [F]
        ),
        onItemLeave: g.useCallback(
          (B) => {
            var L;
            F(B) || ((L = A.current) == null || L.focus(), O(null));
          },
          [F]
        ),
        onTriggerLeave: g.useCallback(
          (B) => {
            F(B) && B.preventDefault();
          },
          [F]
        ),
        pointerGraceTimerRef: E,
        onPointerGraceIntentChange: g.useCallback((B) => {
          C.current = B;
        }, []),
        children: /* @__PURE__ */ S(D, { ...$, children: /* @__PURE__ */ S(
          ui,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: Z(a, (B) => {
              var L;
              B.preventDefault(), (L = A.current) == null || L.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: i,
            children: /* @__PURE__ */ S(
              wn,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: l,
                onPointerDownOutside: f,
                onFocusOutside: u,
                onInteractOutside: d,
                onDismiss: h,
                children: /* @__PURE__ */ S(
                  WP,
                  {
                    asChild: !0,
                    ...x,
                    dir: b.dir,
                    orientation: "vertical",
                    loop: n,
                    currentTabStopId: y,
                    onCurrentTabStopIdChange: O,
                    onEntryFocus: Z(c, (B) => {
                      b.isUsingKeyboardRef.current || B.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ S(
                      Oc,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": vE(p.open),
                        "data-radix-menu-content": "",
                        dir: b.dir,
                        ...w,
                        ...v,
                        ref: P,
                        style: { outline: "none", ...v.style },
                        onKeyDown: Z(v.onKeyDown, (B) => {
                          const z = B.target.closest("[data-radix-menu-content]") === B.currentTarget, N = B.ctrlKey || B.altKey || B.metaKey, U = B.key.length === 1;
                          z && (B.key === "Tab" && B.preventDefault(), !N && U && q(B.key));
                          const K = A.current;
                          if (B.target !== K || !BL.includes(B.key)) return;
                          B.preventDefault();
                          const J = _().filter((V) => !V.disabled).map((V) => V.ref.current);
                          HP.includes(B.key) && J.reverse(), iB(J);
                        }),
                        onBlur: Z(e.onBlur, (B) => {
                          B.currentTarget.contains(B.target) || (window.clearTimeout(T.current), I.current = "");
                        }),
                        onPointerMove: Z(
                          e.onPointerMove,
                          Sa((B) => {
                            const L = B.target, z = M.current !== B.clientX;
                            if (B.currentTarget.contains(L) && z) {
                              const N = B.clientX > M.current ? "right" : "left";
                              R.current = N, M.current = B.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
JP.displayName = At;
var ZL = "MenuGroup", Im = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e;
    return /* @__PURE__ */ S(ae.div, { role: "group", ...n, ref: t });
  }
);
Im.displayName = ZL;
var JL = "MenuLabel", QP = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e;
    return /* @__PURE__ */ S(ae.div, { ...n, ref: t });
  }
);
QP.displayName = JL;
var fs = "MenuItem", Py = "menu.itemSelect", Fc = g.forwardRef(
  (e, t) => {
    const { disabled: r = !1, onSelect: n, ...o } = e, a = g.useRef(null), i = wi(fs, e.__scopeMenu), s = Rm(fs, e.__scopeMenu), c = le(t, a), l = g.useRef(!1), f = () => {
      const u = a.current;
      if (!r && u) {
        const d = new CustomEvent(Py, { bubbles: !0, cancelable: !0 });
        u.addEventListener(Py, (h) => n == null ? void 0 : n(h), { once: !0 }), om(u, d), d.defaultPrevented ? l.current = !1 : i.onClose();
      }
    };
    return /* @__PURE__ */ S(
      eE,
      {
        ...o,
        ref: c,
        disabled: r,
        onClick: Z(e.onClick, f),
        onPointerDown: (u) => {
          var d;
          (d = e.onPointerDown) == null || d.call(e, u), l.current = !0;
        },
        onPointerUp: Z(e.onPointerUp, (u) => {
          var d;
          l.current || (d = u.currentTarget) == null || d.click();
        }),
        onKeyDown: Z(e.onKeyDown, (u) => {
          const d = s.searchRef.current !== "";
          r || d && u.key === " " || _h.includes(u.key) && (u.currentTarget.click(), u.preventDefault());
        })
      }
    );
  }
);
Fc.displayName = fs;
var eE = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, disabled: n = !1, textValue: o, ...a } = e, i = Rm(fs, r), s = KP(r), c = g.useRef(null), l = le(t, c), [f, u] = g.useState(!1), [d, h] = g.useState("");
    return g.useEffect(() => {
      const m = c.current;
      m && h((m.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ S(
      xa.ItemSlot,
      {
        scope: r,
        disabled: n,
        textValue: o ?? d,
        children: /* @__PURE__ */ S(UP, { asChild: !0, ...s, focusable: !n, children: /* @__PURE__ */ S(
          ae.div,
          {
            role: "menuitem",
            "data-highlighted": f ? "" : void 0,
            "aria-disabled": n || void 0,
            "data-disabled": n ? "" : void 0,
            ...a,
            ref: l,
            onPointerMove: Z(
              e.onPointerMove,
              Sa((m) => {
                n ? i.onItemLeave(m) : (i.onItemEnter(m), m.defaultPrevented || m.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: Z(
              e.onPointerLeave,
              Sa((m) => i.onItemLeave(m))
            ),
            onFocus: Z(e.onFocus, () => u(!0)),
            onBlur: Z(e.onBlur, () => u(!1))
          }
        ) })
      }
    );
  }
), QL = "MenuCheckboxItem", tE = g.forwardRef(
  (e, t) => {
    const { checked: r = !1, onCheckedChange: n, ...o } = e;
    return /* @__PURE__ */ S(iE, { scope: e.__scopeMenu, checked: r, children: /* @__PURE__ */ S(
      Fc,
      {
        role: "menuitemcheckbox",
        "aria-checked": ds(r) ? "mixed" : r,
        ...o,
        ref: t,
        "data-state": $m(r),
        onSelect: Z(
          o.onSelect,
          () => n == null ? void 0 : n(ds(r) ? !0 : !r),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
tE.displayName = QL;
var rE = "MenuRadioGroup", [eB, tB] = xn(
  rE,
  { value: void 0, onValueChange: () => {
  } }
), nE = g.forwardRef(
  (e, t) => {
    const { value: r, onValueChange: n, ...o } = e, a = $e(n);
    return /* @__PURE__ */ S(eB, { scope: e.__scopeMenu, value: r, onValueChange: a, children: /* @__PURE__ */ S(Im, { ...o, ref: t }) });
  }
);
nE.displayName = rE;
var oE = "MenuRadioItem", aE = g.forwardRef(
  (e, t) => {
    const { value: r, ...n } = e, o = tB(oE, e.__scopeMenu), a = r === o.value;
    return /* @__PURE__ */ S(iE, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ S(
      Fc,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...n,
        ref: t,
        "data-state": $m(a),
        onSelect: Z(
          n.onSelect,
          () => {
            var i;
            return (i = o.onValueChange) == null ? void 0 : i.call(o, r);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
aE.displayName = oE;
var Nm = "MenuItemIndicator", [iE, rB] = xn(
  Nm,
  { checked: !1 }
), sE = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, forceMount: n, ...o } = e, a = rB(Nm, r);
    return /* @__PURE__ */ S(
      Ge,
      {
        present: n || ds(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ S(
          ae.span,
          {
            ...o,
            ref: t,
            "data-state": $m(a.checked)
          }
        )
      }
    );
  }
);
sE.displayName = Nm;
var nB = "MenuSeparator", cE = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e;
    return /* @__PURE__ */ S(
      ae.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...n,
        ref: t
      }
    );
  }
);
cE.displayName = nB;
var oB = "MenuArrow", lE = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e, o = bi(r);
    return /* @__PURE__ */ S(Ac, { ...o, ...n, ref: t });
  }
);
lE.displayName = oB;
var km = "MenuSub", [aB, uE] = xn(km), fE = (e) => {
  const { __scopeMenu: t, children: r, open: n = !1, onOpenChange: o } = e, a = Br(km, t), i = bi(t), [s, c] = g.useState(null), [l, f] = g.useState(null), u = $e(o);
  return g.useEffect(() => (a.open === !1 && u(!1), () => u(!1)), [a.open, u]), /* @__PURE__ */ S(ci, { ...i, children: /* @__PURE__ */ S(
    GP,
    {
      scope: t,
      open: n,
      onOpenChange: u,
      content: l,
      onContentChange: f,
      children: /* @__PURE__ */ S(
        aB,
        {
          scope: t,
          contentId: je(),
          triggerId: je(),
          trigger: s,
          onTriggerChange: c,
          children: r
        }
      )
    }
  ) });
};
fE.displayName = km;
var aa = "MenuSubTrigger", dE = g.forwardRef(
  (e, t) => {
    const r = Br(aa, e.__scopeMenu), n = wi(aa, e.__scopeMenu), o = uE(aa, e.__scopeMenu), a = Rm(aa, e.__scopeMenu), i = g.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: c } = a, l = { __scopeMenu: e.__scopeMenu }, f = g.useCallback(() => {
      i.current && window.clearTimeout(i.current), i.current = null;
    }, []);
    return g.useEffect(() => f, [f]), g.useEffect(() => {
      const u = s.current;
      return () => {
        window.clearTimeout(u), c(null);
      };
    }, [s, c]), /* @__PURE__ */ S(Tm, { asChild: !0, ...l, children: /* @__PURE__ */ S(
      eE,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": r.open,
        "aria-controls": o.contentId,
        "data-state": vE(r.open),
        ...e,
        ref: Zt(t, o.onTriggerChange),
        onClick: (u) => {
          var d;
          (d = e.onClick) == null || d.call(e, u), !(e.disabled || u.defaultPrevented) && (u.currentTarget.focus(), r.open || r.onOpenChange(!0));
        },
        onPointerMove: Z(
          e.onPointerMove,
          Sa((u) => {
            a.onItemEnter(u), !u.defaultPrevented && !e.disabled && !r.open && !i.current && (a.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
              r.onOpenChange(!0), f();
            }, 100));
          })
        ),
        onPointerLeave: Z(
          e.onPointerLeave,
          Sa((u) => {
            var h, m;
            f();
            const d = (h = r.content) == null ? void 0 : h.getBoundingClientRect();
            if (d) {
              const v = (m = r.content) == null ? void 0 : m.dataset.side, p = v === "right", b = p ? -5 : 5, w = d[p ? "left" : "right"], x = d[p ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: u.clientX + b, y: u.clientY },
                  { x: w, y: d.top },
                  { x, y: d.top },
                  { x, y: d.bottom },
                  { x: w, y: d.bottom }
                ],
                side: v
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(u), u.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: Z(e.onKeyDown, (u) => {
          var h;
          const d = a.searchRef.current !== "";
          e.disabled || d && u.key === " " || FL[n.dir].includes(u.key) && (r.onOpenChange(!0), (h = r.content) == null || h.focus(), u.preventDefault());
        })
      }
    ) });
  }
);
dE.displayName = aa;
var pE = "MenuSubContent", hE = g.forwardRef(
  (e, t) => {
    const r = XP(At, e.__scopeMenu), { forceMount: n = r.forceMount, ...o } = e, a = Br(At, e.__scopeMenu), i = wi(At, e.__scopeMenu), s = uE(pE, e.__scopeMenu), c = g.useRef(null), l = le(t, c);
    return /* @__PURE__ */ S(xa.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ S(Ge, { present: n || a.open, children: /* @__PURE__ */ S(xa.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ S(
      Mm,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...o,
        ref: l,
        align: "start",
        side: i.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (f) => {
          var u;
          i.isUsingKeyboardRef.current && ((u = c.current) == null || u.focus()), f.preventDefault();
        },
        onCloseAutoFocus: (f) => f.preventDefault(),
        onFocusOutside: Z(e.onFocusOutside, (f) => {
          f.target !== s.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: Z(e.onEscapeKeyDown, (f) => {
          i.onClose(), f.preventDefault();
        }),
        onKeyDown: Z(e.onKeyDown, (f) => {
          var h;
          const u = f.currentTarget.contains(f.target), d = qL[i.dir].includes(f.key);
          u && d && (a.onOpenChange(!1), (h = s.trigger) == null || h.focus(), f.preventDefault());
        })
      }
    ) }) }) });
  }
);
hE.displayName = pE;
function vE(e) {
  return e ? "open" : "closed";
}
function ds(e) {
  return e === "indeterminate";
}
function $m(e) {
  return ds(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function iB(e) {
  const t = document.activeElement;
  for (const r of e)
    if (r === t || (r.focus(), document.activeElement !== t)) return;
}
function sB(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
function cB(e, t, r) {
  const o = t.length > 1 && Array.from(t).every((l) => l === t[0]) ? t[0] : t, a = r ? e.indexOf(r) : -1;
  let i = sB(e, Math.max(a, 0));
  o.length === 1 && (i = i.filter((l) => l !== r));
  const c = i.find(
    (l) => l.toLowerCase().startsWith(o.toLowerCase())
  );
  return c !== r ? c : void 0;
}
function lB(e, t) {
  const { x: r, y: n } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a], c = t[i], l = s.x, f = s.y, u = c.x, d = c.y;
    f > n != d > n && r < (u - l) * (n - f) / (d - f) + l && (o = !o);
  }
  return o;
}
function uB(e, t) {
  if (!t) return !1;
  const r = { x: e.clientX, y: e.clientY };
  return lB(r, t);
}
function Sa(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var fB = YP, dB = Tm, pB = ZP, hB = JP, vB = Im, mB = QP, gB = Fc, yB = tE, bB = nE, wB = aE, xB = sE, SB = cE, _B = lE, OB = fE, AB = dE, PB = hE, qc = "DropdownMenu", [EB] = at(
  qc,
  [VP]
), tt = VP(), [TB, mE] = EB(qc), gE = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: r,
    dir: n,
    open: o,
    defaultOpen: a,
    onOpenChange: i,
    modal: s = !0
  } = e, c = tt(t), l = g.useRef(null), [f, u] = Pt({
    prop: o,
    defaultProp: a ?? !1,
    onChange: i,
    caller: qc
  });
  return /* @__PURE__ */ S(
    TB,
    {
      scope: t,
      triggerId: je(),
      triggerRef: l,
      contentId: je(),
      open: f,
      onOpenChange: u,
      onOpenToggle: g.useCallback(() => u((d) => !d), [u]),
      modal: s,
      children: /* @__PURE__ */ S(fB, { ...c, open: f, onOpenChange: u, dir: n, modal: s, children: r })
    }
  );
};
gE.displayName = qc;
var yE = "DropdownMenuTrigger", bE = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, disabled: n = !1, ...o } = e, a = mE(yE, r), i = tt(r);
    return /* @__PURE__ */ S(dB, { asChild: !0, ...i, children: /* @__PURE__ */ S(
      ae.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": n ? "" : void 0,
        disabled: n,
        ...o,
        ref: Zt(t, a.triggerRef),
        onPointerDown: Z(e.onPointerDown, (s) => {
          !n && s.button === 0 && s.ctrlKey === !1 && (a.onOpenToggle(), a.open || s.preventDefault());
        }),
        onKeyDown: Z(e.onKeyDown, (s) => {
          n || (["Enter", " "].includes(s.key) && a.onOpenToggle(), s.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
bE.displayName = yE;
var CB = "DropdownMenuPortal", wE = (e) => {
  const { __scopeDropdownMenu: t, ...r } = e, n = tt(t);
  return /* @__PURE__ */ S(pB, { ...n, ...r });
};
wE.displayName = CB;
var xE = "DropdownMenuContent", SE = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = mE(xE, r), a = tt(r), i = g.useRef(!1);
    return /* @__PURE__ */ S(
      hB,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...a,
        ...n,
        ref: t,
        onCloseAutoFocus: Z(e.onCloseAutoFocus, (s) => {
          var c;
          i.current || (c = o.triggerRef.current) == null || c.focus(), i.current = !1, s.preventDefault();
        }),
        onInteractOutside: Z(e.onInteractOutside, (s) => {
          const c = s.detail.originalEvent, l = c.button === 0 && c.ctrlKey === !0, f = c.button === 2 || l;
          (!o.modal || f) && (i.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
SE.displayName = xE;
var RB = "DropdownMenuGroup", _E = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = tt(r);
    return /* @__PURE__ */ S(vB, { ...o, ...n, ref: t });
  }
);
_E.displayName = RB;
var MB = "DropdownMenuLabel", OE = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = tt(r);
    return /* @__PURE__ */ S(mB, { ...o, ...n, ref: t });
  }
);
OE.displayName = MB;
var IB = "DropdownMenuItem", AE = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = tt(r);
    return /* @__PURE__ */ S(gB, { ...o, ...n, ref: t });
  }
);
AE.displayName = IB;
var NB = "DropdownMenuCheckboxItem", PE = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = tt(r);
  return /* @__PURE__ */ S(yB, { ...o, ...n, ref: t });
});
PE.displayName = NB;
var kB = "DropdownMenuRadioGroup", EE = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = tt(r);
  return /* @__PURE__ */ S(bB, { ...o, ...n, ref: t });
});
EE.displayName = kB;
var $B = "DropdownMenuRadioItem", TE = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = tt(r);
  return /* @__PURE__ */ S(wB, { ...o, ...n, ref: t });
});
TE.displayName = $B;
var DB = "DropdownMenuItemIndicator", CE = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = tt(r);
  return /* @__PURE__ */ S(xB, { ...o, ...n, ref: t });
});
CE.displayName = DB;
var jB = "DropdownMenuSeparator", RE = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = tt(r);
  return /* @__PURE__ */ S(SB, { ...o, ...n, ref: t });
});
RE.displayName = jB;
var LB = "DropdownMenuArrow", BB = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = tt(r);
    return /* @__PURE__ */ S(_B, { ...o, ...n, ref: t });
  }
);
BB.displayName = LB;
var FB = (e) => {
  const { __scopeDropdownMenu: t, children: r, open: n, onOpenChange: o, defaultOpen: a } = e, i = tt(t), [s, c] = Pt({
    prop: n,
    defaultProp: a ?? !1,
    onChange: o,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ S(OB, { ...i, open: s, onOpenChange: c, children: r });
}, qB = "DropdownMenuSubTrigger", ME = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = tt(r);
  return /* @__PURE__ */ S(AB, { ...o, ...n, ref: t });
});
ME.displayName = qB;
var zB = "DropdownMenuSubContent", IE = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = tt(r);
  return /* @__PURE__ */ S(
    PB,
    {
      ...o,
      ...n,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
IE.displayName = zB;
var WB = gE, UB = bE, NE = wE, kE = SE, HB = _E, $E = OE, DE = AE, jE = PE, VB = EE, LE = TE, BE = CE, FE = RE, KB = FB, qE = ME, zE = IE;
const GB = WB, YB = UB, dJ = HB, pJ = NE, hJ = KB, vJ = VB, XB = g.forwardRef(({ className: e, inset: t, children: r, ...n }, o) => /* @__PURE__ */ ee(
  qE,
  {
    ref: o,
    className: re(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-slate-100 data-[state=open]:bg-slate-100 dark:focus:bg-slate-800 dark:data-[state=open]:bg-slate-800",
      t && "pl-8",
      e
    ),
    ...n,
    children: [
      r,
      /* @__PURE__ */ S(ZN, { className: "ml-auto h-4 w-4" })
    ]
  }
));
XB.displayName = qE.displayName;
const ZB = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  zE,
  {
    ref: r,
    className: re(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border border-slate-200 bg-white p-1 text-slate-950 shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50",
      e
    ),
    ...t
  }
));
ZB.displayName = zE.displayName;
const WE = g.forwardRef(({ className: e, sideOffset: t = 4, ...r }, n) => /* @__PURE__ */ S(NE, { children: /* @__PURE__ */ S(
  kE,
  {
    ref: n,
    sideOffset: t,
    className: re(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border border-slate-200 bg-white p-1 text-slate-950 shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50",
      e
    ),
    ...r
  }
) }));
WE.displayName = kE.displayName;
const JB = g.forwardRef(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ S(
  DE,
  {
    ref: n,
    className: re(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-slate-100 focus:text-slate-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-slate-800 dark:focus:text-slate-50",
      t && "pl-8",
      e
    ),
    ...r
  }
));
JB.displayName = DE.displayName;
const QB = g.forwardRef(({ className: e, children: t, checked: r, ...n }, o) => /* @__PURE__ */ ee(
  jE,
  {
    ref: o,
    className: re(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-slate-100 focus:text-slate-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-slate-800 dark:focus:text-slate-50",
      e
    ),
    checked: r,
    ...n,
    children: [
      /* @__PURE__ */ S("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ S(BE, { children: /* @__PURE__ */ S(yc, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
QB.displayName = jE.displayName;
const eF = g.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ ee(
  LE,
  {
    ref: n,
    className: re(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-slate-100 focus:text-slate-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-slate-800 dark:focus:text-slate-50",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ S("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ S(BE, { children: /* @__PURE__ */ S(QN, { className: "h-2 w-2 fill-current" }) }) }),
      t
    ]
  }
));
eF.displayName = LE.displayName;
const tF = g.forwardRef(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ S(
  $E,
  {
    ref: n,
    className: re(
      "px-2 py-1.5 text-sm font-semibold",
      t && "pl-8",
      e
    ),
    ...r
  }
));
tF.displayName = $E.displayName;
const rF = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  FE,
  {
    ref: r,
    className: re("-mx-1 my-1 h-px bg-slate-100 dark:bg-slate-800", e),
    ...t
  }
));
rF.displayName = FE.displayName;
const nF = ({
  className: e,
  ...t
}) => /* @__PURE__ */ S(
  "span",
  {
    className: re("ml-auto text-xs tracking-widest opacity-60", e),
    ...t
  }
);
nF.displayName = "DropdownMenuShortcut";
function oF(e, t) {
  return g.useReducer((r, n) => t[r][n] ?? r, e);
}
var Dm = "ScrollArea", [UE] = at(Dm), [aF, Tt] = UE(Dm), HE = g.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: r,
      type: n = "hover",
      dir: o,
      scrollHideDelay: a = 600,
      ...i
    } = e, [s, c] = g.useState(null), [l, f] = g.useState(null), [u, d] = g.useState(null), [h, m] = g.useState(null), [v, p] = g.useState(null), [b, w] = g.useState(0), [x, _] = g.useState(0), [y, O] = g.useState(!1), [A, P] = g.useState(!1), T = le(t, (E) => c(E)), I = Ro(o);
    return /* @__PURE__ */ S(
      aF,
      {
        scope: r,
        type: n,
        dir: I,
        scrollHideDelay: a,
        scrollArea: s,
        viewport: l,
        onViewportChange: f,
        content: u,
        onContentChange: d,
        scrollbarX: h,
        onScrollbarXChange: m,
        scrollbarXEnabled: y,
        onScrollbarXEnabledChange: O,
        scrollbarY: v,
        onScrollbarYChange: p,
        scrollbarYEnabled: A,
        onScrollbarYEnabledChange: P,
        onCornerWidthChange: w,
        onCornerHeightChange: _,
        children: /* @__PURE__ */ S(
          ae.div,
          {
            dir: I,
            ...i,
            ref: T,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": b + "px",
              "--radix-scroll-area-corner-height": x + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
HE.displayName = Dm;
var VE = "ScrollAreaViewport", KE = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: r, children: n, nonce: o, ...a } = e, i = Tt(VE, r), s = g.useRef(null), c = le(t, s, i.onViewportChange);
    return /* @__PURE__ */ ee(ke, { children: [
      /* @__PURE__ */ S(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ S(
        ae.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...a,
          ref: c,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ S("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: n })
        }
      )
    ] });
  }
);
KE.displayName = VE;
var rr = "ScrollAreaScrollbar", jm = g.forwardRef(
  (e, t) => {
    const { forceMount: r, ...n } = e, o = Tt(rr, e.__scopeScrollArea), { onScrollbarXEnabledChange: a, onScrollbarYEnabledChange: i } = o, s = e.orientation === "horizontal";
    return g.useEffect(() => (s ? a(!0) : i(!0), () => {
      s ? a(!1) : i(!1);
    }), [s, a, i]), o.type === "hover" ? /* @__PURE__ */ S(iF, { ...n, ref: t, forceMount: r }) : o.type === "scroll" ? /* @__PURE__ */ S(sF, { ...n, ref: t, forceMount: r }) : o.type === "auto" ? /* @__PURE__ */ S(GE, { ...n, ref: t, forceMount: r }) : o.type === "always" ? /* @__PURE__ */ S(Lm, { ...n, ref: t }) : null;
  }
);
jm.displayName = rr;
var iF = g.forwardRef((e, t) => {
  const { forceMount: r, ...n } = e, o = Tt(rr, e.__scopeScrollArea), [a, i] = g.useState(!1);
  return g.useEffect(() => {
    const s = o.scrollArea;
    let c = 0;
    if (s) {
      const l = () => {
        window.clearTimeout(c), i(!0);
      }, f = () => {
        c = window.setTimeout(() => i(!1), o.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", l), s.addEventListener("pointerleave", f), () => {
        window.clearTimeout(c), s.removeEventListener("pointerenter", l), s.removeEventListener("pointerleave", f);
      };
    }
  }, [o.scrollArea, o.scrollHideDelay]), /* @__PURE__ */ S(Ge, { present: r || a, children: /* @__PURE__ */ S(
    GE,
    {
      "data-state": a ? "visible" : "hidden",
      ...n,
      ref: t
    }
  ) });
}), sF = g.forwardRef((e, t) => {
  const { forceMount: r, ...n } = e, o = Tt(rr, e.__scopeScrollArea), a = e.orientation === "horizontal", i = Wc(() => c("SCROLL_END"), 100), [s, c] = oF("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return g.useEffect(() => {
    if (s === "idle") {
      const l = window.setTimeout(() => c("HIDE"), o.scrollHideDelay);
      return () => window.clearTimeout(l);
    }
  }, [s, o.scrollHideDelay, c]), g.useEffect(() => {
    const l = o.viewport, f = a ? "scrollLeft" : "scrollTop";
    if (l) {
      let u = l[f];
      const d = () => {
        const h = l[f];
        u !== h && (c("SCROLL"), i()), u = h;
      };
      return l.addEventListener("scroll", d), () => l.removeEventListener("scroll", d);
    }
  }, [o.viewport, a, c, i]), /* @__PURE__ */ S(Ge, { present: r || s !== "hidden", children: /* @__PURE__ */ S(
    Lm,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...n,
      ref: t,
      onPointerEnter: Z(e.onPointerEnter, () => c("POINTER_ENTER")),
      onPointerLeave: Z(e.onPointerLeave, () => c("POINTER_LEAVE"))
    }
  ) });
}), GE = g.forwardRef((e, t) => {
  const r = Tt(rr, e.__scopeScrollArea), { forceMount: n, ...o } = e, [a, i] = g.useState(!1), s = e.orientation === "horizontal", c = Wc(() => {
    if (r.viewport) {
      const l = r.viewport.offsetWidth < r.viewport.scrollWidth, f = r.viewport.offsetHeight < r.viewport.scrollHeight;
      i(s ? l : f);
    }
  }, 10);
  return eo(r.viewport, c), eo(r.content, c), /* @__PURE__ */ S(Ge, { present: n || a, children: /* @__PURE__ */ S(
    Lm,
    {
      "data-state": a ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), Lm = g.forwardRef((e, t) => {
  const { orientation: r = "vertical", ...n } = e, o = Tt(rr, e.__scopeScrollArea), a = g.useRef(null), i = g.useRef(0), [s, c] = g.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), l = QE(s.viewport, s.content), f = {
    ...n,
    sizes: s,
    onSizesChange: c,
    hasThumb: l > 0 && l < 1,
    onThumbChange: (d) => a.current = d,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (d) => i.current = d
  };
  function u(d, h) {
    return pF(d, i.current, s, h);
  }
  return r === "horizontal" ? /* @__PURE__ */ S(
    cF,
    {
      ...f,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && a.current) {
          const d = o.viewport.scrollLeft, h = Ey(d, s, o.dir);
          a.current.style.transform = `translate3d(${h}px, 0, 0)`;
        }
      },
      onWheelScroll: (d) => {
        o.viewport && (o.viewport.scrollLeft = d);
      },
      onDragScroll: (d) => {
        o.viewport && (o.viewport.scrollLeft = u(d, o.dir));
      }
    }
  ) : r === "vertical" ? /* @__PURE__ */ S(
    lF,
    {
      ...f,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && a.current) {
          const d = o.viewport.scrollTop, h = Ey(d, s);
          a.current.style.transform = `translate3d(0, ${h}px, 0)`;
        }
      },
      onWheelScroll: (d) => {
        o.viewport && (o.viewport.scrollTop = d);
      },
      onDragScroll: (d) => {
        o.viewport && (o.viewport.scrollTop = u(d));
      }
    }
  ) : null;
}), cF = g.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: n, ...o } = e, a = Tt(rr, e.__scopeScrollArea), [i, s] = g.useState(), c = g.useRef(null), l = le(t, c, a.onScrollbarXChange);
  return g.useEffect(() => {
    c.current && s(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ S(
    XE,
    {
      "data-orientation": "horizontal",
      ...o,
      ref: l,
      sizes: r,
      style: {
        bottom: 0,
        left: a.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: a.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": zc(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (f) => e.onThumbPointerDown(f.x),
      onDragScroll: (f) => e.onDragScroll(f.x),
      onWheelScroll: (f, u) => {
        if (a.viewport) {
          const d = a.viewport.scrollLeft + f.deltaX;
          e.onWheelScroll(d), tT(d, u) && f.preventDefault();
        }
      },
      onResize: () => {
        c.current && a.viewport && i && n({
          content: a.viewport.scrollWidth,
          viewport: a.viewport.offsetWidth,
          scrollbar: {
            size: c.current.clientWidth,
            paddingStart: hs(i.paddingLeft),
            paddingEnd: hs(i.paddingRight)
          }
        });
      }
    }
  );
}), lF = g.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: n, ...o } = e, a = Tt(rr, e.__scopeScrollArea), [i, s] = g.useState(), c = g.useRef(null), l = le(t, c, a.onScrollbarYChange);
  return g.useEffect(() => {
    c.current && s(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ S(
    XE,
    {
      "data-orientation": "vertical",
      ...o,
      ref: l,
      sizes: r,
      style: {
        top: 0,
        right: a.dir === "ltr" ? 0 : void 0,
        left: a.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": zc(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (f) => e.onThumbPointerDown(f.y),
      onDragScroll: (f) => e.onDragScroll(f.y),
      onWheelScroll: (f, u) => {
        if (a.viewport) {
          const d = a.viewport.scrollTop + f.deltaY;
          e.onWheelScroll(d), tT(d, u) && f.preventDefault();
        }
      },
      onResize: () => {
        c.current && a.viewport && i && n({
          content: a.viewport.scrollHeight,
          viewport: a.viewport.offsetHeight,
          scrollbar: {
            size: c.current.clientHeight,
            paddingStart: hs(i.paddingTop),
            paddingEnd: hs(i.paddingBottom)
          }
        });
      }
    }
  );
}), [uF, YE] = UE(rr), XE = g.forwardRef((e, t) => {
  const {
    __scopeScrollArea: r,
    sizes: n,
    hasThumb: o,
    onThumbChange: a,
    onThumbPointerUp: i,
    onThumbPointerDown: s,
    onThumbPositionChange: c,
    onDragScroll: l,
    onWheelScroll: f,
    onResize: u,
    ...d
  } = e, h = Tt(rr, r), [m, v] = g.useState(null), p = le(t, (T) => v(T)), b = g.useRef(null), w = g.useRef(""), x = h.viewport, _ = n.content - n.viewport, y = $e(f), O = $e(c), A = Wc(u, 10);
  function P(T) {
    if (b.current) {
      const I = T.clientX - b.current.left, E = T.clientY - b.current.top;
      l({ x: I, y: E });
    }
  }
  return g.useEffect(() => {
    const T = (I) => {
      const E = I.target;
      (m == null ? void 0 : m.contains(E)) && y(I, _);
    };
    return document.addEventListener("wheel", T, { passive: !1 }), () => document.removeEventListener("wheel", T, { passive: !1 });
  }, [x, m, _, y]), g.useEffect(O, [n, O]), eo(m, A), eo(h.content, A), /* @__PURE__ */ S(
    uF,
    {
      scope: r,
      scrollbar: m,
      hasThumb: o,
      onThumbChange: $e(a),
      onThumbPointerUp: $e(i),
      onThumbPositionChange: O,
      onThumbPointerDown: $e(s),
      children: /* @__PURE__ */ S(
        ae.div,
        {
          ...d,
          ref: p,
          style: { position: "absolute", ...d.style },
          onPointerDown: Z(e.onPointerDown, (T) => {
            T.button === 0 && (T.target.setPointerCapture(T.pointerId), b.current = m.getBoundingClientRect(), w.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", h.viewport && (h.viewport.style.scrollBehavior = "auto"), P(T));
          }),
          onPointerMove: Z(e.onPointerMove, P),
          onPointerUp: Z(e.onPointerUp, (T) => {
            const I = T.target;
            I.hasPointerCapture(T.pointerId) && I.releasePointerCapture(T.pointerId), document.body.style.webkitUserSelect = w.current, h.viewport && (h.viewport.style.scrollBehavior = ""), b.current = null;
          })
        }
      )
    }
  );
}), ps = "ScrollAreaThumb", ZE = g.forwardRef(
  (e, t) => {
    const { forceMount: r, ...n } = e, o = YE(ps, e.__scopeScrollArea);
    return /* @__PURE__ */ S(Ge, { present: r || o.hasThumb, children: /* @__PURE__ */ S(fF, { ref: t, ...n }) });
  }
), fF = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: r, style: n, ...o } = e, a = Tt(ps, r), i = YE(ps, r), { onThumbPositionChange: s } = i, c = le(
      t,
      (u) => i.onThumbChange(u)
    ), l = g.useRef(void 0), f = Wc(() => {
      l.current && (l.current(), l.current = void 0);
    }, 100);
    return g.useEffect(() => {
      const u = a.viewport;
      if (u) {
        const d = () => {
          if (f(), !l.current) {
            const h = hF(u, s);
            l.current = h, s();
          }
        };
        return s(), u.addEventListener("scroll", d), () => u.removeEventListener("scroll", d);
      }
    }, [a.viewport, f, s]), /* @__PURE__ */ S(
      ae.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...o,
        ref: c,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...n
        },
        onPointerDownCapture: Z(e.onPointerDownCapture, (u) => {
          const h = u.target.getBoundingClientRect(), m = u.clientX - h.left, v = u.clientY - h.top;
          i.onThumbPointerDown({ x: m, y: v });
        }),
        onPointerUp: Z(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
ZE.displayName = ps;
var Bm = "ScrollAreaCorner", JE = g.forwardRef(
  (e, t) => {
    const r = Tt(Bm, e.__scopeScrollArea), n = !!(r.scrollbarX && r.scrollbarY);
    return r.type !== "scroll" && n ? /* @__PURE__ */ S(dF, { ...e, ref: t }) : null;
  }
);
JE.displayName = Bm;
var dF = g.forwardRef((e, t) => {
  const { __scopeScrollArea: r, ...n } = e, o = Tt(Bm, r), [a, i] = g.useState(0), [s, c] = g.useState(0), l = !!(a && s);
  return eo(o.scrollbarX, () => {
    var u;
    const f = ((u = o.scrollbarX) == null ? void 0 : u.offsetHeight) || 0;
    o.onCornerHeightChange(f), c(f);
  }), eo(o.scrollbarY, () => {
    var u;
    const f = ((u = o.scrollbarY) == null ? void 0 : u.offsetWidth) || 0;
    o.onCornerWidthChange(f), i(f);
  }), l ? /* @__PURE__ */ S(
    ae.div,
    {
      ...n,
      ref: t,
      style: {
        width: a,
        height: s,
        position: "absolute",
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function hs(e) {
  return e ? parseInt(e, 10) : 0;
}
function QE(e, t) {
  const r = e / t;
  return isNaN(r) ? 0 : r;
}
function zc(e) {
  const t = QE(e.viewport, e.content), r = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, n = (e.scrollbar.size - r) * t;
  return Math.max(n, 18);
}
function pF(e, t, r, n = "ltr") {
  const o = zc(r), a = o / 2, i = t || a, s = o - i, c = r.scrollbar.paddingStart + i, l = r.scrollbar.size - r.scrollbar.paddingEnd - s, f = r.content - r.viewport, u = n === "ltr" ? [0, f] : [f * -1, 0];
  return eT([c, l], u)(e);
}
function Ey(e, t, r = "ltr") {
  const n = zc(t), o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, a = t.scrollbar.size - o, i = t.content - t.viewport, s = a - n, c = r === "ltr" ? [0, i] : [i * -1, 0], l = ga(e, c);
  return eT([0, i], [0, s])(l);
}
function eT(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const n = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + n * (r - e[0]);
  };
}
function tT(e, t) {
  return e > 0 && e < t;
}
var hF = (e, t = () => {
}) => {
  let r = { left: e.scrollLeft, top: e.scrollTop }, n = 0;
  return (function o() {
    const a = { left: e.scrollLeft, top: e.scrollTop }, i = r.left !== a.left, s = r.top !== a.top;
    (i || s) && t(), r = a, n = window.requestAnimationFrame(o);
  })(), () => window.cancelAnimationFrame(n);
};
function Wc(e, t) {
  const r = $e(e), n = g.useRef(0);
  return g.useEffect(() => () => window.clearTimeout(n.current), []), g.useCallback(() => {
    window.clearTimeout(n.current), n.current = window.setTimeout(r, t);
  }, [r, t]);
}
function eo(e, t) {
  const r = $e(t);
  Ue(() => {
    let n = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(n), n = window.requestAnimationFrame(r);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(n), o.unobserve(e);
      };
    }
  }, [e, r]);
}
var rT = HE, vF = KE, mF = JE;
const nT = g.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ ee(
  rT,
  {
    ref: n,
    className: re("relative overflow-hidden", e),
    ...r,
    children: [
      /* @__PURE__ */ S(vF, { className: "h-full w-full rounded-[inherit]", children: t }),
      /* @__PURE__ */ S(oT, {}),
      /* @__PURE__ */ S(mF, {})
    ]
  }
));
nT.displayName = rT.displayName;
const oT = g.forwardRef(({ className: e, orientation: t = "vertical", ...r }, n) => /* @__PURE__ */ S(
  jm,
  {
    ref: n,
    orientation: t,
    className: re(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...r,
    children: /* @__PURE__ */ S(ZE, { className: "relative flex-1 rounded-full bg-slate-200 dark:bg-slate-800" })
  }
));
oT.displayName = jm.displayName;
var gF = [" ", "Enter", "ArrowUp", "ArrowDown"], yF = [" ", "Enter"], pn = "Select", [Uc, Hc, bF] = ii(pn), [Lo] = at(pn, [
  bF,
  jr
]), Vc = jr(), [wF, Fr] = Lo(pn), [xF, SF] = Lo(pn), aT = (e) => {
  const {
    __scopeSelect: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: a,
    value: i,
    defaultValue: s,
    onValueChange: c,
    dir: l,
    name: f,
    autoComplete: u,
    disabled: d,
    required: h,
    form: m
  } = e, v = Vc(t), [p, b] = g.useState(null), [w, x] = g.useState(null), [_, y] = g.useState(!1), O = Ro(l), [A, P] = Pt({
    prop: n,
    defaultProp: o ?? !1,
    onChange: a,
    caller: pn
  }), [T, I] = Pt({
    prop: i,
    defaultProp: s,
    onChange: c,
    caller: pn
  }), E = g.useRef(null), C = p ? m || !!p.closest("form") : !0, [R, M] = g.useState(/* @__PURE__ */ new Set()), D = Array.from(R).map(($) => $.props.value).join(";");
  return /* @__PURE__ */ S(ci, { ...v, children: /* @__PURE__ */ ee(
    wF,
    {
      required: h,
      scope: t,
      trigger: p,
      onTriggerChange: b,
      valueNode: w,
      onValueNodeChange: x,
      valueNodeHasChildren: _,
      onValueNodeHasChildrenChange: y,
      contentId: je(),
      value: T,
      onValueChange: I,
      open: A,
      onOpenChange: P,
      dir: O,
      triggerPointerDownPosRef: E,
      disabled: d,
      children: [
        /* @__PURE__ */ S(Uc.Provider, { scope: t, children: /* @__PURE__ */ S(
          xF,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: g.useCallback(($) => {
              M((q) => new Set(q).add($));
            }, []),
            onNativeOptionRemove: g.useCallback(($) => {
              M((q) => {
                const F = new Set(q);
                return F.delete($), F;
              });
            }, []),
            children: r
          }
        ) }),
        C ? /* @__PURE__ */ ee(
          RT,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: f,
            autoComplete: u,
            value: T,
            onChange: ($) => I($.target.value),
            disabled: d,
            form: m,
            children: [
              T === void 0 ? /* @__PURE__ */ S("option", { value: "" }) : null,
              Array.from(R)
            ]
          },
          D
        ) : null
      ]
    }
  ) });
};
aT.displayName = pn;
var iT = "SelectTrigger", sT = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, disabled: n = !1, ...o } = e, a = Vc(r), i = Fr(iT, r), s = i.disabled || n, c = le(t, i.onTriggerChange), l = Hc(r), f = g.useRef("touch"), [u, d, h] = IT((v) => {
      const p = l().filter((x) => !x.disabled), b = p.find((x) => x.value === i.value), w = NT(p, v, b);
      w !== void 0 && i.onValueChange(w.value);
    }), m = (v) => {
      s || (i.onOpenChange(!0), h()), v && (i.triggerPointerDownPosRef.current = {
        x: Math.round(v.pageX),
        y: Math.round(v.pageY)
      });
    };
    return /* @__PURE__ */ S(li, { asChild: !0, ...a, children: /* @__PURE__ */ S(
      ae.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": MT(i.value) ? "" : void 0,
        ...o,
        ref: c,
        onClick: Z(o.onClick, (v) => {
          v.currentTarget.focus(), f.current !== "mouse" && m(v);
        }),
        onPointerDown: Z(o.onPointerDown, (v) => {
          f.current = v.pointerType;
          const p = v.target;
          p.hasPointerCapture(v.pointerId) && p.releasePointerCapture(v.pointerId), v.button === 0 && v.ctrlKey === !1 && v.pointerType === "mouse" && (m(v), v.preventDefault());
        }),
        onKeyDown: Z(o.onKeyDown, (v) => {
          const p = u.current !== "";
          !(v.ctrlKey || v.altKey || v.metaKey) && v.key.length === 1 && d(v.key), !(p && v.key === " ") && gF.includes(v.key) && (m(), v.preventDefault());
        })
      }
    ) });
  }
);
sT.displayName = iT;
var cT = "SelectValue", lT = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, className: n, style: o, children: a, placeholder: i = "", ...s } = e, c = Fr(cT, r), { onValueNodeHasChildrenChange: l } = c, f = a !== void 0, u = le(t, c.onValueNodeChange);
    return Ue(() => {
      l(f);
    }, [l, f]), /* @__PURE__ */ S(
      ae.span,
      {
        ...s,
        ref: u,
        style: { pointerEvents: "none" },
        children: MT(c.value) ? /* @__PURE__ */ S(ke, { children: i }) : a
      }
    );
  }
);
lT.displayName = cT;
var _F = "SelectIcon", uT = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, children: n, ...o } = e;
    return /* @__PURE__ */ S(ae.span, { "aria-hidden": !0, ...o, ref: t, children: n || "▼" });
  }
);
uT.displayName = _F;
var OF = "SelectPortal", fT = (e) => /* @__PURE__ */ S(ko, { asChild: !0, ...e });
fT.displayName = OF;
var hn = "SelectContent", dT = g.forwardRef(
  (e, t) => {
    const r = Fr(hn, e.__scopeSelect), [n, o] = g.useState();
    if (Ue(() => {
      o(new DocumentFragment());
    }, []), !r.open) {
      const a = n;
      return a ? oi.createPortal(
        /* @__PURE__ */ S(pT, { scope: e.__scopeSelect, children: /* @__PURE__ */ S(Uc.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ S("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ S(hT, { ...e, ref: t });
  }
);
dT.displayName = hn;
var It = 10, [pT, qr] = Lo(hn), AF = "SelectContentImpl", PF = /* @__PURE__ */ ln("SelectContent.RemoveScroll"), hT = g.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: r,
      position: n = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: s,
      sideOffset: c,
      align: l,
      alignOffset: f,
      arrowPadding: u,
      collisionBoundary: d,
      collisionPadding: h,
      sticky: m,
      hideWhenDetached: v,
      avoidCollisions: p,
      //
      ...b
    } = e, w = Fr(hn, r), [x, _] = g.useState(null), [y, O] = g.useState(null), A = le(t, (V) => _(V)), [P, T] = g.useState(null), [I, E] = g.useState(
      null
    ), C = Hc(r), [R, M] = g.useState(!1), D = g.useRef(!1);
    g.useEffect(() => {
      if (x) return Ic(x);
    }, [x]), Rc();
    const $ = g.useCallback(
      (V) => {
        const [Q, ...W] = C().map((j) => j.ref.current), [Y] = W.slice(-1), te = document.activeElement;
        for (const j of V)
          if (j === te || (j == null || j.scrollIntoView({ block: "nearest" }), j === Q && y && (y.scrollTop = 0), j === Y && y && (y.scrollTop = y.scrollHeight), j == null || j.focus(), document.activeElement !== te)) return;
      },
      [C, y]
    ), q = g.useCallback(
      () => $([P, x]),
      [$, P, x]
    );
    g.useEffect(() => {
      R && q();
    }, [R, q]);
    const { onOpenChange: F, triggerPointerDownPosRef: B } = w;
    g.useEffect(() => {
      if (x) {
        let V = { x: 0, y: 0 };
        const Q = (Y) => {
          var te, j;
          V = {
            x: Math.abs(Math.round(Y.pageX) - (((te = B.current) == null ? void 0 : te.x) ?? 0)),
            y: Math.abs(Math.round(Y.pageY) - (((j = B.current) == null ? void 0 : j.y) ?? 0))
          };
        }, W = (Y) => {
          V.x <= 10 && V.y <= 10 ? Y.preventDefault() : x.contains(Y.target) || F(!1), document.removeEventListener("pointermove", Q), B.current = null;
        };
        return B.current !== null && (document.addEventListener("pointermove", Q), document.addEventListener("pointerup", W, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Q), document.removeEventListener("pointerup", W, { capture: !0 });
        };
      }
    }, [x, F, B]), g.useEffect(() => {
      const V = () => F(!1);
      return window.addEventListener("blur", V), window.addEventListener("resize", V), () => {
        window.removeEventListener("blur", V), window.removeEventListener("resize", V);
      };
    }, [F]);
    const [L, z] = IT((V) => {
      const Q = C().filter((te) => !te.disabled), W = Q.find((te) => te.ref.current === document.activeElement), Y = NT(Q, V, W);
      Y && setTimeout(() => Y.ref.current.focus());
    }), N = g.useCallback(
      (V, Q, W) => {
        const Y = !D.current && !W;
        (w.value !== void 0 && w.value === Q || Y) && (T(V), Y && (D.current = !0));
      },
      [w.value]
    ), U = g.useCallback(() => x == null ? void 0 : x.focus(), [x]), K = g.useCallback(
      (V, Q, W) => {
        const Y = !D.current && !W;
        (w.value !== void 0 && w.value === Q || Y) && E(V);
      },
      [w.value]
    ), G = n === "popper" ? Oh : vT, J = G === Oh ? {
      side: s,
      sideOffset: c,
      align: l,
      alignOffset: f,
      arrowPadding: u,
      collisionBoundary: d,
      collisionPadding: h,
      sticky: m,
      hideWhenDetached: v,
      avoidCollisions: p
    } : {};
    return /* @__PURE__ */ S(
      pT,
      {
        scope: r,
        content: x,
        viewport: y,
        onViewportChange: O,
        itemRefCallback: N,
        selectedItem: P,
        onItemLeave: U,
        itemTextRefCallback: K,
        focusSelectedItem: q,
        selectedItemText: I,
        position: n,
        isPositioned: R,
        searchRef: L,
        children: /* @__PURE__ */ S(fi, { as: PF, allowPinchZoom: !0, children: /* @__PURE__ */ S(
          ui,
          {
            asChild: !0,
            trapped: w.open,
            onMountAutoFocus: (V) => {
              V.preventDefault();
            },
            onUnmountAutoFocus: Z(o, (V) => {
              var Q;
              (Q = w.trigger) == null || Q.focus({ preventScroll: !0 }), V.preventDefault();
            }),
            children: /* @__PURE__ */ S(
              wn,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: i,
                onFocusOutside: (V) => V.preventDefault(),
                onDismiss: () => w.onOpenChange(!1),
                children: /* @__PURE__ */ S(
                  G,
                  {
                    role: "listbox",
                    id: w.contentId,
                    "data-state": w.open ? "open" : "closed",
                    dir: w.dir,
                    onContextMenu: (V) => V.preventDefault(),
                    ...b,
                    ...J,
                    onPlaced: () => M(!0),
                    ref: A,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: Z(b.onKeyDown, (V) => {
                      const Q = V.ctrlKey || V.altKey || V.metaKey;
                      if (V.key === "Tab" && V.preventDefault(), !Q && V.key.length === 1 && z(V.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(V.key)) {
                        let Y = C().filter((te) => !te.disabled).map((te) => te.ref.current);
                        if (["ArrowUp", "End"].includes(V.key) && (Y = Y.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(V.key)) {
                          const te = V.target, j = Y.indexOf(te);
                          Y = Y.slice(j + 1);
                        }
                        setTimeout(() => $(Y)), V.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
hT.displayName = AF;
var EF = "SelectItemAlignedPosition", vT = g.forwardRef((e, t) => {
  const { __scopeSelect: r, onPlaced: n, ...o } = e, a = Fr(hn, r), i = qr(hn, r), [s, c] = g.useState(null), [l, f] = g.useState(null), u = le(t, (A) => f(A)), d = Hc(r), h = g.useRef(!1), m = g.useRef(!0), { viewport: v, selectedItem: p, selectedItemText: b, focusSelectedItem: w } = i, x = g.useCallback(() => {
    if (a.trigger && a.valueNode && s && l && v && p && b) {
      const A = a.trigger.getBoundingClientRect(), P = l.getBoundingClientRect(), T = a.valueNode.getBoundingClientRect(), I = b.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const te = I.left - P.left, j = T.left - te, ce = A.left - j, X = A.width + ce, he = Math.max(X, P.width), ge = window.innerWidth - It, Ie = ga(j, [
          It,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(It, ge - he)
        ]);
        s.style.minWidth = X + "px", s.style.left = Ie + "px";
      } else {
        const te = P.right - I.right, j = window.innerWidth - T.right - te, ce = window.innerWidth - A.right - j, X = A.width + ce, he = Math.max(X, P.width), ge = window.innerWidth - It, Ie = ga(j, [
          It,
          Math.max(It, ge - he)
        ]);
        s.style.minWidth = X + "px", s.style.right = Ie + "px";
      }
      const E = d(), C = window.innerHeight - It * 2, R = v.scrollHeight, M = window.getComputedStyle(l), D = parseInt(M.borderTopWidth, 10), $ = parseInt(M.paddingTop, 10), q = parseInt(M.borderBottomWidth, 10), F = parseInt(M.paddingBottom, 10), B = D + $ + R + F + q, L = Math.min(p.offsetHeight * 5, B), z = window.getComputedStyle(v), N = parseInt(z.paddingTop, 10), U = parseInt(z.paddingBottom, 10), K = A.top + A.height / 2 - It, G = C - K, J = p.offsetHeight / 2, V = p.offsetTop + J, Q = D + $ + V, W = B - Q;
      if (Q <= K) {
        const te = E.length > 0 && p === E[E.length - 1].ref.current;
        s.style.bottom = "0px";
        const j = l.clientHeight - v.offsetTop - v.offsetHeight, ce = Math.max(
          G,
          J + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (te ? U : 0) + j + q
        ), X = Q + ce;
        s.style.height = X + "px";
      } else {
        const te = E.length > 0 && p === E[0].ref.current;
        s.style.top = "0px";
        const ce = Math.max(
          K,
          D + v.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (te ? N : 0) + J
        ) + W;
        s.style.height = ce + "px", v.scrollTop = Q - K + v.offsetTop;
      }
      s.style.margin = `${It}px 0`, s.style.minHeight = L + "px", s.style.maxHeight = C + "px", n == null || n(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    d,
    a.trigger,
    a.valueNode,
    s,
    l,
    v,
    p,
    b,
    a.dir,
    n
  ]);
  Ue(() => x(), [x]);
  const [_, y] = g.useState();
  Ue(() => {
    l && y(window.getComputedStyle(l).zIndex);
  }, [l]);
  const O = g.useCallback(
    (A) => {
      A && m.current === !0 && (x(), w == null || w(), m.current = !1);
    },
    [x, w]
  );
  return /* @__PURE__ */ S(
    CF,
    {
      scope: r,
      contentWrapper: s,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: O,
      children: /* @__PURE__ */ S(
        "div",
        {
          ref: c,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: _
          },
          children: /* @__PURE__ */ S(
            ae.div,
            {
              ...o,
              ref: u,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
vT.displayName = EF;
var TF = "SelectPopperPosition", Oh = g.forwardRef((e, t) => {
  const {
    __scopeSelect: r,
    align: n = "start",
    collisionPadding: o = It,
    ...a
  } = e, i = Vc(r);
  return /* @__PURE__ */ S(
    Oc,
    {
      ...i,
      ...a,
      ref: t,
      align: n,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Oh.displayName = TF;
var [CF, Fm] = Lo(hn, {}), Ah = "SelectViewport", mT = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, nonce: n, ...o } = e, a = qr(Ah, r), i = Fm(Ah, r), s = le(t, a.onViewportChange), c = g.useRef(0);
    return /* @__PURE__ */ ee(ke, { children: [
      /* @__PURE__ */ S(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ S(Uc.Slot, { scope: r, children: /* @__PURE__ */ S(
        ae.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: Z(o.onScroll, (l) => {
            const f = l.currentTarget, { contentWrapper: u, shouldExpandOnScrollRef: d } = i;
            if (d != null && d.current && u) {
              const h = Math.abs(c.current - f.scrollTop);
              if (h > 0) {
                const m = window.innerHeight - It * 2, v = parseFloat(u.style.minHeight), p = parseFloat(u.style.height), b = Math.max(v, p);
                if (b < m) {
                  const w = b + h, x = Math.min(m, w), _ = w - x;
                  u.style.height = x + "px", u.style.bottom === "0px" && (f.scrollTop = _ > 0 ? _ : 0, u.style.justifyContent = "flex-end");
                }
              }
            }
            c.current = f.scrollTop;
          })
        }
      ) })
    ] });
  }
);
mT.displayName = Ah;
var gT = "SelectGroup", [RF, MF] = Lo(gT), yT = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, o = je();
    return /* @__PURE__ */ S(RF, { scope: r, id: o, children: /* @__PURE__ */ S(ae.div, { role: "group", "aria-labelledby": o, ...n, ref: t }) });
  }
);
yT.displayName = gT;
var bT = "SelectLabel", wT = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, o = MF(bT, r);
    return /* @__PURE__ */ S(ae.div, { id: o.id, ...n, ref: t });
  }
);
wT.displayName = bT;
var vs = "SelectItem", [IF, xT] = Lo(vs), ST = g.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: r,
      value: n,
      disabled: o = !1,
      textValue: a,
      ...i
    } = e, s = Fr(vs, r), c = qr(vs, r), l = s.value === n, [f, u] = g.useState(a ?? ""), [d, h] = g.useState(!1), m = le(
      t,
      (w) => {
        var x;
        return (x = c.itemRefCallback) == null ? void 0 : x.call(c, w, n, o);
      }
    ), v = je(), p = g.useRef("touch"), b = () => {
      o || (s.onValueChange(n), s.onOpenChange(!1));
    };
    if (n === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ S(
      IF,
      {
        scope: r,
        value: n,
        disabled: o,
        textId: v,
        isSelected: l,
        onItemTextChange: g.useCallback((w) => {
          u((x) => x || ((w == null ? void 0 : w.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ S(
          Uc.ItemSlot,
          {
            scope: r,
            value: n,
            disabled: o,
            textValue: f,
            children: /* @__PURE__ */ S(
              ae.div,
              {
                role: "option",
                "aria-labelledby": v,
                "data-highlighted": d ? "" : void 0,
                "aria-selected": l && d,
                "data-state": l ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...i,
                ref: m,
                onFocus: Z(i.onFocus, () => h(!0)),
                onBlur: Z(i.onBlur, () => h(!1)),
                onClick: Z(i.onClick, () => {
                  p.current !== "mouse" && b();
                }),
                onPointerUp: Z(i.onPointerUp, () => {
                  p.current === "mouse" && b();
                }),
                onPointerDown: Z(i.onPointerDown, (w) => {
                  p.current = w.pointerType;
                }),
                onPointerMove: Z(i.onPointerMove, (w) => {
                  var x;
                  p.current = w.pointerType, o ? (x = c.onItemLeave) == null || x.call(c) : p.current === "mouse" && w.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: Z(i.onPointerLeave, (w) => {
                  var x;
                  w.currentTarget === document.activeElement && ((x = c.onItemLeave) == null || x.call(c));
                }),
                onKeyDown: Z(i.onKeyDown, (w) => {
                  var _;
                  ((_ = c.searchRef) == null ? void 0 : _.current) !== "" && w.key === " " || (yF.includes(w.key) && b(), w.key === " " && w.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
ST.displayName = vs;
var ia = "SelectItemText", _T = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, className: n, style: o, ...a } = e, i = Fr(ia, r), s = qr(ia, r), c = xT(ia, r), l = SF(ia, r), [f, u] = g.useState(null), d = le(
      t,
      (b) => u(b),
      c.onItemTextChange,
      (b) => {
        var w;
        return (w = s.itemTextRefCallback) == null ? void 0 : w.call(s, b, c.value, c.disabled);
      }
    ), h = f == null ? void 0 : f.textContent, m = g.useMemo(
      () => /* @__PURE__ */ S("option", { value: c.value, disabled: c.disabled, children: h }, c.value),
      [c.disabled, c.value, h]
    ), { onNativeOptionAdd: v, onNativeOptionRemove: p } = l;
    return Ue(() => (v(m), () => p(m)), [v, p, m]), /* @__PURE__ */ ee(ke, { children: [
      /* @__PURE__ */ S(ae.span, { id: c.textId, ...a, ref: d }),
      c.isSelected && i.valueNode && !i.valueNodeHasChildren ? oi.createPortal(a.children, i.valueNode) : null
    ] });
  }
);
_T.displayName = ia;
var OT = "SelectItemIndicator", AT = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e;
    return xT(OT, r).isSelected ? /* @__PURE__ */ S(ae.span, { "aria-hidden": !0, ...n, ref: t }) : null;
  }
);
AT.displayName = OT;
var Ph = "SelectScrollUpButton", PT = g.forwardRef((e, t) => {
  const r = qr(Ph, e.__scopeSelect), n = Fm(Ph, e.__scopeSelect), [o, a] = g.useState(!1), i = le(t, n.onScrollButtonChange);
  return Ue(() => {
    if (r.viewport && r.isPositioned) {
      let s = function() {
        const l = c.scrollTop > 0;
        a(l);
      };
      const c = r.viewport;
      return s(), c.addEventListener("scroll", s), () => c.removeEventListener("scroll", s);
    }
  }, [r.viewport, r.isPositioned]), o ? /* @__PURE__ */ S(
    TT,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: c } = r;
        s && c && (s.scrollTop = s.scrollTop - c.offsetHeight);
      }
    }
  ) : null;
});
PT.displayName = Ph;
var Eh = "SelectScrollDownButton", ET = g.forwardRef((e, t) => {
  const r = qr(Eh, e.__scopeSelect), n = Fm(Eh, e.__scopeSelect), [o, a] = g.useState(!1), i = le(t, n.onScrollButtonChange);
  return Ue(() => {
    if (r.viewport && r.isPositioned) {
      let s = function() {
        const l = c.scrollHeight - c.clientHeight, f = Math.ceil(c.scrollTop) < l;
        a(f);
      };
      const c = r.viewport;
      return s(), c.addEventListener("scroll", s), () => c.removeEventListener("scroll", s);
    }
  }, [r.viewport, r.isPositioned]), o ? /* @__PURE__ */ S(
    TT,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: c } = r;
        s && c && (s.scrollTop = s.scrollTop + c.offsetHeight);
      }
    }
  ) : null;
});
ET.displayName = Eh;
var TT = g.forwardRef((e, t) => {
  const { __scopeSelect: r, onAutoScroll: n, ...o } = e, a = qr("SelectScrollButton", r), i = g.useRef(null), s = Hc(r), c = g.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return g.useEffect(() => () => c(), [c]), Ue(() => {
    var f;
    const l = s().find((u) => u.ref.current === document.activeElement);
    (f = l == null ? void 0 : l.ref.current) == null || f.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ S(
    ae.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: Z(o.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(n, 50));
      }),
      onPointerMove: Z(o.onPointerMove, () => {
        var l;
        (l = a.onItemLeave) == null || l.call(a), i.current === null && (i.current = window.setInterval(n, 50));
      }),
      onPointerLeave: Z(o.onPointerLeave, () => {
        c();
      })
    }
  );
}), NF = "SelectSeparator", CT = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e;
    return /* @__PURE__ */ S(ae.div, { "aria-hidden": !0, ...n, ref: t });
  }
);
CT.displayName = NF;
var Th = "SelectArrow", kF = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, o = Vc(r), a = Fr(Th, r), i = qr(Th, r);
    return a.open && i.position === "popper" ? /* @__PURE__ */ S(Ac, { ...o, ...n, ref: t }) : null;
  }
);
kF.displayName = Th;
var $F = "SelectBubbleInput", RT = g.forwardRef(
  ({ __scopeSelect: e, value: t, ...r }, n) => {
    const o = g.useRef(null), a = le(n, o), i = rm(t);
    return g.useEffect(() => {
      const s = o.current;
      if (!s) return;
      const c = window.HTMLSelectElement.prototype, f = Object.getOwnPropertyDescriptor(
        c,
        "value"
      ).set;
      if (i !== t && f) {
        const u = new Event("change", { bubbles: !0 });
        f.call(s, t), s.dispatchEvent(u);
      }
    }, [i, t]), /* @__PURE__ */ S(
      ae.select,
      {
        ...r,
        style: { ...HO, ...r.style },
        ref: a,
        defaultValue: t
      }
    );
  }
);
RT.displayName = $F;
function MT(e) {
  return e === "" || e === void 0;
}
function IT(e) {
  const t = $e(e), r = g.useRef(""), n = g.useRef(0), o = g.useCallback(
    (i) => {
      const s = r.current + i;
      t(s), (function c(l) {
        r.current = l, window.clearTimeout(n.current), l !== "" && (n.current = window.setTimeout(() => c(""), 1e3));
      })(s);
    },
    [t]
  ), a = g.useCallback(() => {
    r.current = "", window.clearTimeout(n.current);
  }, []);
  return g.useEffect(() => () => window.clearTimeout(n.current), []), [r, o, a];
}
function NT(e, t, r) {
  const o = t.length > 1 && Array.from(t).every((l) => l === t[0]) ? t[0] : t, a = r ? e.indexOf(r) : -1;
  let i = DF(e, Math.max(a, 0));
  o.length === 1 && (i = i.filter((l) => l !== r));
  const c = i.find(
    (l) => l.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return c !== r ? c : void 0;
}
function DF(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
var jF = aT, kT = sT, LF = lT, BF = uT, FF = fT, $T = dT, qF = mT, zF = yT, DT = wT, jT = ST, WF = _T, UF = AT, LT = PT, BT = ET, FT = CT;
const Ty = jF, mJ = zF, Cy = LF, Ch = g.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ ee(
  kT,
  {
    ref: n,
    className: re(
      "flex h-10 w-full items-center justify-between rounded-md border border-slate-200 bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-slate-500 focus:outline-none focus:ring-1 focus:ring-primary/30 focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 dark:border-slate-800 dark:bg-slate-950 dark:ring-offset-slate-950 dark:placeholder:text-slate-400",
      e
    ),
    ...r,
    children: [
      t,
      /* @__PURE__ */ S(BF, { asChild: !0, children: /* @__PURE__ */ S(J1, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
Ch.displayName = kT.displayName;
const qT = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  LT,
  {
    ref: r,
    className: re(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ S(JN, { className: "h-4 w-4" })
  }
));
qT.displayName = LT.displayName;
const zT = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  BT,
  {
    ref: r,
    className: re(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ S(J1, { className: "h-4 w-4" })
  }
));
zT.displayName = BT.displayName;
const Rh = g.forwardRef(({ className: e, children: t, position: r = "popper", ...n }, o) => /* @__PURE__ */ S(FF, { children: /* @__PURE__ */ ee(
  $T,
  {
    ref: o,
    className: re(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border border-slate-200 bg-white text-slate-950 shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50",
      r === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: r,
    ...n,
    children: [
      /* @__PURE__ */ S(qT, {}),
      /* @__PURE__ */ S(
        qF,
        {
          className: re(
            "p-1",
            r === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ S(zT, {})
    ]
  }
) }));
Rh.displayName = $T.displayName;
const HF = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  DT,
  {
    ref: r,
    className: re("py-1.5 pl-8 pr-2 text-sm font-semibold", e),
    ...t
  }
));
HF.displayName = DT.displayName;
const Tr = g.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ ee(
  jT,
  {
    ref: n,
    className: re(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-slate-100 focus:text-slate-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-slate-800 dark:focus:text-slate-50",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ S("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ S(UF, { children: /* @__PURE__ */ S(yc, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ S(WF, { children: t })
    ]
  }
));
Tr.displayName = jT.displayName;
const VF = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  FT,
  {
    ref: r,
    className: re("-mx-1 my-1 h-px bg-slate-100 dark:bg-slate-800", e),
    ...t
  }
));
VF.displayName = FT.displayName;
const KF = kc, gJ = Sm, yJ = jo, GF = $c, WT = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  $o,
  {
    className: re(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: r
  }
));
WT.displayName = $o.displayName;
const YF = ai(
  "fixed z-50 gap-4 bg-white p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500 dark:bg-slate-950",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b border-slate-200 data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top dark:border-slate-800",
        bottom: "inset-x-0 bottom-0 border-t border-slate-200 data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom dark:border-slate-800",
        left: "inset-y-0 left-0 h-full w-3/4 border-r border-slate-200 data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm dark:border-slate-800",
        right: "inset-y-0 right-0 h-full w-3/4  border-l border-slate-200 data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm dark:border-slate-800"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), UT = g.forwardRef(({ side: e = "right", className: t, children: r, ...n }, o) => /* @__PURE__ */ ee(GF, { children: [
  /* @__PURE__ */ S(WT, {}),
  /* @__PURE__ */ ee(
    Do,
    {
      ref: o,
      className: re(YF({ side: e }), t),
      ...n,
      children: [
        r,
        /* @__PURE__ */ ee(jo, { className: "absolute right-4 top-4 rounded-md opacity-70 ring-offset-white transition-all duration-200 hover:opacity-100 hover:bg-slate-100 hover:scale-110 hover:rotate-90 dark:hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-slate-50 dark:ring-offset-slate-950 dark:focus:ring-slate-300 dark:data-[state=open]:bg-slate-800/50", children: [
          /* @__PURE__ */ S(Co, { className: "h-4 w-4 transition-transform" }),
          /* @__PURE__ */ S("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
UT.displayName = Do.displayName;
const HT = ({
  className: e,
  ...t
}) => /* @__PURE__ */ S(
  "div",
  {
    className: re(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
);
HT.displayName = "SheetHeader";
const XF = ({
  className: e,
  ...t
}) => /* @__PURE__ */ S(
  "div",
  {
    className: re(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
XF.displayName = "SheetFooter";
const VT = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  di,
  {
    ref: r,
    className: re("text-lg font-semibold text-slate-950 dark:text-slate-50", e),
    ...t
  }
));
VT.displayName = di.displayName;
const ZF = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  pi,
  {
    ref: r,
    className: re("text-sm text-slate-500 dark:text-slate-400", e),
    ...t
  }
));
ZF.displayName = pi.displayName;
var Kc = "Tabs", [JF] = at(Kc, [
  Bc
]), KT = Bc(), [QF, qm] = JF(Kc), GT = g.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: r,
      value: n,
      onValueChange: o,
      defaultValue: a,
      orientation: i = "horizontal",
      dir: s,
      activationMode: c = "automatic",
      ...l
    } = e, f = Ro(s), [u, d] = Pt({
      prop: n,
      onChange: o,
      defaultProp: a ?? "",
      caller: Kc
    });
    return /* @__PURE__ */ S(
      QF,
      {
        scope: r,
        baseId: je(),
        value: u,
        onValueChange: d,
        orientation: i,
        dir: f,
        activationMode: c,
        children: /* @__PURE__ */ S(
          ae.div,
          {
            dir: f,
            "data-orientation": i,
            ...l,
            ref: t
          }
        )
      }
    );
  }
);
GT.displayName = Kc;
var YT = "TabsList", XT = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, loop: n = !0, ...o } = e, a = qm(YT, r), i = KT(r);
    return /* @__PURE__ */ S(
      WP,
      {
        asChild: !0,
        ...i,
        orientation: a.orientation,
        dir: a.dir,
        loop: n,
        children: /* @__PURE__ */ S(
          ae.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
XT.displayName = YT;
var ZT = "TabsTrigger", JT = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, value: n, disabled: o = !1, ...a } = e, i = qm(ZT, r), s = KT(r), c = tC(i.baseId, n), l = rC(i.baseId, n), f = n === i.value;
    return /* @__PURE__ */ S(
      UP,
      {
        asChild: !0,
        ...s,
        focusable: !o,
        active: f,
        children: /* @__PURE__ */ S(
          ae.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": f,
            "aria-controls": l,
            "data-state": f ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: c,
            ...a,
            ref: t,
            onMouseDown: Z(e.onMouseDown, (u) => {
              !o && u.button === 0 && u.ctrlKey === !1 ? i.onValueChange(n) : u.preventDefault();
            }),
            onKeyDown: Z(e.onKeyDown, (u) => {
              [" ", "Enter"].includes(u.key) && i.onValueChange(n);
            }),
            onFocus: Z(e.onFocus, () => {
              const u = i.activationMode !== "manual";
              !f && !o && u && i.onValueChange(n);
            })
          }
        )
      }
    );
  }
);
JT.displayName = ZT;
var QT = "TabsContent", eC = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, value: n, forceMount: o, children: a, ...i } = e, s = qm(QT, r), c = tC(s.baseId, n), l = rC(s.baseId, n), f = n === s.value, u = g.useRef(f);
    return g.useEffect(() => {
      const d = requestAnimationFrame(() => u.current = !1);
      return () => cancelAnimationFrame(d);
    }, []), /* @__PURE__ */ S(Ge, { present: o || f, children: ({ present: d }) => /* @__PURE__ */ S(
      ae.div,
      {
        "data-state": f ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": c,
        hidden: !d,
        id: l,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: u.current ? "0s" : void 0
        },
        children: d && a
      }
    ) });
  }
);
eC.displayName = QT;
function tC(e, t) {
  return `${e}-trigger-${t}`;
}
function rC(e, t) {
  return `${e}-content-${t}`;
}
var e5 = GT, nC = XT, oC = JT, aC = eC;
const bJ = e5, t5 = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  nC,
  {
    ref: r,
    className: re(
      "inline-flex h-10 items-center justify-center rounded-md bg-slate-100 p-1 text-slate-500 dark:bg-slate-800 dark:text-slate-400",
      e
    ),
    ...t
  }
));
t5.displayName = nC.displayName;
const r5 = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  oC,
  {
    ref: r,
    className: re(
      "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-white data-[state=active]:text-slate-950 data-[state=active]:shadow-sm dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300 dark:data-[state=active]:bg-slate-950 dark:data-[state=active]:text-slate-50",
      e
    ),
    ...t
  }
));
r5.displayName = oC.displayName;
const n5 = g.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ S(
  aC,
  {
    ref: r,
    className: re(
      "mt-2 ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300",
      e
    ),
    ...t
  }
));
n5.displayName = aC.displayName;
var Ql, Ry;
function lt() {
  if (Ry) return Ql;
  Ry = 1;
  var e = Array.isArray;
  return Ql = e, Ql;
}
var eu, My;
function iC() {
  if (My) return eu;
  My = 1;
  var e = typeof Mi == "object" && Mi && Mi.Object === Object && Mi;
  return eu = e, eu;
}
var tu, Iy;
function nr() {
  if (Iy) return tu;
  Iy = 1;
  var e = iC(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return tu = r, tu;
}
var ru, Ny;
function xi() {
  if (Ny) return ru;
  Ny = 1;
  var e = nr(), t = e.Symbol;
  return ru = t, ru;
}
var nu, ky;
function o5() {
  if (ky) return nu;
  ky = 1;
  var e = xi(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, o = e ? e.toStringTag : void 0;
  function a(i) {
    var s = r.call(i, o), c = i[o];
    try {
      i[o] = void 0;
      var l = !0;
    } catch {
    }
    var f = n.call(i);
    return l && (s ? i[o] = c : delete i[o]), f;
  }
  return nu = a, nu;
}
var ou, $y;
function a5() {
  if ($y) return ou;
  $y = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return ou = r, ou;
}
var au, Dy;
function Sr() {
  if (Dy) return au;
  Dy = 1;
  var e = xi(), t = o5(), r = a5(), n = "[object Null]", o = "[object Undefined]", a = e ? e.toStringTag : void 0;
  function i(s) {
    return s == null ? s === void 0 ? o : n : a && a in Object(s) ? t(s) : r(s);
  }
  return au = i, au;
}
var iu, jy;
function _r() {
  if (jy) return iu;
  jy = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return iu = e, iu;
}
var su, Ly;
function Bo() {
  if (Ly) return su;
  Ly = 1;
  var e = Sr(), t = _r(), r = "[object Symbol]";
  function n(o) {
    return typeof o == "symbol" || t(o) && e(o) == r;
  }
  return su = n, su;
}
var cu, By;
function zm() {
  if (By) return cu;
  By = 1;
  var e = lt(), t = Bo(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function o(a, i) {
    if (e(a))
      return !1;
    var s = typeof a;
    return s == "number" || s == "symbol" || s == "boolean" || a == null || t(a) ? !0 : n.test(a) || !r.test(a) || i != null && a in Object(i);
  }
  return cu = o, cu;
}
var lu, Fy;
function zr() {
  if (Fy) return lu;
  Fy = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return lu = e, lu;
}
var uu, qy;
function Wm() {
  if (qy) return uu;
  qy = 1;
  var e = Sr(), t = zr(), r = "[object AsyncFunction]", n = "[object Function]", o = "[object GeneratorFunction]", a = "[object Proxy]";
  function i(s) {
    if (!t(s))
      return !1;
    var c = e(s);
    return c == n || c == o || c == r || c == a;
  }
  return uu = i, uu;
}
var fu, zy;
function i5() {
  if (zy) return fu;
  zy = 1;
  var e = nr(), t = e["__core-js_shared__"];
  return fu = t, fu;
}
var du, Wy;
function s5() {
  if (Wy) return du;
  Wy = 1;
  var e = i5(), t = (function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  })();
  function r(n) {
    return !!t && t in n;
  }
  return du = r, du;
}
var pu, Uy;
function sC() {
  if (Uy) return pu;
  Uy = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return pu = r, pu;
}
var hu, Hy;
function c5() {
  if (Hy) return hu;
  Hy = 1;
  var e = Wm(), t = s5(), r = zr(), n = sC(), o = /[\\^$.*+?()[\]{}|]/g, a = /^\[object .+?Constructor\]$/, i = Function.prototype, s = Object.prototype, c = i.toString, l = s.hasOwnProperty, f = RegExp(
    "^" + c.call(l).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function u(d) {
    if (!r(d) || t(d))
      return !1;
    var h = e(d) ? f : a;
    return h.test(n(d));
  }
  return hu = u, hu;
}
var vu, Vy;
function l5() {
  if (Vy) return vu;
  Vy = 1;
  function e(t, r) {
    return t == null ? void 0 : t[r];
  }
  return vu = e, vu;
}
var mu, Ky;
function Sn() {
  if (Ky) return mu;
  Ky = 1;
  var e = c5(), t = l5();
  function r(n, o) {
    var a = t(n, o);
    return e(a) ? a : void 0;
  }
  return mu = r, mu;
}
var gu, Gy;
function Gc() {
  if (Gy) return gu;
  Gy = 1;
  var e = Sn(), t = e(Object, "create");
  return gu = t, gu;
}
var yu, Yy;
function u5() {
  if (Yy) return yu;
  Yy = 1;
  var e = Gc();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return yu = t, yu;
}
var bu, Xy;
function f5() {
  if (Xy) return bu;
  Xy = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return bu = e, bu;
}
var wu, Zy;
function d5() {
  if (Zy) return wu;
  Zy = 1;
  var e = Gc(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function o(a) {
    var i = this.__data__;
    if (e) {
      var s = i[a];
      return s === t ? void 0 : s;
    }
    return n.call(i, a) ? i[a] : void 0;
  }
  return wu = o, wu;
}
var xu, Jy;
function p5() {
  if (Jy) return xu;
  Jy = 1;
  var e = Gc(), t = Object.prototype, r = t.hasOwnProperty;
  function n(o) {
    var a = this.__data__;
    return e ? a[o] !== void 0 : r.call(a, o);
  }
  return xu = n, xu;
}
var Su, Qy;
function h5() {
  if (Qy) return Su;
  Qy = 1;
  var e = Gc(), t = "__lodash_hash_undefined__";
  function r(n, o) {
    var a = this.__data__;
    return this.size += this.has(n) ? 0 : 1, a[n] = e && o === void 0 ? t : o, this;
  }
  return Su = r, Su;
}
var _u, eb;
function v5() {
  if (eb) return _u;
  eb = 1;
  var e = u5(), t = f5(), r = d5(), n = p5(), o = h5();
  function a(i) {
    var s = -1, c = i == null ? 0 : i.length;
    for (this.clear(); ++s < c; ) {
      var l = i[s];
      this.set(l[0], l[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = o, _u = a, _u;
}
var Ou, tb;
function m5() {
  if (tb) return Ou;
  tb = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Ou = e, Ou;
}
var Au, rb;
function Um() {
  if (rb) return Au;
  rb = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return Au = e, Au;
}
var Pu, nb;
function Yc() {
  if (nb) return Pu;
  nb = 1;
  var e = Um();
  function t(r, n) {
    for (var o = r.length; o--; )
      if (e(r[o][0], n))
        return o;
    return -1;
  }
  return Pu = t, Pu;
}
var Eu, ob;
function g5() {
  if (ob) return Eu;
  ob = 1;
  var e = Yc(), t = Array.prototype, r = t.splice;
  function n(o) {
    var a = this.__data__, i = e(a, o);
    if (i < 0)
      return !1;
    var s = a.length - 1;
    return i == s ? a.pop() : r.call(a, i, 1), --this.size, !0;
  }
  return Eu = n, Eu;
}
var Tu, ab;
function y5() {
  if (ab) return Tu;
  ab = 1;
  var e = Yc();
  function t(r) {
    var n = this.__data__, o = e(n, r);
    return o < 0 ? void 0 : n[o][1];
  }
  return Tu = t, Tu;
}
var Cu, ib;
function b5() {
  if (ib) return Cu;
  ib = 1;
  var e = Yc();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return Cu = t, Cu;
}
var Ru, sb;
function w5() {
  if (sb) return Ru;
  sb = 1;
  var e = Yc();
  function t(r, n) {
    var o = this.__data__, a = e(o, r);
    return a < 0 ? (++this.size, o.push([r, n])) : o[a][1] = n, this;
  }
  return Ru = t, Ru;
}
var Mu, cb;
function Xc() {
  if (cb) return Mu;
  cb = 1;
  var e = m5(), t = g5(), r = y5(), n = b5(), o = w5();
  function a(i) {
    var s = -1, c = i == null ? 0 : i.length;
    for (this.clear(); ++s < c; ) {
      var l = i[s];
      this.set(l[0], l[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = o, Mu = a, Mu;
}
var Iu, lb;
function Hm() {
  if (lb) return Iu;
  lb = 1;
  var e = Sn(), t = nr(), r = e(t, "Map");
  return Iu = r, Iu;
}
var Nu, ub;
function x5() {
  if (ub) return Nu;
  ub = 1;
  var e = v5(), t = Xc(), r = Hm();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return Nu = n, Nu;
}
var ku, fb;
function S5() {
  if (fb) return ku;
  fb = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return ku = e, ku;
}
var $u, db;
function Zc() {
  if (db) return $u;
  db = 1;
  var e = S5();
  function t(r, n) {
    var o = r.__data__;
    return e(n) ? o[typeof n == "string" ? "string" : "hash"] : o.map;
  }
  return $u = t, $u;
}
var Du, pb;
function _5() {
  if (pb) return Du;
  pb = 1;
  var e = Zc();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return Du = t, Du;
}
var ju, hb;
function O5() {
  if (hb) return ju;
  hb = 1;
  var e = Zc();
  function t(r) {
    return e(this, r).get(r);
  }
  return ju = t, ju;
}
var Lu, vb;
function A5() {
  if (vb) return Lu;
  vb = 1;
  var e = Zc();
  function t(r) {
    return e(this, r).has(r);
  }
  return Lu = t, Lu;
}
var Bu, mb;
function P5() {
  if (mb) return Bu;
  mb = 1;
  var e = Zc();
  function t(r, n) {
    var o = e(this, r), a = o.size;
    return o.set(r, n), this.size += o.size == a ? 0 : 1, this;
  }
  return Bu = t, Bu;
}
var Fu, gb;
function Vm() {
  if (gb) return Fu;
  gb = 1;
  var e = x5(), t = _5(), r = O5(), n = A5(), o = P5();
  function a(i) {
    var s = -1, c = i == null ? 0 : i.length;
    for (this.clear(); ++s < c; ) {
      var l = i[s];
      this.set(l[0], l[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = o, Fu = a, Fu;
}
var qu, yb;
function cC() {
  if (yb) return qu;
  yb = 1;
  var e = Vm(), t = "Expected a function";
  function r(n, o) {
    if (typeof n != "function" || o != null && typeof o != "function")
      throw new TypeError(t);
    var a = function() {
      var i = arguments, s = o ? o.apply(this, i) : i[0], c = a.cache;
      if (c.has(s))
        return c.get(s);
      var l = n.apply(this, i);
      return a.cache = c.set(s, l) || c, l;
    };
    return a.cache = new (r.Cache || e)(), a;
  }
  return r.Cache = e, qu = r, qu;
}
var zu, bb;
function E5() {
  if (bb) return zu;
  bb = 1;
  var e = cC(), t = 500;
  function r(n) {
    var o = e(n, function(i) {
      return a.size === t && a.clear(), i;
    }), a = o.cache;
    return o;
  }
  return zu = r, zu;
}
var Wu, wb;
function T5() {
  if (wb) return Wu;
  wb = 1;
  var e = E5(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = e(function(o) {
    var a = [];
    return o.charCodeAt(0) === 46 && a.push(""), o.replace(t, function(i, s, c, l) {
      a.push(c ? l.replace(r, "$1") : s || i);
    }), a;
  });
  return Wu = n, Wu;
}
var Uu, xb;
function Km() {
  if (xb) return Uu;
  xb = 1;
  function e(t, r) {
    for (var n = -1, o = t == null ? 0 : t.length, a = Array(o); ++n < o; )
      a[n] = r(t[n], n, t);
    return a;
  }
  return Uu = e, Uu;
}
var Hu, Sb;
function C5() {
  if (Sb) return Hu;
  Sb = 1;
  var e = xi(), t = Km(), r = lt(), n = Bo(), o = e ? e.prototype : void 0, a = o ? o.toString : void 0;
  function i(s) {
    if (typeof s == "string")
      return s;
    if (r(s))
      return t(s, i) + "";
    if (n(s))
      return a ? a.call(s) : "";
    var c = s + "";
    return c == "0" && 1 / s == -1 / 0 ? "-0" : c;
  }
  return Hu = i, Hu;
}
var Vu, _b;
function lC() {
  if (_b) return Vu;
  _b = 1;
  var e = C5();
  function t(r) {
    return r == null ? "" : e(r);
  }
  return Vu = t, Vu;
}
var Ku, Ob;
function uC() {
  if (Ob) return Ku;
  Ob = 1;
  var e = lt(), t = zm(), r = T5(), n = lC();
  function o(a, i) {
    return e(a) ? a : t(a, i) ? [a] : r(n(a));
  }
  return Ku = o, Ku;
}
var Gu, Ab;
function Jc() {
  if (Ab) return Gu;
  Ab = 1;
  var e = Bo();
  function t(r) {
    if (typeof r == "string" || e(r))
      return r;
    var n = r + "";
    return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
  }
  return Gu = t, Gu;
}
var Yu, Pb;
function Gm() {
  if (Pb) return Yu;
  Pb = 1;
  var e = uC(), t = Jc();
  function r(n, o) {
    o = e(o, n);
    for (var a = 0, i = o.length; n != null && a < i; )
      n = n[t(o[a++])];
    return a && a == i ? n : void 0;
  }
  return Yu = r, Yu;
}
var Xu, Eb;
function fC() {
  if (Eb) return Xu;
  Eb = 1;
  var e = Gm();
  function t(r, n, o) {
    var a = r == null ? void 0 : e(r, n);
    return a === void 0 ? o : a;
  }
  return Xu = t, Xu;
}
var R5 = fC();
const yt = /* @__PURE__ */ Ae(R5);
var Zu, Tb;
function M5() {
  if (Tb) return Zu;
  Tb = 1;
  function e(t) {
    return t == null;
  }
  return Zu = e, Zu;
}
var I5 = M5();
const fe = /* @__PURE__ */ Ae(I5);
var Ju, Cb;
function N5() {
  if (Cb) return Ju;
  Cb = 1;
  var e = Sr(), t = lt(), r = _r(), n = "[object String]";
  function o(a) {
    return typeof a == "string" || !t(a) && r(a) && e(a) == n;
  }
  return Ju = o, Ju;
}
var k5 = N5();
const vn = /* @__PURE__ */ Ae(k5);
var $5 = Wm();
const ue = /* @__PURE__ */ Ae($5);
var D5 = zr();
const Fo = /* @__PURE__ */ Ae(D5);
var Bi = { exports: {} }, ye = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rb;
function j5() {
  if (Rb) return ye;
  Rb = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function v(p) {
    if (typeof p == "object" && p !== null) {
      var b = p.$$typeof;
      switch (b) {
        case e:
          switch (p = p.type, p) {
            case r:
            case o:
            case n:
            case l:
            case f:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case s:
                case i:
                case c:
                case d:
                case u:
                case a:
                  return p;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  return ye.ContextConsumer = i, ye.ContextProvider = a, ye.Element = e, ye.ForwardRef = c, ye.Fragment = r, ye.Lazy = d, ye.Memo = u, ye.Portal = t, ye.Profiler = o, ye.StrictMode = n, ye.Suspense = l, ye.SuspenseList = f, ye.isAsyncMode = function() {
    return !1;
  }, ye.isConcurrentMode = function() {
    return !1;
  }, ye.isContextConsumer = function(p) {
    return v(p) === i;
  }, ye.isContextProvider = function(p) {
    return v(p) === a;
  }, ye.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === e;
  }, ye.isForwardRef = function(p) {
    return v(p) === c;
  }, ye.isFragment = function(p) {
    return v(p) === r;
  }, ye.isLazy = function(p) {
    return v(p) === d;
  }, ye.isMemo = function(p) {
    return v(p) === u;
  }, ye.isPortal = function(p) {
    return v(p) === t;
  }, ye.isProfiler = function(p) {
    return v(p) === o;
  }, ye.isStrictMode = function(p) {
    return v(p) === n;
  }, ye.isSuspense = function(p) {
    return v(p) === l;
  }, ye.isSuspenseList = function(p) {
    return v(p) === f;
  }, ye.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === r || p === o || p === n || p === l || p === f || p === h || typeof p == "object" && p !== null && (p.$$typeof === d || p.$$typeof === u || p.$$typeof === a || p.$$typeof === i || p.$$typeof === c || p.$$typeof === m || p.getModuleId !== void 0);
  }, ye.typeOf = v, ye;
}
var be = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mb;
function L5() {
  return Mb || (Mb = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = !1, v = !1, p = !1, b = !1, w = !1, x;
    x = Symbol.for("react.module.reference");
    function _(X) {
      return !!(typeof X == "string" || typeof X == "function" || X === r || X === o || w || X === n || X === l || X === f || b || X === h || m || v || p || typeof X == "object" && X !== null && (X.$$typeof === d || X.$$typeof === u || X.$$typeof === a || X.$$typeof === i || X.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      X.$$typeof === x || X.getModuleId !== void 0));
    }
    function y(X) {
      if (typeof X == "object" && X !== null) {
        var he = X.$$typeof;
        switch (he) {
          case e:
            var ge = X.type;
            switch (ge) {
              case r:
              case o:
              case n:
              case l:
              case f:
                return ge;
              default:
                var Ie = ge && ge.$$typeof;
                switch (Ie) {
                  case s:
                  case i:
                  case c:
                  case d:
                  case u:
                  case a:
                    return Ie;
                  default:
                    return he;
                }
            }
          case t:
            return he;
        }
      }
    }
    var O = i, A = a, P = e, T = c, I = r, E = d, C = u, R = t, M = o, D = n, $ = l, q = f, F = !1, B = !1;
    function L(X) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function z(X) {
      return B || (B = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function N(X) {
      return y(X) === i;
    }
    function U(X) {
      return y(X) === a;
    }
    function K(X) {
      return typeof X == "object" && X !== null && X.$$typeof === e;
    }
    function G(X) {
      return y(X) === c;
    }
    function J(X) {
      return y(X) === r;
    }
    function V(X) {
      return y(X) === d;
    }
    function Q(X) {
      return y(X) === u;
    }
    function W(X) {
      return y(X) === t;
    }
    function Y(X) {
      return y(X) === o;
    }
    function te(X) {
      return y(X) === n;
    }
    function j(X) {
      return y(X) === l;
    }
    function ce(X) {
      return y(X) === f;
    }
    be.ContextConsumer = O, be.ContextProvider = A, be.Element = P, be.ForwardRef = T, be.Fragment = I, be.Lazy = E, be.Memo = C, be.Portal = R, be.Profiler = M, be.StrictMode = D, be.Suspense = $, be.SuspenseList = q, be.isAsyncMode = L, be.isConcurrentMode = z, be.isContextConsumer = N, be.isContextProvider = U, be.isElement = K, be.isForwardRef = G, be.isFragment = J, be.isLazy = V, be.isMemo = Q, be.isPortal = W, be.isProfiler = Y, be.isStrictMode = te, be.isSuspense = j, be.isSuspenseList = ce, be.isValidElementType = _, be.typeOf = y;
  })()), be;
}
var Ib;
function B5() {
  return Ib || (Ib = 1, process.env.NODE_ENV === "production" ? Bi.exports = j5() : Bi.exports = L5()), Bi.exports;
}
var F5 = B5(), Qu, Nb;
function dC() {
  if (Nb) return Qu;
  Nb = 1;
  var e = Sr(), t = _r(), r = "[object Number]";
  function n(o) {
    return typeof o == "number" || t(o) && e(o) == r;
  }
  return Qu = n, Qu;
}
var ef, kb;
function q5() {
  if (kb) return ef;
  kb = 1;
  var e = dC();
  function t(r) {
    return e(r) && r != +r;
  }
  return ef = t, ef;
}
var z5 = q5();
const Si = /* @__PURE__ */ Ae(z5);
var W5 = dC();
const U5 = /* @__PURE__ */ Ae(W5);
var rt = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, en = function(t) {
  return vn(t) && t.indexOf("%") === t.length - 1;
}, ne = function(t) {
  return U5(t) && !Si(t);
}, H5 = function(t) {
  return fe(t);
}, We = function(t) {
  return ne(t) || vn(t);
}, V5 = 0, qo = function(t) {
  var r = ++V5;
  return "".concat(t || "").concat(r);
}, nt = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!ne(t) && !vn(t))
    return n;
  var a;
  if (en(t)) {
    var i = t.indexOf("%");
    a = r * parseFloat(t.slice(0, i)) / 100;
  } else
    a = +t;
  return Si(a) && (a = n), o && a > r && (a = r), a;
}, Dn = function(t) {
  if (!t)
    return null;
  var r = Object.keys(t);
  return r && r.length ? t[r[0]] : null;
}, K5 = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var r = t.length, n = {}, o = 0; o < r; o++)
    if (!n[t[o]])
      n[t[o]] = !0;
    else
      return !0;
  return !1;
}, ht = function(t, r) {
  return ne(t) && ne(r) ? function(n) {
    return t + n * (r - t);
  } : function() {
    return r;
  };
};
function ms(e, t, r) {
  return !e || !e.length ? null : e.find(function(n) {
    return n && (typeof t == "function" ? t(n) : yt(n, t)) === r;
  });
}
var G5 = function(t, r) {
  return ne(t) && ne(r) ? t - r : vn(t) && vn(r) ? t.localeCompare(r) : t instanceof Date && r instanceof Date ? t.getTime() - r.getTime() : String(t).localeCompare(String(r));
};
function Vn(e, t) {
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r) && (!{}.hasOwnProperty.call(t, r) || e[r] !== t[r]))
      return !1;
  for (var n in t)
    if ({}.hasOwnProperty.call(t, n) && !{}.hasOwnProperty.call(e, n))
      return !1;
  return !0;
}
function Mh(e) {
  "@babel/helpers - typeof";
  return Mh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mh(e);
}
var Y5 = ["viewBox", "children"], X5 = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], $b = ["points", "pathLength"], tf = {
  svg: Y5,
  polygon: $b,
  polyline: $b
}, Ym = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], gs = function(t, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var n = t;
  if (/* @__PURE__ */ jt(t) && (n = t.props), !Fo(n))
    return null;
  var o = {};
  return Object.keys(n).forEach(function(a) {
    Ym.includes(a) && (o[a] = r || function(i) {
      return n[a](n, i);
    });
  }), o;
}, Z5 = function(t, r, n) {
  return function(o) {
    return t(r, n, o), null;
  };
}, mn = function(t, r, n) {
  if (!Fo(t) || Mh(t) !== "object")
    return null;
  var o = null;
  return Object.keys(t).forEach(function(a) {
    var i = t[a];
    Ym.includes(a) && typeof i == "function" && (o || (o = {}), o[a] = Z5(i, r, n));
  }), o;
}, J5 = ["children"], Q5 = ["children"];
function Db(e, t) {
  if (e == null) return {};
  var r = eq(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function eq(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Ih(e) {
  "@babel/helpers - typeof";
  return Ih = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ih(e);
}
var jb = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, dr = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, Lb = null, rf = null, Xm = function e(t) {
  if (t === Lb && Array.isArray(rf))
    return rf;
  var r = [];
  return on.forEach(t, function(n) {
    fe(n) || (F5.isFragment(n) ? r = r.concat(e(n.props.children)) : r.push(n));
  }), rf = r, Lb = t, r;
};
function bt(e, t) {
  var r = [], n = [];
  return Array.isArray(t) ? n = t.map(function(o) {
    return dr(o);
  }) : n = [dr(t)], Xm(e).forEach(function(o) {
    var a = yt(o, "type.displayName") || yt(o, "type.name");
    n.indexOf(a) !== -1 && r.push(o);
  }), r;
}
function dt(e, t) {
  var r = bt(e, t);
  return r && r[0];
}
var Bb = function(t) {
  if (!t || !t.props)
    return !1;
  var r = t.props, n = r.width, o = r.height;
  return !(!ne(n) || n <= 0 || !ne(o) || o <= 0);
}, tq = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], rq = function(t) {
  return t && t.type && vn(t.type) && tq.indexOf(t.type) >= 0;
}, nq = function(t) {
  return t && Ih(t) === "object" && "clipDot" in t;
}, oq = function(t, r, n, o) {
  var a, i = (a = tf == null ? void 0 : tf[o]) !== null && a !== void 0 ? a : [];
  return r.startsWith("data-") || !ue(t) && (o && i.includes(r) || X5.includes(r)) || n && Ym.includes(r);
}, ie = function(t, r, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var o = t;
  if (/* @__PURE__ */ jt(t) && (o = t.props), !Fo(o))
    return null;
  var a = {};
  return Object.keys(o).forEach(function(i) {
    var s;
    oq((s = o) === null || s === void 0 ? void 0 : s[i], i, r, n) && (a[i] = o[i]);
  }), a;
}, Nh = function e(t, r) {
  if (t === r)
    return !0;
  var n = on.count(t);
  if (n !== on.count(r))
    return !1;
  if (n === 0)
    return !0;
  if (n === 1)
    return Fb(Array.isArray(t) ? t[0] : t, Array.isArray(r) ? r[0] : r);
  for (var o = 0; o < n; o++) {
    var a = t[o], i = r[o];
    if (Array.isArray(a) || Array.isArray(i)) {
      if (!e(a, i))
        return !1;
    } else if (!Fb(a, i))
      return !1;
  }
  return !0;
}, Fb = function(t, r) {
  if (fe(t) && fe(r))
    return !0;
  if (!fe(t) && !fe(r)) {
    var n = t.props || {}, o = n.children, a = Db(n, J5), i = r.props || {}, s = i.children, c = Db(i, Q5);
    return o && s ? Vn(a, c) && Nh(o, s) : !o && !s ? Vn(a, c) : !1;
  }
  return !1;
}, qb = function(t, r) {
  var n = [], o = {};
  return Xm(t).forEach(function(a, i) {
    if (rq(a))
      n.push(a);
    else if (a) {
      var s = dr(a.type), c = r[s] || {}, l = c.handler, f = c.once;
      if (l && (!f || !o[s])) {
        var u = l(a, s, i);
        n.push(u), o[s] = !0;
      }
    }
  }), n;
}, aq = function(t) {
  var r = t && t.type;
  return r && jb[r] ? jb[r] : null;
}, iq = function(t, r) {
  return Xm(r).indexOf(t);
}, sq = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function kh() {
  return kh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kh.apply(this, arguments);
}
function cq(e, t) {
  if (e == null) return {};
  var r = lq(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function lq(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function $h(e) {
  var t = e.children, r = e.width, n = e.height, o = e.viewBox, a = e.className, i = e.style, s = e.title, c = e.desc, l = cq(e, sq), f = o || {
    width: r,
    height: n,
    x: 0,
    y: 0
  }, u = de("recharts-surface", a);
  return /* @__PURE__ */ k.createElement("svg", kh({}, ie(l, !0, "svg"), {
    className: u,
    width: r,
    height: n,
    style: i,
    viewBox: "".concat(f.x, " ").concat(f.y, " ").concat(f.width, " ").concat(f.height)
  }), /* @__PURE__ */ k.createElement("title", null, s), /* @__PURE__ */ k.createElement("desc", null, c), t);
}
var uq = ["children", "className"];
function Dh() {
  return Dh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Dh.apply(this, arguments);
}
function fq(e, t) {
  if (e == null) return {};
  var r = dq(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function dq(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var ve = /* @__PURE__ */ k.forwardRef(function(e, t) {
  var r = e.children, n = e.className, o = fq(e, uq), a = de("recharts-layer", n);
  return /* @__PURE__ */ k.createElement("g", Dh({
    className: a
  }, ie(o, !0), {
    ref: t
  }), r);
}), pq = process.env.NODE_ENV !== "production", pr = function(t, r) {
  for (var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++)
    o[a - 2] = arguments[a];
  if (pq && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var i = 0;
      console.warn(r.replace(/%s/g, function() {
        return o[i++];
      }));
    }
}, nf, zb;
function hq() {
  if (zb) return nf;
  zb = 1;
  function e(t, r, n) {
    var o = -1, a = t.length;
    r < 0 && (r = -r > a ? 0 : a + r), n = n > a ? a : n, n < 0 && (n += a), a = r > n ? 0 : n - r >>> 0, r >>>= 0;
    for (var i = Array(a); ++o < a; )
      i[o] = t[o + r];
    return i;
  }
  return nf = e, nf;
}
var of, Wb;
function vq() {
  if (Wb) return of;
  Wb = 1;
  var e = hq();
  function t(r, n, o) {
    var a = r.length;
    return o = o === void 0 ? a : o, !n && o >= a ? r : e(r, n, o);
  }
  return of = t, of;
}
var af, Ub;
function pC() {
  if (Ub) return af;
  Ub = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", o = t + r + n, a = "\\ufe0e\\ufe0f", i = "\\u200d", s = RegExp("[" + i + e + o + a + "]");
  function c(l) {
    return s.test(l);
  }
  return af = c, af;
}
var sf, Hb;
function mq() {
  if (Hb) return sf;
  Hb = 1;
  function e(t) {
    return t.split("");
  }
  return sf = e, sf;
}
var cf, Vb;
function gq() {
  if (Vb) return cf;
  Vb = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", o = t + r + n, a = "\\ufe0e\\ufe0f", i = "[" + e + "]", s = "[" + o + "]", c = "\\ud83c[\\udffb-\\udfff]", l = "(?:" + s + "|" + c + ")", f = "[^" + e + "]", u = "(?:\\ud83c[\\udde6-\\uddff]){2}", d = "[\\ud800-\\udbff][\\udc00-\\udfff]", h = "\\u200d", m = l + "?", v = "[" + a + "]?", p = "(?:" + h + "(?:" + [f, u, d].join("|") + ")" + v + m + ")*", b = v + m + p, w = "(?:" + [f + s + "?", s, u, d, i].join("|") + ")", x = RegExp(c + "(?=" + c + ")|" + w + b, "g");
  function _(y) {
    return y.match(x) || [];
  }
  return cf = _, cf;
}
var lf, Kb;
function yq() {
  if (Kb) return lf;
  Kb = 1;
  var e = mq(), t = pC(), r = gq();
  function n(o) {
    return t(o) ? r(o) : e(o);
  }
  return lf = n, lf;
}
var uf, Gb;
function bq() {
  if (Gb) return uf;
  Gb = 1;
  var e = vq(), t = pC(), r = yq(), n = lC();
  function o(a) {
    return function(i) {
      i = n(i);
      var s = t(i) ? r(i) : void 0, c = s ? s[0] : i.charAt(0), l = s ? e(s, 1).join("") : i.slice(1);
      return c[a]() + l;
    };
  }
  return uf = o, uf;
}
var ff, Yb;
function wq() {
  if (Yb) return ff;
  Yb = 1;
  var e = bq(), t = e("toUpperCase");
  return ff = t, ff;
}
var xq = wq();
const Qc = /* @__PURE__ */ Ae(xq);
function Ee(e) {
  return function() {
    return e;
  };
}
const hC = Math.cos, ys = Math.sin, Wt = Math.sqrt, bs = Math.PI, el = 2 * bs, jh = Math.PI, Lh = 2 * jh, Zr = 1e-6, Sq = Lh - Zr;
function vC(e) {
  this._ += e[0];
  for (let t = 1, r = e.length; t < r; ++t)
    this._ += arguments[t] + e[t];
}
function _q(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return vC;
  const r = 10 ** t;
  return function(n) {
    this._ += n[0];
    for (let o = 1, a = n.length; o < a; ++o)
      this._ += Math.round(arguments[o] * r) / r + n[o];
  };
}
class Oq {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? vC : _q(t);
  }
  moveTo(t, r) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, r) {
    this._append`L${this._x1 = +t},${this._y1 = +r}`;
  }
  quadraticCurveTo(t, r, n, o) {
    this._append`Q${+t},${+r},${this._x1 = +n},${this._y1 = +o}`;
  }
  bezierCurveTo(t, r, n, o, a, i) {
    this._append`C${+t},${+r},${+n},${+o},${this._x1 = +a},${this._y1 = +i}`;
  }
  arcTo(t, r, n, o, a) {
    if (t = +t, r = +r, n = +n, o = +o, a = +a, a < 0) throw new Error(`negative radius: ${a}`);
    let i = this._x1, s = this._y1, c = n - t, l = o - r, f = i - t, u = s - r, d = f * f + u * u;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = r}`;
    else if (d > Zr) if (!(Math.abs(u * c - l * f) > Zr) || !a)
      this._append`L${this._x1 = t},${this._y1 = r}`;
    else {
      let h = n - i, m = o - s, v = c * c + l * l, p = h * h + m * m, b = Math.sqrt(v), w = Math.sqrt(d), x = a * Math.tan((jh - Math.acos((v + d - p) / (2 * b * w))) / 2), _ = x / w, y = x / b;
      Math.abs(_ - 1) > Zr && this._append`L${t + _ * f},${r + _ * u}`, this._append`A${a},${a},0,0,${+(u * h > f * m)},${this._x1 = t + y * c},${this._y1 = r + y * l}`;
    }
  }
  arc(t, r, n, o, a, i) {
    if (t = +t, r = +r, n = +n, i = !!i, n < 0) throw new Error(`negative radius: ${n}`);
    let s = n * Math.cos(o), c = n * Math.sin(o), l = t + s, f = r + c, u = 1 ^ i, d = i ? o - a : a - o;
    this._x1 === null ? this._append`M${l},${f}` : (Math.abs(this._x1 - l) > Zr || Math.abs(this._y1 - f) > Zr) && this._append`L${l},${f}`, n && (d < 0 && (d = d % Lh + Lh), d > Sq ? this._append`A${n},${n},0,1,${u},${t - s},${r - c}A${n},${n},0,1,${u},${this._x1 = l},${this._y1 = f}` : d > Zr && this._append`A${n},${n},0,${+(d >= jh)},${u},${this._x1 = t + n * Math.cos(a)},${this._y1 = r + n * Math.sin(a)}`);
  }
  rect(t, r, n, o) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}h${n = +n}v${+o}h${-n}Z`;
  }
  toString() {
    return this._;
  }
}
function Zm(e) {
  let t = 3;
  return e.digits = function(r) {
    if (!arguments.length) return t;
    if (r == null)
      t = null;
    else {
      const n = Math.floor(r);
      if (!(n >= 0)) throw new RangeError(`invalid digits: ${r}`);
      t = n;
    }
    return e;
  }, () => new Oq(t);
}
function Jm(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function mC(e) {
  this._context = e;
}
mC.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function tl(e) {
  return new mC(e);
}
function gC(e) {
  return e[0];
}
function yC(e) {
  return e[1];
}
function bC(e, t) {
  var r = Ee(!0), n = null, o = tl, a = null, i = Zm(s);
  e = typeof e == "function" ? e : e === void 0 ? gC : Ee(e), t = typeof t == "function" ? t : t === void 0 ? yC : Ee(t);
  function s(c) {
    var l, f = (c = Jm(c)).length, u, d = !1, h;
    for (n == null && (a = o(h = i())), l = 0; l <= f; ++l)
      !(l < f && r(u = c[l], l, c)) === d && ((d = !d) ? a.lineStart() : a.lineEnd()), d && a.point(+e(u, l, c), +t(u, l, c));
    if (h) return a = null, h + "" || null;
  }
  return s.x = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : Ee(+c), s) : e;
  }, s.y = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : Ee(+c), s) : t;
  }, s.defined = function(c) {
    return arguments.length ? (r = typeof c == "function" ? c : Ee(!!c), s) : r;
  }, s.curve = function(c) {
    return arguments.length ? (o = c, n != null && (a = o(n)), s) : o;
  }, s.context = function(c) {
    return arguments.length ? (c == null ? n = a = null : a = o(n = c), s) : n;
  }, s;
}
function Fi(e, t, r) {
  var n = null, o = Ee(!0), a = null, i = tl, s = null, c = Zm(l);
  e = typeof e == "function" ? e : e === void 0 ? gC : Ee(+e), t = typeof t == "function" ? t : Ee(t === void 0 ? 0 : +t), r = typeof r == "function" ? r : r === void 0 ? yC : Ee(+r);
  function l(u) {
    var d, h, m, v = (u = Jm(u)).length, p, b = !1, w, x = new Array(v), _ = new Array(v);
    for (a == null && (s = i(w = c())), d = 0; d <= v; ++d) {
      if (!(d < v && o(p = u[d], d, u)) === b)
        if (b = !b)
          h = d, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), m = d - 1; m >= h; --m)
            s.point(x[m], _[m]);
          s.lineEnd(), s.areaEnd();
        }
      b && (x[d] = +e(p, d, u), _[d] = +t(p, d, u), s.point(n ? +n(p, d, u) : x[d], r ? +r(p, d, u) : _[d]));
    }
    if (w) return s = null, w + "" || null;
  }
  function f() {
    return bC().defined(o).curve(i).context(a);
  }
  return l.x = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : Ee(+u), n = null, l) : e;
  }, l.x0 = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : Ee(+u), l) : e;
  }, l.x1 = function(u) {
    return arguments.length ? (n = u == null ? null : typeof u == "function" ? u : Ee(+u), l) : n;
  }, l.y = function(u) {
    return arguments.length ? (t = typeof u == "function" ? u : Ee(+u), r = null, l) : t;
  }, l.y0 = function(u) {
    return arguments.length ? (t = typeof u == "function" ? u : Ee(+u), l) : t;
  }, l.y1 = function(u) {
    return arguments.length ? (r = u == null ? null : typeof u == "function" ? u : Ee(+u), l) : r;
  }, l.lineX0 = l.lineY0 = function() {
    return f().x(e).y(t);
  }, l.lineY1 = function() {
    return f().x(e).y(r);
  }, l.lineX1 = function() {
    return f().x(n).y(t);
  }, l.defined = function(u) {
    return arguments.length ? (o = typeof u == "function" ? u : Ee(!!u), l) : o;
  }, l.curve = function(u) {
    return arguments.length ? (i = u, a != null && (s = i(a)), l) : i;
  }, l.context = function(u) {
    return arguments.length ? (u == null ? a = s = null : s = i(a = u), l) : a;
  }, l;
}
class wC {
  constructor(t, r) {
    this._context = t, this._x = r;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, r) {
    switch (t = +t, r = +r, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, r, t, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, t, this._y0, t, r);
        break;
      }
    }
    this._x0 = t, this._y0 = r;
  }
}
function Aq(e) {
  return new wC(e, !0);
}
function Pq(e) {
  return new wC(e, !1);
}
const Qm = {
  draw(e, t) {
    const r = Wt(t / bs);
    e.moveTo(r, 0), e.arc(0, 0, r, 0, el);
  }
}, Eq = {
  draw(e, t) {
    const r = Wt(t / 5) / 2;
    e.moveTo(-3 * r, -r), e.lineTo(-r, -r), e.lineTo(-r, -3 * r), e.lineTo(r, -3 * r), e.lineTo(r, -r), e.lineTo(3 * r, -r), e.lineTo(3 * r, r), e.lineTo(r, r), e.lineTo(r, 3 * r), e.lineTo(-r, 3 * r), e.lineTo(-r, r), e.lineTo(-3 * r, r), e.closePath();
  }
}, xC = Wt(1 / 3), Tq = xC * 2, Cq = {
  draw(e, t) {
    const r = Wt(t / Tq), n = r * xC;
    e.moveTo(0, -r), e.lineTo(n, 0), e.lineTo(0, r), e.lineTo(-n, 0), e.closePath();
  }
}, Rq = {
  draw(e, t) {
    const r = Wt(t), n = -r / 2;
    e.rect(n, n, r, r);
  }
}, Mq = 0.8908130915292852, SC = ys(bs / 10) / ys(7 * bs / 10), Iq = ys(el / 10) * SC, Nq = -hC(el / 10) * SC, kq = {
  draw(e, t) {
    const r = Wt(t * Mq), n = Iq * r, o = Nq * r;
    e.moveTo(0, -r), e.lineTo(n, o);
    for (let a = 1; a < 5; ++a) {
      const i = el * a / 5, s = hC(i), c = ys(i);
      e.lineTo(c * r, -s * r), e.lineTo(s * n - c * o, c * n + s * o);
    }
    e.closePath();
  }
}, df = Wt(3), $q = {
  draw(e, t) {
    const r = -Wt(t / (df * 3));
    e.moveTo(0, r * 2), e.lineTo(-df * r, -r), e.lineTo(df * r, -r), e.closePath();
  }
}, wt = -0.5, xt = Wt(3) / 2, Bh = 1 / Wt(12), Dq = (Bh / 2 + 1) * 3, jq = {
  draw(e, t) {
    const r = Wt(t / Dq), n = r / 2, o = r * Bh, a = n, i = r * Bh + r, s = -a, c = i;
    e.moveTo(n, o), e.lineTo(a, i), e.lineTo(s, c), e.lineTo(wt * n - xt * o, xt * n + wt * o), e.lineTo(wt * a - xt * i, xt * a + wt * i), e.lineTo(wt * s - xt * c, xt * s + wt * c), e.lineTo(wt * n + xt * o, wt * o - xt * n), e.lineTo(wt * a + xt * i, wt * i - xt * a), e.lineTo(wt * s + xt * c, wt * c - xt * s), e.closePath();
  }
};
function Lq(e, t) {
  let r = null, n = Zm(o);
  e = typeof e == "function" ? e : Ee(e || Qm), t = typeof t == "function" ? t : Ee(t === void 0 ? 64 : +t);
  function o() {
    let a;
    if (r || (r = a = n()), e.apply(this, arguments).draw(r, +t.apply(this, arguments)), a) return r = null, a + "" || null;
  }
  return o.type = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : Ee(a), o) : e;
  }, o.size = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : Ee(+a), o) : t;
  }, o.context = function(a) {
    return arguments.length ? (r = a ?? null, o) : r;
  }, o;
}
function ws() {
}
function xs(e, t, r) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + r) / 6
  );
}
function _C(e) {
  this._context = e;
}
_C.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        xs(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        xs(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Bq(e) {
  return new _C(e);
}
function OC(e) {
  this._context = e;
}
OC.prototype = {
  areaStart: ws,
  areaEnd: ws,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        xs(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Fq(e) {
  return new OC(e);
}
function AC(e) {
  this._context = e;
}
AC.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + e) / 6, n = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        xs(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function qq(e) {
  return new AC(e);
}
function PC(e) {
  this._context = e;
}
PC.prototype = {
  areaStart: ws,
  areaEnd: ws,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function zq(e) {
  return new PC(e);
}
function Xb(e) {
  return e < 0 ? -1 : 1;
}
function Zb(e, t, r) {
  var n = e._x1 - e._x0, o = t - e._x1, a = (e._y1 - e._y0) / (n || o < 0 && -0), i = (r - e._y1) / (o || n < 0 && -0), s = (a * o + i * n) / (n + o);
  return (Xb(a) + Xb(i)) * Math.min(Math.abs(a), Math.abs(i), 0.5 * Math.abs(s)) || 0;
}
function Jb(e, t) {
  var r = e._x1 - e._x0;
  return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
}
function pf(e, t, r) {
  var n = e._x0, o = e._y0, a = e._x1, i = e._y1, s = (a - n) / 3;
  e._context.bezierCurveTo(n + s, o + s * t, a - s, i - s * r, a, i);
}
function Ss(e) {
  this._context = e;
}
Ss.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        pf(this, this._t0, Jb(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var r = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, pf(this, Jb(this, r = Zb(this, e, t)), r);
          break;
        default:
          pf(this, this._t0, r = Zb(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
    }
  }
};
function EC(e) {
  this._context = new TC(e);
}
(EC.prototype = Object.create(Ss.prototype)).point = function(e, t) {
  Ss.prototype.point.call(this, t, e);
};
function TC(e) {
  this._context = e;
}
TC.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, r, n, o, a) {
    this._context.bezierCurveTo(t, e, n, r, a, o);
  }
};
function Wq(e) {
  return new Ss(e);
}
function Uq(e) {
  return new EC(e);
}
function CC(e) {
  this._context = e;
}
CC.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, r = e.length;
    if (r)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), r === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var n = Qb(e), o = Qb(t), a = 0, i = 1; i < r; ++a, ++i)
          this._context.bezierCurveTo(n[0][a], o[0][a], n[1][a], o[1][a], e[i], t[i]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function Qb(e) {
  var t, r = e.length - 1, n, o = new Array(r), a = new Array(r), i = new Array(r);
  for (o[0] = 0, a[0] = 2, i[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t) o[t] = 1, a[t] = 4, i[t] = 4 * e[t] + 2 * e[t + 1];
  for (o[r - 1] = 2, a[r - 1] = 7, i[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t) n = o[t] / a[t - 1], a[t] -= n, i[t] -= n * i[t - 1];
  for (o[r - 1] = i[r - 1] / a[r - 1], t = r - 2; t >= 0; --t) o[t] = (i[t] - o[t + 1]) / a[t];
  for (a[r - 1] = (e[r] + o[r - 1]) / 2, t = 0; t < r - 1; ++t) a[t] = 2 * e[t + 1] - o[t + 1];
  return [o, a];
}
function Hq(e) {
  return new CC(e);
}
function rl(e, t) {
  this._context = e, this._t = t;
}
rl.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var r = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function Vq(e) {
  return new rl(e, 0.5);
}
function Kq(e) {
  return new rl(e, 0);
}
function Gq(e) {
  return new rl(e, 1);
}
function to(e, t) {
  if ((i = e.length) > 1)
    for (var r = 1, n, o, a = e[t[0]], i, s = a.length; r < i; ++r)
      for (o = a, a = e[t[r]], n = 0; n < s; ++n)
        a[n][1] += a[n][0] = isNaN(o[n][1]) ? o[n][0] : o[n][1];
}
function Fh(e) {
  for (var t = e.length, r = new Array(t); --t >= 0; ) r[t] = t;
  return r;
}
function Yq(e, t) {
  return e[t];
}
function Xq(e) {
  const t = [];
  return t.key = e, t;
}
function Zq() {
  var e = Ee([]), t = Fh, r = to, n = Yq;
  function o(a) {
    var i = Array.from(e.apply(this, arguments), Xq), s, c = i.length, l = -1, f;
    for (const u of a)
      for (s = 0, ++l; s < c; ++s)
        (i[s][l] = [0, +n(u, i[s].key, l, a)]).data = u;
    for (s = 0, f = Jm(t(i)); s < c; ++s)
      i[f[s]].index = s;
    return r(i, f), i;
  }
  return o.keys = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : Ee(Array.from(a)), o) : e;
  }, o.value = function(a) {
    return arguments.length ? (n = typeof a == "function" ? a : Ee(+a), o) : n;
  }, o.order = function(a) {
    return arguments.length ? (t = a == null ? Fh : typeof a == "function" ? a : Ee(Array.from(a)), o) : t;
  }, o.offset = function(a) {
    return arguments.length ? (r = a ?? to, o) : r;
  }, o;
}
function Jq(e, t) {
  if ((n = e.length) > 0) {
    for (var r, n, o = 0, a = e[0].length, i; o < a; ++o) {
      for (i = r = 0; r < n; ++r) i += e[r][o][1] || 0;
      if (i) for (r = 0; r < n; ++r) e[r][o][1] /= i;
    }
    to(e, t);
  }
}
function Qq(e, t) {
  if ((o = e.length) > 0) {
    for (var r = 0, n = e[t[0]], o, a = n.length; r < a; ++r) {
      for (var i = 0, s = 0; i < o; ++i) s += e[i][r][1] || 0;
      n[r][1] += n[r][0] = -s / 2;
    }
    to(e, t);
  }
}
function e3(e, t) {
  if (!(!((i = e.length) > 0) || !((a = (o = e[t[0]]).length) > 0))) {
    for (var r = 0, n = 1, o, a, i; n < a; ++n) {
      for (var s = 0, c = 0, l = 0; s < i; ++s) {
        for (var f = e[t[s]], u = f[n][1] || 0, d = f[n - 1][1] || 0, h = (u - d) / 2, m = 0; m < s; ++m) {
          var v = e[t[m]], p = v[n][1] || 0, b = v[n - 1][1] || 0;
          h += p - b;
        }
        c += u, l += h * u;
      }
      o[n - 1][1] += o[n - 1][0] = r, c && (r -= l / c);
    }
    o[n - 1][1] += o[n - 1][0] = r, to(e, t);
  }
}
function _a(e) {
  "@babel/helpers - typeof";
  return _a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _a(e);
}
var t3 = ["type", "size", "sizeType"];
function qh() {
  return qh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qh.apply(this, arguments);
}
function e0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function t0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? e0(Object(r), !0).forEach(function(n) {
      r3(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : e0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function r3(e, t, r) {
  return t = n3(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function n3(e) {
  var t = o3(e, "string");
  return _a(t) == "symbol" ? t : t + "";
}
function o3(e, t) {
  if (_a(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (_a(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function a3(e, t) {
  if (e == null) return {};
  var r = i3(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function i3(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var RC = {
  symbolCircle: Qm,
  symbolCross: Eq,
  symbolDiamond: Cq,
  symbolSquare: Rq,
  symbolStar: kq,
  symbolTriangle: $q,
  symbolWye: jq
}, s3 = Math.PI / 180, c3 = function(t) {
  var r = "symbol".concat(Qc(t));
  return RC[r] || Qm;
}, l3 = function(t, r, n) {
  if (r === "area")
    return t;
  switch (n) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var o = 18 * s3;
      return 1.25 * t * t * (Math.tan(o) - Math.tan(o * 2) * Math.pow(Math.tan(o), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, u3 = function(t, r) {
  RC["symbol".concat(Qc(t))] = r;
}, eg = function(t) {
  var r = t.type, n = r === void 0 ? "circle" : r, o = t.size, a = o === void 0 ? 64 : o, i = t.sizeType, s = i === void 0 ? "area" : i, c = a3(t, t3), l = t0(t0({}, c), {}, {
    type: n,
    size: a,
    sizeType: s
  }), f = function() {
    var p = c3(n), b = Lq().type(p).size(l3(a, s, n));
    return b();
  }, u = l.className, d = l.cx, h = l.cy, m = ie(l, !0);
  return d === +d && h === +h && a === +a ? /* @__PURE__ */ k.createElement("path", qh({}, m, {
    className: de("recharts-symbols", u),
    transform: "translate(".concat(d, ", ").concat(h, ")"),
    d: f()
  })) : null;
};
eg.registerSymbol = u3;
function ro(e) {
  "@babel/helpers - typeof";
  return ro = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ro(e);
}
function zh() {
  return zh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zh.apply(this, arguments);
}
function r0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function f3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? r0(Object(r), !0).forEach(function(n) {
      Oa(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : r0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function d3(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function p3(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, IC(n.key), n);
  }
}
function h3(e, t, r) {
  return t && p3(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function v3(e, t, r) {
  return t = _s(t), m3(e, MC() ? Reflect.construct(t, r || [], _s(e).constructor) : t.apply(e, r));
}
function m3(e, t) {
  if (t && (ro(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return g3(e);
}
function g3(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function MC() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (MC = function() {
    return !!e;
  })();
}
function _s(e) {
  return _s = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, _s(e);
}
function y3(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Wh(e, t);
}
function Wh(e, t) {
  return Wh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Wh(e, t);
}
function Oa(e, t, r) {
  return t = IC(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function IC(e) {
  var t = b3(e, "string");
  return ro(t) == "symbol" ? t : t + "";
}
function b3(e, t) {
  if (ro(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ro(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var St = 32, tg = /* @__PURE__ */ (function(e) {
  function t() {
    return d3(this, t), v3(this, t, arguments);
  }
  return y3(t, e), h3(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(n) {
        var o = this.props.inactiveColor, a = St / 2, i = St / 6, s = St / 3, c = n.inactive ? o : n.color;
        if (n.type === "plainline")
          return /* @__PURE__ */ k.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: c,
            strokeDasharray: n.payload.strokeDasharray,
            x1: 0,
            y1: a,
            x2: St,
            y2: a,
            className: "recharts-legend-icon"
          });
        if (n.type === "line")
          return /* @__PURE__ */ k.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: c,
            d: "M0,".concat(a, "h").concat(s, `
            A`).concat(i, ",").concat(i, ",0,1,1,").concat(2 * s, ",").concat(a, `
            H`).concat(St, "M").concat(2 * s, ",").concat(a, `
            A`).concat(i, ",").concat(i, ",0,1,1,").concat(s, ",").concat(a),
            className: "recharts-legend-icon"
          });
        if (n.type === "rect")
          return /* @__PURE__ */ k.createElement("path", {
            stroke: "none",
            fill: c,
            d: "M0,".concat(St / 8, "h").concat(St, "v").concat(St * 3 / 4, "h").concat(-St, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ k.isValidElement(n.legendIcon)) {
          var l = f3({}, n);
          return delete l.legendIcon, /* @__PURE__ */ k.cloneElement(n.legendIcon, l);
        }
        return /* @__PURE__ */ k.createElement(eg, {
          fill: c,
          cx: a,
          cy: a,
          size: St,
          sizeType: "diameter",
          type: n.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var n = this, o = this.props, a = o.payload, i = o.iconSize, s = o.layout, c = o.formatter, l = o.inactiveColor, f = {
        x: 0,
        y: 0,
        width: St,
        height: St
      }, u = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, d = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return a.map(function(h, m) {
        var v = h.formatter || c, p = de(Oa(Oa({
          "recharts-legend-item": !0
        }, "legend-item-".concat(m), !0), "inactive", h.inactive));
        if (h.type === "none")
          return null;
        var b = ue(h.value) ? null : h.value;
        pr(
          !ue(h.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var w = h.inactive ? l : h.color;
        return /* @__PURE__ */ k.createElement("li", zh({
          className: p,
          style: u,
          key: "legend-item-".concat(m)
        }, mn(n.props, h, m)), /* @__PURE__ */ k.createElement($h, {
          width: i,
          height: i,
          viewBox: f,
          style: d
        }, n.renderIcon(h)), /* @__PURE__ */ k.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: w
          }
        }, v ? v(b, h, m) : b));
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, o = n.payload, a = n.layout, i = n.align;
      if (!o || !o.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: a === "horizontal" ? i : "left"
      };
      return /* @__PURE__ */ k.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
})(Ft);
Oa(tg, "displayName", "Legend");
Oa(tg, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var hf, n0;
function w3() {
  if (n0) return hf;
  n0 = 1;
  var e = Xc();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return hf = t, hf;
}
var vf, o0;
function x3() {
  if (o0) return vf;
  o0 = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return vf = e, vf;
}
var mf, a0;
function S3() {
  if (a0) return mf;
  a0 = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return mf = e, mf;
}
var gf, i0;
function _3() {
  if (i0) return gf;
  i0 = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return gf = e, gf;
}
var yf, s0;
function O3() {
  if (s0) return yf;
  s0 = 1;
  var e = Xc(), t = Hm(), r = Vm(), n = 200;
  function o(a, i) {
    var s = this.__data__;
    if (s instanceof e) {
      var c = s.__data__;
      if (!t || c.length < n - 1)
        return c.push([a, i]), this.size = ++s.size, this;
      s = this.__data__ = new r(c);
    }
    return s.set(a, i), this.size = s.size, this;
  }
  return yf = o, yf;
}
var bf, c0;
function NC() {
  if (c0) return bf;
  c0 = 1;
  var e = Xc(), t = w3(), r = x3(), n = S3(), o = _3(), a = O3();
  function i(s) {
    var c = this.__data__ = new e(s);
    this.size = c.size;
  }
  return i.prototype.clear = t, i.prototype.delete = r, i.prototype.get = n, i.prototype.has = o, i.prototype.set = a, bf = i, bf;
}
var wf, l0;
function A3() {
  if (l0) return wf;
  l0 = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return wf = t, wf;
}
var xf, u0;
function P3() {
  if (u0) return xf;
  u0 = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return xf = e, xf;
}
var Sf, f0;
function kC() {
  if (f0) return Sf;
  f0 = 1;
  var e = Vm(), t = A3(), r = P3();
  function n(o) {
    var a = -1, i = o == null ? 0 : o.length;
    for (this.__data__ = new e(); ++a < i; )
      this.add(o[a]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, Sf = n, Sf;
}
var _f, d0;
function $C() {
  if (d0) return _f;
  d0 = 1;
  function e(t, r) {
    for (var n = -1, o = t == null ? 0 : t.length; ++n < o; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return _f = e, _f;
}
var Of, p0;
function DC() {
  if (p0) return Of;
  p0 = 1;
  function e(t, r) {
    return t.has(r);
  }
  return Of = e, Of;
}
var Af, h0;
function jC() {
  if (h0) return Af;
  h0 = 1;
  var e = kC(), t = $C(), r = DC(), n = 1, o = 2;
  function a(i, s, c, l, f, u) {
    var d = c & n, h = i.length, m = s.length;
    if (h != m && !(d && m > h))
      return !1;
    var v = u.get(i), p = u.get(s);
    if (v && p)
      return v == s && p == i;
    var b = -1, w = !0, x = c & o ? new e() : void 0;
    for (u.set(i, s), u.set(s, i); ++b < h; ) {
      var _ = i[b], y = s[b];
      if (l)
        var O = d ? l(y, _, b, s, i, u) : l(_, y, b, i, s, u);
      if (O !== void 0) {
        if (O)
          continue;
        w = !1;
        break;
      }
      if (x) {
        if (!t(s, function(A, P) {
          if (!r(x, P) && (_ === A || f(_, A, c, l, u)))
            return x.push(P);
        })) {
          w = !1;
          break;
        }
      } else if (!(_ === y || f(_, y, c, l, u))) {
        w = !1;
        break;
      }
    }
    return u.delete(i), u.delete(s), w;
  }
  return Af = a, Af;
}
var Pf, v0;
function E3() {
  if (v0) return Pf;
  v0 = 1;
  var e = nr(), t = e.Uint8Array;
  return Pf = t, Pf;
}
var Ef, m0;
function T3() {
  if (m0) return Ef;
  m0 = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(o, a) {
      n[++r] = [a, o];
    }), n;
  }
  return Ef = e, Ef;
}
var Tf, g0;
function rg() {
  if (g0) return Tf;
  g0 = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(o) {
      n[++r] = o;
    }), n;
  }
  return Tf = e, Tf;
}
var Cf, y0;
function C3() {
  if (y0) return Cf;
  y0 = 1;
  var e = xi(), t = E3(), r = Um(), n = jC(), o = T3(), a = rg(), i = 1, s = 2, c = "[object Boolean]", l = "[object Date]", f = "[object Error]", u = "[object Map]", d = "[object Number]", h = "[object RegExp]", m = "[object Set]", v = "[object String]", p = "[object Symbol]", b = "[object ArrayBuffer]", w = "[object DataView]", x = e ? e.prototype : void 0, _ = x ? x.valueOf : void 0;
  function y(O, A, P, T, I, E, C) {
    switch (P) {
      case w:
        if (O.byteLength != A.byteLength || O.byteOffset != A.byteOffset)
          return !1;
        O = O.buffer, A = A.buffer;
      case b:
        return !(O.byteLength != A.byteLength || !E(new t(O), new t(A)));
      case c:
      case l:
      case d:
        return r(+O, +A);
      case f:
        return O.name == A.name && O.message == A.message;
      case h:
      case v:
        return O == A + "";
      case u:
        var R = o;
      case m:
        var M = T & i;
        if (R || (R = a), O.size != A.size && !M)
          return !1;
        var D = C.get(O);
        if (D)
          return D == A;
        T |= s, C.set(O, A);
        var $ = n(R(O), R(A), T, I, E, C);
        return C.delete(O), $;
      case p:
        if (_)
          return _.call(O) == _.call(A);
    }
    return !1;
  }
  return Cf = y, Cf;
}
var Rf, b0;
function LC() {
  if (b0) return Rf;
  b0 = 1;
  function e(t, r) {
    for (var n = -1, o = r.length, a = t.length; ++n < o; )
      t[a + n] = r[n];
    return t;
  }
  return Rf = e, Rf;
}
var Mf, w0;
function R3() {
  if (w0) return Mf;
  w0 = 1;
  var e = LC(), t = lt();
  function r(n, o, a) {
    var i = o(n);
    return t(n) ? i : e(i, a(n));
  }
  return Mf = r, Mf;
}
var If, x0;
function M3() {
  if (x0) return If;
  x0 = 1;
  function e(t, r) {
    for (var n = -1, o = t == null ? 0 : t.length, a = 0, i = []; ++n < o; ) {
      var s = t[n];
      r(s, n, t) && (i[a++] = s);
    }
    return i;
  }
  return If = e, If;
}
var Nf, S0;
function I3() {
  if (S0) return Nf;
  S0 = 1;
  function e() {
    return [];
  }
  return Nf = e, Nf;
}
var kf, _0;
function N3() {
  if (_0) return kf;
  _0 = 1;
  var e = M3(), t = I3(), r = Object.prototype, n = r.propertyIsEnumerable, o = Object.getOwnPropertySymbols, a = o ? function(i) {
    return i == null ? [] : (i = Object(i), e(o(i), function(s) {
      return n.call(i, s);
    }));
  } : t;
  return kf = a, kf;
}
var $f, O0;
function k3() {
  if (O0) return $f;
  O0 = 1;
  function e(t, r) {
    for (var n = -1, o = Array(t); ++n < t; )
      o[n] = r(n);
    return o;
  }
  return $f = e, $f;
}
var Df, A0;
function $3() {
  if (A0) return Df;
  A0 = 1;
  var e = Sr(), t = _r(), r = "[object Arguments]";
  function n(o) {
    return t(o) && e(o) == r;
  }
  return Df = n, Df;
}
var jf, P0;
function ng() {
  if (P0) return jf;
  P0 = 1;
  var e = $3(), t = _r(), r = Object.prototype, n = r.hasOwnProperty, o = r.propertyIsEnumerable, a = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(i) {
    return t(i) && n.call(i, "callee") && !o.call(i, "callee");
  };
  return jf = a, jf;
}
var sa = { exports: {} }, Lf, E0;
function D3() {
  if (E0) return Lf;
  E0 = 1;
  function e() {
    return !1;
  }
  return Lf = e, Lf;
}
sa.exports;
var T0;
function BC() {
  return T0 || (T0 = 1, (function(e, t) {
    var r = nr(), n = D3(), o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, i = a && a.exports === o, s = i ? r.Buffer : void 0, c = s ? s.isBuffer : void 0, l = c || n;
    e.exports = l;
  })(sa, sa.exports)), sa.exports;
}
var Bf, C0;
function og() {
  if (C0) return Bf;
  C0 = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, o) {
    var a = typeof n;
    return o = o ?? e, !!o && (a == "number" || a != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < o;
  }
  return Bf = r, Bf;
}
var Ff, R0;
function ag() {
  if (R0) return Ff;
  R0 = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Ff = t, Ff;
}
var qf, M0;
function j3() {
  if (M0) return qf;
  M0 = 1;
  var e = Sr(), t = ag(), r = _r(), n = "[object Arguments]", o = "[object Array]", a = "[object Boolean]", i = "[object Date]", s = "[object Error]", c = "[object Function]", l = "[object Map]", f = "[object Number]", u = "[object Object]", d = "[object RegExp]", h = "[object Set]", m = "[object String]", v = "[object WeakMap]", p = "[object ArrayBuffer]", b = "[object DataView]", w = "[object Float32Array]", x = "[object Float64Array]", _ = "[object Int8Array]", y = "[object Int16Array]", O = "[object Int32Array]", A = "[object Uint8Array]", P = "[object Uint8ClampedArray]", T = "[object Uint16Array]", I = "[object Uint32Array]", E = {};
  E[w] = E[x] = E[_] = E[y] = E[O] = E[A] = E[P] = E[T] = E[I] = !0, E[n] = E[o] = E[p] = E[a] = E[b] = E[i] = E[s] = E[c] = E[l] = E[f] = E[u] = E[d] = E[h] = E[m] = E[v] = !1;
  function C(R) {
    return r(R) && t(R.length) && !!E[e(R)];
  }
  return qf = C, qf;
}
var zf, I0;
function FC() {
  if (I0) return zf;
  I0 = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return zf = e, zf;
}
var ca = { exports: {} };
ca.exports;
var N0;
function L3() {
  return N0 || (N0 = 1, (function(e, t) {
    var r = iC(), n = t && !t.nodeType && t, o = n && !0 && e && !e.nodeType && e, a = o && o.exports === n, i = a && r.process, s = (function() {
      try {
        var c = o && o.require && o.require("util").types;
        return c || i && i.binding && i.binding("util");
      } catch {
      }
    })();
    e.exports = s;
  })(ca, ca.exports)), ca.exports;
}
var Wf, k0;
function qC() {
  if (k0) return Wf;
  k0 = 1;
  var e = j3(), t = FC(), r = L3(), n = r && r.isTypedArray, o = n ? t(n) : e;
  return Wf = o, Wf;
}
var Uf, $0;
function B3() {
  if ($0) return Uf;
  $0 = 1;
  var e = k3(), t = ng(), r = lt(), n = BC(), o = og(), a = qC(), i = Object.prototype, s = i.hasOwnProperty;
  function c(l, f) {
    var u = r(l), d = !u && t(l), h = !u && !d && n(l), m = !u && !d && !h && a(l), v = u || d || h || m, p = v ? e(l.length, String) : [], b = p.length;
    for (var w in l)
      (f || s.call(l, w)) && !(v && // Safari 9 has enumerable `arguments.length` in strict mode.
      (w == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      h && (w == "offset" || w == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      m && (w == "buffer" || w == "byteLength" || w == "byteOffset") || // Skip index properties.
      o(w, b))) && p.push(w);
    return p;
  }
  return Uf = c, Uf;
}
var Hf, D0;
function F3() {
  if (D0) return Hf;
  D0 = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, o = typeof n == "function" && n.prototype || e;
    return r === o;
  }
  return Hf = t, Hf;
}
var Vf, j0;
function zC() {
  if (j0) return Vf;
  j0 = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return Vf = e, Vf;
}
var Kf, L0;
function q3() {
  if (L0) return Kf;
  L0 = 1;
  var e = zC(), t = e(Object.keys, Object);
  return Kf = t, Kf;
}
var Gf, B0;
function z3() {
  if (B0) return Gf;
  B0 = 1;
  var e = F3(), t = q3(), r = Object.prototype, n = r.hasOwnProperty;
  function o(a) {
    if (!e(a))
      return t(a);
    var i = [];
    for (var s in Object(a))
      n.call(a, s) && s != "constructor" && i.push(s);
    return i;
  }
  return Gf = o, Gf;
}
var Yf, F0;
function _i() {
  if (F0) return Yf;
  F0 = 1;
  var e = Wm(), t = ag();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return Yf = r, Yf;
}
var Xf, q0;
function nl() {
  if (q0) return Xf;
  q0 = 1;
  var e = B3(), t = z3(), r = _i();
  function n(o) {
    return r(o) ? e(o) : t(o);
  }
  return Xf = n, Xf;
}
var Zf, z0;
function W3() {
  if (z0) return Zf;
  z0 = 1;
  var e = R3(), t = N3(), r = nl();
  function n(o) {
    return e(o, r, t);
  }
  return Zf = n, Zf;
}
var Jf, W0;
function U3() {
  if (W0) return Jf;
  W0 = 1;
  var e = W3(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function o(a, i, s, c, l, f) {
    var u = s & t, d = e(a), h = d.length, m = e(i), v = m.length;
    if (h != v && !u)
      return !1;
    for (var p = h; p--; ) {
      var b = d[p];
      if (!(u ? b in i : n.call(i, b)))
        return !1;
    }
    var w = f.get(a), x = f.get(i);
    if (w && x)
      return w == i && x == a;
    var _ = !0;
    f.set(a, i), f.set(i, a);
    for (var y = u; ++p < h; ) {
      b = d[p];
      var O = a[b], A = i[b];
      if (c)
        var P = u ? c(A, O, b, i, a, f) : c(O, A, b, a, i, f);
      if (!(P === void 0 ? O === A || l(O, A, s, c, f) : P)) {
        _ = !1;
        break;
      }
      y || (y = b == "constructor");
    }
    if (_ && !y) {
      var T = a.constructor, I = i.constructor;
      T != I && "constructor" in a && "constructor" in i && !(typeof T == "function" && T instanceof T && typeof I == "function" && I instanceof I) && (_ = !1);
    }
    return f.delete(a), f.delete(i), _;
  }
  return Jf = o, Jf;
}
var Qf, U0;
function H3() {
  if (U0) return Qf;
  U0 = 1;
  var e = Sn(), t = nr(), r = e(t, "DataView");
  return Qf = r, Qf;
}
var ed, H0;
function V3() {
  if (H0) return ed;
  H0 = 1;
  var e = Sn(), t = nr(), r = e(t, "Promise");
  return ed = r, ed;
}
var td, V0;
function WC() {
  if (V0) return td;
  V0 = 1;
  var e = Sn(), t = nr(), r = e(t, "Set");
  return td = r, td;
}
var rd, K0;
function K3() {
  if (K0) return rd;
  K0 = 1;
  var e = Sn(), t = nr(), r = e(t, "WeakMap");
  return rd = r, rd;
}
var nd, G0;
function G3() {
  if (G0) return nd;
  G0 = 1;
  var e = H3(), t = Hm(), r = V3(), n = WC(), o = K3(), a = Sr(), i = sC(), s = "[object Map]", c = "[object Object]", l = "[object Promise]", f = "[object Set]", u = "[object WeakMap]", d = "[object DataView]", h = i(e), m = i(t), v = i(r), p = i(n), b = i(o), w = a;
  return (e && w(new e(new ArrayBuffer(1))) != d || t && w(new t()) != s || r && w(r.resolve()) != l || n && w(new n()) != f || o && w(new o()) != u) && (w = function(x) {
    var _ = a(x), y = _ == c ? x.constructor : void 0, O = y ? i(y) : "";
    if (O)
      switch (O) {
        case h:
          return d;
        case m:
          return s;
        case v:
          return l;
        case p:
          return f;
        case b:
          return u;
      }
    return _;
  }), nd = w, nd;
}
var od, Y0;
function Y3() {
  if (Y0) return od;
  Y0 = 1;
  var e = NC(), t = jC(), r = C3(), n = U3(), o = G3(), a = lt(), i = BC(), s = qC(), c = 1, l = "[object Arguments]", f = "[object Array]", u = "[object Object]", d = Object.prototype, h = d.hasOwnProperty;
  function m(v, p, b, w, x, _) {
    var y = a(v), O = a(p), A = y ? f : o(v), P = O ? f : o(p);
    A = A == l ? u : A, P = P == l ? u : P;
    var T = A == u, I = P == u, E = A == P;
    if (E && i(v)) {
      if (!i(p))
        return !1;
      y = !0, T = !1;
    }
    if (E && !T)
      return _ || (_ = new e()), y || s(v) ? t(v, p, b, w, x, _) : r(v, p, A, b, w, x, _);
    if (!(b & c)) {
      var C = T && h.call(v, "__wrapped__"), R = I && h.call(p, "__wrapped__");
      if (C || R) {
        var M = C ? v.value() : v, D = R ? p.value() : p;
        return _ || (_ = new e()), x(M, D, b, w, _);
      }
    }
    return E ? (_ || (_ = new e()), n(v, p, b, w, x, _)) : !1;
  }
  return od = m, od;
}
var ad, X0;
function ig() {
  if (X0) return ad;
  X0 = 1;
  var e = Y3(), t = _r();
  function r(n, o, a, i, s) {
    return n === o ? !0 : n == null || o == null || !t(n) && !t(o) ? n !== n && o !== o : e(n, o, a, i, r, s);
  }
  return ad = r, ad;
}
var id, Z0;
function X3() {
  if (Z0) return id;
  Z0 = 1;
  var e = NC(), t = ig(), r = 1, n = 2;
  function o(a, i, s, c) {
    var l = s.length, f = l, u = !c;
    if (a == null)
      return !f;
    for (a = Object(a); l--; ) {
      var d = s[l];
      if (u && d[2] ? d[1] !== a[d[0]] : !(d[0] in a))
        return !1;
    }
    for (; ++l < f; ) {
      d = s[l];
      var h = d[0], m = a[h], v = d[1];
      if (u && d[2]) {
        if (m === void 0 && !(h in a))
          return !1;
      } else {
        var p = new e();
        if (c)
          var b = c(m, v, h, a, i, p);
        if (!(b === void 0 ? t(v, m, r | n, c, p) : b))
          return !1;
      }
    }
    return !0;
  }
  return id = o, id;
}
var sd, J0;
function UC() {
  if (J0) return sd;
  J0 = 1;
  var e = zr();
  function t(r) {
    return r === r && !e(r);
  }
  return sd = t, sd;
}
var cd, Q0;
function Z3() {
  if (Q0) return cd;
  Q0 = 1;
  var e = UC(), t = nl();
  function r(n) {
    for (var o = t(n), a = o.length; a--; ) {
      var i = o[a], s = n[i];
      o[a] = [i, s, e(s)];
    }
    return o;
  }
  return cd = r, cd;
}
var ld, ew;
function HC() {
  if (ew) return ld;
  ew = 1;
  function e(t, r) {
    return function(n) {
      return n == null ? !1 : n[t] === r && (r !== void 0 || t in Object(n));
    };
  }
  return ld = e, ld;
}
var ud, tw;
function J3() {
  if (tw) return ud;
  tw = 1;
  var e = X3(), t = Z3(), r = HC();
  function n(o) {
    var a = t(o);
    return a.length == 1 && a[0][2] ? r(a[0][0], a[0][1]) : function(i) {
      return i === o || e(i, o, a);
    };
  }
  return ud = n, ud;
}
var fd, rw;
function Q3() {
  if (rw) return fd;
  rw = 1;
  function e(t, r) {
    return t != null && r in Object(t);
  }
  return fd = e, fd;
}
var dd, nw;
function ez() {
  if (nw) return dd;
  nw = 1;
  var e = uC(), t = ng(), r = lt(), n = og(), o = ag(), a = Jc();
  function i(s, c, l) {
    c = e(c, s);
    for (var f = -1, u = c.length, d = !1; ++f < u; ) {
      var h = a(c[f]);
      if (!(d = s != null && l(s, h)))
        break;
      s = s[h];
    }
    return d || ++f != u ? d : (u = s == null ? 0 : s.length, !!u && o(u) && n(h, u) && (r(s) || t(s)));
  }
  return dd = i, dd;
}
var pd, ow;
function tz() {
  if (ow) return pd;
  ow = 1;
  var e = Q3(), t = ez();
  function r(n, o) {
    return n != null && t(n, o, e);
  }
  return pd = r, pd;
}
var hd, aw;
function rz() {
  if (aw) return hd;
  aw = 1;
  var e = ig(), t = fC(), r = tz(), n = zm(), o = UC(), a = HC(), i = Jc(), s = 1, c = 2;
  function l(f, u) {
    return n(f) && o(u) ? a(i(f), u) : function(d) {
      var h = t(d, f);
      return h === void 0 && h === u ? r(d, f) : e(u, h, s | c);
    };
  }
  return hd = l, hd;
}
var vd, iw;
function zo() {
  if (iw) return vd;
  iw = 1;
  function e(t) {
    return t;
  }
  return vd = e, vd;
}
var md, sw;
function nz() {
  if (sw) return md;
  sw = 1;
  function e(t) {
    return function(r) {
      return r == null ? void 0 : r[t];
    };
  }
  return md = e, md;
}
var gd, cw;
function oz() {
  if (cw) return gd;
  cw = 1;
  var e = Gm();
  function t(r) {
    return function(n) {
      return e(n, r);
    };
  }
  return gd = t, gd;
}
var yd, lw;
function az() {
  if (lw) return yd;
  lw = 1;
  var e = nz(), t = oz(), r = zm(), n = Jc();
  function o(a) {
    return r(a) ? e(n(a)) : t(a);
  }
  return yd = o, yd;
}
var bd, uw;
function or() {
  if (uw) return bd;
  uw = 1;
  var e = J3(), t = rz(), r = zo(), n = lt(), o = az();
  function a(i) {
    return typeof i == "function" ? i : i == null ? r : typeof i == "object" ? n(i) ? t(i[0], i[1]) : e(i) : o(i);
  }
  return bd = a, bd;
}
var wd, fw;
function VC() {
  if (fw) return wd;
  fw = 1;
  function e(t, r, n, o) {
    for (var a = t.length, i = n + (o ? 1 : -1); o ? i-- : ++i < a; )
      if (r(t[i], i, t))
        return i;
    return -1;
  }
  return wd = e, wd;
}
var xd, dw;
function iz() {
  if (dw) return xd;
  dw = 1;
  function e(t) {
    return t !== t;
  }
  return xd = e, xd;
}
var Sd, pw;
function sz() {
  if (pw) return Sd;
  pw = 1;
  function e(t, r, n) {
    for (var o = n - 1, a = t.length; ++o < a; )
      if (t[o] === r)
        return o;
    return -1;
  }
  return Sd = e, Sd;
}
var _d, hw;
function cz() {
  if (hw) return _d;
  hw = 1;
  var e = VC(), t = iz(), r = sz();
  function n(o, a, i) {
    return a === a ? r(o, a, i) : e(o, t, i);
  }
  return _d = n, _d;
}
var Od, vw;
function lz() {
  if (vw) return Od;
  vw = 1;
  var e = cz();
  function t(r, n) {
    var o = r == null ? 0 : r.length;
    return !!o && e(r, n, 0) > -1;
  }
  return Od = t, Od;
}
var Ad, mw;
function uz() {
  if (mw) return Ad;
  mw = 1;
  function e(t, r, n) {
    for (var o = -1, a = t == null ? 0 : t.length; ++o < a; )
      if (n(r, t[o]))
        return !0;
    return !1;
  }
  return Ad = e, Ad;
}
var Pd, gw;
function fz() {
  if (gw) return Pd;
  gw = 1;
  function e() {
  }
  return Pd = e, Pd;
}
var Ed, yw;
function dz() {
  if (yw) return Ed;
  yw = 1;
  var e = WC(), t = fz(), r = rg(), n = 1 / 0, o = e && 1 / r(new e([, -0]))[1] == n ? function(a) {
    return new e(a);
  } : t;
  return Ed = o, Ed;
}
var Td, bw;
function pz() {
  if (bw) return Td;
  bw = 1;
  var e = kC(), t = lz(), r = uz(), n = DC(), o = dz(), a = rg(), i = 200;
  function s(c, l, f) {
    var u = -1, d = t, h = c.length, m = !0, v = [], p = v;
    if (f)
      m = !1, d = r;
    else if (h >= i) {
      var b = l ? null : o(c);
      if (b)
        return a(b);
      m = !1, d = n, p = new e();
    } else
      p = l ? [] : v;
    e:
      for (; ++u < h; ) {
        var w = c[u], x = l ? l(w) : w;
        if (w = f || w !== 0 ? w : 0, m && x === x) {
          for (var _ = p.length; _--; )
            if (p[_] === x)
              continue e;
          l && p.push(x), v.push(w);
        } else d(p, x, f) || (p !== v && p.push(x), v.push(w));
      }
    return v;
  }
  return Td = s, Td;
}
var Cd, ww;
function hz() {
  if (ww) return Cd;
  ww = 1;
  var e = or(), t = pz();
  function r(n, o) {
    return n && n.length ? t(n, e(o, 2)) : [];
  }
  return Cd = r, Cd;
}
var vz = hz();
const xw = /* @__PURE__ */ Ae(vz);
function KC(e, t, r) {
  return t === !0 ? xw(e, r) : ue(t) ? xw(e, t) : e;
}
function no(e) {
  "@babel/helpers - typeof";
  return no = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, no(e);
}
var mz = ["ref"];
function Sw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function sr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sw(Object(r), !0).forEach(function(n) {
      ol(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function gz(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _w(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, YC(n.key), n);
  }
}
function yz(e, t, r) {
  return t && _w(e.prototype, t), r && _w(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function bz(e, t, r) {
  return t = Os(t), wz(e, GC() ? Reflect.construct(t, r || [], Os(e).constructor) : t.apply(e, r));
}
function wz(e, t) {
  if (t && (no(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return xz(e);
}
function xz(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function GC() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (GC = function() {
    return !!e;
  })();
}
function Os(e) {
  return Os = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Os(e);
}
function Sz(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Uh(e, t);
}
function Uh(e, t) {
  return Uh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Uh(e, t);
}
function ol(e, t, r) {
  return t = YC(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function YC(e) {
  var t = _z(e, "string");
  return no(t) == "symbol" ? t : t + "";
}
function _z(e, t) {
  if (no(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (no(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Oz(e, t) {
  if (e == null) return {};
  var r = Az(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Az(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Pz(e) {
  return e.value;
}
function Ez(e, t) {
  if (/* @__PURE__ */ k.isValidElement(e))
    return /* @__PURE__ */ k.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ k.createElement(e, t);
  t.ref;
  var r = Oz(t, mz);
  return /* @__PURE__ */ k.createElement(tg, r);
}
var Ow = 1, Kn = /* @__PURE__ */ (function(e) {
  function t() {
    var r;
    gz(this, t);
    for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++)
      o[a] = arguments[a];
    return r = bz(this, t, [].concat(o)), ol(r, "lastBoundingBox", {
      width: -1,
      height: -1
    }), r;
  }
  return Sz(t, e), yz(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        return n.height = this.wrapperNode.offsetHeight, n.width = this.wrapperNode.offsetWidth, n;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var n = this.props.onBBoxUpdate, o = this.getBBox();
      o ? (Math.abs(o.width - this.lastBoundingBox.width) > Ow || Math.abs(o.height - this.lastBoundingBox.height) > Ow) && (this.lastBoundingBox.width = o.width, this.lastBoundingBox.height = o.height, n && n(o)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, n && n(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? sr({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(n) {
      var o = this.props, a = o.layout, i = o.align, s = o.verticalAlign, c = o.margin, l = o.chartWidth, f = o.chartHeight, u, d;
      if (!n || (n.left === void 0 || n.left === null) && (n.right === void 0 || n.right === null))
        if (i === "center" && a === "vertical") {
          var h = this.getBBoxSnapshot();
          u = {
            left: ((l || 0) - h.width) / 2
          };
        } else
          u = i === "right" ? {
            right: c && c.right || 0
          } : {
            left: c && c.left || 0
          };
      if (!n || (n.top === void 0 || n.top === null) && (n.bottom === void 0 || n.bottom === null))
        if (s === "middle") {
          var m = this.getBBoxSnapshot();
          d = {
            top: ((f || 0) - m.height) / 2
          };
        } else
          d = s === "bottom" ? {
            bottom: c && c.bottom || 0
          } : {
            top: c && c.top || 0
          };
      return sr(sr({}, u), d);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, o = this.props, a = o.content, i = o.width, s = o.height, c = o.wrapperStyle, l = o.payloadUniqBy, f = o.payload, u = sr(sr({
        position: "absolute",
        width: i || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(c)), c);
      return /* @__PURE__ */ k.createElement("div", {
        className: "recharts-legend-wrapper",
        style: u,
        ref: function(h) {
          n.wrapperNode = h;
        }
      }, Ez(a, sr(sr({}, this.props), {}, {
        payload: KC(f, l, Pz)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(n, o) {
      var a = sr(sr({}, this.defaultProps), n.props), i = a.layout;
      return i === "vertical" && ne(n.props.height) ? {
        height: n.props.height
      } : i === "horizontal" ? {
        width: n.props.width || o
      } : null;
    }
  }]);
})(Ft);
ol(Kn, "displayName", "Legend");
ol(Kn, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var Rd, Aw;
function Tz() {
  if (Aw) return Rd;
  Aw = 1;
  var e = xi(), t = ng(), r = lt(), n = e ? e.isConcatSpreadable : void 0;
  function o(a) {
    return r(a) || t(a) || !!(n && a && a[n]);
  }
  return Rd = o, Rd;
}
var Md, Pw;
function XC() {
  if (Pw) return Md;
  Pw = 1;
  var e = LC(), t = Tz();
  function r(n, o, a, i, s) {
    var c = -1, l = n.length;
    for (a || (a = t), s || (s = []); ++c < l; ) {
      var f = n[c];
      o > 0 && a(f) ? o > 1 ? r(f, o - 1, a, i, s) : e(s, f) : i || (s[s.length] = f);
    }
    return s;
  }
  return Md = r, Md;
}
var Id, Ew;
function Cz() {
  if (Ew) return Id;
  Ew = 1;
  function e(t) {
    return function(r, n, o) {
      for (var a = -1, i = Object(r), s = o(r), c = s.length; c--; ) {
        var l = s[t ? c : ++a];
        if (n(i[l], l, i) === !1)
          break;
      }
      return r;
    };
  }
  return Id = e, Id;
}
var Nd, Tw;
function Rz() {
  if (Tw) return Nd;
  Tw = 1;
  var e = Cz(), t = e();
  return Nd = t, Nd;
}
var kd, Cw;
function ZC() {
  if (Cw) return kd;
  Cw = 1;
  var e = Rz(), t = nl();
  function r(n, o) {
    return n && e(n, o, t);
  }
  return kd = r, kd;
}
var $d, Rw;
function Mz() {
  if (Rw) return $d;
  Rw = 1;
  var e = _i();
  function t(r, n) {
    return function(o, a) {
      if (o == null)
        return o;
      if (!e(o))
        return r(o, a);
      for (var i = o.length, s = n ? i : -1, c = Object(o); (n ? s-- : ++s < i) && a(c[s], s, c) !== !1; )
        ;
      return o;
    };
  }
  return $d = t, $d;
}
var Dd, Mw;
function sg() {
  if (Mw) return Dd;
  Mw = 1;
  var e = ZC(), t = Mz(), r = t(e);
  return Dd = r, Dd;
}
var jd, Iw;
function JC() {
  if (Iw) return jd;
  Iw = 1;
  var e = sg(), t = _i();
  function r(n, o) {
    var a = -1, i = t(n) ? Array(n.length) : [];
    return e(n, function(s, c, l) {
      i[++a] = o(s, c, l);
    }), i;
  }
  return jd = r, jd;
}
var Ld, Nw;
function Iz() {
  if (Nw) return Ld;
  Nw = 1;
  function e(t, r) {
    var n = t.length;
    for (t.sort(r); n--; )
      t[n] = t[n].value;
    return t;
  }
  return Ld = e, Ld;
}
var Bd, kw;
function Nz() {
  if (kw) return Bd;
  kw = 1;
  var e = Bo();
  function t(r, n) {
    if (r !== n) {
      var o = r !== void 0, a = r === null, i = r === r, s = e(r), c = n !== void 0, l = n === null, f = n === n, u = e(n);
      if (!l && !u && !s && r > n || s && c && f && !l && !u || a && c && f || !o && f || !i)
        return 1;
      if (!a && !s && !u && r < n || u && o && i && !a && !s || l && o && i || !c && i || !f)
        return -1;
    }
    return 0;
  }
  return Bd = t, Bd;
}
var Fd, $w;
function kz() {
  if ($w) return Fd;
  $w = 1;
  var e = Nz();
  function t(r, n, o) {
    for (var a = -1, i = r.criteria, s = n.criteria, c = i.length, l = o.length; ++a < c; ) {
      var f = e(i[a], s[a]);
      if (f) {
        if (a >= l)
          return f;
        var u = o[a];
        return f * (u == "desc" ? -1 : 1);
      }
    }
    return r.index - n.index;
  }
  return Fd = t, Fd;
}
var qd, Dw;
function $z() {
  if (Dw) return qd;
  Dw = 1;
  var e = Km(), t = Gm(), r = or(), n = JC(), o = Iz(), a = FC(), i = kz(), s = zo(), c = lt();
  function l(f, u, d) {
    u.length ? u = e(u, function(v) {
      return c(v) ? function(p) {
        return t(p, v.length === 1 ? v[0] : v);
      } : v;
    }) : u = [s];
    var h = -1;
    u = e(u, a(r));
    var m = n(f, function(v, p, b) {
      var w = e(u, function(x) {
        return x(v);
      });
      return { criteria: w, index: ++h, value: v };
    });
    return o(m, function(v, p) {
      return i(v, p, d);
    });
  }
  return qd = l, qd;
}
var zd, jw;
function Dz() {
  if (jw) return zd;
  jw = 1;
  function e(t, r, n) {
    switch (n.length) {
      case 0:
        return t.call(r);
      case 1:
        return t.call(r, n[0]);
      case 2:
        return t.call(r, n[0], n[1]);
      case 3:
        return t.call(r, n[0], n[1], n[2]);
    }
    return t.apply(r, n);
  }
  return zd = e, zd;
}
var Wd, Lw;
function jz() {
  if (Lw) return Wd;
  Lw = 1;
  var e = Dz(), t = Math.max;
  function r(n, o, a) {
    return o = t(o === void 0 ? n.length - 1 : o, 0), function() {
      for (var i = arguments, s = -1, c = t(i.length - o, 0), l = Array(c); ++s < c; )
        l[s] = i[o + s];
      s = -1;
      for (var f = Array(o + 1); ++s < o; )
        f[s] = i[s];
      return f[o] = a(l), e(n, this, f);
    };
  }
  return Wd = r, Wd;
}
var Ud, Bw;
function Lz() {
  if (Bw) return Ud;
  Bw = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return Ud = e, Ud;
}
var Hd, Fw;
function QC() {
  if (Fw) return Hd;
  Fw = 1;
  var e = Sn(), t = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Hd = t, Hd;
}
var Vd, qw;
function Bz() {
  if (qw) return Vd;
  qw = 1;
  var e = Lz(), t = QC(), r = zo(), n = t ? function(o, a) {
    return t(o, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(a),
      writable: !0
    });
  } : r;
  return Vd = n, Vd;
}
var Kd, zw;
function Fz() {
  if (zw) return Kd;
  zw = 1;
  var e = 800, t = 16, r = Date.now;
  function n(o) {
    var a = 0, i = 0;
    return function() {
      var s = r(), c = t - (s - i);
      if (i = s, c > 0) {
        if (++a >= e)
          return arguments[0];
      } else
        a = 0;
      return o.apply(void 0, arguments);
    };
  }
  return Kd = n, Kd;
}
var Gd, Ww;
function qz() {
  if (Ww) return Gd;
  Ww = 1;
  var e = Bz(), t = Fz(), r = t(e);
  return Gd = r, Gd;
}
var Yd, Uw;
function zz() {
  if (Uw) return Yd;
  Uw = 1;
  var e = zo(), t = jz(), r = qz();
  function n(o, a) {
    return r(t(o, a, e), o + "");
  }
  return Yd = n, Yd;
}
var Xd, Hw;
function al() {
  if (Hw) return Xd;
  Hw = 1;
  var e = Um(), t = _i(), r = og(), n = zr();
  function o(a, i, s) {
    if (!n(s))
      return !1;
    var c = typeof i;
    return (c == "number" ? t(s) && r(i, s.length) : c == "string" && i in s) ? e(s[i], a) : !1;
  }
  return Xd = o, Xd;
}
var Zd, Vw;
function Wz() {
  if (Vw) return Zd;
  Vw = 1;
  var e = XC(), t = $z(), r = zz(), n = al(), o = r(function(a, i) {
    if (a == null)
      return [];
    var s = i.length;
    return s > 1 && n(a, i[0], i[1]) ? i = [] : s > 2 && n(i[0], i[1], i[2]) && (i = [i[0]]), t(a, e(i, 1), []);
  });
  return Zd = o, Zd;
}
var Uz = Wz();
const cg = /* @__PURE__ */ Ae(Uz);
function Aa(e) {
  "@babel/helpers - typeof";
  return Aa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Aa(e);
}
function Hh() {
  return Hh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hh.apply(this, arguments);
}
function Hz(e, t) {
  return Yz(e) || Gz(e, t) || Kz(e, t) || Vz();
}
function Vz() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Kz(e, t) {
  if (e) {
    if (typeof e == "string") return Kw(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Kw(e, t);
  }
}
function Kw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Gz(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, o, a, i, s = [], c = !0, l = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, o = f;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw o;
      }
    }
    return s;
  }
}
function Yz(e) {
  if (Array.isArray(e)) return e;
}
function Gw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Jd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Gw(Object(r), !0).forEach(function(n) {
      Xz(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Gw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Xz(e, t, r) {
  return t = Zz(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Zz(e) {
  var t = Jz(e, "string");
  return Aa(t) == "symbol" ? t : t + "";
}
function Jz(e, t) {
  if (Aa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Aa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Qz(e) {
  return Array.isArray(e) && We(e[0]) && We(e[1]) ? e.join(" ~ ") : e;
}
var eW = function(t) {
  var r = t.separator, n = r === void 0 ? " : " : r, o = t.contentStyle, a = o === void 0 ? {} : o, i = t.itemStyle, s = i === void 0 ? {} : i, c = t.labelStyle, l = c === void 0 ? {} : c, f = t.payload, u = t.formatter, d = t.itemSorter, h = t.wrapperClassName, m = t.labelClassName, v = t.label, p = t.labelFormatter, b = t.accessibilityLayer, w = b === void 0 ? !1 : b, x = function() {
    if (f && f.length) {
      var C = {
        padding: 0,
        margin: 0
      }, R = (d ? cg(f, d) : f).map(function(M, D) {
        if (M.type === "none")
          return null;
        var $ = Jd({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: M.color || "#000"
        }, s), q = M.formatter || u || Qz, F = M.value, B = M.name, L = F, z = B;
        if (q && L != null && z != null) {
          var N = q(F, B, M, D, f);
          if (Array.isArray(N)) {
            var U = Hz(N, 2);
            L = U[0], z = U[1];
          } else
            L = N;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ k.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(D),
            style: $
          }, We(z) ? /* @__PURE__ */ k.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, z) : null, We(z) ? /* @__PURE__ */ k.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, n) : null, /* @__PURE__ */ k.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, L), /* @__PURE__ */ k.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, M.unit || ""))
        );
      });
      return /* @__PURE__ */ k.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: C
      }, R);
    }
    return null;
  }, _ = Jd({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, a), y = Jd({
    margin: 0
  }, l), O = !fe(v), A = O ? v : "", P = de("recharts-default-tooltip", h), T = de("recharts-tooltip-label", m);
  O && p && f !== void 0 && f !== null && (A = p(v, f));
  var I = w ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ k.createElement("div", Hh({
    className: P,
    style: _
  }, I), /* @__PURE__ */ k.createElement("p", {
    className: T,
    style: y
  }, /* @__PURE__ */ k.isValidElement(A) ? A : "".concat(A)), x());
};
function Pa(e) {
  "@babel/helpers - typeof";
  return Pa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Pa(e);
}
function qi(e, t, r) {
  return t = tW(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function tW(e) {
  var t = rW(e, "string");
  return Pa(t) == "symbol" ? t : t + "";
}
function rW(e, t) {
  if (Pa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Pa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Xo = "recharts-tooltip-wrapper", nW = {
  visibility: "hidden"
};
function oW(e) {
  var t = e.coordinate, r = e.translateX, n = e.translateY;
  return de(Xo, qi(qi(qi(qi({}, "".concat(Xo, "-right"), ne(r) && t && ne(t.x) && r >= t.x), "".concat(Xo, "-left"), ne(r) && t && ne(t.x) && r < t.x), "".concat(Xo, "-bottom"), ne(n) && t && ne(t.y) && n >= t.y), "".concat(Xo, "-top"), ne(n) && t && ne(t.y) && n < t.y));
}
function Yw(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.key, o = e.offsetTopLeft, a = e.position, i = e.reverseDirection, s = e.tooltipDimension, c = e.viewBox, l = e.viewBoxDimension;
  if (a && ne(a[n]))
    return a[n];
  var f = r[n] - s - o, u = r[n] + o;
  if (t[n])
    return i[n] ? f : u;
  if (i[n]) {
    var d = f, h = c[n];
    return d < h ? Math.max(u, c[n]) : Math.max(f, c[n]);
  }
  var m = u + s, v = c[n] + l;
  return m > v ? Math.max(f, c[n]) : Math.max(u, c[n]);
}
function aW(e) {
  var t = e.translateX, r = e.translateY, n = e.useTranslate3d;
  return {
    transform: n ? "translate3d(".concat(t, "px, ").concat(r, "px, 0)") : "translate(".concat(t, "px, ").concat(r, "px)")
  };
}
function iW(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.offsetTopLeft, o = e.position, a = e.reverseDirection, i = e.tooltipBox, s = e.useTranslate3d, c = e.viewBox, l, f, u;
  return i.height > 0 && i.width > 0 && r ? (f = Yw({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "x",
    offsetTopLeft: n,
    position: o,
    reverseDirection: a,
    tooltipDimension: i.width,
    viewBox: c,
    viewBoxDimension: c.width
  }), u = Yw({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "y",
    offsetTopLeft: n,
    position: o,
    reverseDirection: a,
    tooltipDimension: i.height,
    viewBox: c,
    viewBoxDimension: c.height
  }), l = aW({
    translateX: f,
    translateY: u,
    useTranslate3d: s
  })) : l = nW, {
    cssProperties: l,
    cssClasses: oW({
      translateX: f,
      translateY: u,
      coordinate: r
    })
  };
}
function oo(e) {
  "@babel/helpers - typeof";
  return oo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oo(e);
}
function Xw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Zw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xw(Object(r), !0).forEach(function(n) {
      Kh(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Xw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function sW(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function cW(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, tR(n.key), n);
  }
}
function lW(e, t, r) {
  return t && cW(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function uW(e, t, r) {
  return t = As(t), fW(e, eR() ? Reflect.construct(t, r || [], As(e).constructor) : t.apply(e, r));
}
function fW(e, t) {
  if (t && (oo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return dW(e);
}
function dW(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function eR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (eR = function() {
    return !!e;
  })();
}
function As(e) {
  return As = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, As(e);
}
function pW(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Vh(e, t);
}
function Vh(e, t) {
  return Vh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Vh(e, t);
}
function Kh(e, t, r) {
  return t = tR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function tR(e) {
  var t = hW(e, "string");
  return oo(t) == "symbol" ? t : t + "";
}
function hW(e, t) {
  if (oo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (oo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Jw = 1, vW = /* @__PURE__ */ (function(e) {
  function t() {
    var r;
    sW(this, t);
    for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++)
      o[a] = arguments[a];
    return r = uW(this, t, [].concat(o)), Kh(r, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), Kh(r, "handleKeyDown", function(i) {
      if (i.key === "Escape") {
        var s, c, l, f;
        r.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (c = r.props.coordinate) === null || c === void 0 ? void 0 : c.x) !== null && s !== void 0 ? s : 0,
            y: (l = (f = r.props.coordinate) === null || f === void 0 ? void 0 : f.y) !== null && l !== void 0 ? l : 0
          }
        });
      }
    }), r;
  }
  return pW(t, e), lW(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        (Math.abs(n.width - this.state.lastBoundingBox.width) > Jw || Math.abs(n.height - this.state.lastBoundingBox.height) > Jw) && this.setState({
          lastBoundingBox: {
            width: n.width,
            height: n.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var n, o;
      this.props.active && this.updateBBox(), this.state.dismissed && (((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== this.state.dismissedAtCoordinate.x || ((o = this.props.coordinate) === null || o === void 0 ? void 0 : o.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, o = this.props, a = o.active, i = o.allowEscapeViewBox, s = o.animationDuration, c = o.animationEasing, l = o.children, f = o.coordinate, u = o.hasPayload, d = o.isAnimationActive, h = o.offset, m = o.position, v = o.reverseDirection, p = o.useTranslate3d, b = o.viewBox, w = o.wrapperStyle, x = iW({
        allowEscapeViewBox: i,
        coordinate: f,
        offsetTopLeft: h,
        position: m,
        reverseDirection: v,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: p,
        viewBox: b
      }), _ = x.cssClasses, y = x.cssProperties, O = Zw(Zw({
        transition: d && a ? "transform ".concat(s, "ms ").concat(c) : void 0
      }, y), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && a && u ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, w);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ k.createElement("div", {
          tabIndex: -1,
          className: _,
          style: O,
          ref: function(P) {
            n.wrapperNode = P;
          }
        }, l)
      );
    }
  }]);
})(Ft), mW = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, _n = {
  isSsr: mW()
};
function ao(e) {
  "@babel/helpers - typeof";
  return ao = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ao(e);
}
function Qw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ex(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Qw(Object(r), !0).forEach(function(n) {
      lg(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Qw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function gW(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function yW(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, nR(n.key), n);
  }
}
function bW(e, t, r) {
  return t && yW(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function wW(e, t, r) {
  return t = Ps(t), xW(e, rR() ? Reflect.construct(t, r || [], Ps(e).constructor) : t.apply(e, r));
}
function xW(e, t) {
  if (t && (ao(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return SW(e);
}
function SW(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function rR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (rR = function() {
    return !!e;
  })();
}
function Ps(e) {
  return Ps = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ps(e);
}
function _W(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Gh(e, t);
}
function Gh(e, t) {
  return Gh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Gh(e, t);
}
function lg(e, t, r) {
  return t = nR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function nR(e) {
  var t = OW(e, "string");
  return ao(t) == "symbol" ? t : t + "";
}
function OW(e, t) {
  if (ao(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ao(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function AW(e) {
  return e.dataKey;
}
function PW(e, t) {
  return /* @__PURE__ */ k.isValidElement(e) ? /* @__PURE__ */ k.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ k.createElement(e, t) : /* @__PURE__ */ k.createElement(eW, t);
}
var cr = /* @__PURE__ */ (function(e) {
  function t() {
    return gW(this, t), wW(this, t, arguments);
  }
  return _W(t, e), bW(t, [{
    key: "render",
    value: function() {
      var n = this, o = this.props, a = o.active, i = o.allowEscapeViewBox, s = o.animationDuration, c = o.animationEasing, l = o.content, f = o.coordinate, u = o.filterNull, d = o.isAnimationActive, h = o.offset, m = o.payload, v = o.payloadUniqBy, p = o.position, b = o.reverseDirection, w = o.useTranslate3d, x = o.viewBox, _ = o.wrapperStyle, y = m ?? [];
      u && y.length && (y = KC(m.filter(function(A) {
        return A.value != null && (A.hide !== !0 || n.props.includeHidden);
      }), v, AW));
      var O = y.length > 0;
      return /* @__PURE__ */ k.createElement(vW, {
        allowEscapeViewBox: i,
        animationDuration: s,
        animationEasing: c,
        isAnimationActive: d,
        active: a,
        coordinate: f,
        hasPayload: O,
        offset: h,
        position: p,
        reverseDirection: b,
        useTranslate3d: w,
        viewBox: x,
        wrapperStyle: _
      }, PW(l, ex(ex({}, this.props), {}, {
        payload: y
      })));
    }
  }]);
})(Ft);
lg(cr, "displayName", "Tooltip");
lg(cr, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !_n.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var Qd, tx;
function EW() {
  if (tx) return Qd;
  tx = 1;
  var e = nr(), t = function() {
    return e.Date.now();
  };
  return Qd = t, Qd;
}
var ep, rx;
function TW() {
  if (rx) return ep;
  rx = 1;
  var e = /\s/;
  function t(r) {
    for (var n = r.length; n-- && e.test(r.charAt(n)); )
      ;
    return n;
  }
  return ep = t, ep;
}
var tp, nx;
function CW() {
  if (nx) return tp;
  nx = 1;
  var e = TW(), t = /^\s+/;
  function r(n) {
    return n && n.slice(0, e(n) + 1).replace(t, "");
  }
  return tp = r, tp;
}
var rp, ox;
function oR() {
  if (ox) return rp;
  ox = 1;
  var e = CW(), t = zr(), r = Bo(), n = NaN, o = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, i = /^0o[0-7]+$/i, s = parseInt;
  function c(l) {
    if (typeof l == "number")
      return l;
    if (r(l))
      return n;
    if (t(l)) {
      var f = typeof l.valueOf == "function" ? l.valueOf() : l;
      l = t(f) ? f + "" : f;
    }
    if (typeof l != "string")
      return l === 0 ? l : +l;
    l = e(l);
    var u = a.test(l);
    return u || i.test(l) ? s(l.slice(2), u ? 2 : 8) : o.test(l) ? n : +l;
  }
  return rp = c, rp;
}
var np, ax;
function RW() {
  if (ax) return np;
  ax = 1;
  var e = zr(), t = EW(), r = oR(), n = "Expected a function", o = Math.max, a = Math.min;
  function i(s, c, l) {
    var f, u, d, h, m, v, p = 0, b = !1, w = !1, x = !0;
    if (typeof s != "function")
      throw new TypeError(n);
    c = r(c) || 0, e(l) && (b = !!l.leading, w = "maxWait" in l, d = w ? o(r(l.maxWait) || 0, c) : d, x = "trailing" in l ? !!l.trailing : x);
    function _(R) {
      var M = f, D = u;
      return f = u = void 0, p = R, h = s.apply(D, M), h;
    }
    function y(R) {
      return p = R, m = setTimeout(P, c), b ? _(R) : h;
    }
    function O(R) {
      var M = R - v, D = R - p, $ = c - M;
      return w ? a($, d - D) : $;
    }
    function A(R) {
      var M = R - v, D = R - p;
      return v === void 0 || M >= c || M < 0 || w && D >= d;
    }
    function P() {
      var R = t();
      if (A(R))
        return T(R);
      m = setTimeout(P, O(R));
    }
    function T(R) {
      return m = void 0, x && f ? _(R) : (f = u = void 0, h);
    }
    function I() {
      m !== void 0 && clearTimeout(m), p = 0, f = v = u = m = void 0;
    }
    function E() {
      return m === void 0 ? h : T(t());
    }
    function C() {
      var R = t(), M = A(R);
      if (f = arguments, u = this, v = R, M) {
        if (m === void 0)
          return y(v);
        if (w)
          return clearTimeout(m), m = setTimeout(P, c), _(v);
      }
      return m === void 0 && (m = setTimeout(P, c)), h;
    }
    return C.cancel = I, C.flush = E, C;
  }
  return np = i, np;
}
var op, ix;
function MW() {
  if (ix) return op;
  ix = 1;
  var e = RW(), t = zr(), r = "Expected a function";
  function n(o, a, i) {
    var s = !0, c = !0;
    if (typeof o != "function")
      throw new TypeError(r);
    return t(i) && (s = "leading" in i ? !!i.leading : s, c = "trailing" in i ? !!i.trailing : c), e(o, a, {
      leading: s,
      maxWait: a,
      trailing: c
    });
  }
  return op = n, op;
}
var IW = MW();
const aR = /* @__PURE__ */ Ae(IW);
function Ea(e) {
  "@babel/helpers - typeof";
  return Ea = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ea(e);
}
function sx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function zi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? sx(Object(r), !0).forEach(function(n) {
      NW(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : sx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function NW(e, t, r) {
  return t = kW(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kW(e) {
  var t = $W(e, "string");
  return Ea(t) == "symbol" ? t : t + "";
}
function $W(e, t) {
  if (Ea(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ea(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function DW(e, t) {
  return FW(e) || BW(e, t) || LW(e, t) || jW();
}
function jW() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function LW(e, t) {
  if (e) {
    if (typeof e == "string") return cx(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return cx(e, t);
  }
}
function cx(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function BW(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, o, a, i, s = [], c = !0, l = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, o = f;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw o;
      }
    }
    return s;
  }
}
function FW(e) {
  if (Array.isArray(e)) return e;
}
var wJ = /* @__PURE__ */ ni(function(e, t) {
  var r = e.aspect, n = e.initialDimension, o = n === void 0 ? {
    width: -1,
    height: -1
  } : n, a = e.width, i = a === void 0 ? "100%" : a, s = e.height, c = s === void 0 ? "100%" : s, l = e.minWidth, f = l === void 0 ? 0 : l, u = e.minHeight, d = e.maxHeight, h = e.children, m = e.debounce, v = m === void 0 ? 0 : m, p = e.id, b = e.className, w = e.onResize, x = e.style, _ = x === void 0 ? {} : x, y = Xn(null), O = Xn();
  O.current = w, DI(t, function() {
    return Object.defineProperty(y.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), y.current;
      },
      configurable: !0
    });
  });
  var A = Je({
    containerWidth: o.width,
    containerHeight: o.height
  }), P = DW(A, 2), T = P[0], I = P[1], E = Nn(function(R, M) {
    I(function(D) {
      var $ = Math.round(R), q = Math.round(M);
      return D.containerWidth === $ && D.containerHeight === q ? D : {
        containerWidth: $,
        containerHeight: q
      };
    });
  }, []);
  mt(function() {
    var R = function(B) {
      var L, z = B[0].contentRect, N = z.width, U = z.height;
      E(N, U), (L = O.current) === null || L === void 0 || L.call(O, N, U);
    };
    v > 0 && (R = aR(R, v, {
      trailing: !0,
      leading: !1
    }));
    var M = new ResizeObserver(R), D = y.current.getBoundingClientRect(), $ = D.width, q = D.height;
    return E($, q), M.observe(y.current), function() {
      M.disconnect();
    };
  }, [E, v]);
  var C = M1(function() {
    var R = T.containerWidth, M = T.containerHeight;
    if (R < 0 || M < 0)
      return null;
    pr(en(i) || en(c), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, i, c), pr(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
    var D = en(i) ? R : i, $ = en(c) ? M : c;
    r && r > 0 && (D ? $ = D / r : $ && (D = $ * r), d && $ > d && ($ = d)), pr(D > 0 || $ > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, D, $, i, c, f, u, r);
    var q = !Array.isArray(h) && dr(h.type).endsWith("Chart");
    return k.Children.map(h, function(F) {
      return /* @__PURE__ */ k.isValidElement(F) ? /* @__PURE__ */ qe(F, zi({
        width: D,
        height: $
      }, q ? {
        style: zi({
          height: "100%",
          width: "100%",
          maxHeight: $,
          maxWidth: D
        }, F.props.style)
      } : {})) : F;
    });
  }, [r, h, c, d, u, f, T, i]);
  return /* @__PURE__ */ k.createElement("div", {
    id: p ? "".concat(p) : void 0,
    className: de("recharts-responsive-container", b),
    style: zi(zi({}, _), {}, {
      width: i,
      height: c,
      minWidth: f,
      minHeight: u,
      maxHeight: d
    }),
    ref: y
  }, C);
}), ug = function(t) {
  return null;
};
ug.displayName = "Cell";
function Ta(e) {
  "@babel/helpers - typeof";
  return Ta = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ta(e);
}
function lx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Yh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? lx(Object(r), !0).forEach(function(n) {
      qW(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : lx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function qW(e, t, r) {
  return t = zW(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function zW(e) {
  var t = WW(e, "string");
  return Ta(t) == "symbol" ? t : t + "";
}
function WW(e, t) {
  if (Ta(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ta(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Rn = {
  widthCache: {},
  cacheCount: 0
}, UW = 2e3, HW = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, ux = "recharts_measurement_span";
function VW(e) {
  var t = Yh({}, e);
  return Object.keys(t).forEach(function(r) {
    t[r] || delete t[r];
  }), t;
}
var ua = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || _n.isSsr)
    return {
      width: 0,
      height: 0
    };
  var n = VW(r), o = JSON.stringify({
    text: t,
    copyStyle: n
  });
  if (Rn.widthCache[o])
    return Rn.widthCache[o];
  try {
    var a = document.getElementById(ux);
    a || (a = document.createElement("span"), a.setAttribute("id", ux), a.setAttribute("aria-hidden", "true"), document.body.appendChild(a));
    var i = Yh(Yh({}, HW), n);
    Object.assign(a.style, i), a.textContent = "".concat(t);
    var s = a.getBoundingClientRect(), c = {
      width: s.width,
      height: s.height
    };
    return Rn.widthCache[o] = c, ++Rn.cacheCount > UW && (Rn.cacheCount = 0, Rn.widthCache = {}), c;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, KW = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function Ca(e) {
  "@babel/helpers - typeof";
  return Ca = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ca(e);
}
function Es(e, t) {
  return ZW(e) || XW(e, t) || YW(e, t) || GW();
}
function GW() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function YW(e, t) {
  if (e) {
    if (typeof e == "string") return fx(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return fx(e, t);
  }
}
function fx(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function XW(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, o, a, i, s = [], c = !0, l = !1;
    try {
      if (a = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        c = !1;
      } else for (; !(c = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, o = f;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw o;
      }
    }
    return s;
  }
}
function ZW(e) {
  if (Array.isArray(e)) return e;
}
function JW(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function dx(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, eU(n.key), n);
  }
}
function QW(e, t, r) {
  return t && dx(e.prototype, t), r && dx(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function eU(e) {
  var t = tU(e, "string");
  return Ca(t) == "symbol" ? t : t + "";
}
function tU(e, t) {
  if (Ca(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ca(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var px = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, hx = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, rU = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, nU = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, iR = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, oU = Object.keys(iR), jn = "NaN";
function aU(e, t) {
  return e * iR[t];
}
var Wi = /* @__PURE__ */ (function() {
  function e(t, r) {
    JW(this, e), this.num = t, this.unit = r, this.num = t, this.unit = r, Number.isNaN(t) && (this.unit = ""), r !== "" && !rU.test(r) && (this.num = NaN, this.unit = ""), oU.includes(r) && (this.num = aU(t, r), this.unit = "px");
  }
  return QW(e, [{
    key: "add",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num + r.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num - r.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num * r.num, this.unit || r.unit);
    }
  }, {
    key: "divide",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num / r.num, this.unit || r.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(r) {
      var n, o = (n = nU.exec(r)) !== null && n !== void 0 ? n : [], a = Es(o, 3), i = a[1], s = a[2];
      return new e(parseFloat(i), s ?? "");
    }
  }]);
})();
function sR(e) {
  if (e.includes(jn))
    return jn;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var r, n = (r = px.exec(t)) !== null && r !== void 0 ? r : [], o = Es(n, 4), a = o[1], i = o[2], s = o[3], c = Wi.parse(a ?? ""), l = Wi.parse(s ?? ""), f = i === "*" ? c.multiply(l) : c.divide(l);
    if (f.isNaN())
      return jn;
    t = t.replace(px, f.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var u, d = (u = hx.exec(t)) !== null && u !== void 0 ? u : [], h = Es(d, 4), m = h[1], v = h[2], p = h[3], b = Wi.parse(m ?? ""), w = Wi.parse(p ?? ""), x = v === "+" ? b.add(w) : b.subtract(w);
    if (x.isNaN())
      return jn;
    t = t.replace(hx, x.toString());
  }
  return t;
}
var vx = /\(([^()]*)\)/;
function iU(e) {
  for (var t = e; t.includes("("); ) {
    var r = vx.exec(t), n = Es(r, 2), o = n[1];
    t = t.replace(vx, sR(o));
  }
  return t;
}
function sU(e) {
  var t = e.replace(/\s+/g, "");
  return t = iU(t), t = sR(t), t;
}
function cU(e) {
  try {
    return sU(e);
  } catch {
    return jn;
  }
}
function ap(e) {
  var t = cU(e.slice(5, -1));
  return t === jn ? "" : t;
}
var lU = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], uU = ["dx", "dy", "angle", "className", "breakAll"];
function Xh() {
  return Xh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xh.apply(this, arguments);
}
function mx(e, t) {
  if (e == null) return {};
  var r = fU(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function fU(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function gx(e, t) {
  return vU(e) || hU(e, t) || pU(e, t) || dU();
}
function dU() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pU(e, t) {
  if (e) {
    if (typeof e == "string") return yx(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return yx(e, t);
  }
}
function yx(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function hU(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, o, a, i, s = [], c = !0, l = !1;
    try {
      if (a = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        c = !1;
      } else for (; !(c = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, o = f;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw o;
      }
    }
    return s;
  }
}
function vU(e) {
  if (Array.isArray(e)) return e;
}
var cR = /[ \f\n\r\t\v\u2028\u2029]+/, lR = function(t) {
  var r = t.children, n = t.breakAll, o = t.style;
  try {
    var a = [];
    fe(r) || (n ? a = r.toString().split("") : a = r.toString().split(cR));
    var i = a.map(function(c) {
      return {
        word: c,
        width: ua(c, o).width
      };
    }), s = n ? 0 : ua(" ", o).width;
    return {
      wordsWithComputedWidth: i,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, mU = function(t, r, n, o, a) {
  var i = t.maxLines, s = t.children, c = t.style, l = t.breakAll, f = ne(i), u = s, d = function() {
    var D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return D.reduce(function($, q) {
      var F = q.word, B = q.width, L = $[$.length - 1];
      if (L && (o == null || a || L.width + B + n < Number(o)))
        L.words.push(F), L.width += B + n;
      else {
        var z = {
          words: [F],
          width: B
        };
        $.push(z);
      }
      return $;
    }, []);
  }, h = d(r), m = function(D) {
    return D.reduce(function($, q) {
      return $.width > q.width ? $ : q;
    });
  };
  if (!f)
    return h;
  for (var v = "…", p = function(D) {
    var $ = u.slice(0, D), q = lR({
      breakAll: l,
      style: c,
      children: $ + v
    }).wordsWithComputedWidth, F = d(q), B = F.length > i || m(F).width > Number(o);
    return [B, F];
  }, b = 0, w = u.length - 1, x = 0, _; b <= w && x <= u.length - 1; ) {
    var y = Math.floor((b + w) / 2), O = y - 1, A = p(O), P = gx(A, 2), T = P[0], I = P[1], E = p(y), C = gx(E, 1), R = C[0];
    if (!T && !R && (b = y + 1), T && R && (w = y - 1), !T && R) {
      _ = I;
      break;
    }
    x++;
  }
  return _ || h;
}, bx = function(t) {
  var r = fe(t) ? [] : t.toString().split(cR);
  return [{
    words: r
  }];
}, gU = function(t) {
  var r = t.width, n = t.scaleToFit, o = t.children, a = t.style, i = t.breakAll, s = t.maxLines;
  if ((r || n) && !_n.isSsr) {
    var c, l, f = lR({
      breakAll: i,
      children: o,
      style: a
    });
    if (f) {
      var u = f.wordsWithComputedWidth, d = f.spaceWidth;
      c = u, l = d;
    } else
      return bx(o);
    return mU({
      breakAll: i,
      children: o,
      maxLines: s,
      style: a
    }, c, l, r, n);
  }
  return bx(o);
}, wx = "#808080", gn = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, o = t.y, a = o === void 0 ? 0 : o, i = t.lineHeight, s = i === void 0 ? "1em" : i, c = t.capHeight, l = c === void 0 ? "0.71em" : c, f = t.scaleToFit, u = f === void 0 ? !1 : f, d = t.textAnchor, h = d === void 0 ? "start" : d, m = t.verticalAnchor, v = m === void 0 ? "end" : m, p = t.fill, b = p === void 0 ? wx : p, w = mx(t, lU), x = M1(function() {
    return gU({
      breakAll: w.breakAll,
      children: w.children,
      maxLines: w.maxLines,
      scaleToFit: u,
      style: w.style,
      width: w.width
    });
  }, [w.breakAll, w.children, w.maxLines, u, w.style, w.width]), _ = w.dx, y = w.dy, O = w.angle, A = w.className, P = w.breakAll, T = mx(w, uU);
  if (!We(n) || !We(a))
    return null;
  var I = n + (ne(_) ? _ : 0), E = a + (ne(y) ? y : 0), C;
  switch (v) {
    case "start":
      C = ap("calc(".concat(l, ")"));
      break;
    case "middle":
      C = ap("calc(".concat((x.length - 1) / 2, " * -").concat(s, " + (").concat(l, " / 2))"));
      break;
    default:
      C = ap("calc(".concat(x.length - 1, " * -").concat(s, ")"));
      break;
  }
  var R = [];
  if (u) {
    var M = x[0].width, D = w.width;
    R.push("scale(".concat((ne(D) ? D / M : 1) / M, ")"));
  }
  return O && R.push("rotate(".concat(O, ", ").concat(I, ", ").concat(E, ")")), R.length && (T.transform = R.join(" ")), /* @__PURE__ */ k.createElement("text", Xh({}, ie(T, !0), {
    x: I,
    y: E,
    className: de("recharts-text", A),
    textAnchor: h,
    fill: b.includes("url") ? wx : b
  }), x.map(function($, q) {
    var F = $.words.join(P ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ k.createElement("tspan", {
        x: I,
        dy: q === 0 ? C : s,
        key: "".concat(F, "-").concat(q)
      }, F)
    );
  }));
};
function Ir(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function yU(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function fg(e) {
  let t, r, n;
  e.length !== 2 ? (t = Ir, r = (s, c) => Ir(e(s), c), n = (s, c) => e(s) - c) : (t = e === Ir || e === yU ? e : bU, r = e, n = e);
  function o(s, c, l = 0, f = s.length) {
    if (l < f) {
      if (t(c, c) !== 0) return f;
      do {
        const u = l + f >>> 1;
        r(s[u], c) < 0 ? l = u + 1 : f = u;
      } while (l < f);
    }
    return l;
  }
  function a(s, c, l = 0, f = s.length) {
    if (l < f) {
      if (t(c, c) !== 0) return f;
      do {
        const u = l + f >>> 1;
        r(s[u], c) <= 0 ? l = u + 1 : f = u;
      } while (l < f);
    }
    return l;
  }
  function i(s, c, l = 0, f = s.length) {
    const u = o(s, c, l, f - 1);
    return u > l && n(s[u - 1], c) > -n(s[u], c) ? u - 1 : u;
  }
  return { left: o, center: i, right: a };
}
function bU() {
  return 0;
}
function uR(e) {
  return e === null ? NaN : +e;
}
function* wU(e, t) {
  for (let r of e)
    r != null && (r = +r) >= r && (yield r);
}
const xU = fg(Ir), Oi = xU.right;
fg(uR).center;
class xx extends Map {
  constructor(t, r = OU) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), t != null) for (const [n, o] of t) this.set(n, o);
  }
  get(t) {
    return super.get(Sx(this, t));
  }
  has(t) {
    return super.has(Sx(this, t));
  }
  set(t, r) {
    return super.set(SU(this, t), r);
  }
  delete(t) {
    return super.delete(_U(this, t));
  }
}
function Sx({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : r;
}
function SU({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : (e.set(n, r), r);
}
function _U({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) && (r = e.get(n), e.delete(n)), r;
}
function OU(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function AU(e = Ir) {
  if (e === Ir) return fR;
  if (typeof e != "function") throw new TypeError("compare is not a function");
  return (t, r) => {
    const n = e(t, r);
    return n || n === 0 ? n : (e(r, r) === 0) - (e(t, t) === 0);
  };
}
function fR(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const PU = Math.sqrt(50), EU = Math.sqrt(10), TU = Math.sqrt(2);
function Ts(e, t, r) {
  const n = (t - e) / Math.max(0, r), o = Math.floor(Math.log10(n)), a = n / Math.pow(10, o), i = a >= PU ? 10 : a >= EU ? 5 : a >= TU ? 2 : 1;
  let s, c, l;
  return o < 0 ? (l = Math.pow(10, -o) / i, s = Math.round(e * l), c = Math.round(t * l), s / l < e && ++s, c / l > t && --c, l = -l) : (l = Math.pow(10, o) * i, s = Math.round(e / l), c = Math.round(t / l), s * l < e && ++s, c * l > t && --c), c < s && 0.5 <= r && r < 2 ? Ts(e, t, r * 2) : [s, c, l];
}
function Zh(e, t, r) {
  if (t = +t, e = +e, r = +r, !(r > 0)) return [];
  if (e === t) return [e];
  const n = t < e, [o, a, i] = n ? Ts(t, e, r) : Ts(e, t, r);
  if (!(a >= o)) return [];
  const s = a - o + 1, c = new Array(s);
  if (n)
    if (i < 0) for (let l = 0; l < s; ++l) c[l] = (a - l) / -i;
    else for (let l = 0; l < s; ++l) c[l] = (a - l) * i;
  else if (i < 0) for (let l = 0; l < s; ++l) c[l] = (o + l) / -i;
  else for (let l = 0; l < s; ++l) c[l] = (o + l) * i;
  return c;
}
function Jh(e, t, r) {
  return t = +t, e = +e, r = +r, Ts(e, t, r)[2];
}
function Qh(e, t, r) {
  t = +t, e = +e, r = +r;
  const n = t < e, o = n ? Jh(t, e, r) : Jh(e, t, r);
  return (n ? -1 : 1) * (o < 0 ? 1 / -o : o);
}
function _x(e, t) {
  let r;
  for (const n of e)
    n != null && (r < n || r === void 0 && n >= n) && (r = n);
  return r;
}
function Ox(e, t) {
  let r;
  for (const n of e)
    n != null && (r > n || r === void 0 && n >= n) && (r = n);
  return r;
}
function dR(e, t, r = 0, n = 1 / 0, o) {
  if (t = Math.floor(t), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(e.length - 1, n)), !(r <= t && t <= n)) return e;
  for (o = o === void 0 ? fR : AU(o); n > r; ) {
    if (n - r > 600) {
      const c = n - r + 1, l = t - r + 1, f = Math.log(c), u = 0.5 * Math.exp(2 * f / 3), d = 0.5 * Math.sqrt(f * u * (c - u) / c) * (l - c / 2 < 0 ? -1 : 1), h = Math.max(r, Math.floor(t - l * u / c + d)), m = Math.min(n, Math.floor(t + (c - l) * u / c + d));
      dR(e, t, h, m, o);
    }
    const a = e[t];
    let i = r, s = n;
    for (Zo(e, r, t), o(e[n], a) > 0 && Zo(e, r, n); i < s; ) {
      for (Zo(e, i, s), ++i, --s; o(e[i], a) < 0; ) ++i;
      for (; o(e[s], a) > 0; ) --s;
    }
    o(e[r], a) === 0 ? Zo(e, r, s) : (++s, Zo(e, s, n)), s <= t && (r = s + 1), t <= s && (n = s - 1);
  }
  return e;
}
function Zo(e, t, r) {
  const n = e[t];
  e[t] = e[r], e[r] = n;
}
function CU(e, t, r) {
  if (e = Float64Array.from(wU(e)), !(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return Ox(e);
    if (t >= 1) return _x(e);
    var n, o = (n - 1) * t, a = Math.floor(o), i = _x(dR(e, a).subarray(0, a + 1)), s = Ox(e.subarray(a + 1));
    return i + (s - i) * (o - a);
  }
}
function RU(e, t, r = uR) {
  if (!(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return +r(e[0], 0, e);
    if (t >= 1) return +r(e[n - 1], n - 1, e);
    var n, o = (n - 1) * t, a = Math.floor(o), i = +r(e[a], a, e), s = +r(e[a + 1], a + 1, e);
    return i + (s - i) * (o - a);
  }
}
function MU(e, t, r) {
  e = +e, t = +t, r = (o = arguments.length) < 2 ? (t = e, e = 0, 1) : o < 3 ? 1 : +r;
  for (var n = -1, o = Math.max(0, Math.ceil((t - e) / r)) | 0, a = new Array(o); ++n < o; )
    a[n] = e + n * r;
  return a;
}
function Ct(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function Or(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const ev = Symbol("implicit");
function dg() {
  var e = new xx(), t = [], r = [], n = ev;
  function o(a) {
    let i = e.get(a);
    if (i === void 0) {
      if (n !== ev) return n;
      e.set(a, i = t.push(a) - 1);
    }
    return r[i % r.length];
  }
  return o.domain = function(a) {
    if (!arguments.length) return t.slice();
    t = [], e = new xx();
    for (const i of a)
      e.has(i) || e.set(i, t.push(i) - 1);
    return o;
  }, o.range = function(a) {
    return arguments.length ? (r = Array.from(a), o) : r.slice();
  }, o.unknown = function(a) {
    return arguments.length ? (n = a, o) : n;
  }, o.copy = function() {
    return dg(t, r).unknown(n);
  }, Ct.apply(o, arguments), o;
}
function Ra() {
  var e = dg().unknown(void 0), t = e.domain, r = e.range, n = 0, o = 1, a, i, s = !1, c = 0, l = 0, f = 0.5;
  delete e.unknown;
  function u() {
    var d = t().length, h = o < n, m = h ? o : n, v = h ? n : o;
    a = (v - m) / Math.max(1, d - c + l * 2), s && (a = Math.floor(a)), m += (v - m - a * (d - c)) * f, i = a * (1 - c), s && (m = Math.round(m), i = Math.round(i));
    var p = MU(d).map(function(b) {
      return m + a * b;
    });
    return r(h ? p.reverse() : p);
  }
  return e.domain = function(d) {
    return arguments.length ? (t(d), u()) : t();
  }, e.range = function(d) {
    return arguments.length ? ([n, o] = d, n = +n, o = +o, u()) : [n, o];
  }, e.rangeRound = function(d) {
    return [n, o] = d, n = +n, o = +o, s = !0, u();
  }, e.bandwidth = function() {
    return i;
  }, e.step = function() {
    return a;
  }, e.round = function(d) {
    return arguments.length ? (s = !!d, u()) : s;
  }, e.padding = function(d) {
    return arguments.length ? (c = Math.min(1, l = +d), u()) : c;
  }, e.paddingInner = function(d) {
    return arguments.length ? (c = Math.min(1, d), u()) : c;
  }, e.paddingOuter = function(d) {
    return arguments.length ? (l = +d, u()) : l;
  }, e.align = function(d) {
    return arguments.length ? (f = Math.max(0, Math.min(1, d)), u()) : f;
  }, e.copy = function() {
    return Ra(t(), [n, o]).round(s).paddingInner(c).paddingOuter(l).align(f);
  }, Ct.apply(u(), arguments);
}
function pR(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return pR(t());
  }, e;
}
function fa() {
  return pR(Ra.apply(null, arguments).paddingInner(1));
}
function pg(e, t, r) {
  e.prototype = t.prototype = r, r.constructor = e;
}
function hR(e, t) {
  var r = Object.create(e.prototype);
  for (var n in t) r[n] = t[n];
  return r;
}
function Ai() {
}
var Ma = 0.7, Cs = 1 / Ma, Gn = "\\s*([+-]?\\d+)\\s*", Ia = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Yt = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", IU = /^#([0-9a-f]{3,8})$/, NU = new RegExp(`^rgb\\(${Gn},${Gn},${Gn}\\)$`), kU = new RegExp(`^rgb\\(${Yt},${Yt},${Yt}\\)$`), $U = new RegExp(`^rgba\\(${Gn},${Gn},${Gn},${Ia}\\)$`), DU = new RegExp(`^rgba\\(${Yt},${Yt},${Yt},${Ia}\\)$`), jU = new RegExp(`^hsl\\(${Ia},${Yt},${Yt}\\)$`), LU = new RegExp(`^hsla\\(${Ia},${Yt},${Yt},${Ia}\\)$`), Ax = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
pg(Ai, Na, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Px,
  // Deprecated! Use color.formatHex.
  formatHex: Px,
  formatHex8: BU,
  formatHsl: FU,
  formatRgb: Ex,
  toString: Ex
});
function Px() {
  return this.rgb().formatHex();
}
function BU() {
  return this.rgb().formatHex8();
}
function FU() {
  return vR(this).formatHsl();
}
function Ex() {
  return this.rgb().formatRgb();
}
function Na(e) {
  var t, r;
  return e = (e + "").trim().toLowerCase(), (t = IU.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? Tx(t) : r === 3 ? new it(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? Ui(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? Ui(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = NU.exec(e)) ? new it(t[1], t[2], t[3], 1) : (t = kU.exec(e)) ? new it(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = $U.exec(e)) ? Ui(t[1], t[2], t[3], t[4]) : (t = DU.exec(e)) ? Ui(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = jU.exec(e)) ? Mx(t[1], t[2] / 100, t[3] / 100, 1) : (t = LU.exec(e)) ? Mx(t[1], t[2] / 100, t[3] / 100, t[4]) : Ax.hasOwnProperty(e) ? Tx(Ax[e]) : e === "transparent" ? new it(NaN, NaN, NaN, 0) : null;
}
function Tx(e) {
  return new it(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Ui(e, t, r, n) {
  return n <= 0 && (e = t = r = NaN), new it(e, t, r, n);
}
function qU(e) {
  return e instanceof Ai || (e = Na(e)), e ? (e = e.rgb(), new it(e.r, e.g, e.b, e.opacity)) : new it();
}
function tv(e, t, r, n) {
  return arguments.length === 1 ? qU(e) : new it(e, t, r, n ?? 1);
}
function it(e, t, r, n) {
  this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
}
pg(it, tv, hR(Ai, {
  brighter(e) {
    return e = e == null ? Cs : Math.pow(Cs, e), new it(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Ma : Math.pow(Ma, e), new it(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new it(an(this.r), an(this.g), an(this.b), Rs(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Cx,
  // Deprecated! Use color.formatHex.
  formatHex: Cx,
  formatHex8: zU,
  formatRgb: Rx,
  toString: Rx
}));
function Cx() {
  return `#${tn(this.r)}${tn(this.g)}${tn(this.b)}`;
}
function zU() {
  return `#${tn(this.r)}${tn(this.g)}${tn(this.b)}${tn((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Rx() {
  const e = Rs(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${an(this.r)}, ${an(this.g)}, ${an(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function Rs(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function an(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function tn(e) {
  return e = an(e), (e < 16 ? "0" : "") + e.toString(16);
}
function Mx(e, t, r, n) {
  return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new $t(e, t, r, n);
}
function vR(e) {
  if (e instanceof $t) return new $t(e.h, e.s, e.l, e.opacity);
  if (e instanceof Ai || (e = Na(e)), !e) return new $t();
  if (e instanceof $t) return e;
  e = e.rgb();
  var t = e.r / 255, r = e.g / 255, n = e.b / 255, o = Math.min(t, r, n), a = Math.max(t, r, n), i = NaN, s = a - o, c = (a + o) / 2;
  return s ? (t === a ? i = (r - n) / s + (r < n) * 6 : r === a ? i = (n - t) / s + 2 : i = (t - r) / s + 4, s /= c < 0.5 ? a + o : 2 - a - o, i *= 60) : s = c > 0 && c < 1 ? 0 : i, new $t(i, s, c, e.opacity);
}
function WU(e, t, r, n) {
  return arguments.length === 1 ? vR(e) : new $t(e, t, r, n ?? 1);
}
function $t(e, t, r, n) {
  this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
}
pg($t, WU, hR(Ai, {
  brighter(e) {
    return e = e == null ? Cs : Math.pow(Cs, e), new $t(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Ma : Math.pow(Ma, e), new $t(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * t, o = 2 * r - n;
    return new it(
      ip(e >= 240 ? e - 240 : e + 120, o, n),
      ip(e, o, n),
      ip(e < 120 ? e + 240 : e - 120, o, n),
      this.opacity
    );
  },
  clamp() {
    return new $t(Ix(this.h), Hi(this.s), Hi(this.l), Rs(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = Rs(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${Ix(this.h)}, ${Hi(this.s) * 100}%, ${Hi(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function Ix(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Hi(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function ip(e, t, r) {
  return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
}
const hg = (e) => () => e;
function UU(e, t) {
  return function(r) {
    return e + r * t;
  };
}
function HU(e, t, r) {
  return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
    return Math.pow(e + n * t, r);
  };
}
function VU(e) {
  return (e = +e) == 1 ? mR : function(t, r) {
    return r - t ? HU(t, r, e) : hg(isNaN(t) ? r : t);
  };
}
function mR(e, t) {
  var r = t - e;
  return r ? UU(e, r) : hg(isNaN(e) ? t : e);
}
const Nx = (function e(t) {
  var r = VU(t);
  function n(o, a) {
    var i = r((o = tv(o)).r, (a = tv(a)).r), s = r(o.g, a.g), c = r(o.b, a.b), l = mR(o.opacity, a.opacity);
    return function(f) {
      return o.r = i(f), o.g = s(f), o.b = c(f), o.opacity = l(f), o + "";
    };
  }
  return n.gamma = e, n;
})(1);
function KU(e, t) {
  t || (t = []);
  var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), o;
  return function(a) {
    for (o = 0; o < r; ++o) n[o] = e[o] * (1 - a) + t[o] * a;
    return n;
  };
}
function GU(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function YU(e, t) {
  var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, o = new Array(n), a = new Array(r), i;
  for (i = 0; i < n; ++i) o[i] = Wo(e[i], t[i]);
  for (; i < r; ++i) a[i] = t[i];
  return function(s) {
    for (i = 0; i < n; ++i) a[i] = o[i](s);
    return a;
  };
}
function XU(e, t) {
  var r = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(n) {
    return r.setTime(e * (1 - n) + t * n), r;
  };
}
function Ms(e, t) {
  return e = +e, t = +t, function(r) {
    return e * (1 - r) + t * r;
  };
}
function ZU(e, t) {
  var r = {}, n = {}, o;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (o in t)
    o in e ? r[o] = Wo(e[o], t[o]) : n[o] = t[o];
  return function(a) {
    for (o in r) n[o] = r[o](a);
    return n;
  };
}
var rv = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, sp = new RegExp(rv.source, "g");
function JU(e) {
  return function() {
    return e;
  };
}
function QU(e) {
  return function(t) {
    return e(t) + "";
  };
}
function e8(e, t) {
  var r = rv.lastIndex = sp.lastIndex = 0, n, o, a, i = -1, s = [], c = [];
  for (e = e + "", t = t + ""; (n = rv.exec(e)) && (o = sp.exec(t)); )
    (a = o.index) > r && (a = t.slice(r, a), s[i] ? s[i] += a : s[++i] = a), (n = n[0]) === (o = o[0]) ? s[i] ? s[i] += o : s[++i] = o : (s[++i] = null, c.push({ i, x: Ms(n, o) })), r = sp.lastIndex;
  return r < t.length && (a = t.slice(r), s[i] ? s[i] += a : s[++i] = a), s.length < 2 ? c[0] ? QU(c[0].x) : JU(t) : (t = c.length, function(l) {
    for (var f = 0, u; f < t; ++f) s[(u = c[f]).i] = u.x(l);
    return s.join("");
  });
}
function Wo(e, t) {
  var r = typeof t, n;
  return t == null || r === "boolean" ? hg(t) : (r === "number" ? Ms : r === "string" ? (n = Na(t)) ? (t = n, Nx) : e8 : t instanceof Na ? Nx : t instanceof Date ? XU : GU(t) ? KU : Array.isArray(t) ? YU : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? ZU : Ms)(e, t);
}
function vg(e, t) {
  return e = +e, t = +t, function(r) {
    return Math.round(e * (1 - r) + t * r);
  };
}
function t8(e, t) {
  t === void 0 && (t = e, e = Wo);
  for (var r = 0, n = t.length - 1, o = t[0], a = new Array(n < 0 ? 0 : n); r < n; ) a[r] = e(o, o = t[++r]);
  return function(i) {
    var s = Math.max(0, Math.min(n - 1, Math.floor(i *= n)));
    return a[s](i - s);
  };
}
function r8(e) {
  return function() {
    return e;
  };
}
function Is(e) {
  return +e;
}
var kx = [0, 1];
function ot(e) {
  return e;
}
function nv(e, t) {
  return (t -= e = +e) ? function(r) {
    return (r - e) / t;
  } : r8(isNaN(t) ? NaN : 0.5);
}
function n8(e, t) {
  var r;
  return e > t && (r = e, e = t, t = r), function(n) {
    return Math.max(e, Math.min(t, n));
  };
}
function o8(e, t, r) {
  var n = e[0], o = e[1], a = t[0], i = t[1];
  return o < n ? (n = nv(o, n), a = r(i, a)) : (n = nv(n, o), a = r(a, i)), function(s) {
    return a(n(s));
  };
}
function a8(e, t, r) {
  var n = Math.min(e.length, t.length) - 1, o = new Array(n), a = new Array(n), i = -1;
  for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++i < n; )
    o[i] = nv(e[i], e[i + 1]), a[i] = r(t[i], t[i + 1]);
  return function(s) {
    var c = Oi(e, s, 1, n) - 1;
    return a[c](o[c](s));
  };
}
function Pi(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function il() {
  var e = kx, t = kx, r = Wo, n, o, a, i = ot, s, c, l;
  function f() {
    var d = Math.min(e.length, t.length);
    return i !== ot && (i = n8(e[0], e[d - 1])), s = d > 2 ? a8 : o8, c = l = null, u;
  }
  function u(d) {
    return d == null || isNaN(d = +d) ? a : (c || (c = s(e.map(n), t, r)))(n(i(d)));
  }
  return u.invert = function(d) {
    return i(o((l || (l = s(t, e.map(n), Ms)))(d)));
  }, u.domain = function(d) {
    return arguments.length ? (e = Array.from(d, Is), f()) : e.slice();
  }, u.range = function(d) {
    return arguments.length ? (t = Array.from(d), f()) : t.slice();
  }, u.rangeRound = function(d) {
    return t = Array.from(d), r = vg, f();
  }, u.clamp = function(d) {
    return arguments.length ? (i = d ? !0 : ot, f()) : i !== ot;
  }, u.interpolate = function(d) {
    return arguments.length ? (r = d, f()) : r;
  }, u.unknown = function(d) {
    return arguments.length ? (a = d, u) : a;
  }, function(d, h) {
    return n = d, o = h, f();
  };
}
function mg() {
  return il()(ot, ot);
}
function i8(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function Ns(e, t) {
  if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var r, n = e.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +e.slice(r + 1)
  ];
}
function io(e) {
  return e = Ns(Math.abs(e)), e ? e[1] : NaN;
}
function s8(e, t) {
  return function(r, n) {
    for (var o = r.length, a = [], i = 0, s = e[0], c = 0; o > 0 && s > 0 && (c + s + 1 > n && (s = Math.max(1, n - c)), a.push(r.substring(o -= s, o + s)), !((c += s + 1) > n)); )
      s = e[i = (i + 1) % e.length];
    return a.reverse().join(t);
  };
}
function c8(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(r) {
      return e[+r];
    });
  };
}
var l8 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function ka(e) {
  if (!(t = l8.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new gg({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
ka.prototype = gg.prototype;
function gg(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
gg.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function u8(e) {
  e: for (var t = e.length, r = 1, n = -1, o; r < t; ++r)
    switch (e[r]) {
      case ".":
        n = o = r;
        break;
      case "0":
        n === 0 && (n = r), o = r;
        break;
      default:
        if (!+e[r]) break e;
        n > 0 && (n = 0);
        break;
    }
  return n > 0 ? e.slice(0, n) + e.slice(o + 1) : e;
}
var gR;
function f8(e, t) {
  var r = Ns(e, t);
  if (!r) return e + "";
  var n = r[0], o = r[1], a = o - (gR = Math.max(-8, Math.min(8, Math.floor(o / 3))) * 3) + 1, i = n.length;
  return a === i ? n : a > i ? n + new Array(a - i + 1).join("0") : a > 0 ? n.slice(0, a) + "." + n.slice(a) : "0." + new Array(1 - a).join("0") + Ns(e, Math.max(0, t + a - 1))[0];
}
function $x(e, t) {
  var r = Ns(e, t);
  if (!r) return e + "";
  var n = r[0], o = r[1];
  return o < 0 ? "0." + new Array(-o).join("0") + n : n.length > o + 1 ? n.slice(0, o + 1) + "." + n.slice(o + 1) : n + new Array(o - n.length + 2).join("0");
}
const Dx = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: i8,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => $x(e * 100, t),
  r: $x,
  s: f8,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function jx(e) {
  return e;
}
var Lx = Array.prototype.map, Bx = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function d8(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? jx : s8(Lx.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", o = e.decimal === void 0 ? "." : e.decimal + "", a = e.numerals === void 0 ? jx : c8(Lx.call(e.numerals, String)), i = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", c = e.nan === void 0 ? "NaN" : e.nan + "";
  function l(u) {
    u = ka(u);
    var d = u.fill, h = u.align, m = u.sign, v = u.symbol, p = u.zero, b = u.width, w = u.comma, x = u.precision, _ = u.trim, y = u.type;
    y === "n" ? (w = !0, y = "g") : Dx[y] || (x === void 0 && (x = 12), _ = !0, y = "g"), (p || d === "0" && h === "=") && (p = !0, d = "0", h = "=");
    var O = v === "$" ? r : v === "#" && /[boxX]/.test(y) ? "0" + y.toLowerCase() : "", A = v === "$" ? n : /[%p]/.test(y) ? i : "", P = Dx[y], T = /[defgprs%]/.test(y);
    x = x === void 0 ? 6 : /[gprs]/.test(y) ? Math.max(1, Math.min(21, x)) : Math.max(0, Math.min(20, x));
    function I(E) {
      var C = O, R = A, M, D, $;
      if (y === "c")
        R = P(E) + R, E = "";
      else {
        E = +E;
        var q = E < 0 || 1 / E < 0;
        if (E = isNaN(E) ? c : P(Math.abs(E), x), _ && (E = u8(E)), q && +E == 0 && m !== "+" && (q = !1), C = (q ? m === "(" ? m : s : m === "-" || m === "(" ? "" : m) + C, R = (y === "s" ? Bx[8 + gR / 3] : "") + R + (q && m === "(" ? ")" : ""), T) {
          for (M = -1, D = E.length; ++M < D; )
            if ($ = E.charCodeAt(M), 48 > $ || $ > 57) {
              R = ($ === 46 ? o + E.slice(M + 1) : E.slice(M)) + R, E = E.slice(0, M);
              break;
            }
        }
      }
      w && !p && (E = t(E, 1 / 0));
      var F = C.length + E.length + R.length, B = F < b ? new Array(b - F + 1).join(d) : "";
      switch (w && p && (E = t(B + E, B.length ? b - R.length : 1 / 0), B = ""), h) {
        case "<":
          E = C + E + R + B;
          break;
        case "=":
          E = C + B + E + R;
          break;
        case "^":
          E = B.slice(0, F = B.length >> 1) + C + E + R + B.slice(F);
          break;
        default:
          E = B + C + E + R;
          break;
      }
      return a(E);
    }
    return I.toString = function() {
      return u + "";
    }, I;
  }
  function f(u, d) {
    var h = l((u = ka(u), u.type = "f", u)), m = Math.max(-8, Math.min(8, Math.floor(io(d) / 3))) * 3, v = Math.pow(10, -m), p = Bx[8 + m / 3];
    return function(b) {
      return h(v * b) + p;
    };
  }
  return {
    format: l,
    formatPrefix: f
  };
}
var Vi, yg, yR;
p8({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function p8(e) {
  return Vi = d8(e), yg = Vi.format, yR = Vi.formatPrefix, Vi;
}
function h8(e) {
  return Math.max(0, -io(Math.abs(e)));
}
function v8(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(io(t) / 3))) * 3 - io(Math.abs(e)));
}
function m8(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, io(t) - io(e)) + 1;
}
function bR(e, t, r, n) {
  var o = Qh(e, t, r), a;
  switch (n = ka(n ?? ",f"), n.type) {
    case "s": {
      var i = Math.max(Math.abs(e), Math.abs(t));
      return n.precision == null && !isNaN(a = v8(o, i)) && (n.precision = a), yR(n, i);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(a = m8(o, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = a - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(a = h8(o)) && (n.precision = a - (n.type === "%") * 2);
      break;
    }
  }
  return yg(n);
}
function Wr(e) {
  var t = e.domain;
  return e.ticks = function(r) {
    var n = t();
    return Zh(n[0], n[n.length - 1], r ?? 10);
  }, e.tickFormat = function(r, n) {
    var o = t();
    return bR(o[0], o[o.length - 1], r ?? 10, n);
  }, e.nice = function(r) {
    r == null && (r = 10);
    var n = t(), o = 0, a = n.length - 1, i = n[o], s = n[a], c, l, f = 10;
    for (s < i && (l = i, i = s, s = l, l = o, o = a, a = l); f-- > 0; ) {
      if (l = Jh(i, s, r), l === c)
        return n[o] = i, n[a] = s, t(n);
      if (l > 0)
        i = Math.floor(i / l) * l, s = Math.ceil(s / l) * l;
      else if (l < 0)
        i = Math.ceil(i * l) / l, s = Math.floor(s * l) / l;
      else
        break;
      c = l;
    }
    return e;
  }, e;
}
function ks() {
  var e = mg();
  return e.copy = function() {
    return Pi(e, ks());
  }, Ct.apply(e, arguments), Wr(e);
}
function wR(e) {
  var t;
  function r(n) {
    return n == null || isNaN(n = +n) ? t : n;
  }
  return r.invert = r, r.domain = r.range = function(n) {
    return arguments.length ? (e = Array.from(n, Is), r) : e.slice();
  }, r.unknown = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.copy = function() {
    return wR(e).unknown(t);
  }, e = arguments.length ? Array.from(e, Is) : [0, 1], Wr(r);
}
function xR(e, t) {
  e = e.slice();
  var r = 0, n = e.length - 1, o = e[r], a = e[n], i;
  return a < o && (i = r, r = n, n = i, i = o, o = a, a = i), e[r] = t.floor(o), e[n] = t.ceil(a), e;
}
function Fx(e) {
  return Math.log(e);
}
function qx(e) {
  return Math.exp(e);
}
function g8(e) {
  return -Math.log(-e);
}
function y8(e) {
  return -Math.exp(-e);
}
function b8(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function w8(e) {
  return e === 10 ? b8 : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function x8(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function zx(e) {
  return (t, r) => -e(-t, r);
}
function bg(e) {
  const t = e(Fx, qx), r = t.domain;
  let n = 10, o, a;
  function i() {
    return o = x8(n), a = w8(n), r()[0] < 0 ? (o = zx(o), a = zx(a), e(g8, y8)) : e(Fx, qx), t;
  }
  return t.base = function(s) {
    return arguments.length ? (n = +s, i()) : n;
  }, t.domain = function(s) {
    return arguments.length ? (r(s), i()) : r();
  }, t.ticks = (s) => {
    const c = r();
    let l = c[0], f = c[c.length - 1];
    const u = f < l;
    u && ([l, f] = [f, l]);
    let d = o(l), h = o(f), m, v;
    const p = s == null ? 10 : +s;
    let b = [];
    if (!(n % 1) && h - d < p) {
      if (d = Math.floor(d), h = Math.ceil(h), l > 0) {
        for (; d <= h; ++d)
          for (m = 1; m < n; ++m)
            if (v = d < 0 ? m / a(-d) : m * a(d), !(v < l)) {
              if (v > f) break;
              b.push(v);
            }
      } else for (; d <= h; ++d)
        for (m = n - 1; m >= 1; --m)
          if (v = d > 0 ? m / a(-d) : m * a(d), !(v < l)) {
            if (v > f) break;
            b.push(v);
          }
      b.length * 2 < p && (b = Zh(l, f, p));
    } else
      b = Zh(d, h, Math.min(h - d, p)).map(a);
    return u ? b.reverse() : b;
  }, t.tickFormat = (s, c) => {
    if (s == null && (s = 10), c == null && (c = n === 10 ? "s" : ","), typeof c != "function" && (!(n % 1) && (c = ka(c)).precision == null && (c.trim = !0), c = yg(c)), s === 1 / 0) return c;
    const l = Math.max(1, n * s / t.ticks().length);
    return (f) => {
      let u = f / a(Math.round(o(f)));
      return u * n < n - 0.5 && (u *= n), u <= l ? c(f) : "";
    };
  }, t.nice = () => r(xR(r(), {
    floor: (s) => a(Math.floor(o(s))),
    ceil: (s) => a(Math.ceil(o(s)))
  })), t;
}
function SR() {
  const e = bg(il()).domain([1, 10]);
  return e.copy = () => Pi(e, SR()).base(e.base()), Ct.apply(e, arguments), e;
}
function Wx(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function Ux(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function wg(e) {
  var t = 1, r = e(Wx(t), Ux(t));
  return r.constant = function(n) {
    return arguments.length ? e(Wx(t = +n), Ux(t)) : t;
  }, Wr(r);
}
function _R() {
  var e = wg(il());
  return e.copy = function() {
    return Pi(e, _R()).constant(e.constant());
  }, Ct.apply(e, arguments);
}
function Hx(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function S8(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function _8(e) {
  return e < 0 ? -e * e : e * e;
}
function xg(e) {
  var t = e(ot, ot), r = 1;
  function n() {
    return r === 1 ? e(ot, ot) : r === 0.5 ? e(S8, _8) : e(Hx(r), Hx(1 / r));
  }
  return t.exponent = function(o) {
    return arguments.length ? (r = +o, n()) : r;
  }, Wr(t);
}
function Sg() {
  var e = xg(il());
  return e.copy = function() {
    return Pi(e, Sg()).exponent(e.exponent());
  }, Ct.apply(e, arguments), e;
}
function O8() {
  return Sg.apply(null, arguments).exponent(0.5);
}
function Vx(e) {
  return Math.sign(e) * e * e;
}
function A8(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function OR() {
  var e = mg(), t = [0, 1], r = !1, n;
  function o(a) {
    var i = A8(e(a));
    return isNaN(i) ? n : r ? Math.round(i) : i;
  }
  return o.invert = function(a) {
    return e.invert(Vx(a));
  }, o.domain = function(a) {
    return arguments.length ? (e.domain(a), o) : e.domain();
  }, o.range = function(a) {
    return arguments.length ? (e.range((t = Array.from(a, Is)).map(Vx)), o) : t.slice();
  }, o.rangeRound = function(a) {
    return o.range(a).round(!0);
  }, o.round = function(a) {
    return arguments.length ? (r = !!a, o) : r;
  }, o.clamp = function(a) {
    return arguments.length ? (e.clamp(a), o) : e.clamp();
  }, o.unknown = function(a) {
    return arguments.length ? (n = a, o) : n;
  }, o.copy = function() {
    return OR(e.domain(), t).round(r).clamp(e.clamp()).unknown(n);
  }, Ct.apply(o, arguments), Wr(o);
}
function AR() {
  var e = [], t = [], r = [], n;
  function o() {
    var i = 0, s = Math.max(1, t.length);
    for (r = new Array(s - 1); ++i < s; ) r[i - 1] = RU(e, i / s);
    return a;
  }
  function a(i) {
    return i == null || isNaN(i = +i) ? n : t[Oi(r, i)];
  }
  return a.invertExtent = function(i) {
    var s = t.indexOf(i);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? r[s - 1] : e[0],
      s < r.length ? r[s] : e[e.length - 1]
    ];
  }, a.domain = function(i) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let s of i) s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(Ir), o();
  }, a.range = function(i) {
    return arguments.length ? (t = Array.from(i), o()) : t.slice();
  }, a.unknown = function(i) {
    return arguments.length ? (n = i, a) : n;
  }, a.quantiles = function() {
    return r.slice();
  }, a.copy = function() {
    return AR().domain(e).range(t).unknown(n);
  }, Ct.apply(a, arguments);
}
function PR() {
  var e = 0, t = 1, r = 1, n = [0.5], o = [0, 1], a;
  function i(c) {
    return c != null && c <= c ? o[Oi(n, c, 0, r)] : a;
  }
  function s() {
    var c = -1;
    for (n = new Array(r); ++c < r; ) n[c] = ((c + 1) * t - (c - r) * e) / (r + 1);
    return i;
  }
  return i.domain = function(c) {
    return arguments.length ? ([e, t] = c, e = +e, t = +t, s()) : [e, t];
  }, i.range = function(c) {
    return arguments.length ? (r = (o = Array.from(c)).length - 1, s()) : o.slice();
  }, i.invertExtent = function(c) {
    var l = o.indexOf(c);
    return l < 0 ? [NaN, NaN] : l < 1 ? [e, n[0]] : l >= r ? [n[r - 1], t] : [n[l - 1], n[l]];
  }, i.unknown = function(c) {
    return arguments.length && (a = c), i;
  }, i.thresholds = function() {
    return n.slice();
  }, i.copy = function() {
    return PR().domain([e, t]).range(o).unknown(a);
  }, Ct.apply(Wr(i), arguments);
}
function ER() {
  var e = [0.5], t = [0, 1], r, n = 1;
  function o(a) {
    return a != null && a <= a ? t[Oi(e, a, 0, n)] : r;
  }
  return o.domain = function(a) {
    return arguments.length ? (e = Array.from(a), n = Math.min(e.length, t.length - 1), o) : e.slice();
  }, o.range = function(a) {
    return arguments.length ? (t = Array.from(a), n = Math.min(e.length, t.length - 1), o) : t.slice();
  }, o.invertExtent = function(a) {
    var i = t.indexOf(a);
    return [e[i - 1], e[i]];
  }, o.unknown = function(a) {
    return arguments.length ? (r = a, o) : r;
  }, o.copy = function() {
    return ER().domain(e).range(t).unknown(r);
  }, Ct.apply(o, arguments);
}
const cp = /* @__PURE__ */ new Date(), lp = /* @__PURE__ */ new Date();
function He(e, t, r, n) {
  function o(a) {
    return e(a = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+a)), a;
  }
  return o.floor = (a) => (e(a = /* @__PURE__ */ new Date(+a)), a), o.ceil = (a) => (e(a = new Date(a - 1)), t(a, 1), e(a), a), o.round = (a) => {
    const i = o(a), s = o.ceil(a);
    return a - i < s - a ? i : s;
  }, o.offset = (a, i) => (t(a = /* @__PURE__ */ new Date(+a), i == null ? 1 : Math.floor(i)), a), o.range = (a, i, s) => {
    const c = [];
    if (a = o.ceil(a), s = s == null ? 1 : Math.floor(s), !(a < i) || !(s > 0)) return c;
    let l;
    do
      c.push(l = /* @__PURE__ */ new Date(+a)), t(a, s), e(a);
    while (l < a && a < i);
    return c;
  }, o.filter = (a) => He((i) => {
    if (i >= i) for (; e(i), !a(i); ) i.setTime(i - 1);
  }, (i, s) => {
    if (i >= i)
      if (s < 0) for (; ++s <= 0; )
        for (; t(i, -1), !a(i); )
          ;
      else for (; --s >= 0; )
        for (; t(i, 1), !a(i); )
          ;
  }), r && (o.count = (a, i) => (cp.setTime(+a), lp.setTime(+i), e(cp), e(lp), Math.floor(r(cp, lp))), o.every = (a) => (a = Math.floor(a), !isFinite(a) || !(a > 0) ? null : a > 1 ? o.filter(n ? (i) => n(i) % a === 0 : (i) => o.count(0, i) % a === 0) : o)), o;
}
const $s = He(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
$s.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? He((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, r) => {
  t.setTime(+t + r * e);
}, (t, r) => (r - t) / e) : $s);
$s.range;
const ur = 1e3, Ot = ur * 60, fr = Ot * 60, yr = fr * 24, _g = yr * 7, Kx = yr * 30, up = yr * 365, rn = He((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * ur);
}, (e, t) => (t - e) / ur, (e) => e.getUTCSeconds());
rn.range;
const Og = He((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * ur);
}, (e, t) => {
  e.setTime(+e + t * Ot);
}, (e, t) => (t - e) / Ot, (e) => e.getMinutes());
Og.range;
const Ag = He((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * Ot);
}, (e, t) => (t - e) / Ot, (e) => e.getUTCMinutes());
Ag.range;
const Pg = He((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * ur - e.getMinutes() * Ot);
}, (e, t) => {
  e.setTime(+e + t * fr);
}, (e, t) => (t - e) / fr, (e) => e.getHours());
Pg.range;
const Eg = He((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * fr);
}, (e, t) => (t - e) / fr, (e) => e.getUTCHours());
Eg.range;
const Ei = He(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Ot) / yr,
  (e) => e.getDate() - 1
);
Ei.range;
const sl = He((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / yr, (e) => e.getUTCDate() - 1);
sl.range;
const TR = He((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / yr, (e) => Math.floor(e / yr));
TR.range;
function On(e) {
  return He((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setDate(t.getDate() + r * 7);
  }, (t, r) => (r - t - (r.getTimezoneOffset() - t.getTimezoneOffset()) * Ot) / _g);
}
const cl = On(0), Ds = On(1), P8 = On(2), E8 = On(3), so = On(4), T8 = On(5), C8 = On(6);
cl.range;
Ds.range;
P8.range;
E8.range;
so.range;
T8.range;
C8.range;
function An(e) {
  return He((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setUTCDate(t.getUTCDate() + r * 7);
  }, (t, r) => (r - t) / _g);
}
const ll = An(0), js = An(1), R8 = An(2), M8 = An(3), co = An(4), I8 = An(5), N8 = An(6);
ll.range;
js.range;
R8.range;
M8.range;
co.range;
I8.range;
N8.range;
const Tg = He((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
Tg.range;
const Cg = He((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
Cg.range;
const br = He((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
br.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : He((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, r) => {
  t.setFullYear(t.getFullYear() + r * e);
});
br.range;
const wr = He((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
wr.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : He((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, r) => {
  t.setUTCFullYear(t.getUTCFullYear() + r * e);
});
wr.range;
function CR(e, t, r, n, o, a) {
  const i = [
    [rn, 1, ur],
    [rn, 5, 5 * ur],
    [rn, 15, 15 * ur],
    [rn, 30, 30 * ur],
    [a, 1, Ot],
    [a, 5, 5 * Ot],
    [a, 15, 15 * Ot],
    [a, 30, 30 * Ot],
    [o, 1, fr],
    [o, 3, 3 * fr],
    [o, 6, 6 * fr],
    [o, 12, 12 * fr],
    [n, 1, yr],
    [n, 2, 2 * yr],
    [r, 1, _g],
    [t, 1, Kx],
    [t, 3, 3 * Kx],
    [e, 1, up]
  ];
  function s(l, f, u) {
    const d = f < l;
    d && ([l, f] = [f, l]);
    const h = u && typeof u.range == "function" ? u : c(l, f, u), m = h ? h.range(l, +f + 1) : [];
    return d ? m.reverse() : m;
  }
  function c(l, f, u) {
    const d = Math.abs(f - l) / u, h = fg(([, , p]) => p).right(i, d);
    if (h === i.length) return e.every(Qh(l / up, f / up, u));
    if (h === 0) return $s.every(Math.max(Qh(l, f, u), 1));
    const [m, v] = i[d / i[h - 1][2] < i[h][2] / d ? h - 1 : h];
    return m.every(v);
  }
  return [s, c];
}
const [k8, $8] = CR(wr, Cg, ll, TR, Eg, Ag), [D8, j8] = CR(br, Tg, cl, Ei, Pg, Og);
function fp(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function dp(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Jo(e, t, r) {
  return { y: e, m: t, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function L8(e) {
  var t = e.dateTime, r = e.date, n = e.time, o = e.periods, a = e.days, i = e.shortDays, s = e.months, c = e.shortMonths, l = Qo(o), f = ea(o), u = Qo(a), d = ea(a), h = Qo(i), m = ea(i), v = Qo(s), p = ea(s), b = Qo(c), w = ea(c), x = {
    a: q,
    A: F,
    b: B,
    B: L,
    c: null,
    d: Qx,
    e: Qx,
    f: s6,
    g: g6,
    G: b6,
    H: o6,
    I: a6,
    j: i6,
    L: RR,
    m: c6,
    M: l6,
    p: z,
    q: N,
    Q: rS,
    s: nS,
    S: u6,
    u: f6,
    U: d6,
    V: p6,
    w: h6,
    W: v6,
    x: null,
    X: null,
    y: m6,
    Y: y6,
    Z: w6,
    "%": tS
  }, _ = {
    a: U,
    A: K,
    b: G,
    B: J,
    c: null,
    d: eS,
    e: eS,
    f: O6,
    g: k6,
    G: D6,
    H: x6,
    I: S6,
    j: _6,
    L: IR,
    m: A6,
    M: P6,
    p: V,
    q: Q,
    Q: rS,
    s: nS,
    S: E6,
    u: T6,
    U: C6,
    V: R6,
    w: M6,
    W: I6,
    x: null,
    X: null,
    y: N6,
    Y: $6,
    Z: j6,
    "%": tS
  }, y = {
    a: I,
    A: E,
    b: C,
    B: R,
    c: M,
    d: Zx,
    e: Zx,
    f: e6,
    g: Xx,
    G: Yx,
    H: Jx,
    I: Jx,
    j: X8,
    L: Q8,
    m: Y8,
    M: Z8,
    p: T,
    q: G8,
    Q: r6,
    s: n6,
    S: J8,
    u: W8,
    U: U8,
    V: H8,
    w: z8,
    W: V8,
    x: D,
    X: $,
    y: Xx,
    Y: Yx,
    Z: K8,
    "%": t6
  };
  x.x = O(r, x), x.X = O(n, x), x.c = O(t, x), _.x = O(r, _), _.X = O(n, _), _.c = O(t, _);
  function O(W, Y) {
    return function(te) {
      var j = [], ce = -1, X = 0, he = W.length, ge, Ie, Ut;
      for (te instanceof Date || (te = /* @__PURE__ */ new Date(+te)); ++ce < he; )
        W.charCodeAt(ce) === 37 && (j.push(W.slice(X, ce)), (Ie = Gx[ge = W.charAt(++ce)]) != null ? ge = W.charAt(++ce) : Ie = ge === "e" ? " " : "0", (Ut = Y[ge]) && (ge = Ut(te, Ie)), j.push(ge), X = ce + 1);
      return j.push(W.slice(X, ce)), j.join("");
    };
  }
  function A(W, Y) {
    return function(te) {
      var j = Jo(1900, void 0, 1), ce = P(j, W, te += "", 0), X, he;
      if (ce != te.length) return null;
      if ("Q" in j) return new Date(j.Q);
      if ("s" in j) return new Date(j.s * 1e3 + ("L" in j ? j.L : 0));
      if (Y && !("Z" in j) && (j.Z = 0), "p" in j && (j.H = j.H % 12 + j.p * 12), j.m === void 0 && (j.m = "q" in j ? j.q : 0), "V" in j) {
        if (j.V < 1 || j.V > 53) return null;
        "w" in j || (j.w = 1), "Z" in j ? (X = dp(Jo(j.y, 0, 1)), he = X.getUTCDay(), X = he > 4 || he === 0 ? js.ceil(X) : js(X), X = sl.offset(X, (j.V - 1) * 7), j.y = X.getUTCFullYear(), j.m = X.getUTCMonth(), j.d = X.getUTCDate() + (j.w + 6) % 7) : (X = fp(Jo(j.y, 0, 1)), he = X.getDay(), X = he > 4 || he === 0 ? Ds.ceil(X) : Ds(X), X = Ei.offset(X, (j.V - 1) * 7), j.y = X.getFullYear(), j.m = X.getMonth(), j.d = X.getDate() + (j.w + 6) % 7);
      } else ("W" in j || "U" in j) && ("w" in j || (j.w = "u" in j ? j.u % 7 : "W" in j ? 1 : 0), he = "Z" in j ? dp(Jo(j.y, 0, 1)).getUTCDay() : fp(Jo(j.y, 0, 1)).getDay(), j.m = 0, j.d = "W" in j ? (j.w + 6) % 7 + j.W * 7 - (he + 5) % 7 : j.w + j.U * 7 - (he + 6) % 7);
      return "Z" in j ? (j.H += j.Z / 100 | 0, j.M += j.Z % 100, dp(j)) : fp(j);
    };
  }
  function P(W, Y, te, j) {
    for (var ce = 0, X = Y.length, he = te.length, ge, Ie; ce < X; ) {
      if (j >= he) return -1;
      if (ge = Y.charCodeAt(ce++), ge === 37) {
        if (ge = Y.charAt(ce++), Ie = y[ge in Gx ? Y.charAt(ce++) : ge], !Ie || (j = Ie(W, te, j)) < 0) return -1;
      } else if (ge != te.charCodeAt(j++))
        return -1;
    }
    return j;
  }
  function T(W, Y, te) {
    var j = l.exec(Y.slice(te));
    return j ? (W.p = f.get(j[0].toLowerCase()), te + j[0].length) : -1;
  }
  function I(W, Y, te) {
    var j = h.exec(Y.slice(te));
    return j ? (W.w = m.get(j[0].toLowerCase()), te + j[0].length) : -1;
  }
  function E(W, Y, te) {
    var j = u.exec(Y.slice(te));
    return j ? (W.w = d.get(j[0].toLowerCase()), te + j[0].length) : -1;
  }
  function C(W, Y, te) {
    var j = b.exec(Y.slice(te));
    return j ? (W.m = w.get(j[0].toLowerCase()), te + j[0].length) : -1;
  }
  function R(W, Y, te) {
    var j = v.exec(Y.slice(te));
    return j ? (W.m = p.get(j[0].toLowerCase()), te + j[0].length) : -1;
  }
  function M(W, Y, te) {
    return P(W, t, Y, te);
  }
  function D(W, Y, te) {
    return P(W, r, Y, te);
  }
  function $(W, Y, te) {
    return P(W, n, Y, te);
  }
  function q(W) {
    return i[W.getDay()];
  }
  function F(W) {
    return a[W.getDay()];
  }
  function B(W) {
    return c[W.getMonth()];
  }
  function L(W) {
    return s[W.getMonth()];
  }
  function z(W) {
    return o[+(W.getHours() >= 12)];
  }
  function N(W) {
    return 1 + ~~(W.getMonth() / 3);
  }
  function U(W) {
    return i[W.getUTCDay()];
  }
  function K(W) {
    return a[W.getUTCDay()];
  }
  function G(W) {
    return c[W.getUTCMonth()];
  }
  function J(W) {
    return s[W.getUTCMonth()];
  }
  function V(W) {
    return o[+(W.getUTCHours() >= 12)];
  }
  function Q(W) {
    return 1 + ~~(W.getUTCMonth() / 3);
  }
  return {
    format: function(W) {
      var Y = O(W += "", x);
      return Y.toString = function() {
        return W;
      }, Y;
    },
    parse: function(W) {
      var Y = A(W += "", !1);
      return Y.toString = function() {
        return W;
      }, Y;
    },
    utcFormat: function(W) {
      var Y = O(W += "", _);
      return Y.toString = function() {
        return W;
      }, Y;
    },
    utcParse: function(W) {
      var Y = A(W += "", !0);
      return Y.toString = function() {
        return W;
      }, Y;
    }
  };
}
var Gx = { "-": "", _: " ", 0: "0" }, Xe = /^\s*\d+/, B8 = /^%/, F8 = /[\\^$*+?|[\]().{}]/g;
function me(e, t, r) {
  var n = e < 0 ? "-" : "", o = (n ? -e : e) + "", a = o.length;
  return n + (a < r ? new Array(r - a + 1).join(t) + o : o);
}
function q8(e) {
  return e.replace(F8, "\\$&");
}
function Qo(e) {
  return new RegExp("^(?:" + e.map(q8).join("|") + ")", "i");
}
function ea(e) {
  return new Map(e.map((t, r) => [t.toLowerCase(), r]));
}
function z8(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 1));
  return n ? (e.w = +n[0], r + n[0].length) : -1;
}
function W8(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 1));
  return n ? (e.u = +n[0], r + n[0].length) : -1;
}
function U8(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 2));
  return n ? (e.U = +n[0], r + n[0].length) : -1;
}
function H8(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 2));
  return n ? (e.V = +n[0], r + n[0].length) : -1;
}
function V8(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 2));
  return n ? (e.W = +n[0], r + n[0].length) : -1;
}
function Yx(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 4));
  return n ? (e.y = +n[0], r + n[0].length) : -1;
}
function Xx(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 2));
  return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
}
function K8(e, t, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
  return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}
function G8(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 1));
  return n ? (e.q = n[0] * 3 - 3, r + n[0].length) : -1;
}
function Y8(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 2));
  return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
}
function Zx(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 2));
  return n ? (e.d = +n[0], r + n[0].length) : -1;
}
function X8(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 3));
  return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
}
function Jx(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 2));
  return n ? (e.H = +n[0], r + n[0].length) : -1;
}
function Z8(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 2));
  return n ? (e.M = +n[0], r + n[0].length) : -1;
}
function J8(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 2));
  return n ? (e.S = +n[0], r + n[0].length) : -1;
}
function Q8(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 3));
  return n ? (e.L = +n[0], r + n[0].length) : -1;
}
function e6(e, t, r) {
  var n = Xe.exec(t.slice(r, r + 6));
  return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}
function t6(e, t, r) {
  var n = B8.exec(t.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}
function r6(e, t, r) {
  var n = Xe.exec(t.slice(r));
  return n ? (e.Q = +n[0], r + n[0].length) : -1;
}
function n6(e, t, r) {
  var n = Xe.exec(t.slice(r));
  return n ? (e.s = +n[0], r + n[0].length) : -1;
}
function Qx(e, t) {
  return me(e.getDate(), t, 2);
}
function o6(e, t) {
  return me(e.getHours(), t, 2);
}
function a6(e, t) {
  return me(e.getHours() % 12 || 12, t, 2);
}
function i6(e, t) {
  return me(1 + Ei.count(br(e), e), t, 3);
}
function RR(e, t) {
  return me(e.getMilliseconds(), t, 3);
}
function s6(e, t) {
  return RR(e, t) + "000";
}
function c6(e, t) {
  return me(e.getMonth() + 1, t, 2);
}
function l6(e, t) {
  return me(e.getMinutes(), t, 2);
}
function u6(e, t) {
  return me(e.getSeconds(), t, 2);
}
function f6(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function d6(e, t) {
  return me(cl.count(br(e) - 1, e), t, 2);
}
function MR(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? so(e) : so.ceil(e);
}
function p6(e, t) {
  return e = MR(e), me(so.count(br(e), e) + (br(e).getDay() === 4), t, 2);
}
function h6(e) {
  return e.getDay();
}
function v6(e, t) {
  return me(Ds.count(br(e) - 1, e), t, 2);
}
function m6(e, t) {
  return me(e.getFullYear() % 100, t, 2);
}
function g6(e, t) {
  return e = MR(e), me(e.getFullYear() % 100, t, 2);
}
function y6(e, t) {
  return me(e.getFullYear() % 1e4, t, 4);
}
function b6(e, t) {
  var r = e.getDay();
  return e = r >= 4 || r === 0 ? so(e) : so.ceil(e), me(e.getFullYear() % 1e4, t, 4);
}
function w6(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + me(t / 60 | 0, "0", 2) + me(t % 60, "0", 2);
}
function eS(e, t) {
  return me(e.getUTCDate(), t, 2);
}
function x6(e, t) {
  return me(e.getUTCHours(), t, 2);
}
function S6(e, t) {
  return me(e.getUTCHours() % 12 || 12, t, 2);
}
function _6(e, t) {
  return me(1 + sl.count(wr(e), e), t, 3);
}
function IR(e, t) {
  return me(e.getUTCMilliseconds(), t, 3);
}
function O6(e, t) {
  return IR(e, t) + "000";
}
function A6(e, t) {
  return me(e.getUTCMonth() + 1, t, 2);
}
function P6(e, t) {
  return me(e.getUTCMinutes(), t, 2);
}
function E6(e, t) {
  return me(e.getUTCSeconds(), t, 2);
}
function T6(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function C6(e, t) {
  return me(ll.count(wr(e) - 1, e), t, 2);
}
function NR(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? co(e) : co.ceil(e);
}
function R6(e, t) {
  return e = NR(e), me(co.count(wr(e), e) + (wr(e).getUTCDay() === 4), t, 2);
}
function M6(e) {
  return e.getUTCDay();
}
function I6(e, t) {
  return me(js.count(wr(e) - 1, e), t, 2);
}
function N6(e, t) {
  return me(e.getUTCFullYear() % 100, t, 2);
}
function k6(e, t) {
  return e = NR(e), me(e.getUTCFullYear() % 100, t, 2);
}
function $6(e, t) {
  return me(e.getUTCFullYear() % 1e4, t, 4);
}
function D6(e, t) {
  var r = e.getUTCDay();
  return e = r >= 4 || r === 0 ? co(e) : co.ceil(e), me(e.getUTCFullYear() % 1e4, t, 4);
}
function j6() {
  return "+0000";
}
function tS() {
  return "%";
}
function rS(e) {
  return +e;
}
function nS(e) {
  return Math.floor(+e / 1e3);
}
var Mn, kR, $R;
L6({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function L6(e) {
  return Mn = L8(e), kR = Mn.format, Mn.parse, $R = Mn.utcFormat, Mn.utcParse, Mn;
}
function B6(e) {
  return new Date(e);
}
function F6(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function Rg(e, t, r, n, o, a, i, s, c, l) {
  var f = mg(), u = f.invert, d = f.domain, h = l(".%L"), m = l(":%S"), v = l("%I:%M"), p = l("%I %p"), b = l("%a %d"), w = l("%b %d"), x = l("%B"), _ = l("%Y");
  function y(O) {
    return (c(O) < O ? h : s(O) < O ? m : i(O) < O ? v : a(O) < O ? p : n(O) < O ? o(O) < O ? b : w : r(O) < O ? x : _)(O);
  }
  return f.invert = function(O) {
    return new Date(u(O));
  }, f.domain = function(O) {
    return arguments.length ? d(Array.from(O, F6)) : d().map(B6);
  }, f.ticks = function(O) {
    var A = d();
    return e(A[0], A[A.length - 1], O ?? 10);
  }, f.tickFormat = function(O, A) {
    return A == null ? y : l(A);
  }, f.nice = function(O) {
    var A = d();
    return (!O || typeof O.range != "function") && (O = t(A[0], A[A.length - 1], O ?? 10)), O ? d(xR(A, O)) : f;
  }, f.copy = function() {
    return Pi(f, Rg(e, t, r, n, o, a, i, s, c, l));
  }, f;
}
function q6() {
  return Ct.apply(Rg(D8, j8, br, Tg, cl, Ei, Pg, Og, rn, kR).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function z6() {
  return Ct.apply(Rg(k8, $8, wr, Cg, ll, sl, Eg, Ag, rn, $R).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function ul() {
  var e = 0, t = 1, r, n, o, a, i = ot, s = !1, c;
  function l(u) {
    return u == null || isNaN(u = +u) ? c : i(o === 0 ? 0.5 : (u = (a(u) - r) * o, s ? Math.max(0, Math.min(1, u)) : u));
  }
  l.domain = function(u) {
    return arguments.length ? ([e, t] = u, r = a(e = +e), n = a(t = +t), o = r === n ? 0 : 1 / (n - r), l) : [e, t];
  }, l.clamp = function(u) {
    return arguments.length ? (s = !!u, l) : s;
  }, l.interpolator = function(u) {
    return arguments.length ? (i = u, l) : i;
  };
  function f(u) {
    return function(d) {
      var h, m;
      return arguments.length ? ([h, m] = d, i = u(h, m), l) : [i(0), i(1)];
    };
  }
  return l.range = f(Wo), l.rangeRound = f(vg), l.unknown = function(u) {
    return arguments.length ? (c = u, l) : c;
  }, function(u) {
    return a = u, r = u(e), n = u(t), o = r === n ? 0 : 1 / (n - r), l;
  };
}
function Ur(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function DR() {
  var e = Wr(ul()(ot));
  return e.copy = function() {
    return Ur(e, DR());
  }, Or.apply(e, arguments);
}
function jR() {
  var e = bg(ul()).domain([1, 10]);
  return e.copy = function() {
    return Ur(e, jR()).base(e.base());
  }, Or.apply(e, arguments);
}
function LR() {
  var e = wg(ul());
  return e.copy = function() {
    return Ur(e, LR()).constant(e.constant());
  }, Or.apply(e, arguments);
}
function Mg() {
  var e = xg(ul());
  return e.copy = function() {
    return Ur(e, Mg()).exponent(e.exponent());
  }, Or.apply(e, arguments);
}
function W6() {
  return Mg.apply(null, arguments).exponent(0.5);
}
function BR() {
  var e = [], t = ot;
  function r(n) {
    if (n != null && !isNaN(n = +n)) return t((Oi(e, n, 1) - 1) / (e.length - 1));
  }
  return r.domain = function(n) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let o of n) o != null && !isNaN(o = +o) && e.push(o);
    return e.sort(Ir), r;
  }, r.interpolator = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.range = function() {
    return e.map((n, o) => t(o / (e.length - 1)));
  }, r.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (o, a) => CU(e, a / n));
  }, r.copy = function() {
    return BR(t).domain(e);
  }, Or.apply(r, arguments);
}
function fl() {
  var e = 0, t = 0.5, r = 1, n = 1, o, a, i, s, c, l = ot, f, u = !1, d;
  function h(v) {
    return isNaN(v = +v) ? d : (v = 0.5 + ((v = +f(v)) - a) * (n * v < n * a ? s : c), l(u ? Math.max(0, Math.min(1, v)) : v));
  }
  h.domain = function(v) {
    return arguments.length ? ([e, t, r] = v, o = f(e = +e), a = f(t = +t), i = f(r = +r), s = o === a ? 0 : 0.5 / (a - o), c = a === i ? 0 : 0.5 / (i - a), n = a < o ? -1 : 1, h) : [e, t, r];
  }, h.clamp = function(v) {
    return arguments.length ? (u = !!v, h) : u;
  }, h.interpolator = function(v) {
    return arguments.length ? (l = v, h) : l;
  };
  function m(v) {
    return function(p) {
      var b, w, x;
      return arguments.length ? ([b, w, x] = p, l = t8(v, [b, w, x]), h) : [l(0), l(0.5), l(1)];
    };
  }
  return h.range = m(Wo), h.rangeRound = m(vg), h.unknown = function(v) {
    return arguments.length ? (d = v, h) : d;
  }, function(v) {
    return f = v, o = v(e), a = v(t), i = v(r), s = o === a ? 0 : 0.5 / (a - o), c = a === i ? 0 : 0.5 / (i - a), n = a < o ? -1 : 1, h;
  };
}
function FR() {
  var e = Wr(fl()(ot));
  return e.copy = function() {
    return Ur(e, FR());
  }, Or.apply(e, arguments);
}
function qR() {
  var e = bg(fl()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return Ur(e, qR()).base(e.base());
  }, Or.apply(e, arguments);
}
function zR() {
  var e = wg(fl());
  return e.copy = function() {
    return Ur(e, zR()).constant(e.constant());
  }, Or.apply(e, arguments);
}
function Ig() {
  var e = xg(fl());
  return e.copy = function() {
    return Ur(e, Ig()).exponent(e.exponent());
  }, Or.apply(e, arguments);
}
function U6() {
  return Ig.apply(null, arguments).exponent(0.5);
}
const oS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: Ra,
  scaleDiverging: FR,
  scaleDivergingLog: qR,
  scaleDivergingPow: Ig,
  scaleDivergingSqrt: U6,
  scaleDivergingSymlog: zR,
  scaleIdentity: wR,
  scaleImplicit: ev,
  scaleLinear: ks,
  scaleLog: SR,
  scaleOrdinal: dg,
  scalePoint: fa,
  scalePow: Sg,
  scaleQuantile: AR,
  scaleQuantize: PR,
  scaleRadial: OR,
  scaleSequential: DR,
  scaleSequentialLog: jR,
  scaleSequentialPow: Mg,
  scaleSequentialQuantile: BR,
  scaleSequentialSqrt: W6,
  scaleSequentialSymlog: LR,
  scaleSqrt: O8,
  scaleSymlog: _R,
  scaleThreshold: ER,
  scaleTime: q6,
  scaleUtc: z6,
  tickFormat: bR
}, Symbol.toStringTag, { value: "Module" }));
var pp, aS;
function dl() {
  if (aS) return pp;
  aS = 1;
  var e = Bo();
  function t(r, n, o) {
    for (var a = -1, i = r.length; ++a < i; ) {
      var s = r[a], c = n(s);
      if (c != null && (l === void 0 ? c === c && !e(c) : o(c, l)))
        var l = c, f = s;
    }
    return f;
  }
  return pp = t, pp;
}
var hp, iS;
function WR() {
  if (iS) return hp;
  iS = 1;
  function e(t, r) {
    return t > r;
  }
  return hp = e, hp;
}
var vp, sS;
function H6() {
  if (sS) return vp;
  sS = 1;
  var e = dl(), t = WR(), r = zo();
  function n(o) {
    return o && o.length ? e(o, r, t) : void 0;
  }
  return vp = n, vp;
}
var V6 = H6();
const pl = /* @__PURE__ */ Ae(V6);
var mp, cS;
function UR() {
  if (cS) return mp;
  cS = 1;
  function e(t, r) {
    return t < r;
  }
  return mp = e, mp;
}
var gp, lS;
function K6() {
  if (lS) return gp;
  lS = 1;
  var e = dl(), t = UR(), r = zo();
  function n(o) {
    return o && o.length ? e(o, r, t) : void 0;
  }
  return gp = n, gp;
}
var G6 = K6();
const hl = /* @__PURE__ */ Ae(G6);
var yp, uS;
function Y6() {
  if (uS) return yp;
  uS = 1;
  var e = Km(), t = or(), r = JC(), n = lt();
  function o(a, i) {
    var s = n(a) ? e : r;
    return s(a, t(i, 3));
  }
  return yp = o, yp;
}
var bp, fS;
function X6() {
  if (fS) return bp;
  fS = 1;
  var e = XC(), t = Y6();
  function r(n, o) {
    return e(t(n, o), 1);
  }
  return bp = r, bp;
}
var Z6 = X6();
const J6 = /* @__PURE__ */ Ae(Z6);
var wp, dS;
function Q6() {
  if (dS) return wp;
  dS = 1;
  var e = ig();
  function t(r, n) {
    return e(r, n);
  }
  return wp = t, wp;
}
var eH = Q6();
const Ti = /* @__PURE__ */ Ae(eH);
var Uo = 1e9, tH = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, kg, Me = !0, Et = "[DecimalError] ", sn = Et + "Invalid argument: ", Ng = Et + "Exponent out of range: ", Ho = Math.floor, Jr = Math.pow, rH = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, vt, Ve = 1e7, Re = 7, HR = 9007199254740991, Ls = Ho(HR / Re), oe = {};
oe.absoluteValue = oe.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
oe.comparedTo = oe.cmp = function(e) {
  var t, r, n, o, a = this;
  if (e = new a.constructor(e), a.s !== e.s) return a.s || -e.s;
  if (a.e !== e.e) return a.e > e.e ^ a.s < 0 ? 1 : -1;
  for (n = a.d.length, o = e.d.length, t = 0, r = n < o ? n : o; t < r; ++t)
    if (a.d[t] !== e.d[t]) return a.d[t] > e.d[t] ^ a.s < 0 ? 1 : -1;
  return n === o ? 0 : n > o ^ a.s < 0 ? 1 : -1;
};
oe.decimalPlaces = oe.dp = function() {
  var e = this, t = e.d.length - 1, r = (t - e.e) * Re;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) r--;
  return r < 0 ? 0 : r;
};
oe.dividedBy = oe.div = function(e) {
  return hr(this, new this.constructor(e));
};
oe.dividedToIntegerBy = oe.idiv = function(e) {
  var t = this, r = t.constructor;
  return Oe(hr(t, new r(e), 0, 1), r.precision);
};
oe.equals = oe.eq = function(e) {
  return !this.cmp(e);
};
oe.exponent = function() {
  return Le(this);
};
oe.greaterThan = oe.gt = function(e) {
  return this.cmp(e) > 0;
};
oe.greaterThanOrEqualTo = oe.gte = function(e) {
  return this.cmp(e) >= 0;
};
oe.isInteger = oe.isint = function() {
  return this.e > this.d.length - 2;
};
oe.isNegative = oe.isneg = function() {
  return this.s < 0;
};
oe.isPositive = oe.ispos = function() {
  return this.s > 0;
};
oe.isZero = function() {
  return this.s === 0;
};
oe.lessThan = oe.lt = function(e) {
  return this.cmp(e) < 0;
};
oe.lessThanOrEqualTo = oe.lte = function(e) {
  return this.cmp(e) < 1;
};
oe.logarithm = oe.log = function(e) {
  var t, r = this, n = r.constructor, o = n.precision, a = o + 5;
  if (e === void 0)
    e = new n(10);
  else if (e = new n(e), e.s < 1 || e.eq(vt)) throw Error(Et + "NaN");
  if (r.s < 1) throw Error(Et + (r.s ? "NaN" : "-Infinity"));
  return r.eq(vt) ? new n(0) : (Me = !1, t = hr($a(r, a), $a(e, a), a), Me = !0, Oe(t, o));
};
oe.minus = oe.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? GR(t, e) : VR(t, (e.s = -e.s, e));
};
oe.modulo = oe.mod = function(e) {
  var t, r = this, n = r.constructor, o = n.precision;
  if (e = new n(e), !e.s) throw Error(Et + "NaN");
  return r.s ? (Me = !1, t = hr(r, e, 0, 1).times(e), Me = !0, r.minus(t)) : Oe(new n(r), o);
};
oe.naturalExponential = oe.exp = function() {
  return KR(this);
};
oe.naturalLogarithm = oe.ln = function() {
  return $a(this);
};
oe.negated = oe.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
oe.plus = oe.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? VR(t, e) : GR(t, (e.s = -e.s, e));
};
oe.precision = oe.sd = function(e) {
  var t, r, n, o = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(sn + e);
  if (t = Le(o) + 1, n = o.d.length - 1, r = n * Re + 1, n = o.d[n], n) {
    for (; n % 10 == 0; n /= 10) r--;
    for (n = o.d[0]; n >= 10; n /= 10) r++;
  }
  return e && t > r ? t : r;
};
oe.squareRoot = oe.sqrt = function() {
  var e, t, r, n, o, a, i, s = this, c = s.constructor;
  if (s.s < 1) {
    if (!s.s) return new c(0);
    throw Error(Et + "NaN");
  }
  for (e = Le(s), Me = !1, o = Math.sqrt(+s), o == 0 || o == 1 / 0 ? (t = Kt(s.d), (t.length + e) % 2 == 0 && (t += "0"), o = Math.sqrt(t), e = Ho((e + 1) / 2) - (e < 0 || e % 2), o == 1 / 0 ? t = "5e" + e : (t = o.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new c(t)) : n = new c(o.toString()), r = c.precision, o = i = r + 3; ; )
    if (a = n, n = a.plus(hr(s, a, i + 2)).times(0.5), Kt(a.d).slice(0, i) === (t = Kt(n.d)).slice(0, i)) {
      if (t = t.slice(i - 3, i + 1), o == i && t == "4999") {
        if (Oe(a, r + 1, 0), a.times(a).eq(s)) {
          n = a;
          break;
        }
      } else if (t != "9999")
        break;
      i += 4;
    }
  return Me = !0, Oe(n, r);
};
oe.times = oe.mul = function(e) {
  var t, r, n, o, a, i, s, c, l, f = this, u = f.constructor, d = f.d, h = (e = new u(e)).d;
  if (!f.s || !e.s) return new u(0);
  for (e.s *= f.s, r = f.e + e.e, c = d.length, l = h.length, c < l && (a = d, d = h, h = a, i = c, c = l, l = i), a = [], i = c + l, n = i; n--; ) a.push(0);
  for (n = l; --n >= 0; ) {
    for (t = 0, o = c + n; o > n; )
      s = a[o] + h[n] * d[o - n - 1] + t, a[o--] = s % Ve | 0, t = s / Ve | 0;
    a[o] = (a[o] + t) % Ve | 0;
  }
  for (; !a[--i]; ) a.pop();
  return t ? ++r : a.shift(), e.d = a, e.e = r, Me ? Oe(e, u.precision) : e;
};
oe.toDecimalPlaces = oe.todp = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (Qt(e, 0, Uo), t === void 0 ? t = n.rounding : Qt(t, 0, 8), Oe(r, e + Le(r) + 1, t));
};
oe.toExponential = function(e, t) {
  var r, n = this, o = n.constructor;
  return e === void 0 ? r = yn(n, !0) : (Qt(e, 0, Uo), t === void 0 ? t = o.rounding : Qt(t, 0, 8), n = Oe(new o(n), e + 1, t), r = yn(n, !0, e + 1)), r;
};
oe.toFixed = function(e, t) {
  var r, n, o = this, a = o.constructor;
  return e === void 0 ? yn(o) : (Qt(e, 0, Uo), t === void 0 ? t = a.rounding : Qt(t, 0, 8), n = Oe(new a(o), e + Le(o) + 1, t), r = yn(n.abs(), !1, e + Le(n) + 1), o.isneg() && !o.isZero() ? "-" + r : r);
};
oe.toInteger = oe.toint = function() {
  var e = this, t = e.constructor;
  return Oe(new t(e), Le(e) + 1, t.rounding);
};
oe.toNumber = function() {
  return +this;
};
oe.toPower = oe.pow = function(e) {
  var t, r, n, o, a, i, s = this, c = s.constructor, l = 12, f = +(e = new c(e));
  if (!e.s) return new c(vt);
  if (s = new c(s), !s.s) {
    if (e.s < 1) throw Error(Et + "Infinity");
    return s;
  }
  if (s.eq(vt)) return s;
  if (n = c.precision, e.eq(vt)) return Oe(s, n);
  if (t = e.e, r = e.d.length - 1, i = t >= r, a = s.s, i) {
    if ((r = f < 0 ? -f : f) <= HR) {
      for (o = new c(vt), t = Math.ceil(n / Re + 4), Me = !1; r % 2 && (o = o.times(s), hS(o.d, t)), r = Ho(r / 2), r !== 0; )
        s = s.times(s), hS(s.d, t);
      return Me = !0, e.s < 0 ? new c(vt).div(o) : Oe(o, n);
    }
  } else if (a < 0) throw Error(Et + "NaN");
  return a = a < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, s.s = 1, Me = !1, o = e.times($a(s, n + l)), Me = !0, o = KR(o), o.s = a, o;
};
oe.toPrecision = function(e, t) {
  var r, n, o = this, a = o.constructor;
  return e === void 0 ? (r = Le(o), n = yn(o, r <= a.toExpNeg || r >= a.toExpPos)) : (Qt(e, 1, Uo), t === void 0 ? t = a.rounding : Qt(t, 0, 8), o = Oe(new a(o), e, t), r = Le(o), n = yn(o, e <= r || r <= a.toExpNeg, e)), n;
};
oe.toSignificantDigits = oe.tosd = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (Qt(e, 1, Uo), t === void 0 ? t = n.rounding : Qt(t, 0, 8)), Oe(new n(r), e, t);
};
oe.toString = oe.valueOf = oe.val = oe.toJSON = oe[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = Le(e), r = e.constructor;
  return yn(e, t <= r.toExpNeg || t >= r.toExpPos);
};
function VR(e, t) {
  var r, n, o, a, i, s, c, l, f = e.constructor, u = f.precision;
  if (!e.s || !t.s)
    return t.s || (t = new f(e)), Me ? Oe(t, u) : t;
  if (c = e.d, l = t.d, i = e.e, o = t.e, c = c.slice(), a = i - o, a) {
    for (a < 0 ? (n = c, a = -a, s = l.length) : (n = l, o = i, s = c.length), i = Math.ceil(u / Re), s = i > s ? i + 1 : s + 1, a > s && (a = s, n.length = 1), n.reverse(); a--; ) n.push(0);
    n.reverse();
  }
  for (s = c.length, a = l.length, s - a < 0 && (a = s, n = l, l = c, c = n), r = 0; a; )
    r = (c[--a] = c[a] + l[a] + r) / Ve | 0, c[a] %= Ve;
  for (r && (c.unshift(r), ++o), s = c.length; c[--s] == 0; ) c.pop();
  return t.d = c, t.e = o, Me ? Oe(t, u) : t;
}
function Qt(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(sn + e);
}
function Kt(e) {
  var t, r, n, o = e.length - 1, a = "", i = e[0];
  if (o > 0) {
    for (a += i, t = 1; t < o; t++)
      n = e[t] + "", r = Re - n.length, r && (a += Cr(r)), a += n;
    i = e[t], n = i + "", r = Re - n.length, r && (a += Cr(r));
  } else if (i === 0)
    return "0";
  for (; i % 10 === 0; ) i /= 10;
  return a + i;
}
var hr = /* @__PURE__ */ (function() {
  function e(n, o) {
    var a, i = 0, s = n.length;
    for (n = n.slice(); s--; )
      a = n[s] * o + i, n[s] = a % Ve | 0, i = a / Ve | 0;
    return i && n.unshift(i), n;
  }
  function t(n, o, a, i) {
    var s, c;
    if (a != i)
      c = a > i ? 1 : -1;
    else
      for (s = c = 0; s < a; s++)
        if (n[s] != o[s]) {
          c = n[s] > o[s] ? 1 : -1;
          break;
        }
    return c;
  }
  function r(n, o, a) {
    for (var i = 0; a--; )
      n[a] -= i, i = n[a] < o[a] ? 1 : 0, n[a] = i * Ve + n[a] - o[a];
    for (; !n[0] && n.length > 1; ) n.shift();
  }
  return function(n, o, a, i) {
    var s, c, l, f, u, d, h, m, v, p, b, w, x, _, y, O, A, P, T = n.constructor, I = n.s == o.s ? 1 : -1, E = n.d, C = o.d;
    if (!n.s) return new T(n);
    if (!o.s) throw Error(Et + "Division by zero");
    for (c = n.e - o.e, A = C.length, y = E.length, h = new T(I), m = h.d = [], l = 0; C[l] == (E[l] || 0); ) ++l;
    if (C[l] > (E[l] || 0) && --c, a == null ? w = a = T.precision : i ? w = a + (Le(n) - Le(o)) + 1 : w = a, w < 0) return new T(0);
    if (w = w / Re + 2 | 0, l = 0, A == 1)
      for (f = 0, C = C[0], w++; (l < y || f) && w--; l++)
        x = f * Ve + (E[l] || 0), m[l] = x / C | 0, f = x % C | 0;
    else {
      for (f = Ve / (C[0] + 1) | 0, f > 1 && (C = e(C, f), E = e(E, f), A = C.length, y = E.length), _ = A, v = E.slice(0, A), p = v.length; p < A; ) v[p++] = 0;
      P = C.slice(), P.unshift(0), O = C[0], C[1] >= Ve / 2 && ++O;
      do
        f = 0, s = t(C, v, A, p), s < 0 ? (b = v[0], A != p && (b = b * Ve + (v[1] || 0)), f = b / O | 0, f > 1 ? (f >= Ve && (f = Ve - 1), u = e(C, f), d = u.length, p = v.length, s = t(u, v, d, p), s == 1 && (f--, r(u, A < d ? P : C, d))) : (f == 0 && (s = f = 1), u = C.slice()), d = u.length, d < p && u.unshift(0), r(v, u, p), s == -1 && (p = v.length, s = t(C, v, A, p), s < 1 && (f++, r(v, A < p ? P : C, p))), p = v.length) : s === 0 && (f++, v = [0]), m[l++] = f, s && v[0] ? v[p++] = E[_] || 0 : (v = [E[_]], p = 1);
      while ((_++ < y || v[0] !== void 0) && w--);
    }
    return m[0] || m.shift(), h.e = c, Oe(h, i ? a + Le(h) + 1 : a);
  };
})();
function KR(e, t) {
  var r, n, o, a, i, s, c = 0, l = 0, f = e.constructor, u = f.precision;
  if (Le(e) > 16) throw Error(Ng + Le(e));
  if (!e.s) return new f(vt);
  for (Me = !1, s = u, i = new f(0.03125); e.abs().gte(0.1); )
    e = e.times(i), l += 5;
  for (n = Math.log(Jr(2, l)) / Math.LN10 * 2 + 5 | 0, s += n, r = o = a = new f(vt), f.precision = s; ; ) {
    if (o = Oe(o.times(e), s), r = r.times(++c), i = a.plus(hr(o, r, s)), Kt(i.d).slice(0, s) === Kt(a.d).slice(0, s)) {
      for (; l--; ) a = Oe(a.times(a), s);
      return f.precision = u, t == null ? (Me = !0, Oe(a, u)) : a;
    }
    a = i;
  }
}
function Le(e) {
  for (var t = e.e * Re, r = e.d[0]; r >= 10; r /= 10) t++;
  return t;
}
function xp(e, t, r) {
  if (t > e.LN10.sd())
    throw Me = !0, r && (e.precision = r), Error(Et + "LN10 precision limit exceeded");
  return Oe(new e(e.LN10), t);
}
function Cr(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function $a(e, t) {
  var r, n, o, a, i, s, c, l, f, u = 1, d = 10, h = e, m = h.d, v = h.constructor, p = v.precision;
  if (h.s < 1) throw Error(Et + (h.s ? "NaN" : "-Infinity"));
  if (h.eq(vt)) return new v(0);
  if (t == null ? (Me = !1, l = p) : l = t, h.eq(10))
    return t == null && (Me = !0), xp(v, l);
  if (l += d, v.precision = l, r = Kt(m), n = r.charAt(0), a = Le(h), Math.abs(a) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      h = h.times(e), r = Kt(h.d), n = r.charAt(0), u++;
    a = Le(h), n > 1 ? (h = new v("0." + r), a++) : h = new v(n + "." + r.slice(1));
  } else
    return c = xp(v, l + 2, p).times(a + ""), h = $a(new v(n + "." + r.slice(1)), l - d).plus(c), v.precision = p, t == null ? (Me = !0, Oe(h, p)) : h;
  for (s = i = h = hr(h.minus(vt), h.plus(vt), l), f = Oe(h.times(h), l), o = 3; ; ) {
    if (i = Oe(i.times(f), l), c = s.plus(hr(i, new v(o), l)), Kt(c.d).slice(0, l) === Kt(s.d).slice(0, l))
      return s = s.times(2), a !== 0 && (s = s.plus(xp(v, l + 2, p).times(a + ""))), s = hr(s, new v(u), l), v.precision = p, t == null ? (Me = !0, Oe(s, p)) : s;
    s = c, o += 2;
  }
}
function pS(e, t) {
  var r, n, o;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; ) ++n;
  for (o = t.length; t.charCodeAt(o - 1) === 48; ) --o;
  if (t = t.slice(n, o), t) {
    if (o -= n, r = r - n - 1, e.e = Ho(r / Re), e.d = [], n = (r + 1) % Re, r < 0 && (n += Re), n < o) {
      for (n && e.d.push(+t.slice(0, n)), o -= Re; n < o; ) e.d.push(+t.slice(n, n += Re));
      t = t.slice(n), n = Re - t.length;
    } else
      n -= o;
    for (; n--; ) t += "0";
    if (e.d.push(+t), Me && (e.e > Ls || e.e < -Ls)) throw Error(Ng + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function Oe(e, t, r) {
  var n, o, a, i, s, c, l, f, u = e.d;
  for (i = 1, a = u[0]; a >= 10; a /= 10) i++;
  if (n = t - i, n < 0)
    n += Re, o = t, l = u[f = 0];
  else {
    if (f = Math.ceil((n + 1) / Re), a = u.length, f >= a) return e;
    for (l = a = u[f], i = 1; a >= 10; a /= 10) i++;
    n %= Re, o = n - Re + i;
  }
  if (r !== void 0 && (a = Jr(10, i - o - 1), s = l / a % 10 | 0, c = t < 0 || u[f + 1] !== void 0 || l % a, c = r < 4 ? (s || c) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (r == 4 || c || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? o > 0 ? l / Jr(10, i - o) : 0 : u[f - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !u[0])
    return c ? (a = Le(e), u.length = 1, t = t - a - 1, u[0] = Jr(10, (Re - t % Re) % Re), e.e = Ho(-t / Re) || 0) : (u.length = 1, u[0] = e.e = e.s = 0), e;
  if (n == 0 ? (u.length = f, a = 1, f--) : (u.length = f + 1, a = Jr(10, Re - n), u[f] = o > 0 ? (l / Jr(10, i - o) % Jr(10, o) | 0) * a : 0), c)
    for (; ; )
      if (f == 0) {
        (u[0] += a) == Ve && (u[0] = 1, ++e.e);
        break;
      } else {
        if (u[f] += a, u[f] != Ve) break;
        u[f--] = 0, a = 1;
      }
  for (n = u.length; u[--n] === 0; ) u.pop();
  if (Me && (e.e > Ls || e.e < -Ls))
    throw Error(Ng + Le(e));
  return e;
}
function GR(e, t) {
  var r, n, o, a, i, s, c, l, f, u, d = e.constructor, h = d.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new d(e), Me ? Oe(t, h) : t;
  if (c = e.d, u = t.d, n = t.e, l = e.e, c = c.slice(), i = l - n, i) {
    for (f = i < 0, f ? (r = c, i = -i, s = u.length) : (r = u, n = l, s = c.length), o = Math.max(Math.ceil(h / Re), s) + 2, i > o && (i = o, r.length = 1), r.reverse(), o = i; o--; ) r.push(0);
    r.reverse();
  } else {
    for (o = c.length, s = u.length, f = o < s, f && (s = o), o = 0; o < s; o++)
      if (c[o] != u[o]) {
        f = c[o] < u[o];
        break;
      }
    i = 0;
  }
  for (f && (r = c, c = u, u = r, t.s = -t.s), s = c.length, o = u.length - s; o > 0; --o) c[s++] = 0;
  for (o = u.length; o > i; ) {
    if (c[--o] < u[o]) {
      for (a = o; a && c[--a] === 0; ) c[a] = Ve - 1;
      --c[a], c[o] += Ve;
    }
    c[o] -= u[o];
  }
  for (; c[--s] === 0; ) c.pop();
  for (; c[0] === 0; c.shift()) --n;
  return c[0] ? (t.d = c, t.e = n, Me ? Oe(t, h) : t) : new d(0);
}
function yn(e, t, r) {
  var n, o = Le(e), a = Kt(e.d), i = a.length;
  return t ? (r && (n = r - i) > 0 ? a = a.charAt(0) + "." + a.slice(1) + Cr(n) : i > 1 && (a = a.charAt(0) + "." + a.slice(1)), a = a + (o < 0 ? "e" : "e+") + o) : o < 0 ? (a = "0." + Cr(-o - 1) + a, r && (n = r - i) > 0 && (a += Cr(n))) : o >= i ? (a += Cr(o + 1 - i), r && (n = r - o - 1) > 0 && (a = a + "." + Cr(n))) : ((n = o + 1) < i && (a = a.slice(0, n) + "." + a.slice(n)), r && (n = r - i) > 0 && (o + 1 === i && (a += "."), a += Cr(n))), e.s < 0 ? "-" + a : a;
}
function hS(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function YR(e) {
  var t, r, n;
  function o(a) {
    var i = this;
    if (!(i instanceof o)) return new o(a);
    if (i.constructor = o, a instanceof o) {
      i.s = a.s, i.e = a.e, i.d = (a = a.d) ? a.slice() : a;
      return;
    }
    if (typeof a == "number") {
      if (a * 0 !== 0)
        throw Error(sn + a);
      if (a > 0)
        i.s = 1;
      else if (a < 0)
        a = -a, i.s = -1;
      else {
        i.s = 0, i.e = 0, i.d = [0];
        return;
      }
      if (a === ~~a && a < 1e7) {
        i.e = 0, i.d = [a];
        return;
      }
      return pS(i, a.toString());
    } else if (typeof a != "string")
      throw Error(sn + a);
    if (a.charCodeAt(0) === 45 ? (a = a.slice(1), i.s = -1) : i.s = 1, rH.test(a)) pS(i, a);
    else throw Error(sn + a);
  }
  if (o.prototype = oe, o.ROUND_UP = 0, o.ROUND_DOWN = 1, o.ROUND_CEIL = 2, o.ROUND_FLOOR = 3, o.ROUND_HALF_UP = 4, o.ROUND_HALF_DOWN = 5, o.ROUND_HALF_EVEN = 6, o.ROUND_HALF_CEIL = 7, o.ROUND_HALF_FLOOR = 8, o.clone = YR, o.config = o.set = nH, e === void 0 && (e = {}), e)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; ) e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return o.config(e), o;
}
function nH(e) {
  if (!e || typeof e != "object")
    throw Error(Et + "Object expected");
  var t, r, n, o = [
    "precision",
    1,
    Uo,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < o.length; t += 3)
    if ((n = e[r = o[t]]) !== void 0)
      if (Ho(n) === n && n >= o[t + 1] && n <= o[t + 2]) this[r] = n;
      else throw Error(sn + r + ": " + n);
  if ((n = e[r = "LN10"]) !== void 0)
    if (n == Math.LN10) this[r] = new this(n);
    else throw Error(sn + r + ": " + n);
  return this;
}
var kg = YR(tH);
vt = new kg(1);
const _e = kg;
function oH(e) {
  return cH(e) || sH(e) || iH(e) || aH();
}
function aH() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iH(e, t) {
  if (e) {
    if (typeof e == "string") return ov(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ov(e, t);
  }
}
function sH(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function cH(e) {
  if (Array.isArray(e)) return ov(e);
}
function ov(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var lH = function(t) {
  return t;
}, XR = {}, ZR = function(t) {
  return t === XR;
}, vS = function(t) {
  return function r() {
    return arguments.length === 0 || arguments.length === 1 && ZR(arguments.length <= 0 ? void 0 : arguments[0]) ? r : t.apply(void 0, arguments);
  };
}, uH = function e(t, r) {
  return t === 1 ? r : vS(function() {
    for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++)
      o[a] = arguments[a];
    var i = o.filter(function(s) {
      return s !== XR;
    }).length;
    return i >= t ? r.apply(void 0, o) : e(t - i, vS(function() {
      for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
        c[l] = arguments[l];
      var f = o.map(function(u) {
        return ZR(u) ? c.shift() : u;
      });
      return r.apply(void 0, oH(f).concat(c));
    }));
  });
}, vl = function(t) {
  return uH(t.length, t);
}, av = function(t, r) {
  for (var n = [], o = t; o < r; ++o)
    n[o - t] = o;
  return n;
}, fH = vl(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(r) {
    return t[r];
  }).map(e);
}), dH = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  if (!r.length)
    return lH;
  var o = r.reverse(), a = o[0], i = o.slice(1);
  return function() {
    return i.reduce(function(s, c) {
      return c(s);
    }, a.apply(void 0, arguments));
  };
}, iv = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, JR = function(t) {
  var r = null, n = null;
  return function() {
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r && a.every(function(s, c) {
      return s === r[c];
    }) || (r = a, n = t.apply(void 0, a)), n;
  };
};
function pH(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new _e(e).abs().log(10).toNumber()) + 1, t;
}
function hH(e, t, r) {
  for (var n = new _e(e), o = 0, a = []; n.lt(t) && o < 1e5; )
    a.push(n.toNumber()), n = n.add(r), o++;
  return a;
}
var vH = vl(function(e, t, r) {
  var n = +e, o = +t;
  return n + r * (o - n);
}), mH = vl(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, (r - e) / n;
}), gH = vl(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, Math.max(0, Math.min(1, (r - e) / n));
});
const ml = {
  rangeStep: hH,
  getDigitCount: pH,
  interpolateNumber: vH,
  uninterpolateNumber: mH,
  uninterpolateTruncation: gH
};
function sv(e) {
  return wH(e) || bH(e) || QR(e) || yH();
}
function yH() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bH(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function wH(e) {
  if (Array.isArray(e)) return cv(e);
}
function Da(e, t) {
  return _H(e) || SH(e, t) || QR(e, t) || xH();
}
function xH() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function QR(e, t) {
  if (e) {
    if (typeof e == "string") return cv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return cv(e, t);
  }
}
function cv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function SH(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], n = !0, o = !1, a = void 0;
    try {
      for (var i = e[Symbol.iterator](), s; !(n = (s = i.next()).done) && (r.push(s.value), !(t && r.length === t)); n = !0)
        ;
    } catch (c) {
      o = !0, a = c;
    } finally {
      try {
        !n && i.return != null && i.return();
      } finally {
        if (o) throw a;
      }
    }
    return r;
  }
}
function _H(e) {
  if (Array.isArray(e)) return e;
}
function eM(e) {
  var t = Da(e, 2), r = t[0], n = t[1], o = r, a = n;
  return r > n && (o = n, a = r), [o, a];
}
function tM(e, t, r) {
  if (e.lte(0))
    return new _e(0);
  var n = ml.getDigitCount(e.toNumber()), o = new _e(10).pow(n), a = e.div(o), i = n !== 1 ? 0.05 : 0.1, s = new _e(Math.ceil(a.div(i).toNumber())).add(r).mul(i), c = s.mul(o);
  return t ? c : new _e(Math.ceil(c));
}
function OH(e, t, r) {
  var n = 1, o = new _e(e);
  if (!o.isint() && r) {
    var a = Math.abs(e);
    a < 1 ? (n = new _e(10).pow(ml.getDigitCount(e) - 1), o = new _e(Math.floor(o.div(n).toNumber())).mul(n)) : a > 1 && (o = new _e(Math.floor(e)));
  } else e === 0 ? o = new _e(Math.floor((t - 1) / 2)) : r || (o = new _e(Math.floor(e)));
  var i = Math.floor((t - 1) / 2), s = dH(fH(function(c) {
    return o.add(new _e(c - i).mul(n)).toNumber();
  }), av);
  return s(0, t);
}
function rM(e, t, r, n) {
  var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (r - 1)))
    return {
      step: new _e(0),
      tickMin: new _e(0),
      tickMax: new _e(0)
    };
  var a = tM(new _e(t).sub(e).div(r - 1), n, o), i;
  e <= 0 && t >= 0 ? i = new _e(0) : (i = new _e(e).add(t).div(2), i = i.sub(new _e(i).mod(a)));
  var s = Math.ceil(i.sub(e).div(a).toNumber()), c = Math.ceil(new _e(t).sub(i).div(a).toNumber()), l = s + c + 1;
  return l > r ? rM(e, t, r, n, o + 1) : (l < r && (c = t > 0 ? c + (r - l) : c, s = t > 0 ? s : s + (r - l)), {
    step: a,
    tickMin: i.sub(new _e(s).mul(a)),
    tickMax: i.add(new _e(c).mul(a))
  });
}
function AH(e) {
  var t = Da(e, 2), r = t[0], n = t[1], o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, i = Math.max(o, 2), s = eM([r, n]), c = Da(s, 2), l = c[0], f = c[1];
  if (l === -1 / 0 || f === 1 / 0) {
    var u = f === 1 / 0 ? [l].concat(sv(av(0, o - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(sv(av(0, o - 1).map(function() {
      return -1 / 0;
    })), [f]);
    return r > n ? iv(u) : u;
  }
  if (l === f)
    return OH(l, o, a);
  var d = rM(l, f, i, a), h = d.step, m = d.tickMin, v = d.tickMax, p = ml.rangeStep(m, v.add(new _e(0.1).mul(h)), h);
  return r > n ? iv(p) : p;
}
function PH(e, t) {
  var r = Da(e, 2), n = r[0], o = r[1], a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, i = eM([n, o]), s = Da(i, 2), c = s[0], l = s[1];
  if (c === -1 / 0 || l === 1 / 0)
    return [n, o];
  if (c === l)
    return [c];
  var f = Math.max(t, 2), u = tM(new _e(l).sub(c).div(f - 1), a, 0), d = [].concat(sv(ml.rangeStep(new _e(c), new _e(l).sub(new _e(0.99).mul(u)), u)), [l]);
  return n > o ? iv(d) : d;
}
var EH = JR(AH), TH = JR(PH), CH = process.env.NODE_ENV === "production", Sp = "Invariant failed";
function st(e, t) {
  if (CH)
    throw new Error(Sp);
  var r = typeof t == "function" ? t() : t, n = r ? "".concat(Sp, ": ").concat(r) : Sp;
  throw new Error(n);
}
var RH = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function lo(e) {
  "@babel/helpers - typeof";
  return lo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lo(e);
}
function Bs() {
  return Bs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bs.apply(this, arguments);
}
function MH(e, t) {
  return $H(e) || kH(e, t) || NH(e, t) || IH();
}
function IH() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function NH(e, t) {
  if (e) {
    if (typeof e == "string") return mS(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return mS(e, t);
  }
}
function mS(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function kH(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, o, a, i, s = [], c = !0, l = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, o = f;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw o;
      }
    }
    return s;
  }
}
function $H(e) {
  if (Array.isArray(e)) return e;
}
function DH(e, t) {
  if (e == null) return {};
  var r = jH(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function jH(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function LH(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function BH(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, aM(n.key), n);
  }
}
function FH(e, t, r) {
  return t && BH(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function qH(e, t, r) {
  return t = Fs(t), zH(e, nM() ? Reflect.construct(t, r || [], Fs(e).constructor) : t.apply(e, r));
}
function zH(e, t) {
  if (t && (lo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return WH(e);
}
function WH(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function nM() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (nM = function() {
    return !!e;
  })();
}
function Fs(e) {
  return Fs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Fs(e);
}
function UH(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && lv(e, t);
}
function lv(e, t) {
  return lv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, lv(e, t);
}
function oM(e, t, r) {
  return t = aM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function aM(e) {
  var t = HH(e, "string");
  return lo(t) == "symbol" ? t : t + "";
}
function HH(e, t) {
  if (lo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (lo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Ci = /* @__PURE__ */ (function(e) {
  function t() {
    return LH(this, t), qH(this, t, arguments);
  }
  return UH(t, e), FH(t, [{
    key: "render",
    value: function() {
      var n = this.props, o = n.offset, a = n.layout, i = n.width, s = n.dataKey, c = n.data, l = n.dataPointFormatter, f = n.xAxis, u = n.yAxis, d = DH(n, RH), h = ie(d, !1);
      this.props.direction === "x" && f.type !== "number" && (process.env.NODE_ENV !== "production" ? st(!1, 'ErrorBar requires Axis type property to be "number".') : st());
      var m = c.map(function(v) {
        var p = l(v, s), b = p.x, w = p.y, x = p.value, _ = p.errorVal;
        if (!_)
          return null;
        var y = [], O, A;
        if (Array.isArray(_)) {
          var P = MH(_, 2);
          O = P[0], A = P[1];
        } else
          O = A = _;
        if (a === "vertical") {
          var T = f.scale, I = w + o, E = I + i, C = I - i, R = T(x - O), M = T(x + A);
          y.push({
            x1: M,
            y1: E,
            x2: M,
            y2: C
          }), y.push({
            x1: R,
            y1: I,
            x2: M,
            y2: I
          }), y.push({
            x1: R,
            y1: E,
            x2: R,
            y2: C
          });
        } else if (a === "horizontal") {
          var D = u.scale, $ = b + o, q = $ - i, F = $ + i, B = D(x - O), L = D(x + A);
          y.push({
            x1: q,
            y1: L,
            x2: F,
            y2: L
          }), y.push({
            x1: $,
            y1: B,
            x2: $,
            y2: L
          }), y.push({
            x1: q,
            y1: B,
            x2: F,
            y2: B
          });
        }
        return /* @__PURE__ */ k.createElement(ve, Bs({
          className: "recharts-errorBar",
          key: "bar-".concat(y.map(function(z) {
            return "".concat(z.x1, "-").concat(z.x2, "-").concat(z.y1, "-").concat(z.y2);
          }))
        }, h), y.map(function(z) {
          return /* @__PURE__ */ k.createElement("line", Bs({}, z, {
            key: "line-".concat(z.x1, "-").concat(z.x2, "-").concat(z.y1, "-").concat(z.y2)
          }));
        }));
      });
      return /* @__PURE__ */ k.createElement(ve, {
        className: "recharts-errorBars"
      }, m);
    }
  }]);
})(k.Component);
oM(Ci, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
oM(Ci, "displayName", "ErrorBar");
function ja(e) {
  "@babel/helpers - typeof";
  return ja = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ja(e);
}
function gS(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gS(Object(r), !0).forEach(function(n) {
      VH(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gS(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function VH(e, t, r) {
  return t = KH(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function KH(e) {
  var t = GH(e, "string");
  return ja(t) == "symbol" ? t : t + "";
}
function GH(e, t) {
  if (ja(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ja(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var iM = function(t) {
  var r = t.children, n = t.formattedGraphicalItems, o = t.legendWidth, a = t.legendContent, i = dt(r, Kn);
  if (!i)
    return null;
  var s = Kn.defaultProps, c = s !== void 0 ? Gr(Gr({}, s), i.props) : {}, l;
  return i.props && i.props.payload ? l = i.props && i.props.payload : a === "children" ? l = (n || []).reduce(function(f, u) {
    var d = u.item, h = u.props, m = h.sectors || h.data || [];
    return f.concat(m.map(function(v) {
      return {
        type: i.props.iconType || d.props.legendType,
        value: v.name,
        color: v.fill,
        payload: v
      };
    }));
  }, []) : l = (n || []).map(function(f) {
    var u = f.item, d = u.type.defaultProps, h = d !== void 0 ? Gr(Gr({}, d), u.props) : {}, m = h.dataKey, v = h.name, p = h.legendType, b = h.hide;
    return {
      inactive: b,
      dataKey: m,
      type: c.iconType || p || "square",
      color: $g(u),
      value: v || m,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: h
    };
  }), Gr(Gr(Gr({}, c), Kn.getWithHeight(i, o)), {}, {
    payload: l,
    item: i
  });
};
function La(e) {
  "@babel/helpers - typeof";
  return La = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, La(e);
}
function yS(e) {
  return JH(e) || ZH(e) || XH(e) || YH();
}
function YH() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function XH(e, t) {
  if (e) {
    if (typeof e == "string") return uv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return uv(e, t);
  }
}
function ZH(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function JH(e) {
  if (Array.isArray(e)) return uv(e);
}
function uv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function bS(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ne(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bS(Object(r), !0).forEach(function(n) {
      Yn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bS(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Yn(e, t, r) {
  return t = QH(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function QH(e) {
  var t = e4(e, "string");
  return La(t) == "symbol" ? t : t + "";
}
function e4(e, t) {
  if (La(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (La(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ze(e, t, r) {
  return fe(e) || fe(t) ? r : We(t) ? yt(e, t, r) : ue(t) ? t(e) : r;
}
function da(e, t, r, n) {
  var o = J6(e, function(s) {
    return ze(s, t);
  });
  if (r === "number") {
    var a = o.filter(function(s) {
      return ne(s) || parseFloat(s);
    });
    return a.length ? [hl(a), pl(a)] : [1 / 0, -1 / 0];
  }
  var i = n ? o.filter(function(s) {
    return !fe(s);
  }) : o;
  return i.map(function(s) {
    return We(s) || s instanceof Date ? s : "";
  });
}
var t4 = function(t) {
  var r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], o = arguments.length > 2 ? arguments[2] : void 0, a = arguments.length > 3 ? arguments[3] : void 0, i = -1, s = (r = n == null ? void 0 : n.length) !== null && r !== void 0 ? r : 0;
  if (s <= 1)
    return 0;
  if (a && a.axisType === "angleAxis" && Math.abs(Math.abs(a.range[1] - a.range[0]) - 360) <= 1e-6)
    for (var c = a.range, l = 0; l < s; l++) {
      var f = l > 0 ? o[l - 1].coordinate : o[s - 1].coordinate, u = o[l].coordinate, d = l >= s - 1 ? o[0].coordinate : o[l + 1].coordinate, h = void 0;
      if (rt(u - f) !== rt(d - u)) {
        var m = [];
        if (rt(d - u) === rt(c[1] - c[0])) {
          h = d;
          var v = u + c[1] - c[0];
          m[0] = Math.min(v, (v + f) / 2), m[1] = Math.max(v, (v + f) / 2);
        } else {
          h = f;
          var p = d + c[1] - c[0];
          m[0] = Math.min(u, (p + u) / 2), m[1] = Math.max(u, (p + u) / 2);
        }
        var b = [Math.min(u, (h + u) / 2), Math.max(u, (h + u) / 2)];
        if (t > b[0] && t <= b[1] || t >= m[0] && t <= m[1]) {
          i = o[l].index;
          break;
        }
      } else {
        var w = Math.min(f, d), x = Math.max(f, d);
        if (t > (w + u) / 2 && t <= (x + u) / 2) {
          i = o[l].index;
          break;
        }
      }
    }
  else
    for (var _ = 0; _ < s; _++)
      if (_ === 0 && t <= (n[_].coordinate + n[_ + 1].coordinate) / 2 || _ > 0 && _ < s - 1 && t > (n[_].coordinate + n[_ - 1].coordinate) / 2 && t <= (n[_].coordinate + n[_ + 1].coordinate) / 2 || _ === s - 1 && t > (n[_].coordinate + n[_ - 1].coordinate) / 2) {
        i = n[_].index;
        break;
      }
  return i;
}, $g = function(t) {
  var r, n = t, o = n.type.displayName, a = (r = t.type) !== null && r !== void 0 && r.defaultProps ? Ne(Ne({}, t.type.defaultProps), t.props) : t.props, i = a.stroke, s = a.fill, c;
  switch (o) {
    case "Line":
      c = i;
      break;
    case "Area":
    case "Radar":
      c = i && i !== "none" ? i : s;
      break;
    default:
      c = s;
      break;
  }
  return c;
}, r4 = function(t) {
  var r = t.barSize, n = t.totalSize, o = t.stackGroups, a = o === void 0 ? {} : o;
  if (!a)
    return {};
  for (var i = {}, s = Object.keys(a), c = 0, l = s.length; c < l; c++)
    for (var f = a[s[c]].stackGroups, u = Object.keys(f), d = 0, h = u.length; d < h; d++) {
      var m = f[u[d]], v = m.items, p = m.cateAxisId, b = v.filter(function(A) {
        return dr(A.type).indexOf("Bar") >= 0;
      });
      if (b && b.length) {
        var w = b[0].type.defaultProps, x = w !== void 0 ? Ne(Ne({}, w), b[0].props) : b[0].props, _ = x.barSize, y = x[p];
        i[y] || (i[y] = []);
        var O = fe(_) ? r : _;
        i[y].push({
          item: b[0],
          stackList: b.slice(1),
          barSize: fe(O) ? void 0 : nt(O, n, 0)
        });
      }
    }
  return i;
}, n4 = function(t) {
  var r = t.barGap, n = t.barCategoryGap, o = t.bandSize, a = t.sizeList, i = a === void 0 ? [] : a, s = t.maxBarSize, c = i.length;
  if (c < 1) return null;
  var l = nt(r, o, 0, !0), f, u = [];
  if (i[0].barSize === +i[0].barSize) {
    var d = !1, h = o / c, m = i.reduce(function(_, y) {
      return _ + y.barSize || 0;
    }, 0);
    m += (c - 1) * l, m >= o && (m -= (c - 1) * l, l = 0), m >= o && h > 0 && (d = !0, h *= 0.9, m = c * h);
    var v = (o - m) / 2 >> 0, p = {
      offset: v - l,
      size: 0
    };
    f = i.reduce(function(_, y) {
      var O = {
        item: y.item,
        position: {
          offset: p.offset + p.size + l,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: d ? h : y.barSize
        }
      }, A = [].concat(yS(_), [O]);
      return p = A[A.length - 1].position, y.stackList && y.stackList.length && y.stackList.forEach(function(P) {
        A.push({
          item: P,
          position: p
        });
      }), A;
    }, u);
  } else {
    var b = nt(n, o, 0, !0);
    o - 2 * b - (c - 1) * l <= 0 && (l = 0);
    var w = (o - 2 * b - (c - 1) * l) / c;
    w > 1 && (w >>= 0);
    var x = s === +s ? Math.min(w, s) : w;
    f = i.reduce(function(_, y, O) {
      var A = [].concat(yS(_), [{
        item: y.item,
        position: {
          offset: b + (w + l) * O + (w - x) / 2,
          size: x
        }
      }]);
      return y.stackList && y.stackList.length && y.stackList.forEach(function(P) {
        A.push({
          item: P,
          position: A[A.length - 1].position
        });
      }), A;
    }, u);
  }
  return f;
}, o4 = function(t, r, n, o) {
  var a = n.children, i = n.width, s = n.margin, c = i - (s.left || 0) - (s.right || 0), l = iM({
    children: a,
    legendWidth: c
  });
  if (l) {
    var f = o || {}, u = f.width, d = f.height, h = l.align, m = l.verticalAlign, v = l.layout;
    if ((v === "vertical" || v === "horizontal" && m === "middle") && h !== "center" && ne(t[h]))
      return Ne(Ne({}, t), {}, Yn({}, h, t[h] + (u || 0)));
    if ((v === "horizontal" || v === "vertical" && h === "center") && m !== "middle" && ne(t[m]))
      return Ne(Ne({}, t), {}, Yn({}, m, t[m] + (d || 0)));
  }
  return t;
}, a4 = function(t, r, n) {
  return fe(r) ? !0 : t === "horizontal" ? r === "yAxis" : t === "vertical" || n === "x" ? r === "xAxis" : n === "y" ? r === "yAxis" : !0;
}, sM = function(t, r, n, o, a) {
  var i = r.props.children, s = bt(i, Ci).filter(function(l) {
    return a4(o, a, l.props.direction);
  });
  if (s && s.length) {
    var c = s.map(function(l) {
      return l.props.dataKey;
    });
    return t.reduce(function(l, f) {
      var u = ze(f, n);
      if (fe(u)) return l;
      var d = Array.isArray(u) ? [hl(u), pl(u)] : [u, u], h = c.reduce(function(m, v) {
        var p = ze(f, v, 0), b = d[0] - Math.abs(Array.isArray(p) ? p[0] : p), w = d[1] + Math.abs(Array.isArray(p) ? p[1] : p);
        return [Math.min(b, m[0]), Math.max(w, m[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(h[0], l[0]), Math.max(h[1], l[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, i4 = function(t, r, n, o, a) {
  var i = r.map(function(s) {
    return sM(t, s, n, a, o);
  }).filter(function(s) {
    return !fe(s);
  });
  return i && i.length ? i.reduce(function(s, c) {
    return [Math.min(s[0], c[0]), Math.max(s[1], c[1])];
  }, [1 / 0, -1 / 0]) : null;
}, cM = function(t, r, n, o, a) {
  var i = r.map(function(c) {
    var l = c.props.dataKey;
    return n === "number" && l && sM(t, c, l, o) || da(t, l, n, a);
  });
  if (n === "number")
    return i.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(c, l) {
        return [Math.min(c[0], l[0]), Math.max(c[1], l[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return i.reduce(function(c, l) {
    for (var f = 0, u = l.length; f < u; f++)
      s[l[f]] || (s[l[f]] = !0, c.push(l[f]));
    return c;
  }, []);
}, lM = function(t, r) {
  return t === "horizontal" && r === "xAxis" || t === "vertical" && r === "yAxis" || t === "centric" && r === "angleAxis" || t === "radial" && r === "radiusAxis";
}, nn = function(t, r, n) {
  if (!t) return null;
  var o = t.scale, a = t.duplicateDomain, i = t.type, s = t.range, c = t.realScaleType === "scaleBand" ? o.bandwidth() / 2 : 2, l = (r || n) && i === "category" && o.bandwidth ? o.bandwidth() / c : 0;
  if (l = t.axisType === "angleAxis" && (s == null ? void 0 : s.length) >= 2 ? rt(s[0] - s[1]) * 2 * l : l, r && (t.ticks || t.niceTicks)) {
    var f = (t.ticks || t.niceTicks).map(function(u) {
      var d = a ? a.indexOf(u) : u;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: o(d) + l,
        value: u,
        offset: l
      };
    });
    return f.filter(function(u) {
      return !Si(u.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(u, d) {
    return {
      coordinate: o(u) + l,
      value: u,
      index: d,
      offset: l
    };
  }) : o.ticks && !n ? o.ticks(t.tickCount).map(function(u) {
    return {
      coordinate: o(u) + l,
      value: u,
      offset: l
    };
  }) : o.domain().map(function(u, d) {
    return {
      coordinate: o(u) + l,
      value: a ? a[u] : u,
      index: d,
      offset: l
    };
  });
}, _p = /* @__PURE__ */ new WeakMap(), Ki = function(t, r) {
  if (typeof r != "function")
    return t;
  _p.has(t) || _p.set(t, /* @__PURE__ */ new WeakMap());
  var n = _p.get(t);
  if (n.has(r))
    return n.get(r);
  var o = function() {
    t.apply(void 0, arguments), r.apply(void 0, arguments);
  };
  return n.set(r, o), o;
}, uM = function(t, r, n) {
  var o = t.scale, a = t.type, i = t.layout, s = t.axisType;
  if (o === "auto")
    return i === "radial" && s === "radiusAxis" ? {
      scale: Ra(),
      realScaleType: "band"
    } : i === "radial" && s === "angleAxis" ? {
      scale: ks(),
      realScaleType: "linear"
    } : a === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !n) ? {
      scale: fa(),
      realScaleType: "point"
    } : a === "category" ? {
      scale: Ra(),
      realScaleType: "band"
    } : {
      scale: ks(),
      realScaleType: "linear"
    };
  if (vn(o)) {
    var c = "scale".concat(Qc(o));
    return {
      scale: (oS[c] || fa)(),
      realScaleType: oS[c] ? c : "point"
    };
  }
  return ue(o) ? {
    scale: o
  } : {
    scale: fa(),
    realScaleType: "point"
  };
}, wS = 1e-4, fM = function(t) {
  var r = t.domain();
  if (!(!r || r.length <= 2)) {
    var n = r.length, o = t.range(), a = Math.min(o[0], o[1]) - wS, i = Math.max(o[0], o[1]) + wS, s = t(r[0]), c = t(r[n - 1]);
    (s < a || s > i || c < a || c > i) && t.domain([r[0], r[n - 1]]);
  }
}, s4 = function(t, r) {
  if (!t)
    return null;
  for (var n = 0, o = t.length; n < o; n++)
    if (t[n].item === r)
      return t[n].position;
  return null;
}, c4 = function(t, r) {
  if (!r || r.length !== 2 || !ne(r[0]) || !ne(r[1]))
    return t;
  var n = Math.min(r[0], r[1]), o = Math.max(r[0], r[1]), a = [t[0], t[1]];
  return (!ne(t[0]) || t[0] < n) && (a[0] = n), (!ne(t[1]) || t[1] > o) && (a[1] = o), a[0] > o && (a[0] = o), a[1] < n && (a[1] = n), a;
}, l4 = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, o = t[0].length; n < o; ++n)
      for (var a = 0, i = 0, s = 0; s < r; ++s) {
        var c = Si(t[s][n][1]) ? t[s][n][0] : t[s][n][1];
        c >= 0 ? (t[s][n][0] = a, t[s][n][1] = a + c, a = t[s][n][1]) : (t[s][n][0] = i, t[s][n][1] = i + c, i = t[s][n][1]);
      }
}, u4 = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, o = t[0].length; n < o; ++n)
      for (var a = 0, i = 0; i < r; ++i) {
        var s = Si(t[i][n][1]) ? t[i][n][0] : t[i][n][1];
        s >= 0 ? (t[i][n][0] = a, t[i][n][1] = a + s, a = t[i][n][1]) : (t[i][n][0] = 0, t[i][n][1] = 0);
      }
}, f4 = {
  sign: l4,
  // @ts-expect-error definitelytyped types are incorrect
  expand: Jq,
  // @ts-expect-error definitelytyped types are incorrect
  none: to,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: Qq,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: e3,
  positive: u4
}, d4 = function(t, r, n) {
  var o = r.map(function(s) {
    return s.props.dataKey;
  }), a = f4[n], i = Zq().keys(o).value(function(s, c) {
    return +ze(s, c, 0);
  }).order(Fh).offset(a);
  return i(t);
}, p4 = function(t, r, n, o, a, i) {
  if (!t)
    return null;
  var s = i ? r.reverse() : r, c = {}, l = s.reduce(function(u, d) {
    var h, m = (h = d.type) !== null && h !== void 0 && h.defaultProps ? Ne(Ne({}, d.type.defaultProps), d.props) : d.props, v = m.stackId, p = m.hide;
    if (p)
      return u;
    var b = m[n], w = u[b] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (We(v)) {
      var x = w.stackGroups[v] || {
        numericAxisId: n,
        cateAxisId: o,
        items: []
      };
      x.items.push(d), w.hasStack = !0, w.stackGroups[v] = x;
    } else
      w.stackGroups[qo("_stackId_")] = {
        numericAxisId: n,
        cateAxisId: o,
        items: [d]
      };
    return Ne(Ne({}, u), {}, Yn({}, b, w));
  }, c), f = {};
  return Object.keys(l).reduce(function(u, d) {
    var h = l[d];
    if (h.hasStack) {
      var m = {};
      h.stackGroups = Object.keys(h.stackGroups).reduce(function(v, p) {
        var b = h.stackGroups[p];
        return Ne(Ne({}, v), {}, Yn({}, p, {
          numericAxisId: n,
          cateAxisId: o,
          items: b.items,
          stackedData: d4(t, b.items, a)
        }));
      }, m);
    }
    return Ne(Ne({}, u), {}, Yn({}, d, h));
  }, f);
}, dM = function(t, r) {
  var n = r.realScaleType, o = r.type, a = r.tickCount, i = r.originalDomain, s = r.allowDecimals, c = n || r.scale;
  if (c !== "auto" && c !== "linear")
    return null;
  if (a && o === "number" && i && (i[0] === "auto" || i[1] === "auto")) {
    var l = t.domain();
    if (!l.length)
      return null;
    var f = EH(l, a, s);
    return t.domain([hl(f), pl(f)]), {
      niceTicks: f
    };
  }
  if (a && o === "number") {
    var u = t.domain(), d = TH(u, a, s);
    return {
      niceTicks: d
    };
  }
  return null;
};
function xS(e) {
  var t = e.axis, r = e.ticks, n = e.bandSize, o = e.entry, a = e.index, i = e.dataKey;
  if (t.type === "category") {
    if (!t.allowDuplicatedCategory && t.dataKey && !fe(o[t.dataKey])) {
      var s = ms(r, "value", o[t.dataKey]);
      if (s)
        return s.coordinate + n / 2;
    }
    return r[a] ? r[a].coordinate + n / 2 : null;
  }
  var c = ze(o, fe(i) ? t.dataKey : i);
  return fe(c) ? null : t.scale(c);
}
var SS = function(t) {
  var r = t.axis, n = t.ticks, o = t.offset, a = t.bandSize, i = t.entry, s = t.index;
  if (r.type === "category")
    return n[s] ? n[s].coordinate + o : null;
  var c = ze(i, r.dataKey, r.domain[s]);
  return fe(c) ? null : r.scale(c) - a / 2 + o;
}, h4 = function(t) {
  var r = t.numericAxis, n = r.scale.domain();
  if (r.type === "number") {
    var o = Math.min(n[0], n[1]), a = Math.max(n[0], n[1]);
    return o <= 0 && a >= 0 ? 0 : a < 0 ? a : o;
  }
  return n[0];
}, v4 = function(t, r) {
  var n, o = (n = t.type) !== null && n !== void 0 && n.defaultProps ? Ne(Ne({}, t.type.defaultProps), t.props) : t.props, a = o.stackId;
  if (We(a)) {
    var i = r[a];
    if (i) {
      var s = i.items.indexOf(t);
      return s >= 0 ? i.stackedData[s] : null;
    }
  }
  return null;
}, m4 = function(t) {
  return t.reduce(function(r, n) {
    return [hl(n.concat([r[0]]).filter(ne)), pl(n.concat([r[1]]).filter(ne))];
  }, [1 / 0, -1 / 0]);
}, pM = function(t, r, n) {
  return Object.keys(t).reduce(function(o, a) {
    var i = t[a], s = i.stackedData, c = s.reduce(function(l, f) {
      var u = m4(f.slice(r, n + 1));
      return [Math.min(l[0], u[0]), Math.max(l[1], u[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(c[0], o[0]), Math.max(c[1], o[1])];
  }, [1 / 0, -1 / 0]).map(function(o) {
    return o === 1 / 0 || o === -1 / 0 ? 0 : o;
  });
}, _S = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, OS = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, fv = function(t, r, n) {
  if (ue(t))
    return t(r, n);
  if (!Array.isArray(t))
    return r;
  var o = [];
  if (ne(t[0]))
    o[0] = n ? t[0] : Math.min(t[0], r[0]);
  else if (_S.test(t[0])) {
    var a = +_S.exec(t[0])[1];
    o[0] = r[0] - a;
  } else ue(t[0]) ? o[0] = t[0](r[0]) : o[0] = r[0];
  if (ne(t[1]))
    o[1] = n ? t[1] : Math.max(t[1], r[1]);
  else if (OS.test(t[1])) {
    var i = +OS.exec(t[1])[1];
    o[1] = r[1] + i;
  } else ue(t[1]) ? o[1] = t[1](r[1]) : o[1] = r[1];
  return o;
}, qs = function(t, r, n) {
  if (t && t.scale && t.scale.bandwidth) {
    var o = t.scale.bandwidth();
    if (!n || o > 0)
      return o;
  }
  if (t && r && r.length >= 2) {
    for (var a = cg(r, function(u) {
      return u.coordinate;
    }), i = 1 / 0, s = 1, c = a.length; s < c; s++) {
      var l = a[s], f = a[s - 1];
      i = Math.min((l.coordinate || 0) - (f.coordinate || 0), i);
    }
    return i === 1 / 0 ? 0 : i;
  }
  return n ? void 0 : 0;
}, AS = function(t, r, n) {
  return !t || !t.length || Ti(t, yt(n, "type.defaultProps.domain")) ? r : t;
}, hM = function(t, r) {
  var n = t.type.defaultProps ? Ne(Ne({}, t.type.defaultProps), t.props) : t.props, o = n.dataKey, a = n.name, i = n.unit, s = n.formatter, c = n.tooltipType, l = n.chartType, f = n.hide;
  return Ne(Ne({}, ie(t, !1)), {}, {
    dataKey: o,
    unit: i,
    formatter: s,
    name: a || o,
    color: $g(t),
    value: ze(r, o),
    type: c,
    payload: r,
    chartType: l,
    hide: f
  });
};
function Ba(e) {
  "@babel/helpers - typeof";
  return Ba = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ba(e);
}
function PS(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function lr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? PS(Object(r), !0).forEach(function(n) {
      vM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : PS(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function vM(e, t, r) {
  return t = g4(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function g4(e) {
  var t = y4(e, "string");
  return Ba(t) == "symbol" ? t : t + "";
}
function y4(e, t) {
  if (Ba(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ba(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function b4(e, t) {
  return _4(e) || S4(e, t) || x4(e, t) || w4();
}
function w4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function x4(e, t) {
  if (e) {
    if (typeof e == "string") return ES(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ES(e, t);
  }
}
function ES(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function S4(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, o, a, i, s = [], c = !0, l = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, o = f;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw o;
      }
    }
    return s;
  }
}
function _4(e) {
  if (Array.isArray(e)) return e;
}
var zs = Math.PI / 180, O4 = function(t) {
  return t * 180 / Math.PI;
}, Te = function(t, r, n, o) {
  return {
    x: t + Math.cos(-zs * o) * n,
    y: r + Math.sin(-zs * o) * n
  };
}, mM = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (n.left || 0) - (n.right || 0)), Math.abs(r - (n.top || 0) - (n.bottom || 0))) / 2;
}, A4 = function(t, r, n, o, a) {
  var i = t.width, s = t.height, c = t.startAngle, l = t.endAngle, f = nt(t.cx, i, i / 2), u = nt(t.cy, s, s / 2), d = mM(i, s, n), h = nt(t.innerRadius, d, 0), m = nt(t.outerRadius, d, d * 0.8), v = Object.keys(r);
  return v.reduce(function(p, b) {
    var w = r[b], x = w.domain, _ = w.reversed, y;
    if (fe(w.range))
      o === "angleAxis" ? y = [c, l] : o === "radiusAxis" && (y = [h, m]), _ && (y = [y[1], y[0]]);
    else {
      y = w.range;
      var O = y, A = b4(O, 2);
      c = A[0], l = A[1];
    }
    var P = uM(w, a), T = P.realScaleType, I = P.scale;
    I.domain(x).range(y), fM(I);
    var E = dM(I, lr(lr({}, w), {}, {
      realScaleType: T
    })), C = lr(lr(lr({}, w), E), {}, {
      range: y,
      radius: m,
      realScaleType: T,
      scale: I,
      cx: f,
      cy: u,
      innerRadius: h,
      outerRadius: m,
      startAngle: c,
      endAngle: l
    });
    return lr(lr({}, p), {}, vM({}, b, C));
  }, {});
}, P4 = function(t, r) {
  var n = t.x, o = t.y, a = r.x, i = r.y;
  return Math.sqrt(Math.pow(n - a, 2) + Math.pow(o - i, 2));
}, E4 = function(t, r) {
  var n = t.x, o = t.y, a = r.cx, i = r.cy, s = P4({
    x: n,
    y: o
  }, {
    x: a,
    y: i
  });
  if (s <= 0)
    return {
      radius: s
    };
  var c = (n - a) / s, l = Math.acos(c);
  return o > i && (l = 2 * Math.PI - l), {
    radius: s,
    angle: O4(l),
    angleInRadian: l
  };
}, T4 = function(t) {
  var r = t.startAngle, n = t.endAngle, o = Math.floor(r / 360), a = Math.floor(n / 360), i = Math.min(o, a);
  return {
    startAngle: r - i * 360,
    endAngle: n - i * 360
  };
}, C4 = function(t, r) {
  var n = r.startAngle, o = r.endAngle, a = Math.floor(n / 360), i = Math.floor(o / 360), s = Math.min(a, i);
  return t + s * 360;
}, TS = function(t, r) {
  var n = t.x, o = t.y, a = E4({
    x: n,
    y: o
  }, r), i = a.radius, s = a.angle, c = r.innerRadius, l = r.outerRadius;
  if (i < c || i > l)
    return !1;
  if (i === 0)
    return !0;
  var f = T4(r), u = f.startAngle, d = f.endAngle, h = s, m;
  if (u <= d) {
    for (; h > d; )
      h -= 360;
    for (; h < u; )
      h += 360;
    m = h >= u && h <= d;
  } else {
    for (; h > u; )
      h -= 360;
    for (; h < d; )
      h += 360;
    m = h >= d && h <= u;
  }
  return m ? lr(lr({}, r), {}, {
    radius: i,
    angle: C4(h, r)
  }) : null;
}, gM = function(t) {
  return !/* @__PURE__ */ jt(t) && !ue(t) && typeof t != "boolean" ? t.className : "";
};
function Fa(e) {
  "@babel/helpers - typeof";
  return Fa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fa(e);
}
var R4 = ["offset"];
function M4(e) {
  return $4(e) || k4(e) || N4(e) || I4();
}
function I4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function N4(e, t) {
  if (e) {
    if (typeof e == "string") return dv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return dv(e, t);
  }
}
function k4(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function $4(e) {
  if (Array.isArray(e)) return dv(e);
}
function dv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function D4(e, t) {
  if (e == null) return {};
  var r = j4(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function j4(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function CS(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Fe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? CS(Object(r), !0).forEach(function(n) {
      L4(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : CS(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function L4(e, t, r) {
  return t = B4(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function B4(e) {
  var t = F4(e, "string");
  return Fa(t) == "symbol" ? t : t + "";
}
function F4(e, t) {
  if (Fa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Fa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function qa() {
  return qa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qa.apply(this, arguments);
}
var q4 = function(t) {
  var r = t.value, n = t.formatter, o = fe(t.children) ? r : t.children;
  return ue(n) ? n(o) : o;
}, z4 = function(t, r) {
  var n = rt(r - t), o = Math.min(Math.abs(r - t), 360);
  return n * o;
}, W4 = function(t, r, n) {
  var o = t.position, a = t.viewBox, i = t.offset, s = t.className, c = a, l = c.cx, f = c.cy, u = c.innerRadius, d = c.outerRadius, h = c.startAngle, m = c.endAngle, v = c.clockWise, p = (u + d) / 2, b = z4(h, m), w = b >= 0 ? 1 : -1, x, _;
  o === "insideStart" ? (x = h + w * i, _ = v) : o === "insideEnd" ? (x = m - w * i, _ = !v) : o === "end" && (x = m + w * i, _ = v), _ = b <= 0 ? _ : !_;
  var y = Te(l, f, p, x), O = Te(l, f, p, x + (_ ? 1 : -1) * 359), A = "M".concat(y.x, ",").concat(y.y, `
    A`).concat(p, ",").concat(p, ",0,1,").concat(_ ? 0 : 1, `,
    `).concat(O.x, ",").concat(O.y), P = fe(t.id) ? qo("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ k.createElement("text", qa({}, n, {
    dominantBaseline: "central",
    className: de("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("path", {
    id: P,
    d: A
  })), /* @__PURE__ */ k.createElement("textPath", {
    xlinkHref: "#".concat(P)
  }, r));
}, U4 = function(t) {
  var r = t.viewBox, n = t.offset, o = t.position, a = r, i = a.cx, s = a.cy, c = a.innerRadius, l = a.outerRadius, f = a.startAngle, u = a.endAngle, d = (f + u) / 2;
  if (o === "outside") {
    var h = Te(i, s, l + n, d), m = h.x, v = h.y;
    return {
      x: m,
      y: v,
      textAnchor: m >= i ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (o === "center")
    return {
      x: i,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (o === "centerTop")
    return {
      x: i,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (o === "centerBottom")
    return {
      x: i,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var p = (c + l) / 2, b = Te(i, s, p, d), w = b.x, x = b.y;
  return {
    x: w,
    y: x,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, H4 = function(t) {
  var r = t.viewBox, n = t.parentViewBox, o = t.offset, a = t.position, i = r, s = i.x, c = i.y, l = i.width, f = i.height, u = f >= 0 ? 1 : -1, d = u * o, h = u > 0 ? "end" : "start", m = u > 0 ? "start" : "end", v = l >= 0 ? 1 : -1, p = v * o, b = v > 0 ? "end" : "start", w = v > 0 ? "start" : "end";
  if (a === "top") {
    var x = {
      x: s + l / 2,
      y: c - u * o,
      textAnchor: "middle",
      verticalAnchor: h
    };
    return Fe(Fe({}, x), n ? {
      height: Math.max(c - n.y, 0),
      width: l
    } : {});
  }
  if (a === "bottom") {
    var _ = {
      x: s + l / 2,
      y: c + f + d,
      textAnchor: "middle",
      verticalAnchor: m
    };
    return Fe(Fe({}, _), n ? {
      height: Math.max(n.y + n.height - (c + f), 0),
      width: l
    } : {});
  }
  if (a === "left") {
    var y = {
      x: s - p,
      y: c + f / 2,
      textAnchor: b,
      verticalAnchor: "middle"
    };
    return Fe(Fe({}, y), n ? {
      width: Math.max(y.x - n.x, 0),
      height: f
    } : {});
  }
  if (a === "right") {
    var O = {
      x: s + l + p,
      y: c + f / 2,
      textAnchor: w,
      verticalAnchor: "middle"
    };
    return Fe(Fe({}, O), n ? {
      width: Math.max(n.x + n.width - O.x, 0),
      height: f
    } : {});
  }
  var A = n ? {
    width: l,
    height: f
  } : {};
  return a === "insideLeft" ? Fe({
    x: s + p,
    y: c + f / 2,
    textAnchor: w,
    verticalAnchor: "middle"
  }, A) : a === "insideRight" ? Fe({
    x: s + l - p,
    y: c + f / 2,
    textAnchor: b,
    verticalAnchor: "middle"
  }, A) : a === "insideTop" ? Fe({
    x: s + l / 2,
    y: c + d,
    textAnchor: "middle",
    verticalAnchor: m
  }, A) : a === "insideBottom" ? Fe({
    x: s + l / 2,
    y: c + f - d,
    textAnchor: "middle",
    verticalAnchor: h
  }, A) : a === "insideTopLeft" ? Fe({
    x: s + p,
    y: c + d,
    textAnchor: w,
    verticalAnchor: m
  }, A) : a === "insideTopRight" ? Fe({
    x: s + l - p,
    y: c + d,
    textAnchor: b,
    verticalAnchor: m
  }, A) : a === "insideBottomLeft" ? Fe({
    x: s + p,
    y: c + f - d,
    textAnchor: w,
    verticalAnchor: h
  }, A) : a === "insideBottomRight" ? Fe({
    x: s + l - p,
    y: c + f - d,
    textAnchor: b,
    verticalAnchor: h
  }, A) : Fo(a) && (ne(a.x) || en(a.x)) && (ne(a.y) || en(a.y)) ? Fe({
    x: s + nt(a.x, l),
    y: c + nt(a.y, f),
    textAnchor: "end",
    verticalAnchor: "end"
  }, A) : Fe({
    x: s + l / 2,
    y: c + f / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, A);
}, V4 = function(t) {
  return "cx" in t && ne(t.cx);
};
function Ke(e) {
  var t = e.offset, r = t === void 0 ? 5 : t, n = D4(e, R4), o = Fe({
    offset: r
  }, n), a = o.viewBox, i = o.position, s = o.value, c = o.children, l = o.content, f = o.className, u = f === void 0 ? "" : f, d = o.textBreakAll;
  if (!a || fe(s) && fe(c) && !/* @__PURE__ */ jt(l) && !ue(l))
    return null;
  if (/* @__PURE__ */ jt(l))
    return /* @__PURE__ */ qe(l, o);
  var h;
  if (ue(l)) {
    if (h = /* @__PURE__ */ cn(l, o), /* @__PURE__ */ jt(h))
      return h;
  } else
    h = q4(o);
  var m = V4(a), v = ie(o, !0);
  if (m && (i === "insideStart" || i === "insideEnd" || i === "end"))
    return W4(o, h, v);
  var p = m ? U4(o) : H4(o);
  return /* @__PURE__ */ k.createElement(gn, qa({
    className: de("recharts-label", u)
  }, v, p, {
    breakAll: d
  }), h);
}
Ke.displayName = "Label";
var yM = function(t) {
  var r = t.cx, n = t.cy, o = t.angle, a = t.startAngle, i = t.endAngle, s = t.r, c = t.radius, l = t.innerRadius, f = t.outerRadius, u = t.x, d = t.y, h = t.top, m = t.left, v = t.width, p = t.height, b = t.clockWise, w = t.labelViewBox;
  if (w)
    return w;
  if (ne(v) && ne(p)) {
    if (ne(u) && ne(d))
      return {
        x: u,
        y: d,
        width: v,
        height: p
      };
    if (ne(h) && ne(m))
      return {
        x: h,
        y: m,
        width: v,
        height: p
      };
  }
  return ne(u) && ne(d) ? {
    x: u,
    y: d,
    width: 0,
    height: 0
  } : ne(r) && ne(n) ? {
    cx: r,
    cy: n,
    startAngle: a || o || 0,
    endAngle: i || o || 0,
    innerRadius: l || 0,
    outerRadius: f || c || s || 0,
    clockWise: b
  } : t.viewBox ? t.viewBox : {};
}, K4 = function(t, r) {
  return t ? t === !0 ? /* @__PURE__ */ k.createElement(Ke, {
    key: "label-implicit",
    viewBox: r
  }) : We(t) ? /* @__PURE__ */ k.createElement(Ke, {
    key: "label-implicit",
    viewBox: r,
    value: t
  }) : /* @__PURE__ */ jt(t) ? t.type === Ke ? /* @__PURE__ */ qe(t, {
    key: "label-implicit",
    viewBox: r
  }) : /* @__PURE__ */ k.createElement(Ke, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : ue(t) ? /* @__PURE__ */ k.createElement(Ke, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : Fo(t) ? /* @__PURE__ */ k.createElement(Ke, qa({
    viewBox: r
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, G4 = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && n && !t.label)
    return null;
  var o = t.children, a = yM(t), i = bt(o, Ke).map(function(c, l) {
    return /* @__PURE__ */ qe(c, {
      viewBox: r || a,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(l)
    });
  });
  if (!n)
    return i;
  var s = K4(t.label, r || a);
  return [s].concat(M4(i));
};
Ke.parseViewBox = yM;
Ke.renderCallByParent = G4;
var Op, RS;
function Y4() {
  if (RS) return Op;
  RS = 1;
  function e(t) {
    var r = t == null ? 0 : t.length;
    return r ? t[r - 1] : void 0;
  }
  return Op = e, Op;
}
var X4 = Y4();
const Z4 = /* @__PURE__ */ Ae(X4);
function za(e) {
  "@babel/helpers - typeof";
  return za = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, za(e);
}
var J4 = ["valueAccessor"], Q4 = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function eV(e) {
  return oV(e) || nV(e) || rV(e) || tV();
}
function tV() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rV(e, t) {
  if (e) {
    if (typeof e == "string") return pv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return pv(e, t);
  }
}
function nV(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function oV(e) {
  if (Array.isArray(e)) return pv(e);
}
function pv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Ws() {
  return Ws = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ws.apply(this, arguments);
}
function MS(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function IS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? MS(Object(r), !0).forEach(function(n) {
      aV(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : MS(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function aV(e, t, r) {
  return t = iV(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function iV(e) {
  var t = sV(e, "string");
  return za(t) == "symbol" ? t : t + "";
}
function sV(e, t) {
  if (za(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (za(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function NS(e, t) {
  if (e == null) return {};
  var r = cV(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function cV(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var lV = function(t) {
  return Array.isArray(t.value) ? Z4(t.value) : t.value;
};
function vr(e) {
  var t = e.valueAccessor, r = t === void 0 ? lV : t, n = NS(e, J4), o = n.data, a = n.dataKey, i = n.clockWise, s = n.id, c = n.textBreakAll, l = NS(n, Q4);
  return !o || !o.length ? null : /* @__PURE__ */ k.createElement(ve, {
    className: "recharts-label-list"
  }, o.map(function(f, u) {
    var d = fe(a) ? r(f, u) : ze(f && f.payload, a), h = fe(s) ? {} : {
      id: "".concat(s, "-").concat(u)
    };
    return /* @__PURE__ */ k.createElement(Ke, Ws({}, ie(f, !0), l, h, {
      parentViewBox: f.parentViewBox,
      value: d,
      textBreakAll: c,
      viewBox: Ke.parseViewBox(fe(i) ? f : IS(IS({}, f), {}, {
        clockWise: i
      })),
      key: "label-".concat(u),
      index: u
    }));
  }));
}
vr.displayName = "LabelList";
function uV(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ k.createElement(vr, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ k.isValidElement(e) || ue(e) ? /* @__PURE__ */ k.createElement(vr, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : Fo(e) ? /* @__PURE__ */ k.createElement(vr, Ws({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function fV(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && r && !e.label)
    return null;
  var n = e.children, o = bt(n, vr).map(function(i, s) {
    return /* @__PURE__ */ qe(i, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!r)
    return o;
  var a = uV(e.label, t);
  return [a].concat(eV(o));
}
vr.renderCallByParent = fV;
function Wa(e) {
  "@babel/helpers - typeof";
  return Wa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wa(e);
}
function hv() {
  return hv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hv.apply(this, arguments);
}
function kS(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $S(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? kS(Object(r), !0).forEach(function(n) {
      dV(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : kS(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function dV(e, t, r) {
  return t = pV(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function pV(e) {
  var t = hV(e, "string");
  return Wa(t) == "symbol" ? t : t + "";
}
function hV(e, t) {
  if (Wa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Wa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var vV = function(t, r) {
  var n = rt(r - t), o = Math.min(Math.abs(r - t), 359.999);
  return n * o;
}, Gi = function(t) {
  var r = t.cx, n = t.cy, o = t.radius, a = t.angle, i = t.sign, s = t.isExternal, c = t.cornerRadius, l = t.cornerIsExternal, f = c * (s ? 1 : -1) + o, u = Math.asin(c / f) / zs, d = l ? a : a + i * u, h = Te(r, n, f, d), m = Te(r, n, o, d), v = l ? a - i * u : a, p = Te(r, n, f * Math.cos(u * zs), v);
  return {
    center: h,
    circleTangency: m,
    lineTangency: p,
    theta: u
  };
}, bM = function(t) {
  var r = t.cx, n = t.cy, o = t.innerRadius, a = t.outerRadius, i = t.startAngle, s = t.endAngle, c = vV(i, s), l = i + c, f = Te(r, n, a, i), u = Te(r, n, a, l), d = "M ".concat(f.x, ",").concat(f.y, `
    A `).concat(a, ",").concat(a, `,0,
    `).concat(+(Math.abs(c) > 180), ",").concat(+(i > l), `,
    `).concat(u.x, ",").concat(u.y, `
  `);
  if (o > 0) {
    var h = Te(r, n, o, i), m = Te(r, n, o, l);
    d += "L ".concat(m.x, ",").concat(m.y, `
            A `).concat(o, ",").concat(o, `,0,
            `).concat(+(Math.abs(c) > 180), ",").concat(+(i <= l), `,
            `).concat(h.x, ",").concat(h.y, " Z");
  } else
    d += "L ".concat(r, ",").concat(n, " Z");
  return d;
}, mV = function(t) {
  var r = t.cx, n = t.cy, o = t.innerRadius, a = t.outerRadius, i = t.cornerRadius, s = t.forceCornerRadius, c = t.cornerIsExternal, l = t.startAngle, f = t.endAngle, u = rt(f - l), d = Gi({
    cx: r,
    cy: n,
    radius: a,
    angle: l,
    sign: u,
    cornerRadius: i,
    cornerIsExternal: c
  }), h = d.circleTangency, m = d.lineTangency, v = d.theta, p = Gi({
    cx: r,
    cy: n,
    radius: a,
    angle: f,
    sign: -u,
    cornerRadius: i,
    cornerIsExternal: c
  }), b = p.circleTangency, w = p.lineTangency, x = p.theta, _ = c ? Math.abs(l - f) : Math.abs(l - f) - v - x;
  if (_ < 0)
    return s ? "M ".concat(m.x, ",").concat(m.y, `
        a`).concat(i, ",").concat(i, ",0,0,1,").concat(i * 2, `,0
        a`).concat(i, ",").concat(i, ",0,0,1,").concat(-i * 2, `,0
      `) : bM({
      cx: r,
      cy: n,
      innerRadius: o,
      outerRadius: a,
      startAngle: l,
      endAngle: f
    });
  var y = "M ".concat(m.x, ",").concat(m.y, `
    A`).concat(i, ",").concat(i, ",0,0,").concat(+(u < 0), ",").concat(h.x, ",").concat(h.y, `
    A`).concat(a, ",").concat(a, ",0,").concat(+(_ > 180), ",").concat(+(u < 0), ",").concat(b.x, ",").concat(b.y, `
    A`).concat(i, ",").concat(i, ",0,0,").concat(+(u < 0), ",").concat(w.x, ",").concat(w.y, `
  `);
  if (o > 0) {
    var O = Gi({
      cx: r,
      cy: n,
      radius: o,
      angle: l,
      sign: u,
      isExternal: !0,
      cornerRadius: i,
      cornerIsExternal: c
    }), A = O.circleTangency, P = O.lineTangency, T = O.theta, I = Gi({
      cx: r,
      cy: n,
      radius: o,
      angle: f,
      sign: -u,
      isExternal: !0,
      cornerRadius: i,
      cornerIsExternal: c
    }), E = I.circleTangency, C = I.lineTangency, R = I.theta, M = c ? Math.abs(l - f) : Math.abs(l - f) - T - R;
    if (M < 0 && i === 0)
      return "".concat(y, "L").concat(r, ",").concat(n, "Z");
    y += "L".concat(C.x, ",").concat(C.y, `
      A`).concat(i, ",").concat(i, ",0,0,").concat(+(u < 0), ",").concat(E.x, ",").concat(E.y, `
      A`).concat(o, ",").concat(o, ",0,").concat(+(M > 180), ",").concat(+(u > 0), ",").concat(A.x, ",").concat(A.y, `
      A`).concat(i, ",").concat(i, ",0,0,").concat(+(u < 0), ",").concat(P.x, ",").concat(P.y, "Z");
  } else
    y += "L".concat(r, ",").concat(n, "Z");
  return y;
}, gV = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, wM = function(t) {
  var r = $S($S({}, gV), t), n = r.cx, o = r.cy, a = r.innerRadius, i = r.outerRadius, s = r.cornerRadius, c = r.forceCornerRadius, l = r.cornerIsExternal, f = r.startAngle, u = r.endAngle, d = r.className;
  if (i < a || f === u)
    return null;
  var h = de("recharts-sector", d), m = i - a, v = nt(s, m, 0, !0), p;
  return v > 0 && Math.abs(f - u) < 360 ? p = mV({
    cx: n,
    cy: o,
    innerRadius: a,
    outerRadius: i,
    cornerRadius: Math.min(v, m / 2),
    forceCornerRadius: c,
    cornerIsExternal: l,
    startAngle: f,
    endAngle: u
  }) : p = bM({
    cx: n,
    cy: o,
    innerRadius: a,
    outerRadius: i,
    startAngle: f,
    endAngle: u
  }), /* @__PURE__ */ k.createElement("path", hv({}, ie(r, !0), {
    className: h,
    d: p,
    role: "img"
  }));
};
function Ua(e) {
  "@babel/helpers - typeof";
  return Ua = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ua(e);
}
function vv() {
  return vv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vv.apply(this, arguments);
}
function DS(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function jS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? DS(Object(r), !0).forEach(function(n) {
      yV(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : DS(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function yV(e, t, r) {
  return t = bV(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function bV(e) {
  var t = wV(e, "string");
  return Ua(t) == "symbol" ? t : t + "";
}
function wV(e, t) {
  if (Ua(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ua(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var LS = {
  curveBasisClosed: Fq,
  curveBasisOpen: qq,
  curveBasis: Bq,
  curveBumpX: Aq,
  curveBumpY: Pq,
  curveLinearClosed: zq,
  curveLinear: tl,
  curveMonotoneX: Wq,
  curveMonotoneY: Uq,
  curveNatural: Hq,
  curveStep: Vq,
  curveStepAfter: Gq,
  curveStepBefore: Kq
}, Yi = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, ta = function(t) {
  return t.x;
}, ra = function(t) {
  return t.y;
}, xV = function(t, r) {
  if (ue(t))
    return t;
  var n = "curve".concat(Qc(t));
  return (n === "curveMonotone" || n === "curveBump") && r ? LS["".concat(n).concat(r === "vertical" ? "Y" : "X")] : LS[n] || tl;
}, SV = function(t) {
  var r = t.type, n = r === void 0 ? "linear" : r, o = t.points, a = o === void 0 ? [] : o, i = t.baseLine, s = t.layout, c = t.connectNulls, l = c === void 0 ? !1 : c, f = xV(n, s), u = l ? a.filter(function(v) {
    return Yi(v);
  }) : a, d;
  if (Array.isArray(i)) {
    var h = l ? i.filter(function(v) {
      return Yi(v);
    }) : i, m = u.map(function(v, p) {
      return jS(jS({}, v), {}, {
        base: h[p]
      });
    });
    return s === "vertical" ? d = Fi().y(ra).x1(ta).x0(function(v) {
      return v.base.x;
    }) : d = Fi().x(ta).y1(ra).y0(function(v) {
      return v.base.y;
    }), d.defined(Yi).curve(f), d(m);
  }
  return s === "vertical" && ne(i) ? d = Fi().y(ra).x1(ta).x0(i) : ne(i) ? d = Fi().x(ta).y1(ra).y0(i) : d = bC().x(ta).y(ra), d.defined(Yi).curve(f), d(u);
}, Us = function(t) {
  var r = t.className, n = t.points, o = t.path, a = t.pathRef;
  if ((!n || !n.length) && !o)
    return null;
  var i = n && n.length ? SV(t) : o;
  return /* @__PURE__ */ g.createElement("path", vv({}, ie(t, !1), gs(t), {
    className: de("recharts-curve", r),
    d: i,
    ref: a
  }));
}, Xi = { exports: {} }, Zi = { exports: {} }, we = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var BS;
function _V() {
  if (BS) return we;
  BS = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, p = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function x(y) {
    if (typeof y == "object" && y !== null) {
      var O = y.$$typeof;
      switch (O) {
        case t:
          switch (y = y.type, y) {
            case c:
            case l:
            case n:
            case a:
            case o:
            case u:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case f:
                case m:
                case h:
                case i:
                  return y;
                default:
                  return O;
              }
          }
        case r:
          return O;
      }
    }
  }
  function _(y) {
    return x(y) === l;
  }
  return we.AsyncMode = c, we.ConcurrentMode = l, we.ContextConsumer = s, we.ContextProvider = i, we.Element = t, we.ForwardRef = f, we.Fragment = n, we.Lazy = m, we.Memo = h, we.Portal = r, we.Profiler = a, we.StrictMode = o, we.Suspense = u, we.isAsyncMode = function(y) {
    return _(y) || x(y) === c;
  }, we.isConcurrentMode = _, we.isContextConsumer = function(y) {
    return x(y) === s;
  }, we.isContextProvider = function(y) {
    return x(y) === i;
  }, we.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, we.isForwardRef = function(y) {
    return x(y) === f;
  }, we.isFragment = function(y) {
    return x(y) === n;
  }, we.isLazy = function(y) {
    return x(y) === m;
  }, we.isMemo = function(y) {
    return x(y) === h;
  }, we.isPortal = function(y) {
    return x(y) === r;
  }, we.isProfiler = function(y) {
    return x(y) === a;
  }, we.isStrictMode = function(y) {
    return x(y) === o;
  }, we.isSuspense = function(y) {
    return x(y) === u;
  }, we.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === l || y === a || y === o || y === u || y === d || typeof y == "object" && y !== null && (y.$$typeof === m || y.$$typeof === h || y.$$typeof === i || y.$$typeof === s || y.$$typeof === f || y.$$typeof === p || y.$$typeof === b || y.$$typeof === w || y.$$typeof === v);
  }, we.typeOf = x, we;
}
var xe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var FS;
function OV() {
  return FS || (FS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, p = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function x(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === n || j === l || j === a || j === o || j === u || j === d || typeof j == "object" && j !== null && (j.$$typeof === m || j.$$typeof === h || j.$$typeof === i || j.$$typeof === s || j.$$typeof === f || j.$$typeof === p || j.$$typeof === b || j.$$typeof === w || j.$$typeof === v);
    }
    function _(j) {
      if (typeof j == "object" && j !== null) {
        var ce = j.$$typeof;
        switch (ce) {
          case t:
            var X = j.type;
            switch (X) {
              case c:
              case l:
              case n:
              case a:
              case o:
              case u:
                return X;
              default:
                var he = X && X.$$typeof;
                switch (he) {
                  case s:
                  case f:
                  case m:
                  case h:
                  case i:
                    return he;
                  default:
                    return ce;
                }
            }
          case r:
            return ce;
        }
      }
    }
    var y = c, O = l, A = s, P = i, T = t, I = f, E = n, C = m, R = h, M = r, D = a, $ = o, q = u, F = !1;
    function B(j) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), L(j) || _(j) === c;
    }
    function L(j) {
      return _(j) === l;
    }
    function z(j) {
      return _(j) === s;
    }
    function N(j) {
      return _(j) === i;
    }
    function U(j) {
      return typeof j == "object" && j !== null && j.$$typeof === t;
    }
    function K(j) {
      return _(j) === f;
    }
    function G(j) {
      return _(j) === n;
    }
    function J(j) {
      return _(j) === m;
    }
    function V(j) {
      return _(j) === h;
    }
    function Q(j) {
      return _(j) === r;
    }
    function W(j) {
      return _(j) === a;
    }
    function Y(j) {
      return _(j) === o;
    }
    function te(j) {
      return _(j) === u;
    }
    xe.AsyncMode = y, xe.ConcurrentMode = O, xe.ContextConsumer = A, xe.ContextProvider = P, xe.Element = T, xe.ForwardRef = I, xe.Fragment = E, xe.Lazy = C, xe.Memo = R, xe.Portal = M, xe.Profiler = D, xe.StrictMode = $, xe.Suspense = q, xe.isAsyncMode = B, xe.isConcurrentMode = L, xe.isContextConsumer = z, xe.isContextProvider = N, xe.isElement = U, xe.isForwardRef = K, xe.isFragment = G, xe.isLazy = J, xe.isMemo = V, xe.isPortal = Q, xe.isProfiler = W, xe.isStrictMode = Y, xe.isSuspense = te, xe.isValidElementType = x, xe.typeOf = _;
  })()), xe;
}
var qS;
function xM() {
  return qS || (qS = 1, process.env.NODE_ENV === "production" ? Zi.exports = _V() : Zi.exports = OV()), Zi.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ap, zS;
function AV() {
  if (zS) return Ap;
  zS = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(i).map(function(f) {
        return i[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        l[f] = f;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ap = o() ? Object.assign : function(a, i) {
    for (var s, c = n(a), l, f = 1; f < arguments.length; f++) {
      s = Object(arguments[f]);
      for (var u in s)
        t.call(s, u) && (c[u] = s[u]);
      if (e) {
        l = e(s);
        for (var d = 0; d < l.length; d++)
          r.call(s, l[d]) && (c[l[d]] = s[l[d]]);
      }
    }
    return c;
  }, Ap;
}
var Pp, WS;
function Dg() {
  if (WS) return Pp;
  WS = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Pp = e, Pp;
}
var Ep, US;
function SM() {
  return US || (US = 1, Ep = Function.call.bind(Object.prototype.hasOwnProperty)), Ep;
}
var Tp, HS;
function PV() {
  if (HS) return Tp;
  HS = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ Dg(), r = {}, n = /* @__PURE__ */ SM();
    e = function(a) {
      var i = "Warning: " + a;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(a, i, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in a)
        if (n(a, f)) {
          var u;
          try {
            if (typeof a[f] != "function") {
              var d = Error(
                (c || "React class") + ": " + s + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            u = a[f](i, f, c, s, null, t);
          } catch (m) {
            u = m;
          }
          if (u && !(u instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), u instanceof Error && !(u.message in r)) {
            r[u.message] = !0;
            var h = l ? l() : "";
            e(
              "Failed " + s + " type: " + u.message + (h ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Tp = o, Tp;
}
var Cp, VS;
function EV() {
  if (VS) return Cp;
  VS = 1;
  var e = xM(), t = AV(), r = /* @__PURE__ */ Dg(), n = /* @__PURE__ */ SM(), o = /* @__PURE__ */ PV(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return Cp = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function u(L) {
      var z = L && (l && L[l] || L[f]);
      if (typeof z == "function")
        return z;
    }
    var d = "<<anonymous>>", h = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: w(),
      arrayOf: x,
      element: _(),
      elementType: y(),
      instanceOf: O,
      node: I(),
      objectOf: P,
      oneOf: A,
      oneOfType: T,
      shape: C,
      exact: R
    };
    function m(L, z) {
      return L === z ? L !== 0 || 1 / L === 1 / z : L !== L && z !== z;
    }
    function v(L, z) {
      this.message = L, this.data = z && typeof z == "object" ? z : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function p(L) {
      if (process.env.NODE_ENV !== "production")
        var z = {}, N = 0;
      function U(G, J, V, Q, W, Y, te) {
        if (Q = Q || d, Y = Y || V, te !== r) {
          if (c) {
            var j = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw j.name = "Invariant Violation", j;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ce = Q + ":" + V;
            !z[ce] && // Avoid spamming the console because they are often not actionable except for lib authors
            N < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + Y + "` prop on `" + Q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), z[ce] = !0, N++);
          }
        }
        return J[V] == null ? G ? J[V] === null ? new v("The " + W + " `" + Y + "` is marked as required " + ("in `" + Q + "`, but its value is `null`.")) : new v("The " + W + " `" + Y + "` is marked as required in " + ("`" + Q + "`, but its value is `undefined`.")) : null : L(J, V, Q, W, Y);
      }
      var K = U.bind(null, !1);
      return K.isRequired = U.bind(null, !0), K;
    }
    function b(L) {
      function z(N, U, K, G, J, V) {
        var Q = N[U], W = $(Q);
        if (W !== L) {
          var Y = q(Q);
          return new v(
            "Invalid " + G + " `" + J + "` of type " + ("`" + Y + "` supplied to `" + K + "`, expected ") + ("`" + L + "`."),
            { expectedType: L }
          );
        }
        return null;
      }
      return p(z);
    }
    function w() {
      return p(i);
    }
    function x(L) {
      function z(N, U, K, G, J) {
        if (typeof L != "function")
          return new v("Property `" + J + "` of component `" + K + "` has invalid PropType notation inside arrayOf.");
        var V = N[U];
        if (!Array.isArray(V)) {
          var Q = $(V);
          return new v("Invalid " + G + " `" + J + "` of type " + ("`" + Q + "` supplied to `" + K + "`, expected an array."));
        }
        for (var W = 0; W < V.length; W++) {
          var Y = L(V, W, K, G, J + "[" + W + "]", r);
          if (Y instanceof Error)
            return Y;
        }
        return null;
      }
      return p(z);
    }
    function _() {
      function L(z, N, U, K, G) {
        var J = z[N];
        if (!s(J)) {
          var V = $(J);
          return new v("Invalid " + K + " `" + G + "` of type " + ("`" + V + "` supplied to `" + U + "`, expected a single ReactElement."));
        }
        return null;
      }
      return p(L);
    }
    function y() {
      function L(z, N, U, K, G) {
        var J = z[N];
        if (!e.isValidElementType(J)) {
          var V = $(J);
          return new v("Invalid " + K + " `" + G + "` of type " + ("`" + V + "` supplied to `" + U + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return p(L);
    }
    function O(L) {
      function z(N, U, K, G, J) {
        if (!(N[U] instanceof L)) {
          var V = L.name || d, Q = B(N[U]);
          return new v("Invalid " + G + " `" + J + "` of type " + ("`" + Q + "` supplied to `" + K + "`, expected ") + ("instance of `" + V + "`."));
        }
        return null;
      }
      return p(z);
    }
    function A(L) {
      if (!Array.isArray(L))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), i;
      function z(N, U, K, G, J) {
        for (var V = N[U], Q = 0; Q < L.length; Q++)
          if (m(V, L[Q]))
            return null;
        var W = JSON.stringify(L, function(te, j) {
          var ce = q(j);
          return ce === "symbol" ? String(j) : j;
        });
        return new v("Invalid " + G + " `" + J + "` of value `" + String(V) + "` " + ("supplied to `" + K + "`, expected one of " + W + "."));
      }
      return p(z);
    }
    function P(L) {
      function z(N, U, K, G, J) {
        if (typeof L != "function")
          return new v("Property `" + J + "` of component `" + K + "` has invalid PropType notation inside objectOf.");
        var V = N[U], Q = $(V);
        if (Q !== "object")
          return new v("Invalid " + G + " `" + J + "` of type " + ("`" + Q + "` supplied to `" + K + "`, expected an object."));
        for (var W in V)
          if (n(V, W)) {
            var Y = L(V, W, K, G, J + "." + W, r);
            if (Y instanceof Error)
              return Y;
          }
        return null;
      }
      return p(z);
    }
    function T(L) {
      if (!Array.isArray(L))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var z = 0; z < L.length; z++) {
        var N = L[z];
        if (typeof N != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + F(N) + " at index " + z + "."
          ), i;
      }
      function U(K, G, J, V, Q) {
        for (var W = [], Y = 0; Y < L.length; Y++) {
          var te = L[Y], j = te(K, G, J, V, Q, r);
          if (j == null)
            return null;
          j.data && n(j.data, "expectedType") && W.push(j.data.expectedType);
        }
        var ce = W.length > 0 ? ", expected one of type [" + W.join(", ") + "]" : "";
        return new v("Invalid " + V + " `" + Q + "` supplied to " + ("`" + J + "`" + ce + "."));
      }
      return p(U);
    }
    function I() {
      function L(z, N, U, K, G) {
        return M(z[N]) ? null : new v("Invalid " + K + " `" + G + "` supplied to " + ("`" + U + "`, expected a ReactNode."));
      }
      return p(L);
    }
    function E(L, z, N, U, K) {
      return new v(
        (L || "React class") + ": " + z + " type `" + N + "." + U + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + K + "`."
      );
    }
    function C(L) {
      function z(N, U, K, G, J) {
        var V = N[U], Q = $(V);
        if (Q !== "object")
          return new v("Invalid " + G + " `" + J + "` of type `" + Q + "` " + ("supplied to `" + K + "`, expected `object`."));
        for (var W in L) {
          var Y = L[W];
          if (typeof Y != "function")
            return E(K, G, J, W, q(Y));
          var te = Y(V, W, K, G, J + "." + W, r);
          if (te)
            return te;
        }
        return null;
      }
      return p(z);
    }
    function R(L) {
      function z(N, U, K, G, J) {
        var V = N[U], Q = $(V);
        if (Q !== "object")
          return new v("Invalid " + G + " `" + J + "` of type `" + Q + "` " + ("supplied to `" + K + "`, expected `object`."));
        var W = t({}, N[U], L);
        for (var Y in W) {
          var te = L[Y];
          if (n(L, Y) && typeof te != "function")
            return E(K, G, J, Y, q(te));
          if (!te)
            return new v(
              "Invalid " + G + " `" + J + "` key `" + Y + "` supplied to `" + K + "`.\nBad object: " + JSON.stringify(N[U], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(L), null, "  ")
            );
          var j = te(V, Y, K, G, J + "." + Y, r);
          if (j)
            return j;
        }
        return null;
      }
      return p(z);
    }
    function M(L) {
      switch (typeof L) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !L;
        case "object":
          if (Array.isArray(L))
            return L.every(M);
          if (L === null || s(L))
            return !0;
          var z = u(L);
          if (z) {
            var N = z.call(L), U;
            if (z !== L.entries) {
              for (; !(U = N.next()).done; )
                if (!M(U.value))
                  return !1;
            } else
              for (; !(U = N.next()).done; ) {
                var K = U.value;
                if (K && !M(K[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function D(L, z) {
      return L === "symbol" ? !0 : z ? z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && z instanceof Symbol : !1;
    }
    function $(L) {
      var z = typeof L;
      return Array.isArray(L) ? "array" : L instanceof RegExp ? "object" : D(z, L) ? "symbol" : z;
    }
    function q(L) {
      if (typeof L > "u" || L === null)
        return "" + L;
      var z = $(L);
      if (z === "object") {
        if (L instanceof Date)
          return "date";
        if (L instanceof RegExp)
          return "regexp";
      }
      return z;
    }
    function F(L) {
      var z = q(L);
      switch (z) {
        case "array":
        case "object":
          return "an " + z;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + z;
        default:
          return z;
      }
    }
    function B(L) {
      return !L.constructor || !L.constructor.name ? d : L.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, Cp;
}
var Rp, KS;
function TV() {
  if (KS) return Rp;
  KS = 1;
  var e = /* @__PURE__ */ Dg();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Rp = function() {
    function n(i, s, c, l, f, u) {
      if (u !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Rp;
}
var GS;
function CV() {
  if (GS) return Xi.exports;
  if (GS = 1, process.env.NODE_ENV !== "production") {
    var e = xM(), t = !0;
    Xi.exports = /* @__PURE__ */ EV()(e.isElement, t);
  } else
    Xi.exports = /* @__PURE__ */ TV()();
  return Xi.exports;
}
var RV = /* @__PURE__ */ CV();
const Se = /* @__PURE__ */ Ae(RV), { getOwnPropertyNames: MV, getOwnPropertySymbols: IV } = Object, { hasOwnProperty: NV } = Object.prototype;
function Mp(e, t) {
  return function(n, o, a) {
    return e(n, o, a) && t(n, o, a);
  };
}
function Ji(e) {
  return function(r, n, o) {
    if (!r || !n || typeof r != "object" || typeof n != "object")
      return e(r, n, o);
    const { cache: a } = o, i = a.get(r), s = a.get(n);
    if (i && s)
      return i === n && s === r;
    a.set(r, n), a.set(n, r);
    const c = e(r, n, o);
    return a.delete(r), a.delete(n), c;
  };
}
function kV(e) {
  return e != null ? e[Symbol.toStringTag] : void 0;
}
function YS(e) {
  return MV(e).concat(IV(e));
}
const $V = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  Object.hasOwn || ((e, t) => NV.call(e, t))
);
function Pn(e, t) {
  return e === t || !e && !t && e !== e && t !== t;
}
const DV = "__v", jV = "__o", LV = "_owner", { getOwnPropertyDescriptor: XS, keys: ZS } = Object;
function BV(e, t) {
  return e.byteLength === t.byteLength && Hs(new Uint8Array(e), new Uint8Array(t));
}
function FV(e, t, r) {
  let n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (!r.equals(e[n], t[n], n, n, e, t, r))
      return !1;
  return !0;
}
function qV(e, t) {
  return e.byteLength === t.byteLength && Hs(new Uint8Array(e.buffer, e.byteOffset, e.byteLength), new Uint8Array(t.buffer, t.byteOffset, t.byteLength));
}
function zV(e, t) {
  return Pn(e.getTime(), t.getTime());
}
function WV(e, t) {
  return e.name === t.name && e.message === t.message && e.cause === t.cause && e.stack === t.stack;
}
function UV(e, t) {
  return e === t;
}
function JS(e, t, r) {
  const n = e.size;
  if (n !== t.size)
    return !1;
  if (!n)
    return !0;
  const o = new Array(n), a = e.entries();
  let i, s, c = 0;
  for (; (i = a.next()) && !i.done; ) {
    const l = t.entries();
    let f = !1, u = 0;
    for (; (s = l.next()) && !s.done; ) {
      if (o[u]) {
        u++;
        continue;
      }
      const d = i.value, h = s.value;
      if (r.equals(d[0], h[0], c, u, e, t, r) && r.equals(d[1], h[1], d[0], h[0], e, t, r)) {
        f = o[u] = !0;
        break;
      }
      u++;
    }
    if (!f)
      return !1;
    c++;
  }
  return !0;
}
const HV = Pn;
function VV(e, t, r) {
  const n = ZS(e);
  let o = n.length;
  if (ZS(t).length !== o)
    return !1;
  for (; o-- > 0; )
    if (!_M(e, t, r, n[o]))
      return !1;
  return !0;
}
function na(e, t, r) {
  const n = YS(e);
  let o = n.length;
  if (YS(t).length !== o)
    return !1;
  let a, i, s;
  for (; o-- > 0; )
    if (a = n[o], !_M(e, t, r, a) || (i = XS(e, a), s = XS(t, a), (i || s) && (!i || !s || i.configurable !== s.configurable || i.enumerable !== s.enumerable || i.writable !== s.writable)))
      return !1;
  return !0;
}
function KV(e, t) {
  return Pn(e.valueOf(), t.valueOf());
}
function GV(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function QS(e, t, r) {
  const n = e.size;
  if (n !== t.size)
    return !1;
  if (!n)
    return !0;
  const o = new Array(n), a = e.values();
  let i, s;
  for (; (i = a.next()) && !i.done; ) {
    const c = t.values();
    let l = !1, f = 0;
    for (; (s = c.next()) && !s.done; ) {
      if (!o[f] && r.equals(i.value, s.value, i.value, s.value, e, t, r)) {
        l = o[f] = !0;
        break;
      }
      f++;
    }
    if (!l)
      return !1;
  }
  return !0;
}
function Hs(e, t) {
  let r = e.byteLength;
  if (t.byteLength !== r || e.byteOffset !== t.byteOffset)
    return !1;
  for (; r-- > 0; )
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function YV(e, t) {
  return e.hostname === t.hostname && e.pathname === t.pathname && e.protocol === t.protocol && e.port === t.port && e.hash === t.hash && e.username === t.username && e.password === t.password;
}
function _M(e, t, r, n) {
  return (n === LV || n === jV || n === DV) && (e.$$typeof || t.$$typeof) ? !0 : $V(t, n) && r.equals(e[n], t[n], n, n, e, t, r);
}
const XV = "[object ArrayBuffer]", ZV = "[object Arguments]", JV = "[object Boolean]", QV = "[object DataView]", eK = "[object Date]", tK = "[object Error]", rK = "[object Map]", nK = "[object Number]", oK = "[object Object]", aK = "[object RegExp]", iK = "[object Set]", sK = "[object String]", cK = {
  "[object Int8Array]": !0,
  "[object Uint8Array]": !0,
  "[object Uint8ClampedArray]": !0,
  "[object Int16Array]": !0,
  "[object Uint16Array]": !0,
  "[object Int32Array]": !0,
  "[object Uint32Array]": !0,
  "[object Float16Array]": !0,
  "[object Float32Array]": !0,
  "[object Float64Array]": !0,
  "[object BigInt64Array]": !0,
  "[object BigUint64Array]": !0
}, lK = "[object URL]", uK = Object.prototype.toString;
function fK({ areArrayBuffersEqual: e, areArraysEqual: t, areDataViewsEqual: r, areDatesEqual: n, areErrorsEqual: o, areFunctionsEqual: a, areMapsEqual: i, areNumbersEqual: s, areObjectsEqual: c, arePrimitiveWrappersEqual: l, areRegExpsEqual: f, areSetsEqual: u, areTypedArraysEqual: d, areUrlsEqual: h, unknownTagComparators: m }) {
  return function(p, b, w) {
    if (p === b)
      return !0;
    if (p == null || b == null)
      return !1;
    const x = typeof p;
    if (x !== typeof b)
      return !1;
    if (x !== "object")
      return x === "number" ? s(p, b, w) : x === "function" ? a(p, b, w) : !1;
    const _ = p.constructor;
    if (_ !== b.constructor)
      return !1;
    if (_ === Object)
      return c(p, b, w);
    if (Array.isArray(p))
      return t(p, b, w);
    if (_ === Date)
      return n(p, b, w);
    if (_ === RegExp)
      return f(p, b, w);
    if (_ === Map)
      return i(p, b, w);
    if (_ === Set)
      return u(p, b, w);
    const y = uK.call(p);
    if (y === eK)
      return n(p, b, w);
    if (y === aK)
      return f(p, b, w);
    if (y === rK)
      return i(p, b, w);
    if (y === iK)
      return u(p, b, w);
    if (y === oK)
      return typeof p.then != "function" && typeof b.then != "function" && c(p, b, w);
    if (y === lK)
      return h(p, b, w);
    if (y === tK)
      return o(p, b, w);
    if (y === ZV)
      return c(p, b, w);
    if (cK[y])
      return d(p, b, w);
    if (y === XV)
      return e(p, b, w);
    if (y === QV)
      return r(p, b, w);
    if (y === JV || y === nK || y === sK)
      return l(p, b, w);
    if (m) {
      let O = m[y];
      if (!O) {
        const A = kV(p);
        A && (O = m[A]);
      }
      if (O)
        return O(p, b, w);
    }
    return !1;
  };
}
function dK({ circular: e, createCustomConfig: t, strict: r }) {
  let n = {
    areArrayBuffersEqual: BV,
    areArraysEqual: r ? na : FV,
    areDataViewsEqual: qV,
    areDatesEqual: zV,
    areErrorsEqual: WV,
    areFunctionsEqual: UV,
    areMapsEqual: r ? Mp(JS, na) : JS,
    areNumbersEqual: HV,
    areObjectsEqual: r ? na : VV,
    arePrimitiveWrappersEqual: KV,
    areRegExpsEqual: GV,
    areSetsEqual: r ? Mp(QS, na) : QS,
    areTypedArraysEqual: r ? Mp(Hs, na) : Hs,
    areUrlsEqual: YV,
    unknownTagComparators: void 0
  };
  if (t && (n = Object.assign({}, n, t(n))), e) {
    const o = Ji(n.areArraysEqual), a = Ji(n.areMapsEqual), i = Ji(n.areObjectsEqual), s = Ji(n.areSetsEqual);
    n = Object.assign({}, n, {
      areArraysEqual: o,
      areMapsEqual: a,
      areObjectsEqual: i,
      areSetsEqual: s
    });
  }
  return n;
}
function pK(e) {
  return function(t, r, n, o, a, i, s) {
    return e(t, r, s);
  };
}
function hK({ circular: e, comparator: t, createState: r, equals: n, strict: o }) {
  if (r)
    return function(s, c) {
      const { cache: l = e ? /* @__PURE__ */ new WeakMap() : void 0, meta: f } = r();
      return t(s, c, {
        cache: l,
        equals: n,
        meta: f,
        strict: o
      });
    };
  if (e)
    return function(s, c) {
      return t(s, c, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: n,
        meta: void 0,
        strict: o
      });
    };
  const a = {
    cache: void 0,
    equals: n,
    meta: void 0,
    strict: o
  };
  return function(s, c) {
    return t(s, c, a);
  };
}
const vK = Hr();
Hr({ strict: !0 });
Hr({ circular: !0 });
Hr({
  circular: !0,
  strict: !0
});
Hr({
  createInternalComparator: () => Pn
});
Hr({
  strict: !0,
  createInternalComparator: () => Pn
});
Hr({
  circular: !0,
  createInternalComparator: () => Pn
});
Hr({
  circular: !0,
  createInternalComparator: () => Pn,
  strict: !0
});
function Hr(e = {}) {
  const { circular: t = !1, createInternalComparator: r, createState: n, strict: o = !1 } = e, a = dK(e), i = fK(a), s = r ? r(i) : pK(i);
  return hK({ circular: t, comparator: i, createState: n, equals: s, strict: o });
}
function mK(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function e_(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, n = function o(a) {
    r < 0 && (r = a), a - r > t ? (e(a), r = -1) : mK(o);
  };
  requestAnimationFrame(n);
}
function mv(e) {
  "@babel/helpers - typeof";
  return mv = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, mv(e);
}
function gK(e) {
  return xK(e) || wK(e) || bK(e) || yK();
}
function yK() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bK(e, t) {
  if (e) {
    if (typeof e == "string") return t_(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return t_(e, t);
  }
}
function t_(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function wK(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function xK(e) {
  if (Array.isArray(e)) return e;
}
function SK() {
  var e = {}, t = function() {
    return null;
  }, r = !1, n = function o(a) {
    if (!r) {
      if (Array.isArray(a)) {
        if (!a.length)
          return;
        var i = a, s = gK(i), c = s[0], l = s.slice(1);
        if (typeof c == "number") {
          e_(o.bind(null, l), c);
          return;
        }
        o(c), e_(o.bind(null, l));
        return;
      }
      mv(a) === "object" && (e = a, t(e)), typeof a == "function" && a();
    }
  };
  return {
    stop: function() {
      r = !0;
    },
    start: function(a) {
      r = !1, n(a);
    },
    subscribe: function(a) {
      return t = a, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function Ha(e) {
  "@babel/helpers - typeof";
  return Ha = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ha(e);
}
function r_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function n_(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? r_(Object(r), !0).forEach(function(n) {
      OM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : r_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function OM(e, t, r) {
  return t = _K(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _K(e) {
  var t = OK(e, "string");
  return Ha(t) === "symbol" ? t : String(t);
}
function OK(e, t) {
  if (Ha(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ha(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var AK = function(t, r) {
  return [Object.keys(t), Object.keys(r)].reduce(function(n, o) {
    return n.filter(function(a) {
      return o.includes(a);
    });
  });
}, PK = function(t) {
  return t;
}, EK = function(t) {
  return t.replace(/([A-Z])/g, function(r) {
    return "-".concat(r.toLowerCase());
  });
}, pa = function(t, r) {
  return Object.keys(r).reduce(function(n, o) {
    return n_(n_({}, n), {}, OM({}, o, t(o, r[o])));
  }, {});
}, o_ = function(t, r, n) {
  return t.map(function(o) {
    return "".concat(EK(o), " ").concat(r, "ms ").concat(n);
  }).join(",");
}, TK = process.env.NODE_ENV !== "production", Vs = function(t, r, n, o, a, i, s, c) {
  if (TK && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var l = [n, o, a, i, s, c], f = 0;
      console.warn(r.replace(/%s/g, function() {
        return l[f++];
      }));
    }
};
function CK(e, t) {
  return IK(e) || MK(e, t) || AM(e, t) || RK();
}
function RK() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function MK(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, o, a, i, s = [], c = !0, l = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, o = f;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw o;
      }
    }
    return s;
  }
}
function IK(e) {
  if (Array.isArray(e)) return e;
}
function NK(e) {
  return DK(e) || $K(e) || AM(e) || kK();
}
function kK() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function AM(e, t) {
  if (e) {
    if (typeof e == "string") return gv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return gv(e, t);
  }
}
function $K(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function DK(e) {
  if (Array.isArray(e)) return gv(e);
}
function gv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var Ks = 1e-4, PM = function(t, r) {
  return [0, 3 * t, 3 * r - 6 * t, 3 * t - 3 * r + 1];
}, EM = function(t, r) {
  return t.map(function(n, o) {
    return n * Math.pow(r, o);
  }).reduce(function(n, o) {
    return n + o;
  });
}, a_ = function(t, r) {
  return function(n) {
    var o = PM(t, r);
    return EM(o, n);
  };
}, jK = function(t, r) {
  return function(n) {
    var o = PM(t, r), a = [].concat(NK(o.map(function(i, s) {
      return i * s;
    }).slice(1)), [0]);
    return EM(a, n);
  };
}, i_ = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var o = r[0], a = r[1], i = r[2], s = r[3];
  if (r.length === 1)
    switch (r[0]) {
      case "linear":
        o = 0, a = 0, i = 1, s = 1;
        break;
      case "ease":
        o = 0.25, a = 0.1, i = 0.25, s = 1;
        break;
      case "ease-in":
        o = 0.42, a = 0, i = 1, s = 1;
        break;
      case "ease-out":
        o = 0.42, a = 0, i = 0.58, s = 1;
        break;
      case "ease-in-out":
        o = 0, a = 0, i = 0.58, s = 1;
        break;
      default: {
        var c = r[0].split("(");
        if (c[0] === "cubic-bezier" && c[1].split(")")[0].split(",").length === 4) {
          var l = c[1].split(")")[0].split(",").map(function(p) {
            return parseFloat(p);
          }), f = CK(l, 4);
          o = f[0], a = f[1], i = f[2], s = f[3];
        } else
          Vs(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
      }
    }
  Vs([o, i, a, s].every(function(p) {
    return typeof p == "number" && p >= 0 && p <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
  var u = a_(o, i), d = a_(a, s), h = jK(o, i), m = function(b) {
    return b > 1 ? 1 : b < 0 ? 0 : b;
  }, v = function(b) {
    for (var w = b > 1 ? 1 : b, x = w, _ = 0; _ < 8; ++_) {
      var y = u(x) - w, O = h(x);
      if (Math.abs(y - w) < Ks || O < Ks)
        return d(x);
      x = m(x - y / O);
    }
    return d(x);
  };
  return v.isStepper = !1, v;
}, LK = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.stiff, n = r === void 0 ? 100 : r, o = t.damping, a = o === void 0 ? 8 : o, i = t.dt, s = i === void 0 ? 17 : i, c = function(f, u, d) {
    var h = -(f - u) * n, m = d * a, v = d + (h - m) * s / 1e3, p = d * s / 1e3 + f;
    return Math.abs(p - u) < Ks && Math.abs(v) < Ks ? [u, 0] : [p, v];
  };
  return c.isStepper = !0, c.dt = s, c;
}, BK = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var o = r[0];
  if (typeof o == "string")
    switch (o) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return i_(o);
      case "spring":
        return LK();
      default:
        if (o.split("(")[0] === "cubic-bezier")
          return i_(o);
        Vs(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
    }
  return typeof o == "function" ? o : (Vs(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
};
function Va(e) {
  "@babel/helpers - typeof";
  return Va = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Va(e);
}
function s_(e) {
  return zK(e) || qK(e) || TM(e) || FK();
}
function FK() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qK(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function zK(e) {
  if (Array.isArray(e)) return bv(e);
}
function c_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ze(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? c_(Object(r), !0).forEach(function(n) {
      yv(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function yv(e, t, r) {
  return t = WK(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function WK(e) {
  var t = UK(e, "string");
  return Va(t) === "symbol" ? t : String(t);
}
function UK(e, t) {
  if (Va(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Va(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function HK(e, t) {
  return GK(e) || KK(e, t) || TM(e, t) || VK();
}
function VK() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function TM(e, t) {
  if (e) {
    if (typeof e == "string") return bv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return bv(e, t);
  }
}
function bv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function KK(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, o, a, i, s = [], c = !0, l = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, o = f;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw o;
      }
    }
    return s;
  }
}
function GK(e) {
  if (Array.isArray(e)) return e;
}
var Gs = function(t, r, n) {
  return t + (r - t) * n;
}, wv = function(t) {
  var r = t.from, n = t.to;
  return r !== n;
}, YK = function e(t, r, n) {
  var o = pa(function(a, i) {
    if (wv(i)) {
      var s = t(i.from, i.to, i.velocity), c = HK(s, 2), l = c[0], f = c[1];
      return Ze(Ze({}, i), {}, {
        from: l,
        velocity: f
      });
    }
    return i;
  }, r);
  return n < 1 ? pa(function(a, i) {
    return wv(i) ? Ze(Ze({}, i), {}, {
      velocity: Gs(i.velocity, o[a].velocity, n),
      from: Gs(i.from, o[a].from, n)
    }) : i;
  }, r) : e(t, o, n - 1);
};
const XK = (function(e, t, r, n, o) {
  var a = AK(e, t), i = a.reduce(function(p, b) {
    return Ze(Ze({}, p), {}, yv({}, b, [e[b], t[b]]));
  }, {}), s = a.reduce(function(p, b) {
    return Ze(Ze({}, p), {}, yv({}, b, {
      from: e[b],
      velocity: 0,
      to: t[b]
    }));
  }, {}), c = -1, l, f, u = function() {
    return null;
  }, d = function() {
    return pa(function(b, w) {
      return w.from;
    }, s);
  }, h = function() {
    return !Object.values(s).filter(wv).length;
  }, m = function(b) {
    l || (l = b);
    var w = b - l, x = w / r.dt;
    s = YK(r, s, x), o(Ze(Ze(Ze({}, e), t), d())), l = b, h() || (c = requestAnimationFrame(u));
  }, v = function(b) {
    f || (f = b);
    var w = (b - f) / n, x = pa(function(y, O) {
      return Gs.apply(void 0, s_(O).concat([r(w)]));
    }, i);
    if (o(Ze(Ze(Ze({}, e), t), x)), w < 1)
      c = requestAnimationFrame(u);
    else {
      var _ = pa(function(y, O) {
        return Gs.apply(void 0, s_(O).concat([r(1)]));
      }, i);
      o(Ze(Ze(Ze({}, e), t), _));
    }
  };
  return u = r.isStepper ? m : v, function() {
    return requestAnimationFrame(u), function() {
      cancelAnimationFrame(c);
    };
  };
});
function uo(e) {
  "@babel/helpers - typeof";
  return uo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, uo(e);
}
var ZK = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function JK(e, t) {
  if (e == null) return {};
  var r = QK(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function QK(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), o, a;
  for (a = 0; a < n.length; a++)
    o = n[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function Ip(e) {
  return nG(e) || rG(e) || tG(e) || eG();
}
function eG() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tG(e, t) {
  if (e) {
    if (typeof e == "string") return xv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return xv(e, t);
  }
}
function rG(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function nG(e) {
  if (Array.isArray(e)) return xv(e);
}
function xv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function l_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Mt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? l_(Object(r), !0).forEach(function(n) {
      la(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function la(e, t, r) {
  return t = CM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function oG(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function aG(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, CM(n.key), n);
  }
}
function iG(e, t, r) {
  return t && aG(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function CM(e) {
  var t = sG(e, "string");
  return uo(t) === "symbol" ? t : String(t);
}
function sG(e, t) {
  if (uo(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (uo(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function cG(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Sv(e, t);
}
function Sv(e, t) {
  return Sv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Sv(e, t);
}
function lG(e) {
  var t = uG();
  return function() {
    var n = Ys(e), o;
    if (t) {
      var a = Ys(this).constructor;
      o = Reflect.construct(n, arguments, a);
    } else
      o = n.apply(this, arguments);
    return _v(this, o);
  };
}
function _v(e, t) {
  if (t && (uo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ov(e);
}
function Ov(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function uG() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ys(e) {
  return Ys = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ys(e);
}
var er = /* @__PURE__ */ (function(e) {
  cG(r, e);
  var t = lG(r);
  function r(n, o) {
    var a;
    oG(this, r), a = t.call(this, n, o);
    var i = a.props, s = i.isActive, c = i.attributeName, l = i.from, f = i.to, u = i.steps, d = i.children, h = i.duration;
    if (a.handleStyleChange = a.handleStyleChange.bind(Ov(a)), a.changeStyle = a.changeStyle.bind(Ov(a)), !s || h <= 0)
      return a.state = {
        style: {}
      }, typeof d == "function" && (a.state = {
        style: f
      }), _v(a);
    if (u && u.length)
      a.state = {
        style: u[0].style
      };
    else if (l) {
      if (typeof d == "function")
        return a.state = {
          style: l
        }, _v(a);
      a.state = {
        style: c ? la({}, c, l) : l
      };
    } else
      a.state = {
        style: {}
      };
    return a;
  }
  return iG(r, [{
    key: "componentDidMount",
    value: function() {
      var o = this.props, a = o.isActive, i = o.canBegin;
      this.mounted = !0, !(!a || !i) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(o) {
      var a = this.props, i = a.isActive, s = a.canBegin, c = a.attributeName, l = a.shouldReAnimate, f = a.to, u = a.from, d = this.state.style;
      if (s) {
        if (!i) {
          var h = {
            style: c ? la({}, c, f) : f
          };
          this.state && d && (c && d[c] !== f || !c && d !== f) && this.setState(h);
          return;
        }
        if (!(vK(o.to, f) && o.canBegin && o.isActive)) {
          var m = !o.canBegin || !o.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var v = m || l ? u : o.to;
          if (this.state && d) {
            var p = {
              style: c ? la({}, c, v) : v
            };
            (c && d[c] !== v || !c && d !== v) && this.setState(p);
          }
          this.runAnimation(Mt(Mt({}, this.props), {}, {
            from: v,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var o = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), o && o();
    }
  }, {
    key: "handleStyleChange",
    value: function(o) {
      this.changeStyle(o);
    }
  }, {
    key: "changeStyle",
    value: function(o) {
      this.mounted && this.setState({
        style: o
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(o) {
      var a = this, i = o.from, s = o.to, c = o.duration, l = o.easing, f = o.begin, u = o.onAnimationEnd, d = o.onAnimationStart, h = XK(i, s, BK(l), c, this.changeStyle), m = function() {
        a.stopJSAnimation = h();
      };
      this.manager.start([d, f, m, c, u]);
    }
  }, {
    key: "runStepAnimation",
    value: function(o) {
      var a = this, i = o.steps, s = o.begin, c = o.onAnimationStart, l = i[0], f = l.style, u = l.duration, d = u === void 0 ? 0 : u, h = function(v, p, b) {
        if (b === 0)
          return v;
        var w = p.duration, x = p.easing, _ = x === void 0 ? "ease" : x, y = p.style, O = p.properties, A = p.onAnimationEnd, P = b > 0 ? i[b - 1] : p, T = O || Object.keys(y);
        if (typeof _ == "function" || _ === "spring")
          return [].concat(Ip(v), [a.runJSAnimation.bind(a, {
            from: P.style,
            to: y,
            duration: w,
            easing: _
          }), w]);
        var I = o_(T, w, _), E = Mt(Mt(Mt({}, P.style), y), {}, {
          transition: I
        });
        return [].concat(Ip(v), [E, w, A]).filter(PK);
      };
      return this.manager.start([c].concat(Ip(i.reduce(h, [f, Math.max(d, s)])), [o.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(o) {
      this.manager || (this.manager = SK());
      var a = o.begin, i = o.duration, s = o.attributeName, c = o.to, l = o.easing, f = o.onAnimationStart, u = o.onAnimationEnd, d = o.steps, h = o.children, m = this.manager;
      if (this.unSubscribe = m.subscribe(this.handleStyleChange), typeof l == "function" || typeof h == "function" || l === "spring") {
        this.runJSAnimation(o);
        return;
      }
      if (d.length > 1) {
        this.runStepAnimation(o);
        return;
      }
      var v = s ? la({}, s, c) : c, p = o_(Object.keys(v), i, l);
      m.start([f, a, Mt(Mt({}, v), {}, {
        transition: p
      }), i, u]);
    }
  }, {
    key: "render",
    value: function() {
      var o = this.props, a = o.children;
      o.begin;
      var i = o.duration;
      o.attributeName, o.easing;
      var s = o.isActive;
      o.steps, o.from, o.to, o.canBegin, o.onAnimationEnd, o.shouldReAnimate, o.onAnimationReStart;
      var c = JK(o, ZK), l = on.count(a), f = this.state.style;
      if (typeof a == "function")
        return a(f);
      if (!s || l === 0 || i <= 0)
        return a;
      var u = function(h) {
        var m = h.props, v = m.style, p = v === void 0 ? {} : v, b = m.className, w = /* @__PURE__ */ qe(h, Mt(Mt({}, c), {}, {
          style: Mt(Mt({}, p), f),
          className: b
        }));
        return w;
      };
      return l === 1 ? u(on.only(a)) : /* @__PURE__ */ k.createElement("div", null, on.map(a, function(d) {
        return u(d);
      }));
    }
  }]), r;
})(Ft);
er.displayName = "Animate";
er.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
er.propTypes = {
  from: Se.oneOfType([Se.object, Se.string]),
  to: Se.oneOfType([Se.object, Se.string]),
  attributeName: Se.string,
  // animation duration
  duration: Se.number,
  begin: Se.number,
  easing: Se.oneOfType([Se.string, Se.func]),
  steps: Se.arrayOf(Se.shape({
    duration: Se.number.isRequired,
    style: Se.object.isRequired,
    easing: Se.oneOfType([Se.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), Se.func]),
    // transition css properties(dash case), optional
    properties: Se.arrayOf("string"),
    onAnimationEnd: Se.func
  })),
  children: Se.oneOfType([Se.node, Se.func]),
  isActive: Se.bool,
  canBegin: Se.bool,
  onAnimationEnd: Se.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: Se.bool,
  onAnimationStart: Se.func,
  onAnimationReStart: Se.func
};
function Ka(e) {
  "@babel/helpers - typeof";
  return Ka = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ka(e);
}
function Xs() {
  return Xs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xs.apply(this, arguments);
}
function fG(e, t) {
  return vG(e) || hG(e, t) || pG(e, t) || dG();
}
function dG() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pG(e, t) {
  if (e) {
    if (typeof e == "string") return u_(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return u_(e, t);
  }
}
function u_(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function hG(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, o, a, i, s = [], c = !0, l = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, o = f;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw o;
      }
    }
    return s;
  }
}
function vG(e) {
  if (Array.isArray(e)) return e;
}
function f_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function d_(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? f_(Object(r), !0).forEach(function(n) {
      mG(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function mG(e, t, r) {
  return t = gG(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function gG(e) {
  var t = yG(e, "string");
  return Ka(t) == "symbol" ? t : t + "";
}
function yG(e, t) {
  if (Ka(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ka(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var p_ = function(t, r, n, o, a) {
  var i = Math.min(Math.abs(n) / 2, Math.abs(o) / 2), s = o >= 0 ? 1 : -1, c = n >= 0 ? 1 : -1, l = o >= 0 && n >= 0 || o < 0 && n < 0 ? 1 : 0, f;
  if (i > 0 && a instanceof Array) {
    for (var u = [0, 0, 0, 0], d = 0, h = 4; d < h; d++)
      u[d] = a[d] > i ? i : a[d];
    f = "M".concat(t, ",").concat(r + s * u[0]), u[0] > 0 && (f += "A ".concat(u[0], ",").concat(u[0], ",0,0,").concat(l, ",").concat(t + c * u[0], ",").concat(r)), f += "L ".concat(t + n - c * u[1], ",").concat(r), u[1] > 0 && (f += "A ".concat(u[1], ",").concat(u[1], ",0,0,").concat(l, `,
        `).concat(t + n, ",").concat(r + s * u[1])), f += "L ".concat(t + n, ",").concat(r + o - s * u[2]), u[2] > 0 && (f += "A ".concat(u[2], ",").concat(u[2], ",0,0,").concat(l, `,
        `).concat(t + n - c * u[2], ",").concat(r + o)), f += "L ".concat(t + c * u[3], ",").concat(r + o), u[3] > 0 && (f += "A ".concat(u[3], ",").concat(u[3], ",0,0,").concat(l, `,
        `).concat(t, ",").concat(r + o - s * u[3])), f += "Z";
  } else if (i > 0 && a === +a && a > 0) {
    var m = Math.min(i, a);
    f = "M ".concat(t, ",").concat(r + s * m, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(l, ",").concat(t + c * m, ",").concat(r, `
            L `).concat(t + n - c * m, ",").concat(r, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(l, ",").concat(t + n, ",").concat(r + s * m, `
            L `).concat(t + n, ",").concat(r + o - s * m, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(l, ",").concat(t + n - c * m, ",").concat(r + o, `
            L `).concat(t + c * m, ",").concat(r + o, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(l, ",").concat(t, ",").concat(r + o - s * m, " Z");
  } else
    f = "M ".concat(t, ",").concat(r, " h ").concat(n, " v ").concat(o, " h ").concat(-n, " Z");
  return f;
}, bG = function(t, r) {
  if (!t || !r)
    return !1;
  var n = t.x, o = t.y, a = r.x, i = r.y, s = r.width, c = r.height;
  if (Math.abs(s) > 0 && Math.abs(c) > 0) {
    var l = Math.min(a, a + s), f = Math.max(a, a + s), u = Math.min(i, i + c), d = Math.max(i, i + c);
    return n >= l && n <= f && o >= u && o <= d;
  }
  return !1;
}, wG = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, jg = function(t) {
  var r = d_(d_({}, wG), t), n = Xn(), o = Je(-1), a = fG(o, 2), i = a[0], s = a[1];
  mt(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var _ = n.current.getTotalLength();
        _ && s(_);
      } catch {
      }
  }, []);
  var c = r.x, l = r.y, f = r.width, u = r.height, d = r.radius, h = r.className, m = r.animationEasing, v = r.animationDuration, p = r.animationBegin, b = r.isAnimationActive, w = r.isUpdateAnimationActive;
  if (c !== +c || l !== +l || f !== +f || u !== +u || f === 0 || u === 0)
    return null;
  var x = de("recharts-rectangle", h);
  return w ? /* @__PURE__ */ k.createElement(er, {
    canBegin: i > 0,
    from: {
      width: f,
      height: u,
      x: c,
      y: l
    },
    to: {
      width: f,
      height: u,
      x: c,
      y: l
    },
    duration: v,
    animationEasing: m,
    isActive: w
  }, function(_) {
    var y = _.width, O = _.height, A = _.x, P = _.y;
    return /* @__PURE__ */ k.createElement(er, {
      canBegin: i > 0,
      from: "0px ".concat(i === -1 ? 1 : i, "px"),
      to: "".concat(i, "px 0px"),
      attributeName: "strokeDasharray",
      begin: p,
      duration: v,
      isActive: b,
      easing: m
    }, /* @__PURE__ */ k.createElement("path", Xs({}, ie(r, !0), {
      className: x,
      d: p_(A, P, y, O, d),
      ref: n
    })));
  }) : /* @__PURE__ */ k.createElement("path", Xs({}, ie(r, !0), {
    className: x,
    d: p_(c, l, f, u, d)
  }));
}, xG = ["points", "className", "baseLinePoints", "connectNulls"];
function Ln() {
  return Ln = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ln.apply(this, arguments);
}
function SG(e, t) {
  if (e == null) return {};
  var r = _G(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function _G(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function h_(e) {
  return EG(e) || PG(e) || AG(e) || OG();
}
function OG() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function AG(e, t) {
  if (e) {
    if (typeof e == "string") return Av(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Av(e, t);
  }
}
function PG(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function EG(e) {
  if (Array.isArray(e)) return Av(e);
}
function Av(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var v_ = function(t) {
  return t && t.x === +t.x && t.y === +t.y;
}, TG = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = [[]];
  return t.forEach(function(n) {
    v_(n) ? r[r.length - 1].push(n) : r[r.length - 1].length > 0 && r.push([]);
  }), v_(t[0]) && r[r.length - 1].push(t[0]), r[r.length - 1].length <= 0 && (r = r.slice(0, -1)), r;
}, ha = function(t, r) {
  var n = TG(t);
  r && (n = [n.reduce(function(a, i) {
    return [].concat(h_(a), h_(i));
  }, [])]);
  var o = n.map(function(a) {
    return a.reduce(function(i, s, c) {
      return "".concat(i).concat(c === 0 ? "M" : "L").concat(s.x, ",").concat(s.y);
    }, "");
  }).join("");
  return n.length === 1 ? "".concat(o, "Z") : o;
}, CG = function(t, r, n) {
  var o = ha(t, n);
  return "".concat(o.slice(-1) === "Z" ? o.slice(0, -1) : o, "L").concat(ha(r.reverse(), n).slice(1));
}, RG = function(t) {
  var r = t.points, n = t.className, o = t.baseLinePoints, a = t.connectNulls, i = SG(t, xG);
  if (!r || !r.length)
    return null;
  var s = de("recharts-polygon", n);
  if (o && o.length) {
    var c = i.stroke && i.stroke !== "none", l = CG(r, o, a);
    return /* @__PURE__ */ k.createElement("g", {
      className: s
    }, /* @__PURE__ */ k.createElement("path", Ln({}, ie(i, !0), {
      fill: l.slice(-1) === "Z" ? i.fill : "none",
      stroke: "none",
      d: l
    })), c ? /* @__PURE__ */ k.createElement("path", Ln({}, ie(i, !0), {
      fill: "none",
      d: ha(r, a)
    })) : null, c ? /* @__PURE__ */ k.createElement("path", Ln({}, ie(i, !0), {
      fill: "none",
      d: ha(o, a)
    })) : null);
  }
  var f = ha(r, a);
  return /* @__PURE__ */ k.createElement("path", Ln({}, ie(i, !0), {
    fill: f.slice(-1) === "Z" ? i.fill : "none",
    className: s,
    d: f
  }));
};
function Pv() {
  return Pv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pv.apply(this, arguments);
}
var gl = function(t) {
  var r = t.cx, n = t.cy, o = t.r, a = t.className, i = de("recharts-dot", a);
  return r === +r && n === +n && o === +o ? /* @__PURE__ */ g.createElement("circle", Pv({}, ie(t, !1), gs(t), {
    className: i,
    cx: r,
    cy: n,
    r: o
  })) : null;
};
function Ga(e) {
  "@babel/helpers - typeof";
  return Ga = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ga(e);
}
var MG = ["x", "y", "top", "left", "width", "height", "className"];
function Ev() {
  return Ev = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ev.apply(this, arguments);
}
function m_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function IG(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? m_(Object(r), !0).forEach(function(n) {
      NG(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : m_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function NG(e, t, r) {
  return t = kG(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kG(e) {
  var t = $G(e, "string");
  return Ga(t) == "symbol" ? t : t + "";
}
function $G(e, t) {
  if (Ga(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ga(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function DG(e, t) {
  if (e == null) return {};
  var r = jG(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function jG(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var LG = function(t, r, n, o, a, i) {
  return "M".concat(t, ",").concat(a, "v").concat(o, "M").concat(i, ",").concat(r, "h").concat(n);
}, BG = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, o = t.y, a = o === void 0 ? 0 : o, i = t.top, s = i === void 0 ? 0 : i, c = t.left, l = c === void 0 ? 0 : c, f = t.width, u = f === void 0 ? 0 : f, d = t.height, h = d === void 0 ? 0 : d, m = t.className, v = DG(t, MG), p = IG({
    x: n,
    y: a,
    top: s,
    left: l,
    width: u,
    height: h
  }, v);
  return !ne(n) || !ne(a) || !ne(u) || !ne(h) || !ne(s) || !ne(l) ? null : /* @__PURE__ */ k.createElement("path", Ev({}, ie(p, !0), {
    className: de("recharts-cross", m),
    d: LG(n, a, u, h, s, l)
  }));
}, Np, g_;
function FG() {
  if (g_) return Np;
  g_ = 1;
  var e = dl(), t = WR(), r = or();
  function n(o, a) {
    return o && o.length ? e(o, r(a, 2), t) : void 0;
  }
  return Np = n, Np;
}
var qG = FG();
const zG = /* @__PURE__ */ Ae(qG);
var kp, y_;
function WG() {
  if (y_) return kp;
  y_ = 1;
  var e = dl(), t = or(), r = UR();
  function n(o, a) {
    return o && o.length ? e(o, t(a, 2), r) : void 0;
  }
  return kp = n, kp;
}
var UG = WG();
const HG = /* @__PURE__ */ Ae(UG);
var VG = ["cx", "cy", "angle", "ticks", "axisLine"], KG = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function fo(e) {
  "@babel/helpers - typeof";
  return fo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fo(e);
}
function va() {
  return va = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, va.apply(this, arguments);
}
function b_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Yr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? b_(Object(r), !0).forEach(function(n) {
      yl(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : b_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function w_(e, t) {
  if (e == null) return {};
  var r = GG(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function GG(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function YG(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function x_(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, MM(n.key), n);
  }
}
function XG(e, t, r) {
  return t && x_(e.prototype, t), r && x_(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ZG(e, t, r) {
  return t = Zs(t), JG(e, RM() ? Reflect.construct(t, r || [], Zs(e).constructor) : t.apply(e, r));
}
function JG(e, t) {
  if (t && (fo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return QG(e);
}
function QG(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function RM() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (RM = function() {
    return !!e;
  })();
}
function Zs(e) {
  return Zs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Zs(e);
}
function e9(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Tv(e, t);
}
function Tv(e, t) {
  return Tv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Tv(e, t);
}
function yl(e, t, r) {
  return t = MM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function MM(e) {
  var t = t9(e, "string");
  return fo(t) == "symbol" ? t : t + "";
}
function t9(e, t) {
  if (fo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (fo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var bl = /* @__PURE__ */ (function(e) {
  function t() {
    return YG(this, t), ZG(this, t, arguments);
  }
  return e9(t, e), XG(t, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(n) {
        var o = n.coordinate, a = this.props, i = a.angle, s = a.cx, c = a.cy;
        return Te(s, c, o, i);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props.orientation, o;
      switch (n) {
        case "left":
          o = "end";
          break;
        case "right":
          o = "start";
          break;
        default:
          o = "middle";
          break;
      }
      return o;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var n = this.props, o = n.cx, a = n.cy, i = n.angle, s = n.ticks, c = zG(s, function(f) {
        return f.coordinate || 0;
      }), l = HG(s, function(f) {
        return f.coordinate || 0;
      });
      return {
        cx: o,
        cy: a,
        startAngle: i,
        endAngle: i,
        innerRadius: l.coordinate || 0,
        outerRadius: c.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, o = n.cx, a = n.cy, i = n.angle, s = n.ticks, c = n.axisLine, l = w_(n, VG), f = s.reduce(function(m, v) {
        return [Math.min(m[0], v.coordinate), Math.max(m[1], v.coordinate)];
      }, [1 / 0, -1 / 0]), u = Te(o, a, f[0], i), d = Te(o, a, f[1], i), h = Yr(Yr(Yr({}, ie(l, !1)), {}, {
        fill: "none"
      }, ie(c, !1)), {}, {
        x1: u.x,
        y1: u.y,
        x2: d.x,
        y2: d.y
      });
      return /* @__PURE__ */ k.createElement("line", va({
        className: "recharts-polar-radius-axis-line"
      }, h));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, o = this.props, a = o.ticks, i = o.tick, s = o.angle, c = o.tickFormatter, l = o.stroke, f = w_(o, KG), u = this.getTickTextAnchor(), d = ie(f, !1), h = ie(i, !1), m = a.map(function(v, p) {
        var b = n.getTickValueCoord(v), w = Yr(Yr(Yr(Yr({
          textAnchor: u,
          transform: "rotate(".concat(90 - s, ", ").concat(b.x, ", ").concat(b.y, ")")
        }, d), {}, {
          stroke: "none",
          fill: l
        }, h), {}, {
          index: p
        }, b), {}, {
          payload: v
        });
        return /* @__PURE__ */ k.createElement(ve, va({
          className: de("recharts-polar-radius-axis-tick", gM(i)),
          key: "tick-".concat(v.coordinate)
        }, mn(n.props, v, p)), t.renderTickItem(i, w, c ? c(v.value, p) : v.value));
      });
      return /* @__PURE__ */ k.createElement(ve, {
        className: "recharts-polar-radius-axis-ticks"
      }, m);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, o = n.ticks, a = n.axisLine, i = n.tick;
      return !o || !o.length ? null : /* @__PURE__ */ k.createElement(ve, {
        className: de("recharts-polar-radius-axis", this.props.className)
      }, a && this.renderAxisLine(), i && this.renderTicks(), Ke.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, o, a) {
      var i;
      return /* @__PURE__ */ k.isValidElement(n) ? i = /* @__PURE__ */ k.cloneElement(n, o) : ue(n) ? i = n(o) : i = /* @__PURE__ */ k.createElement(gn, va({}, o, {
        className: "recharts-polar-radius-axis-tick-value"
      }), a), i;
    }
  }]);
})(Ft);
yl(bl, "displayName", "PolarRadiusAxis");
yl(bl, "axisType", "radiusAxis");
yl(bl, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function po(e) {
  "@babel/helpers - typeof";
  return po = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, po(e);
}
function Qr() {
  return Qr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qr.apply(this, arguments);
}
function S_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Xr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? S_(Object(r), !0).forEach(function(n) {
      wl(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : S_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function r9(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function __(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, NM(n.key), n);
  }
}
function n9(e, t, r) {
  return t && __(e.prototype, t), r && __(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function o9(e, t, r) {
  return t = Js(t), a9(e, IM() ? Reflect.construct(t, r || [], Js(e).constructor) : t.apply(e, r));
}
function a9(e, t) {
  if (t && (po(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return i9(e);
}
function i9(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function IM() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (IM = function() {
    return !!e;
  })();
}
function Js(e) {
  return Js = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Js(e);
}
function s9(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Cv(e, t);
}
function Cv(e, t) {
  return Cv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Cv(e, t);
}
function wl(e, t, r) {
  return t = NM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function NM(e) {
  var t = c9(e, "string");
  return po(t) == "symbol" ? t : t + "";
}
function c9(e, t) {
  if (po(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (po(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var l9 = Math.PI / 180, O_ = 1e-5, xl = /* @__PURE__ */ (function(e) {
  function t() {
    return r9(this, t), o9(this, t, arguments);
  }
  return s9(t, e), n9(t, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(n) {
        var o = this.props, a = o.cx, i = o.cy, s = o.radius, c = o.orientation, l = o.tickSize, f = l || 8, u = Te(a, i, s, n.coordinate), d = Te(a, i, s + (c === "inner" ? -1 : 1) * f, n.coordinate);
        return {
          x1: u.x,
          y1: u.y,
          x2: d.x,
          y2: d.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(n) {
      var o = this.props.orientation, a = Math.cos(-n.coordinate * l9), i;
      return a > O_ ? i = o === "outer" ? "start" : "end" : a < -O_ ? i = o === "outer" ? "end" : "start" : i = "middle", i;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, o = n.cx, a = n.cy, i = n.radius, s = n.axisLine, c = n.axisLineType, l = Xr(Xr({}, ie(this.props, !1)), {}, {
        fill: "none"
      }, ie(s, !1));
      if (c === "circle")
        return /* @__PURE__ */ k.createElement(gl, Qr({
          className: "recharts-polar-angle-axis-line"
        }, l, {
          cx: o,
          cy: a,
          r: i
        }));
      var f = this.props.ticks, u = f.map(function(d) {
        return Te(o, a, i, d.coordinate);
      });
      return /* @__PURE__ */ k.createElement(RG, Qr({
        className: "recharts-polar-angle-axis-line"
      }, l, {
        points: u
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, o = this.props, a = o.ticks, i = o.tick, s = o.tickLine, c = o.tickFormatter, l = o.stroke, f = ie(this.props, !1), u = ie(i, !1), d = Xr(Xr({}, f), {}, {
        fill: "none"
      }, ie(s, !1)), h = a.map(function(m, v) {
        var p = n.getTickLineCoord(m), b = n.getTickTextAnchor(m), w = Xr(Xr(Xr({
          textAnchor: b
        }, f), {}, {
          stroke: "none",
          fill: l
        }, u), {}, {
          index: v,
          payload: m,
          x: p.x2,
          y: p.y2
        });
        return /* @__PURE__ */ k.createElement(ve, Qr({
          className: de("recharts-polar-angle-axis-tick", gM(i)),
          key: "tick-".concat(m.coordinate)
        }, mn(n.props, m, v)), s && /* @__PURE__ */ k.createElement("line", Qr({
          className: "recharts-polar-angle-axis-tick-line"
        }, d, p)), i && t.renderTickItem(i, w, c ? c(m.value, v) : m.value));
      });
      return /* @__PURE__ */ k.createElement(ve, {
        className: "recharts-polar-angle-axis-ticks"
      }, h);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, o = n.ticks, a = n.radius, i = n.axisLine;
      return a <= 0 || !o || !o.length ? null : /* @__PURE__ */ k.createElement(ve, {
        className: de("recharts-polar-angle-axis", this.props.className)
      }, i && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(n, o, a) {
      var i;
      return /* @__PURE__ */ k.isValidElement(n) ? i = /* @__PURE__ */ k.cloneElement(n, o) : ue(n) ? i = n(o) : i = /* @__PURE__ */ k.createElement(gn, Qr({}, o, {
        className: "recharts-polar-angle-axis-tick-value"
      }), a), i;
    }
  }]);
})(Ft);
wl(xl, "displayName", "PolarAngleAxis");
wl(xl, "axisType", "angleAxis");
wl(xl, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var $p, A_;
function u9() {
  if (A_) return $p;
  A_ = 1;
  var e = zC(), t = e(Object.getPrototypeOf, Object);
  return $p = t, $p;
}
var Dp, P_;
function f9() {
  if (P_) return Dp;
  P_ = 1;
  var e = Sr(), t = u9(), r = _r(), n = "[object Object]", o = Function.prototype, a = Object.prototype, i = o.toString, s = a.hasOwnProperty, c = i.call(Object);
  function l(f) {
    if (!r(f) || e(f) != n)
      return !1;
    var u = t(f);
    if (u === null)
      return !0;
    var d = s.call(u, "constructor") && u.constructor;
    return typeof d == "function" && d instanceof d && i.call(d) == c;
  }
  return Dp = l, Dp;
}
var d9 = f9();
const p9 = /* @__PURE__ */ Ae(d9);
var jp, E_;
function h9() {
  if (E_) return jp;
  E_ = 1;
  var e = Sr(), t = _r(), r = "[object Boolean]";
  function n(o) {
    return o === !0 || o === !1 || t(o) && e(o) == r;
  }
  return jp = n, jp;
}
var v9 = h9();
const m9 = /* @__PURE__ */ Ae(v9);
function Ya(e) {
  "@babel/helpers - typeof";
  return Ya = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ya(e);
}
function Qs() {
  return Qs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qs.apply(this, arguments);
}
function g9(e, t) {
  return x9(e) || w9(e, t) || b9(e, t) || y9();
}
function y9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function b9(e, t) {
  if (e) {
    if (typeof e == "string") return T_(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return T_(e, t);
  }
}
function T_(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function w9(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, o, a, i, s = [], c = !0, l = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, o = f;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw o;
      }
    }
    return s;
  }
}
function x9(e) {
  if (Array.isArray(e)) return e;
}
function C_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function R_(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? C_(Object(r), !0).forEach(function(n) {
      S9(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : C_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function S9(e, t, r) {
  return t = _9(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _9(e) {
  var t = O9(e, "string");
  return Ya(t) == "symbol" ? t : t + "";
}
function O9(e, t) {
  if (Ya(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ya(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var M_ = function(t, r, n, o, a) {
  var i = n - o, s;
  return s = "M ".concat(t, ",").concat(r), s += "L ".concat(t + n, ",").concat(r), s += "L ".concat(t + n - i / 2, ",").concat(r + a), s += "L ".concat(t + n - i / 2 - o, ",").concat(r + a), s += "L ".concat(t, ",").concat(r, " Z"), s;
}, A9 = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, P9 = function(t) {
  var r = R_(R_({}, A9), t), n = Xn(), o = Je(-1), a = g9(o, 2), i = a[0], s = a[1];
  mt(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var x = n.current.getTotalLength();
        x && s(x);
      } catch {
      }
  }, []);
  var c = r.x, l = r.y, f = r.upperWidth, u = r.lowerWidth, d = r.height, h = r.className, m = r.animationEasing, v = r.animationDuration, p = r.animationBegin, b = r.isUpdateAnimationActive;
  if (c !== +c || l !== +l || f !== +f || u !== +u || d !== +d || f === 0 && u === 0 || d === 0)
    return null;
  var w = de("recharts-trapezoid", h);
  return b ? /* @__PURE__ */ k.createElement(er, {
    canBegin: i > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: d,
      x: c,
      y: l
    },
    to: {
      upperWidth: f,
      lowerWidth: u,
      height: d,
      x: c,
      y: l
    },
    duration: v,
    animationEasing: m,
    isActive: b
  }, function(x) {
    var _ = x.upperWidth, y = x.lowerWidth, O = x.height, A = x.x, P = x.y;
    return /* @__PURE__ */ k.createElement(er, {
      canBegin: i > 0,
      from: "0px ".concat(i === -1 ? 1 : i, "px"),
      to: "".concat(i, "px 0px"),
      attributeName: "strokeDasharray",
      begin: p,
      duration: v,
      easing: m
    }, /* @__PURE__ */ k.createElement("path", Qs({}, ie(r, !0), {
      className: w,
      d: M_(A, P, _, y, O),
      ref: n
    })));
  }) : /* @__PURE__ */ k.createElement("g", null, /* @__PURE__ */ k.createElement("path", Qs({}, ie(r, !0), {
    className: w,
    d: M_(c, l, f, u, d)
  })));
}, E9 = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function Xa(e) {
  "@babel/helpers - typeof";
  return Xa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xa(e);
}
function T9(e, t) {
  if (e == null) return {};
  var r = C9(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function C9(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function I_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ec(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? I_(Object(r), !0).forEach(function(n) {
      R9(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : I_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function R9(e, t, r) {
  return t = M9(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function M9(e) {
  var t = I9(e, "string");
  return Xa(t) == "symbol" ? t : t + "";
}
function I9(e, t) {
  if (Xa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Xa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function N9(e, t) {
  return ec(ec({}, t), e);
}
function k9(e, t) {
  return e === "symbols";
}
function N_(e) {
  var t = e.shapeType, r = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ k.createElement(jg, r);
    case "trapezoid":
      return /* @__PURE__ */ k.createElement(P9, r);
    case "sector":
      return /* @__PURE__ */ k.createElement(wM, r);
    case "symbols":
      if (k9(t))
        return /* @__PURE__ */ k.createElement(eg, r);
      break;
    default:
      return null;
  }
}
function $9(e) {
  return /* @__PURE__ */ jt(e) ? e.props : e;
}
function kM(e) {
  var t = e.option, r = e.shapeType, n = e.propTransformer, o = n === void 0 ? N9 : n, a = e.activeClassName, i = a === void 0 ? "recharts-active-shape" : a, s = e.isActive, c = T9(e, E9), l;
  if (/* @__PURE__ */ jt(t))
    l = /* @__PURE__ */ qe(t, ec(ec({}, c), $9(t)));
  else if (ue(t))
    l = t(c);
  else if (p9(t) && !m9(t)) {
    var f = o(t, c);
    l = /* @__PURE__ */ k.createElement(N_, {
      shapeType: r,
      elementProps: f
    });
  } else {
    var u = c;
    l = /* @__PURE__ */ k.createElement(N_, {
      shapeType: r,
      elementProps: u
    });
  }
  return s ? /* @__PURE__ */ k.createElement(ve, {
    className: i
  }, l) : l;
}
function Sl(e, t) {
  return t != null && "trapezoids" in e.props;
}
function _l(e, t) {
  return t != null && "sectors" in e.props;
}
function Za(e, t) {
  return t != null && "points" in e.props;
}
function D9(e, t) {
  var r, n, o = e.x === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.x) || e.x === t.x, a = e.y === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.y) || e.y === t.y;
  return o && a;
}
function j9(e, t) {
  var r = e.endAngle === t.endAngle, n = e.startAngle === t.startAngle;
  return r && n;
}
function L9(e, t) {
  var r = e.x === t.x, n = e.y === t.y, o = e.z === t.z;
  return r && n && o;
}
function B9(e, t) {
  var r;
  return Sl(e, t) ? r = D9 : _l(e, t) ? r = j9 : Za(e, t) && (r = L9), r;
}
function F9(e, t) {
  var r;
  return Sl(e, t) ? r = "trapezoids" : _l(e, t) ? r = "sectors" : Za(e, t) && (r = "points"), r;
}
function q9(e, t) {
  if (Sl(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  if (_l(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  return Za(e, t) ? t.payload : {};
}
function z9(e) {
  var t = e.activeTooltipItem, r = e.graphicalItem, n = e.itemData, o = F9(r, t), a = q9(r, t), i = n.filter(function(c, l) {
    var f = Ti(a, c), u = r.props[o].filter(function(m) {
      var v = B9(r, t);
      return v(m, t);
    }), d = r.props[o].indexOf(u[u.length - 1]), h = l === d;
    return f && h;
  }), s = n.indexOf(i[i.length - 1]);
  return s;
}
var os;
function ho(e) {
  "@babel/helpers - typeof";
  return ho = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ho(e);
}
function Bn() {
  return Bn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bn.apply(this, arguments);
}
function k_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Pe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? k_(Object(r), !0).forEach(function(n) {
      _t(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : k_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function W9(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $_(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, DM(n.key), n);
  }
}
function U9(e, t, r) {
  return t && $_(e.prototype, t), r && $_(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function H9(e, t, r) {
  return t = tc(t), V9(e, $M() ? Reflect.construct(t, r || [], tc(e).constructor) : t.apply(e, r));
}
function V9(e, t) {
  if (t && (ho(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return K9(e);
}
function K9(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function $M() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return ($M = function() {
    return !!e;
  })();
}
function tc(e) {
  return tc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, tc(e);
}
function G9(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Rv(e, t);
}
function Rv(e, t) {
  return Rv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Rv(e, t);
}
function _t(e, t, r) {
  return t = DM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function DM(e) {
  var t = Y9(e, "string");
  return ho(t) == "symbol" ? t : t + "";
}
function Y9(e, t) {
  if (ho(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ho(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Vr = /* @__PURE__ */ (function(e) {
  function t(r) {
    var n;
    return W9(this, t), n = H9(this, t, [r]), _t(n, "pieRef", null), _t(n, "sectorRefs", []), _t(n, "id", qo("recharts-pie-")), _t(n, "handleAnimationEnd", function() {
      var o = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), ue(o) && o();
    }), _t(n, "handleAnimationStart", function() {
      var o = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), ue(o) && o();
    }), n.state = {
      isAnimationFinished: !r.isAnimationActive,
      prevIsAnimationActive: r.isAnimationActive,
      prevAnimationId: r.animationId,
      sectorToFocus: 0
    }, n;
  }
  return G9(t, e), U9(t, [{
    key: "isActiveIndex",
    value: function(n) {
      var o = this.props.activeIndex;
      return Array.isArray(o) ? o.indexOf(n) !== -1 : n === o;
    }
  }, {
    key: "hasActiveIndex",
    value: function() {
      var n = this.props.activeIndex;
      return Array.isArray(n) ? n.length !== 0 : n || n === 0;
    }
  }, {
    key: "renderLabels",
    value: function(n) {
      var o = this.props.isAnimationActive;
      if (o && !this.state.isAnimationFinished)
        return null;
      var a = this.props, i = a.label, s = a.labelLine, c = a.dataKey, l = a.valueKey, f = ie(this.props, !1), u = ie(i, !1), d = ie(s, !1), h = i && i.offsetRadius || 20, m = n.map(function(v, p) {
        var b = (v.startAngle + v.endAngle) / 2, w = Te(v.cx, v.cy, v.outerRadius + h, b), x = Pe(Pe(Pe(Pe({}, f), v), {}, {
          stroke: "none"
        }, u), {}, {
          index: p,
          textAnchor: t.getTextAnchor(w.x, v.cx)
        }, w), _ = Pe(Pe(Pe(Pe({}, f), v), {}, {
          fill: "none",
          stroke: v.fill
        }, d), {}, {
          index: p,
          points: [Te(v.cx, v.cy, v.outerRadius, b), w]
        }), y = c;
        return fe(c) && fe(l) ? y = "value" : fe(c) && (y = l), // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ k.createElement(ve, {
          key: "label-".concat(v.startAngle, "-").concat(v.endAngle, "-").concat(v.midAngle, "-").concat(p)
        }, s && t.renderLabelLineItem(s, _, "line"), t.renderLabelItem(i, x, ze(v, y)));
      });
      return /* @__PURE__ */ k.createElement(ve, {
        className: "recharts-pie-labels"
      }, m);
    }
  }, {
    key: "renderSectorsStatically",
    value: function(n) {
      var o = this, a = this.props, i = a.activeShape, s = a.blendStroke, c = a.inactiveShape;
      return n.map(function(l, f) {
        if ((l == null ? void 0 : l.startAngle) === 0 && (l == null ? void 0 : l.endAngle) === 0 && n.length !== 1) return null;
        var u = o.isActiveIndex(f), d = c && o.hasActiveIndex() ? c : null, h = u ? i : d, m = Pe(Pe({}, l), {}, {
          stroke: s ? l.fill : l.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ k.createElement(ve, Bn({
          ref: function(p) {
            p && !o.sectorRefs.includes(p) && o.sectorRefs.push(p);
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, mn(o.props, l, f), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(l == null ? void 0 : l.startAngle, "-").concat(l == null ? void 0 : l.endAngle, "-").concat(l.midAngle, "-").concat(f)
        }), /* @__PURE__ */ k.createElement(kM, Bn({
          option: h,
          isActive: u,
          shapeType: "sector"
        }, m)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function() {
      var n = this, o = this.props, a = o.sectors, i = o.isAnimationActive, s = o.animationBegin, c = o.animationDuration, l = o.animationEasing, f = o.animationId, u = this.state, d = u.prevSectors, h = u.prevIsAnimationActive;
      return /* @__PURE__ */ k.createElement(er, {
        begin: s,
        duration: c,
        isActive: i,
        easing: l,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(f, "-").concat(h),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(m) {
        var v = m.t, p = [], b = a && a[0], w = b.startAngle;
        return a.forEach(function(x, _) {
          var y = d && d[_], O = _ > 0 ? yt(x, "paddingAngle", 0) : 0;
          if (y) {
            var A = ht(y.endAngle - y.startAngle, x.endAngle - x.startAngle), P = Pe(Pe({}, x), {}, {
              startAngle: w + O,
              endAngle: w + A(v) + O
            });
            p.push(P), w = P.endAngle;
          } else {
            var T = x.endAngle, I = x.startAngle, E = ht(0, T - I), C = E(v), R = Pe(Pe({}, x), {}, {
              startAngle: w + O,
              endAngle: w + C + O
            });
            p.push(R), w = R.endAngle;
          }
        }), /* @__PURE__ */ k.createElement(ve, null, n.renderSectorsStatically(p));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function(n) {
      var o = this;
      n.onkeydown = function(a) {
        if (!a.altKey)
          switch (a.key) {
            case "ArrowLeft": {
              var i = ++o.state.sectorToFocus % o.sectorRefs.length;
              o.sectorRefs[i].focus(), o.setState({
                sectorToFocus: i
              });
              break;
            }
            case "ArrowRight": {
              var s = --o.state.sectorToFocus < 0 ? o.sectorRefs.length - 1 : o.state.sectorToFocus % o.sectorRefs.length;
              o.sectorRefs[s].focus(), o.setState({
                sectorToFocus: s
              });
              break;
            }
            case "Escape": {
              o.sectorRefs[o.state.sectorToFocus].blur(), o.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }
  }, {
    key: "renderSectors",
    value: function() {
      var n = this.props, o = n.sectors, a = n.isAnimationActive, i = this.state.prevSectors;
      return a && o && o.length && (!i || !Ti(i, o)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(o);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, o = this.props, a = o.hide, i = o.sectors, s = o.className, c = o.label, l = o.cx, f = o.cy, u = o.innerRadius, d = o.outerRadius, h = o.isAnimationActive, m = this.state.isAnimationFinished;
      if (a || !i || !i.length || !ne(l) || !ne(f) || !ne(u) || !ne(d))
        return null;
      var v = de("recharts-pie", s);
      return /* @__PURE__ */ k.createElement(ve, {
        tabIndex: this.props.rootTabIndex,
        className: v,
        ref: function(b) {
          n.pieRef = b;
        }
      }, this.renderSectors(), c && this.renderLabels(i), Ke.renderCallByParent(this.props, null, !1), (!h || m) && vr.renderCallByParent(this.props, i, !1));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, o) {
      return o.prevIsAnimationActive !== n.isAnimationActive ? {
        prevIsAnimationActive: n.isAnimationActive,
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : n.isAnimationActive && n.animationId !== o.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: o.curSectors,
        isAnimationFinished: !0
      } : n.sectors !== o.curSectors ? {
        curSectors: n.sectors,
        isAnimationFinished: !0
      } : null;
    }
  }, {
    key: "getTextAnchor",
    value: function(n, o) {
      return n > o ? "start" : n < o ? "end" : "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function(n, o, a) {
      if (/* @__PURE__ */ k.isValidElement(n))
        return /* @__PURE__ */ k.cloneElement(n, o);
      if (ue(n))
        return n(o);
      var i = de("recharts-pie-label-line", typeof n != "boolean" ? n.className : "");
      return /* @__PURE__ */ k.createElement(Us, Bn({}, o, {
        key: a,
        type: "linear",
        className: i
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function(n, o, a) {
      if (/* @__PURE__ */ k.isValidElement(n))
        return /* @__PURE__ */ k.cloneElement(n, o);
      var i = a;
      if (ue(n) && (i = n(o), /* @__PURE__ */ k.isValidElement(i)))
        return i;
      var s = de("recharts-pie-label-text", typeof n != "boolean" && !ue(n) ? n.className : "");
      return /* @__PURE__ */ k.createElement(gn, Bn({}, o, {
        alignmentBaseline: "middle",
        className: s
      }), i);
    }
  }]);
})(Ft);
os = Vr;
_t(Vr, "displayName", "Pie");
_t(Vr, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !_n.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1,
  rootTabIndex: 0
});
_t(Vr, "parseDeltaAngle", function(e, t) {
  var r = rt(t - e), n = Math.min(Math.abs(t - e), 360);
  return r * n;
});
_t(Vr, "getRealPieData", function(e) {
  var t = e.data, r = e.children, n = ie(e, !1), o = bt(r, ug);
  return t && t.length ? t.map(function(a, i) {
    return Pe(Pe(Pe({
      payload: a
    }, n), a), o && o[i] && o[i].props);
  }) : o && o.length ? o.map(function(a) {
    return Pe(Pe({}, n), a.props);
  }) : [];
});
_t(Vr, "parseCoordinateOfPie", function(e, t) {
  var r = t.top, n = t.left, o = t.width, a = t.height, i = mM(o, a), s = n + nt(e.cx, o, o / 2), c = r + nt(e.cy, a, a / 2), l = nt(e.innerRadius, i, 0), f = nt(e.outerRadius, i, i * 0.8), u = e.maxRadius || Math.sqrt(o * o + a * a) / 2;
  return {
    cx: s,
    cy: c,
    innerRadius: l,
    outerRadius: f,
    maxRadius: u
  };
});
_t(Vr, "getComposedData", function(e) {
  var t = e.item, r = e.offset, n = t.type.defaultProps !== void 0 ? Pe(Pe({}, t.type.defaultProps), t.props) : t.props, o = os.getRealPieData(n);
  if (!o || !o.length)
    return null;
  var a = n.cornerRadius, i = n.startAngle, s = n.endAngle, c = n.paddingAngle, l = n.dataKey, f = n.nameKey, u = n.valueKey, d = n.tooltipType, h = Math.abs(n.minAngle), m = os.parseCoordinateOfPie(n, r), v = os.parseDeltaAngle(i, s), p = Math.abs(v), b = l;
  fe(l) && fe(u) ? (pr(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), b = "value") : fe(l) && (pr(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), b = u);
  var w = o.filter(function(P) {
    return ze(P, b, 0) !== 0;
  }).length, x = (p >= 360 ? w : w - 1) * c, _ = p - w * h - x, y = o.reduce(function(P, T) {
    var I = ze(T, b, 0);
    return P + (ne(I) ? I : 0);
  }, 0), O;
  if (y > 0) {
    var A;
    O = o.map(function(P, T) {
      var I = ze(P, b, 0), E = ze(P, f, T), C = (ne(I) ? I : 0) / y, R;
      T ? R = A.endAngle + rt(v) * c * (I !== 0 ? 1 : 0) : R = i;
      var M = R + rt(v) * ((I !== 0 ? h : 0) + C * _), D = (R + M) / 2, $ = (m.innerRadius + m.outerRadius) / 2, q = [{
        name: E,
        value: I,
        payload: P,
        dataKey: b,
        type: d
      }], F = Te(m.cx, m.cy, $, D);
      return A = Pe(Pe(Pe({
        percent: C,
        cornerRadius: a,
        name: E,
        tooltipPayload: q,
        midAngle: D,
        middleRadius: $,
        tooltipPosition: F
      }, P), m), {}, {
        value: ze(P, b),
        startAngle: R,
        endAngle: M,
        payload: P,
        paddingAngle: rt(v) * c
      }), A;
    });
  }
  return Pe(Pe({}, m), {}, {
    sectors: O,
    data: o
  });
});
var Lp, D_;
function X9() {
  if (D_) return Lp;
  D_ = 1;
  var e = Math.ceil, t = Math.max;
  function r(n, o, a, i) {
    for (var s = -1, c = t(e((o - n) / (a || 1)), 0), l = Array(c); c--; )
      l[i ? c : ++s] = n, n += a;
    return l;
  }
  return Lp = r, Lp;
}
var Bp, j_;
function jM() {
  if (j_) return Bp;
  j_ = 1;
  var e = oR(), t = 1 / 0, r = 17976931348623157e292;
  function n(o) {
    if (!o)
      return o === 0 ? o : 0;
    if (o = e(o), o === t || o === -t) {
      var a = o < 0 ? -1 : 1;
      return a * r;
    }
    return o === o ? o : 0;
  }
  return Bp = n, Bp;
}
var Fp, L_;
function Z9() {
  if (L_) return Fp;
  L_ = 1;
  var e = X9(), t = al(), r = jM();
  function n(o) {
    return function(a, i, s) {
      return s && typeof s != "number" && t(a, i, s) && (i = s = void 0), a = r(a), i === void 0 ? (i = a, a = 0) : i = r(i), s = s === void 0 ? a < i ? 1 : -1 : r(s), e(a, i, s, o);
    };
  }
  return Fp = n, Fp;
}
var qp, B_;
function J9() {
  if (B_) return qp;
  B_ = 1;
  var e = Z9(), t = e();
  return qp = t, qp;
}
var Q9 = J9();
const rc = /* @__PURE__ */ Ae(Q9);
function Ja(e) {
  "@babel/helpers - typeof";
  return Ja = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ja(e);
}
function F_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function q_(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? F_(Object(r), !0).forEach(function(n) {
      LM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : F_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function LM(e, t, r) {
  return t = eY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function eY(e) {
  var t = tY(e, "string");
  return Ja(t) == "symbol" ? t : t + "";
}
function tY(e, t) {
  if (Ja(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ja(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var rY = ["Webkit", "Moz", "O", "ms"], nY = function(t, r) {
  var n = t.replace(/(\w)/, function(a) {
    return a.toUpperCase();
  }), o = rY.reduce(function(a, i) {
    return q_(q_({}, a), {}, LM({}, i + n, r));
  }, {});
  return o[t] = r, o;
};
function vo(e) {
  "@babel/helpers - typeof";
  return vo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vo(e);
}
function nc() {
  return nc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nc.apply(this, arguments);
}
function z_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function zp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? z_(Object(r), !0).forEach(function(n) {
      ft(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : z_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function oY(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function W_(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, FM(n.key), n);
  }
}
function aY(e, t, r) {
  return t && W_(e.prototype, t), r && W_(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function iY(e, t, r) {
  return t = oc(t), sY(e, BM() ? Reflect.construct(t, r || [], oc(e).constructor) : t.apply(e, r));
}
function sY(e, t) {
  if (t && (vo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return cY(e);
}
function cY(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function BM() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (BM = function() {
    return !!e;
  })();
}
function oc(e) {
  return oc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, oc(e);
}
function lY(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Mv(e, t);
}
function Mv(e, t) {
  return Mv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Mv(e, t);
}
function ft(e, t, r) {
  return t = FM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function FM(e) {
  var t = uY(e, "string");
  return vo(t) == "symbol" ? t : t + "";
}
function uY(e, t) {
  if (vo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (vo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var fY = function(t) {
  var r = t.data, n = t.startIndex, o = t.endIndex, a = t.x, i = t.width, s = t.travellerWidth;
  if (!r || !r.length)
    return {};
  var c = r.length, l = fa().domain(rc(0, c)).range([a, a + i - s]), f = l.domain().map(function(u) {
    return l(u);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: l(n),
    endX: l(o),
    scale: l,
    scaleValues: f
  };
}, U_ = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, mo = /* @__PURE__ */ (function(e) {
  function t(r) {
    var n;
    return oY(this, t), n = iY(this, t, [r]), ft(n, "handleDrag", function(o) {
      n.leaveTimer && (clearTimeout(n.leaveTimer), n.leaveTimer = null), n.state.isTravellerMoving ? n.handleTravellerMove(o) : n.state.isSlideMoving && n.handleSlideDrag(o);
    }), ft(n, "handleTouchMove", function(o) {
      o.changedTouches != null && o.changedTouches.length > 0 && n.handleDrag(o.changedTouches[0]);
    }), ft(n, "handleDragEnd", function() {
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var o = n.props, a = o.endIndex, i = o.onDragEnd, s = o.startIndex;
        i == null || i({
          endIndex: a,
          startIndex: s
        });
      }), n.detachDragEndListener();
    }), ft(n, "handleLeaveWrapper", function() {
      (n.state.isTravellerMoving || n.state.isSlideMoving) && (n.leaveTimer = window.setTimeout(n.handleDragEnd, n.props.leaveTimeOut));
    }), ft(n, "handleEnterSlideOrTraveller", function() {
      n.setState({
        isTextActive: !0
      });
    }), ft(n, "handleLeaveSlideOrTraveller", function() {
      n.setState({
        isTextActive: !1
      });
    }), ft(n, "handleSlideDragStart", function(o) {
      var a = U_(o) ? o.changedTouches[0] : o;
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: a.pageX
      }), n.attachDragEndListener();
    }), n.travellerDragStartHandlers = {
      startX: n.handleTravellerDragStart.bind(n, "startX"),
      endX: n.handleTravellerDragStart.bind(n, "endX")
    }, n.state = {}, n;
  }
  return lY(t, e), aY(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(n) {
      var o = n.startX, a = n.endX, i = this.state.scaleValues, s = this.props, c = s.gap, l = s.data, f = l.length - 1, u = Math.min(o, a), d = Math.max(o, a), h = t.getIndexInRange(i, u), m = t.getIndexInRange(i, d);
      return {
        startIndex: h - h % c,
        endIndex: m === f ? f : m - m % c
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(n) {
      var o = this.props, a = o.data, i = o.tickFormatter, s = o.dataKey, c = ze(a[n], s, n);
      return ue(i) ? i(c, n) : c;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(n) {
      var o = this.state, a = o.slideMoveStartX, i = o.startX, s = o.endX, c = this.props, l = c.x, f = c.width, u = c.travellerWidth, d = c.startIndex, h = c.endIndex, m = c.onChange, v = n.pageX - a;
      v > 0 ? v = Math.min(v, l + f - u - s, l + f - u - i) : v < 0 && (v = Math.max(v, l - i, l - s));
      var p = this.getIndex({
        startX: i + v,
        endX: s + v
      });
      (p.startIndex !== d || p.endIndex !== h) && m && m(p), this.setState({
        startX: i + v,
        endX: s + v,
        slideMoveStartX: n.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(n, o) {
      var a = U_(o) ? o.changedTouches[0] : o;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: n,
        brushMoveStartX: a.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(n) {
      var o = this.state, a = o.brushMoveStartX, i = o.movingTravellerId, s = o.endX, c = o.startX, l = this.state[i], f = this.props, u = f.x, d = f.width, h = f.travellerWidth, m = f.onChange, v = f.gap, p = f.data, b = {
        startX: this.state.startX,
        endX: this.state.endX
      }, w = n.pageX - a;
      w > 0 ? w = Math.min(w, u + d - h - l) : w < 0 && (w = Math.max(w, u - l)), b[i] = l + w;
      var x = this.getIndex(b), _ = x.startIndex, y = x.endIndex, O = function() {
        var P = p.length - 1;
        return i === "startX" && (s > c ? _ % v === 0 : y % v === 0) || s < c && y === P || i === "endX" && (s > c ? y % v === 0 : _ % v === 0) || s > c && y === P;
      };
      this.setState(ft(ft({}, i, l + w), "brushMoveStartX", n.pageX), function() {
        m && O() && m(x);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(n, o) {
      var a = this, i = this.state, s = i.scaleValues, c = i.startX, l = i.endX, f = this.state[o], u = s.indexOf(f);
      if (u !== -1) {
        var d = u + n;
        if (!(d === -1 || d >= s.length)) {
          var h = s[d];
          o === "startX" && h >= l || o === "endX" && h <= c || this.setState(ft({}, o, h), function() {
            a.props.onChange(a.getIndex({
              startX: a.state.startX,
              endX: a.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this.props, o = n.x, a = n.y, i = n.width, s = n.height, c = n.fill, l = n.stroke;
      return /* @__PURE__ */ k.createElement("rect", {
        stroke: l,
        fill: c,
        x: o,
        y: a,
        width: i,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var n = this.props, o = n.x, a = n.y, i = n.width, s = n.height, c = n.data, l = n.children, f = n.padding, u = on.only(l);
      return u ? /* @__PURE__ */ k.cloneElement(u, {
        x: o,
        y: a,
        width: i,
        height: s,
        margin: f,
        compact: !0,
        data: c
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(n, o) {
      var a, i, s = this, c = this.props, l = c.y, f = c.travellerWidth, u = c.height, d = c.traveller, h = c.ariaLabel, m = c.data, v = c.startIndex, p = c.endIndex, b = Math.max(n, this.props.x), w = zp(zp({}, ie(this.props, !1)), {}, {
        x: b,
        y: l,
        width: f,
        height: u
      }), x = h || "Min value: ".concat((a = m[v]) === null || a === void 0 ? void 0 : a.name, ", Max value: ").concat((i = m[p]) === null || i === void 0 ? void 0 : i.name);
      return /* @__PURE__ */ k.createElement(ve, {
        tabIndex: 0,
        role: "slider",
        "aria-label": x,
        "aria-valuenow": n,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[o],
        onTouchStart: this.travellerDragStartHandlers[o],
        onKeyDown: function(y) {
          ["ArrowLeft", "ArrowRight"].includes(y.key) && (y.preventDefault(), y.stopPropagation(), s.handleTravellerMoveKeyboard(y.key === "ArrowRight" ? 1 : -1, o));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(d, w));
    }
  }, {
    key: "renderSlide",
    value: function(n, o) {
      var a = this.props, i = a.y, s = a.height, c = a.stroke, l = a.travellerWidth, f = Math.min(n, o) + l, u = Math.max(Math.abs(o - n) - l, 0);
      return /* @__PURE__ */ k.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: c,
        fillOpacity: 0.2,
        x: f,
        y: i,
        width: u,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var n = this.props, o = n.startIndex, a = n.endIndex, i = n.y, s = n.height, c = n.travellerWidth, l = n.stroke, f = this.state, u = f.startX, d = f.endX, h = 5, m = {
        pointerEvents: "none",
        fill: l
      };
      return /* @__PURE__ */ k.createElement(ve, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ k.createElement(gn, nc({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(u, d) - h,
        y: i + s / 2
      }, m), this.getTextOfTick(o)), /* @__PURE__ */ k.createElement(gn, nc({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(u, d) + c + h,
        y: i + s / 2
      }, m), this.getTextOfTick(a)));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, o = n.data, a = n.className, i = n.children, s = n.x, c = n.y, l = n.width, f = n.height, u = n.alwaysShowText, d = this.state, h = d.startX, m = d.endX, v = d.isTextActive, p = d.isSlideMoving, b = d.isTravellerMoving, w = d.isTravellerFocused;
      if (!o || !o.length || !ne(s) || !ne(c) || !ne(l) || !ne(f) || l <= 0 || f <= 0)
        return null;
      var x = de("recharts-brush", a), _ = k.Children.count(i) === 1, y = nY("userSelect", "none");
      return /* @__PURE__ */ k.createElement(ve, {
        className: x,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: y
      }, this.renderBackground(), _ && this.renderPanorama(), this.renderSlide(h, m), this.renderTravellerLayer(h, "startX"), this.renderTravellerLayer(m, "endX"), (v || p || b || w || u) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(n) {
      var o = n.x, a = n.y, i = n.width, s = n.height, c = n.stroke, l = Math.floor(a + s / 2) - 1;
      return /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement("rect", {
        x: o,
        y: a,
        width: i,
        height: s,
        fill: c,
        stroke: "none"
      }), /* @__PURE__ */ k.createElement("line", {
        x1: o + 1,
        y1: l,
        x2: o + i - 1,
        y2: l,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ k.createElement("line", {
        x1: o + 1,
        y1: l + 2,
        x2: o + i - 1,
        y2: l + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(n, o) {
      var a;
      return /* @__PURE__ */ k.isValidElement(n) ? a = /* @__PURE__ */ k.cloneElement(n, o) : ue(n) ? a = n(o) : a = t.renderDefaultTraveller(o), a;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(n, o) {
      var a = n.data, i = n.width, s = n.x, c = n.travellerWidth, l = n.updateId, f = n.startIndex, u = n.endIndex;
      if (a !== o.prevData || l !== o.prevUpdateId)
        return zp({
          prevData: a,
          prevTravellerWidth: c,
          prevUpdateId: l,
          prevX: s,
          prevWidth: i
        }, a && a.length ? fY({
          data: a,
          width: i,
          x: s,
          travellerWidth: c,
          startIndex: f,
          endIndex: u
        }) : {
          scale: null,
          scaleValues: null
        });
      if (o.scale && (i !== o.prevWidth || s !== o.prevX || c !== o.prevTravellerWidth)) {
        o.scale.range([s, s + i - c]);
        var d = o.scale.domain().map(function(h) {
          return o.scale(h);
        });
        return {
          prevData: a,
          prevTravellerWidth: c,
          prevUpdateId: l,
          prevX: s,
          prevWidth: i,
          startX: o.scale(n.startIndex),
          endX: o.scale(n.endIndex),
          scaleValues: d
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(n, o) {
      for (var a = n.length, i = 0, s = a - 1; s - i > 1; ) {
        var c = Math.floor((i + s) / 2);
        n[c] > o ? s = c : i = c;
      }
      return o >= n[s] ? s : i;
    }
  }]);
})(Ft);
ft(mo, "displayName", "Brush");
ft(mo, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var Wp, H_;
function dY() {
  if (H_) return Wp;
  H_ = 1;
  var e = sg();
  function t(r, n) {
    var o;
    return e(r, function(a, i, s) {
      return o = n(a, i, s), !o;
    }), !!o;
  }
  return Wp = t, Wp;
}
var Up, V_;
function pY() {
  if (V_) return Up;
  V_ = 1;
  var e = $C(), t = or(), r = dY(), n = lt(), o = al();
  function a(i, s, c) {
    var l = n(i) ? e : r;
    return c && o(i, s, c) && (s = void 0), l(i, t(s, 3));
  }
  return Up = a, Up;
}
var hY = pY();
const vY = /* @__PURE__ */ Ae(hY);
var Xt = function(t, r) {
  var n = t.alwaysShow, o = t.ifOverflow;
  return n && (o = "extendDomain"), o === r;
}, Hp, K_;
function mY() {
  if (K_) return Hp;
  K_ = 1;
  var e = QC();
  function t(r, n, o) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: o,
      writable: !0
    }) : r[n] = o;
  }
  return Hp = t, Hp;
}
var Vp, G_;
function gY() {
  if (G_) return Vp;
  G_ = 1;
  var e = mY(), t = ZC(), r = or();
  function n(o, a) {
    var i = {};
    return a = r(a, 3), t(o, function(s, c, l) {
      e(i, c, a(s, c, l));
    }), i;
  }
  return Vp = n, Vp;
}
var yY = gY();
const bY = /* @__PURE__ */ Ae(yY);
var Kp, Y_;
function wY() {
  if (Y_) return Kp;
  Y_ = 1;
  function e(t, r) {
    for (var n = -1, o = t == null ? 0 : t.length; ++n < o; )
      if (!r(t[n], n, t))
        return !1;
    return !0;
  }
  return Kp = e, Kp;
}
var Gp, X_;
function xY() {
  if (X_) return Gp;
  X_ = 1;
  var e = sg();
  function t(r, n) {
    var o = !0;
    return e(r, function(a, i, s) {
      return o = !!n(a, i, s), o;
    }), o;
  }
  return Gp = t, Gp;
}
var Yp, Z_;
function SY() {
  if (Z_) return Yp;
  Z_ = 1;
  var e = wY(), t = xY(), r = or(), n = lt(), o = al();
  function a(i, s, c) {
    var l = n(i) ? e : t;
    return c && o(i, s, c) && (s = void 0), l(i, r(s, 3));
  }
  return Yp = a, Yp;
}
var _Y = SY();
const OY = /* @__PURE__ */ Ae(_Y);
var AY = ["x", "y"];
function go(e) {
  "@babel/helpers - typeof";
  return go = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, go(e);
}
function Iv() {
  return Iv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Iv.apply(this, arguments);
}
function J_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function oa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? J_(Object(r), !0).forEach(function(n) {
      PY(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : J_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function PY(e, t, r) {
  return t = EY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function EY(e) {
  var t = TY(e, "string");
  return go(t) == "symbol" ? t : t + "";
}
function TY(e, t) {
  if (go(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (go(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function CY(e, t) {
  if (e == null) return {};
  var r = RY(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function RY(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function MY(e, t) {
  var r = e.x, n = e.y, o = CY(e, AY), a = "".concat(r), i = parseInt(a, 10), s = "".concat(n), c = parseInt(s, 10), l = "".concat(t.height || o.height), f = parseInt(l, 10), u = "".concat(t.width || o.width), d = parseInt(u, 10);
  return oa(oa(oa(oa(oa({}, t), o), i ? {
    x: i
  } : {}), c ? {
    y: c
  } : {}), {}, {
    height: f,
    width: d,
    name: t.name,
    radius: t.radius
  });
}
function Q_(e) {
  return /* @__PURE__ */ k.createElement(kM, Iv({
    shapeType: "rectangle",
    propTransformer: MY,
    activeClassName: "recharts-active-bar"
  }, e));
}
var IY = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(n, o) {
    if (typeof t == "number") return t;
    var a = ne(n) || H5(n);
    return a ? t(n, o) : (a || (process.env.NODE_ENV !== "production" ? st(!1, "minPointSize callback function received a value with type of ".concat(go(n), ". Currently only numbers or null/undefined are supported.")) : st()), r);
  };
}, NY = ["value", "background"], qM;
function yo(e) {
  "@babel/helpers - typeof";
  return yo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, yo(e);
}
function kY(e, t) {
  if (e == null) return {};
  var r = $Y(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function $Y(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function ac() {
  return ac = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ac.apply(this, arguments);
}
function e1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function De(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? e1(Object(r), !0).forEach(function(n) {
      Rr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : e1(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function DY(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function t1(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, WM(n.key), n);
  }
}
function jY(e, t, r) {
  return t && t1(e.prototype, t), r && t1(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function LY(e, t, r) {
  return t = ic(t), BY(e, zM() ? Reflect.construct(t, r || [], ic(e).constructor) : t.apply(e, r));
}
function BY(e, t) {
  if (t && (yo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return FY(e);
}
function FY(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zM() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (zM = function() {
    return !!e;
  })();
}
function ic(e) {
  return ic = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ic(e);
}
function qY(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Nv(e, t);
}
function Nv(e, t) {
  return Nv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Nv(e, t);
}
function Rr(e, t, r) {
  return t = WM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function WM(e) {
  var t = zY(e, "string");
  return yo(t) == "symbol" ? t : t + "";
}
function zY(e, t) {
  if (yo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (yo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Vo = /* @__PURE__ */ (function(e) {
  function t() {
    var r;
    DY(this, t);
    for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++)
      o[a] = arguments[a];
    return r = LY(this, t, [].concat(o)), Rr(r, "state", {
      isAnimationFinished: !1
    }), Rr(r, "id", qo("recharts-bar-")), Rr(r, "handleAnimationEnd", function() {
      var i = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), i && i();
    }), Rr(r, "handleAnimationStart", function() {
      var i = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), i && i();
    }), r;
  }
  return qY(t, e), jY(t, [{
    key: "renderRectanglesStatically",
    value: function(n) {
      var o = this, a = this.props, i = a.shape, s = a.dataKey, c = a.activeIndex, l = a.activeBar, f = ie(this.props, !1);
      return n && n.map(function(u, d) {
        var h = d === c, m = h ? l : i, v = De(De(De({}, f), u), {}, {
          isActive: h,
          option: m,
          index: d,
          dataKey: s,
          onAnimationStart: o.handleAnimationStart,
          onAnimationEnd: o.handleAnimationEnd
        });
        return /* @__PURE__ */ k.createElement(ve, ac({
          className: "recharts-bar-rectangle"
        }, mn(o.props, u, d), {
          // https://github.com/recharts/recharts/issues/5415
          // eslint-disable-next-line react/no-array-index-key
          key: "rectangle-".concat(u == null ? void 0 : u.x, "-").concat(u == null ? void 0 : u.y, "-").concat(u == null ? void 0 : u.value, "-").concat(d)
        }), /* @__PURE__ */ k.createElement(Q_, v));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var n = this, o = this.props, a = o.data, i = o.layout, s = o.isAnimationActive, c = o.animationBegin, l = o.animationDuration, f = o.animationEasing, u = o.animationId, d = this.state.prevData;
      return /* @__PURE__ */ k.createElement(er, {
        begin: c,
        duration: l,
        isActive: s,
        easing: f,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(u),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(h) {
        var m = h.t, v = a.map(function(p, b) {
          var w = d && d[b];
          if (w) {
            var x = ht(w.x, p.x), _ = ht(w.y, p.y), y = ht(w.width, p.width), O = ht(w.height, p.height);
            return De(De({}, p), {}, {
              x: x(m),
              y: _(m),
              width: y(m),
              height: O(m)
            });
          }
          if (i === "horizontal") {
            var A = ht(0, p.height), P = A(m);
            return De(De({}, p), {}, {
              y: p.y + p.height - P,
              height: P
            });
          }
          var T = ht(0, p.width), I = T(m);
          return De(De({}, p), {}, {
            width: I
          });
        });
        return /* @__PURE__ */ k.createElement(ve, null, n.renderRectanglesStatically(v));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var n = this.props, o = n.data, a = n.isAnimationActive, i = this.state.prevData;
      return a && o && o.length && (!i || !Ti(i, o)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(o);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this, o = this.props, a = o.data, i = o.dataKey, s = o.activeIndex, c = ie(this.props.background, !1);
      return a.map(function(l, f) {
        l.value;
        var u = l.background, d = kY(l, NY);
        if (!u)
          return null;
        var h = De(De(De(De(De({}, d), {}, {
          fill: "#eee"
        }, u), c), mn(n.props, l, f)), {}, {
          onAnimationStart: n.handleAnimationStart,
          onAnimationEnd: n.handleAnimationEnd,
          dataKey: i,
          index: f,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ k.createElement(Q_, ac({
          key: "background-bar-".concat(f),
          option: n.props.background,
          isActive: f === s
        }, h));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(n, o) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var a = this.props, i = a.data, s = a.xAxis, c = a.yAxis, l = a.layout, f = a.children, u = bt(f, Ci);
      if (!u)
        return null;
      var d = l === "vertical" ? i[0].height / 2 : i[0].width / 2, h = function(p, b) {
        var w = Array.isArray(p.value) ? p.value[1] : p.value;
        return {
          x: p.x,
          y: p.y,
          value: w,
          errorVal: ze(p, b)
        };
      }, m = {
        clipPath: n ? "url(#clipPath-".concat(o, ")") : null
      };
      return /* @__PURE__ */ k.createElement(ve, m, u.map(function(v) {
        return /* @__PURE__ */ k.cloneElement(v, {
          key: "error-bar-".concat(o, "-").concat(v.props.dataKey),
          data: i,
          xAxis: s,
          yAxis: c,
          layout: l,
          offset: d,
          dataPointFormatter: h
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, o = n.hide, a = n.data, i = n.className, s = n.xAxis, c = n.yAxis, l = n.left, f = n.top, u = n.width, d = n.height, h = n.isAnimationActive, m = n.background, v = n.id;
      if (o || !a || !a.length)
        return null;
      var p = this.state.isAnimationFinished, b = de("recharts-bar", i), w = s && s.allowDataOverflow, x = c && c.allowDataOverflow, _ = w || x, y = fe(v) ? this.id : v;
      return /* @__PURE__ */ k.createElement(ve, {
        className: b
      }, w || x ? /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("clipPath", {
        id: "clipPath-".concat(y)
      }, /* @__PURE__ */ k.createElement("rect", {
        x: w ? l : l - u / 2,
        y: x ? f : f - d / 2,
        width: w ? u : u * 2,
        height: x ? d : d * 2
      }))) : null, /* @__PURE__ */ k.createElement(ve, {
        className: "recharts-bar-rectangles",
        clipPath: _ ? "url(#clipPath-".concat(y, ")") : null
      }, m ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(_, y), (!h || p) && vr.renderCallByParent(this.props, a));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, o) {
      return n.animationId !== o.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curData: n.data,
        prevData: o.curData
      } : n.data !== o.curData ? {
        curData: n.data
      } : null;
    }
  }]);
})(Ft);
qM = Vo;
Rr(Vo, "displayName", "Bar");
Rr(Vo, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !_n.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
Rr(Vo, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.barPosition, o = e.bandSize, a = e.xAxis, i = e.yAxis, s = e.xAxisTicks, c = e.yAxisTicks, l = e.stackedData, f = e.dataStartIndex, u = e.displayedData, d = e.offset, h = s4(n, r);
  if (!h)
    return null;
  var m = t.layout, v = r.type.defaultProps, p = v !== void 0 ? De(De({}, v), r.props) : r.props, b = p.dataKey, w = p.children, x = p.minPointSize, _ = m === "horizontal" ? i : a, y = l ? _.scale.domain() : null, O = h4({
    numericAxis: _
  }), A = bt(w, ug), P = u.map(function(T, I) {
    var E, C, R, M, D, $;
    l ? E = c4(l[f + I], y) : (E = ze(T, b), Array.isArray(E) || (E = [O, E]));
    var q = IY(x, qM.defaultProps.minPointSize)(E[1], I);
    if (m === "horizontal") {
      var F, B = [i.scale(E[0]), i.scale(E[1])], L = B[0], z = B[1];
      C = SS({
        axis: a,
        ticks: s,
        bandSize: o,
        offset: h.offset,
        entry: T,
        index: I
      }), R = (F = z ?? L) !== null && F !== void 0 ? F : void 0, M = h.size;
      var N = L - z;
      if (D = Number.isNaN(N) ? 0 : N, $ = {
        x: C,
        y: i.y,
        width: M,
        height: i.height
      }, Math.abs(q) > 0 && Math.abs(D) < Math.abs(q)) {
        var U = rt(D || q) * (Math.abs(q) - Math.abs(D));
        R -= U, D += U;
      }
    } else {
      var K = [a.scale(E[0]), a.scale(E[1])], G = K[0], J = K[1];
      if (C = G, R = SS({
        axis: i,
        ticks: c,
        bandSize: o,
        offset: h.offset,
        entry: T,
        index: I
      }), M = J - G, D = h.size, $ = {
        x: a.x,
        y: R,
        width: a.width,
        height: D
      }, Math.abs(q) > 0 && Math.abs(M) < Math.abs(q)) {
        var V = rt(M || q) * (Math.abs(q) - Math.abs(M));
        M += V;
      }
    }
    return De(De(De({}, T), {}, {
      x: C,
      y: R,
      width: M,
      height: D,
      value: l ? E : E[1],
      payload: T,
      background: $
    }, A && A[I] && A[I].props), {}, {
      tooltipPayload: [hM(r, T)],
      tooltipPosition: {
        x: C + M / 2,
        y: R + D / 2
      }
    });
  });
  return De({
    data: P,
    layout: m
  }, d);
});
function Qa(e) {
  "@babel/helpers - typeof";
  return Qa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qa(e);
}
function WY(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function r1(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, UM(n.key), n);
  }
}
function UY(e, t, r) {
  return t && r1(e.prototype, t), r && r1(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function n1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Nt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? n1(Object(r), !0).forEach(function(n) {
      Ol(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n1(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ol(e, t, r) {
  return t = UM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function UM(e) {
  var t = HY(e, "string");
  return Qa(t) == "symbol" ? t : t + "";
}
function HY(e, t) {
  if (Qa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Qa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var HM = function(t, r, n, o, a) {
  var i = t.width, s = t.height, c = t.layout, l = t.children, f = Object.keys(r), u = {
    left: n.left,
    leftMirror: n.left,
    right: i - n.right,
    rightMirror: i - n.right,
    top: n.top,
    topMirror: n.top,
    bottom: s - n.bottom,
    bottomMirror: s - n.bottom
  }, d = !!dt(l, Vo);
  return f.reduce(function(h, m) {
    var v = r[m], p = v.orientation, b = v.domain, w = v.padding, x = w === void 0 ? {} : w, _ = v.mirror, y = v.reversed, O = "".concat(p).concat(_ ? "Mirror" : ""), A, P, T, I, E;
    if (v.type === "number" && (v.padding === "gap" || v.padding === "no-gap")) {
      var C = b[1] - b[0], R = 1 / 0, M = v.categoricalDomain.sort(G5);
      if (M.forEach(function(K, G) {
        G > 0 && (R = Math.min((K || 0) - (M[G - 1] || 0), R));
      }), Number.isFinite(R)) {
        var D = R / C, $ = v.layout === "vertical" ? n.height : n.width;
        if (v.padding === "gap" && (A = D * $ / 2), v.padding === "no-gap") {
          var q = nt(t.barCategoryGap, D * $), F = D * $ / 2;
          A = F - q - (F - q) / $ * q;
        }
      }
    }
    o === "xAxis" ? P = [n.left + (x.left || 0) + (A || 0), n.left + n.width - (x.right || 0) - (A || 0)] : o === "yAxis" ? P = c === "horizontal" ? [n.top + n.height - (x.bottom || 0), n.top + (x.top || 0)] : [n.top + (x.top || 0) + (A || 0), n.top + n.height - (x.bottom || 0) - (A || 0)] : P = v.range, y && (P = [P[1], P[0]]);
    var B = uM(v, a, d), L = B.scale, z = B.realScaleType;
    L.domain(b).range(P), fM(L);
    var N = dM(L, Nt(Nt({}, v), {}, {
      realScaleType: z
    }));
    o === "xAxis" ? (E = p === "top" && !_ || p === "bottom" && _, T = n.left, I = u[O] - E * v.height) : o === "yAxis" && (E = p === "left" && !_ || p === "right" && _, T = u[O] - E * v.width, I = n.top);
    var U = Nt(Nt(Nt({}, v), N), {}, {
      realScaleType: z,
      x: T,
      y: I,
      scale: L,
      width: o === "xAxis" ? n.width : v.width,
      height: o === "yAxis" ? n.height : v.height
    });
    return U.bandSize = qs(U, N), !v.hide && o === "xAxis" ? u[O] += (E ? -1 : 1) * U.height : v.hide || (u[O] += (E ? -1 : 1) * U.width), Nt(Nt({}, h), {}, Ol({}, m, U));
  }, {});
}, VM = function(t, r) {
  var n = t.x, o = t.y, a = r.x, i = r.y;
  return {
    x: Math.min(n, a),
    y: Math.min(o, i),
    width: Math.abs(a - n),
    height: Math.abs(i - o)
  };
}, VY = function(t) {
  var r = t.x1, n = t.y1, o = t.x2, a = t.y2;
  return VM({
    x: r,
    y: n
  }, {
    x: o,
    y: a
  });
}, KM = /* @__PURE__ */ (function() {
  function e(t) {
    WY(this, e), this.scale = t;
  }
  return UY(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.bandAware, a = n.position;
      if (r !== void 0) {
        if (a)
          switch (a) {
            case "start":
              return this.scale(r);
            case "middle": {
              var i = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(r) + i;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(r) + s;
            }
            default:
              return this.scale(r);
          }
        if (o) {
          var c = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(r) + c;
        }
        return this.scale(r);
      }
    }
  }, {
    key: "isInRange",
    value: function(r) {
      var n = this.range(), o = n[0], a = n[n.length - 1];
      return o <= a ? r >= o && r <= a : r >= a && r <= o;
    }
  }], [{
    key: "create",
    value: function(r) {
      return new e(r);
    }
  }]);
})();
Ol(KM, "EPS", 1e-4);
var Lg = function(t) {
  var r = Object.keys(t).reduce(function(n, o) {
    return Nt(Nt({}, n), {}, Ol({}, o, KM.create(t[o])));
  }, {});
  return Nt(Nt({}, r), {}, {
    apply: function(o) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = a.bandAware, s = a.position;
      return bY(o, function(c, l) {
        return r[l].apply(c, {
          bandAware: i,
          position: s
        });
      });
    },
    isInRange: function(o) {
      return OY(o, function(a, i) {
        return r[i].isInRange(a);
      });
    }
  });
};
function KY(e) {
  return (e % 180 + 180) % 180;
}
var GY = function(t) {
  var r = t.width, n = t.height, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a = KY(o), i = a * Math.PI / 180, s = Math.atan(n / r), c = i > s && i < Math.PI - s ? n / Math.sin(i) : r / Math.cos(i);
  return Math.abs(c);
}, Xp, o1;
function YY() {
  if (o1) return Xp;
  o1 = 1;
  var e = or(), t = _i(), r = nl();
  function n(o) {
    return function(a, i, s) {
      var c = Object(a);
      if (!t(a)) {
        var l = e(i, 3);
        a = r(a), i = function(u) {
          return l(c[u], u, c);
        };
      }
      var f = o(a, i, s);
      return f > -1 ? c[l ? a[f] : f] : void 0;
    };
  }
  return Xp = n, Xp;
}
var Zp, a1;
function XY() {
  if (a1) return Zp;
  a1 = 1;
  var e = jM();
  function t(r) {
    var n = e(r), o = n % 1;
    return n === n ? o ? n - o : n : 0;
  }
  return Zp = t, Zp;
}
var Jp, i1;
function ZY() {
  if (i1) return Jp;
  i1 = 1;
  var e = VC(), t = or(), r = XY(), n = Math.max;
  function o(a, i, s) {
    var c = a == null ? 0 : a.length;
    if (!c)
      return -1;
    var l = s == null ? 0 : r(s);
    return l < 0 && (l = n(c + l, 0)), e(a, t(i, 3), l);
  }
  return Jp = o, Jp;
}
var Qp, s1;
function JY() {
  if (s1) return Qp;
  s1 = 1;
  var e = YY(), t = ZY(), r = e(t);
  return Qp = r, Qp;
}
JY();
var QY = cC();
const eX = /* @__PURE__ */ Ae(QY);
var tX = eX(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function sc(e) {
  "@babel/helpers - typeof";
  return sc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, sc(e);
}
var GM = /* @__PURE__ */ Dr(void 0), YM = /* @__PURE__ */ Dr(void 0), XM = /* @__PURE__ */ Dr(void 0), rX = /* @__PURE__ */ Dr({}), ZM = /* @__PURE__ */ Dr(void 0), JM = /* @__PURE__ */ Dr(0), QM = /* @__PURE__ */ Dr(0), c1 = function(t) {
  var r = t.state, n = r.xAxisMap, o = r.yAxisMap, a = r.offset, i = t.clipPathId, s = t.children, c = t.width, l = t.height, f = tX(a);
  return /* @__PURE__ */ k.createElement(GM.Provider, {
    value: n
  }, /* @__PURE__ */ k.createElement(YM.Provider, {
    value: o
  }, /* @__PURE__ */ k.createElement(rX.Provider, {
    value: a
  }, /* @__PURE__ */ k.createElement(XM.Provider, {
    value: f
  }, /* @__PURE__ */ k.createElement(ZM.Provider, {
    value: i
  }, /* @__PURE__ */ k.createElement(JM.Provider, {
    value: l
  }, /* @__PURE__ */ k.createElement(QM.Provider, {
    value: c
  }, s)))))));
}, nX = function() {
  return bn(ZM);
};
function eI(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var tI = function(t) {
  var r = bn(GM);
  r == null && (process.env.NODE_ENV !== "production" ? st(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : st());
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? st(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(sc(t), "]. ").concat(eI(r))) : st()), n;
}, rI = function(t) {
  var r = bn(YM);
  r == null && (process.env.NODE_ENV !== "production" ? st(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : st());
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? st(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(sc(t), "]. ").concat(eI(r))) : st()), n;
}, oX = function() {
  var t = bn(XM);
  return t;
}, nI = function() {
  return bn(QM);
}, oI = function() {
  return bn(JM);
};
function bo(e) {
  "@babel/helpers - typeof";
  return bo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, bo(e);
}
function aX(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function iX(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, iI(n.key), n);
  }
}
function sX(e, t, r) {
  return t && iX(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function cX(e, t, r) {
  return t = cc(t), lX(e, aI() ? Reflect.construct(t, r || [], cc(e).constructor) : t.apply(e, r));
}
function lX(e, t) {
  if (t && (bo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return uX(e);
}
function uX(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function aI() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (aI = function() {
    return !!e;
  })();
}
function cc(e) {
  return cc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, cc(e);
}
function fX(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && kv(e, t);
}
function kv(e, t) {
  return kv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, kv(e, t);
}
function l1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function u1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? l1(Object(r), !0).forEach(function(n) {
      Bg(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l1(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Bg(e, t, r) {
  return t = iI(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function iI(e) {
  var t = dX(e, "string");
  return bo(t) == "symbol" ? t : t + "";
}
function dX(e, t) {
  if (bo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (bo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function pX(e, t) {
  return gX(e) || mX(e, t) || vX(e, t) || hX();
}
function hX() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vX(e, t) {
  if (e) {
    if (typeof e == "string") return f1(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return f1(e, t);
  }
}
function f1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function mX(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, o, a, i, s = [], c = !0, l = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, o = f;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw o;
      }
    }
    return s;
  }
}
function gX(e) {
  if (Array.isArray(e)) return e;
}
function $v() {
  return $v = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $v.apply(this, arguments);
}
var yX = function(t, r) {
  var n;
  return /* @__PURE__ */ k.isValidElement(t) ? n = /* @__PURE__ */ k.cloneElement(t, r) : ue(t) ? n = t(r) : n = /* @__PURE__ */ k.createElement("line", $v({}, r, {
    className: "recharts-reference-line-line"
  })), n;
}, bX = function(t, r, n, o, a, i, s, c, l) {
  var f = a.x, u = a.y, d = a.width, h = a.height;
  if (n) {
    var m = l.y, v = t.y.apply(m, {
      position: i
    });
    if (Xt(l, "discard") && !t.y.isInRange(v))
      return null;
    var p = [{
      x: f + d,
      y: v
    }, {
      x: f,
      y: v
    }];
    return c === "left" ? p.reverse() : p;
  }
  if (r) {
    var b = l.x, w = t.x.apply(b, {
      position: i
    });
    if (Xt(l, "discard") && !t.x.isInRange(w))
      return null;
    var x = [{
      x: w,
      y: u + h
    }, {
      x: w,
      y: u
    }];
    return s === "top" ? x.reverse() : x;
  }
  if (o) {
    var _ = l.segment, y = _.map(function(O) {
      return t.apply(O, {
        position: i
      });
    });
    return Xt(l, "discard") && vY(y, function(O) {
      return !t.isInRange(O);
    }) ? null : y;
  }
  return null;
};
function wX(e) {
  var t = e.x, r = e.y, n = e.segment, o = e.xAxisId, a = e.yAxisId, i = e.shape, s = e.className, c = e.alwaysShow, l = nX(), f = tI(o), u = rI(a), d = oX();
  if (!l || !d)
    return null;
  pr(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var h = Lg({
    x: f.scale,
    y: u.scale
  }), m = We(t), v = We(r), p = n && n.length === 2, b = bX(h, m, v, p, d, e.position, f.orientation, u.orientation, e);
  if (!b)
    return null;
  var w = pX(b, 2), x = w[0], _ = x.x, y = x.y, O = w[1], A = O.x, P = O.y, T = Xt(e, "hidden") ? "url(#".concat(l, ")") : void 0, I = u1(u1({
    clipPath: T
  }, ie(e, !0)), {}, {
    x1: _,
    y1: y,
    x2: A,
    y2: P
  });
  return /* @__PURE__ */ k.createElement(ve, {
    className: de("recharts-reference-line", s)
  }, yX(i, I), Ke.renderCallByParent(e, VY({
    x1: _,
    y1: y,
    x2: A,
    y2: P
  })));
}
var Fg = /* @__PURE__ */ (function(e) {
  function t() {
    return aX(this, t), cX(this, t, arguments);
  }
  return fX(t, e), sX(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ k.createElement(wX, this.props);
    }
  }]);
})(k.Component);
Bg(Fg, "displayName", "ReferenceLine");
Bg(Fg, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function Dv() {
  return Dv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Dv.apply(this, arguments);
}
function wo(e) {
  "@babel/helpers - typeof";
  return wo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wo(e);
}
function d1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function p1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? d1(Object(r), !0).forEach(function(n) {
      Al(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : d1(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function xX(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function SX(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, cI(n.key), n);
  }
}
function _X(e, t, r) {
  return t && SX(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function OX(e, t, r) {
  return t = lc(t), AX(e, sI() ? Reflect.construct(t, r || [], lc(e).constructor) : t.apply(e, r));
}
function AX(e, t) {
  if (t && (wo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return PX(e);
}
function PX(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function sI() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (sI = function() {
    return !!e;
  })();
}
function lc(e) {
  return lc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, lc(e);
}
function EX(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && jv(e, t);
}
function jv(e, t) {
  return jv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, jv(e, t);
}
function Al(e, t, r) {
  return t = cI(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function cI(e) {
  var t = TX(e, "string");
  return wo(t) == "symbol" ? t : t + "";
}
function TX(e, t) {
  if (wo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (wo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var CX = function(t) {
  var r = t.x, n = t.y, o = t.xAxis, a = t.yAxis, i = Lg({
    x: o.scale,
    y: a.scale
  }), s = i.apply({
    x: r,
    y: n
  }, {
    bandAware: !0
  });
  return Xt(t, "discard") && !i.isInRange(s) ? null : s;
}, Pl = /* @__PURE__ */ (function(e) {
  function t() {
    return xX(this, t), OX(this, t, arguments);
  }
  return EX(t, e), _X(t, [{
    key: "render",
    value: function() {
      var n = this.props, o = n.x, a = n.y, i = n.r, s = n.alwaysShow, c = n.clipPathId, l = We(o), f = We(a);
      if (pr(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !l || !f)
        return null;
      var u = CX(this.props);
      if (!u)
        return null;
      var d = u.x, h = u.y, m = this.props, v = m.shape, p = m.className, b = Xt(this.props, "hidden") ? "url(#".concat(c, ")") : void 0, w = p1(p1({
        clipPath: b
      }, ie(this.props, !0)), {}, {
        cx: d,
        cy: h
      });
      return /* @__PURE__ */ k.createElement(ve, {
        className: de("recharts-reference-dot", p)
      }, t.renderDot(v, w), Ke.renderCallByParent(this.props, {
        x: d - i,
        y: h - i,
        width: 2 * i,
        height: 2 * i
      }));
    }
  }]);
})(k.Component);
Al(Pl, "displayName", "ReferenceDot");
Al(Pl, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
Al(Pl, "renderDot", function(e, t) {
  var r;
  return /* @__PURE__ */ k.isValidElement(e) ? r = /* @__PURE__ */ k.cloneElement(e, t) : ue(e) ? r = e(t) : r = /* @__PURE__ */ k.createElement(gl, Dv({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), r;
});
function Lv() {
  return Lv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lv.apply(this, arguments);
}
function xo(e) {
  "@babel/helpers - typeof";
  return xo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xo(e);
}
function h1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function v1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? h1(Object(r), !0).forEach(function(n) {
      El(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : h1(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function RX(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function MX(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, uI(n.key), n);
  }
}
function IX(e, t, r) {
  return t && MX(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function NX(e, t, r) {
  return t = uc(t), kX(e, lI() ? Reflect.construct(t, r || [], uc(e).constructor) : t.apply(e, r));
}
function kX(e, t) {
  if (t && (xo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return $X(e);
}
function $X(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function lI() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (lI = function() {
    return !!e;
  })();
}
function uc(e) {
  return uc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, uc(e);
}
function DX(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Bv(e, t);
}
function Bv(e, t) {
  return Bv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Bv(e, t);
}
function El(e, t, r) {
  return t = uI(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function uI(e) {
  var t = jX(e, "string");
  return xo(t) == "symbol" ? t : t + "";
}
function jX(e, t) {
  if (xo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (xo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var LX = function(t, r, n, o, a) {
  var i = a.x1, s = a.x2, c = a.y1, l = a.y2, f = a.xAxis, u = a.yAxis;
  if (!f || !u) return null;
  var d = Lg({
    x: f.scale,
    y: u.scale
  }), h = {
    x: t ? d.x.apply(i, {
      position: "start"
    }) : d.x.rangeMin,
    y: n ? d.y.apply(c, {
      position: "start"
    }) : d.y.rangeMin
  }, m = {
    x: r ? d.x.apply(s, {
      position: "end"
    }) : d.x.rangeMax,
    y: o ? d.y.apply(l, {
      position: "end"
    }) : d.y.rangeMax
  };
  return Xt(a, "discard") && (!d.isInRange(h) || !d.isInRange(m)) ? null : VM(h, m);
}, Tl = /* @__PURE__ */ (function(e) {
  function t() {
    return RX(this, t), NX(this, t, arguments);
  }
  return DX(t, e), IX(t, [{
    key: "render",
    value: function() {
      var n = this.props, o = n.x1, a = n.x2, i = n.y1, s = n.y2, c = n.className, l = n.alwaysShow, f = n.clipPathId;
      pr(l === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var u = We(o), d = We(a), h = We(i), m = We(s), v = this.props.shape;
      if (!u && !d && !h && !m && !v)
        return null;
      var p = LX(u, d, h, m, this.props);
      if (!p && !v)
        return null;
      var b = Xt(this.props, "hidden") ? "url(#".concat(f, ")") : void 0;
      return /* @__PURE__ */ k.createElement(ve, {
        className: de("recharts-reference-area", c)
      }, t.renderRect(v, v1(v1({
        clipPath: b
      }, ie(this.props, !0)), p)), Ke.renderCallByParent(this.props, p));
    }
  }]);
})(k.Component);
El(Tl, "displayName", "ReferenceArea");
El(Tl, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
El(Tl, "renderRect", function(e, t) {
  var r;
  return /* @__PURE__ */ k.isValidElement(e) ? r = /* @__PURE__ */ k.cloneElement(e, t) : ue(e) ? r = e(t) : r = /* @__PURE__ */ k.createElement(jg, Lv({}, t, {
    className: "recharts-reference-area-rect"
  })), r;
});
function fI(e, t, r) {
  if (t < 1)
    return [];
  if (t === 1 && r === void 0)
    return e;
  for (var n = [], o = 0; o < e.length; o += t)
    n.push(e[o]);
  return n;
}
function BX(e, t, r) {
  var n = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return GY(n, r);
}
function FX(e, t, r) {
  var n = r === "width", o = e.x, a = e.y, i = e.width, s = e.height;
  return t === 1 ? {
    start: n ? o : a,
    end: n ? o + i : a + s
  } : {
    start: n ? o + i : a + s,
    end: n ? o : a
  };
}
function fc(e, t, r, n, o) {
  if (e * t < e * n || e * t > e * o)
    return !1;
  var a = r();
  return e * (t - e * a / 2 - n) >= 0 && e * (t + e * a / 2 - o) <= 0;
}
function qX(e, t) {
  return fI(e, t + 1);
}
function zX(e, t, r, n, o) {
  for (var a = (n || []).slice(), i = t.start, s = t.end, c = 0, l = 1, f = i, u = function() {
    var m = n == null ? void 0 : n[c];
    if (m === void 0)
      return {
        v: fI(n, l)
      };
    var v = c, p, b = function() {
      return p === void 0 && (p = r(m, v)), p;
    }, w = m.coordinate, x = c === 0 || fc(e, w, b, f, s);
    x || (c = 0, f = i, l += 1), x && (f = w + e * (b() / 2 + o), c += l);
  }, d; l <= a.length; )
    if (d = u(), d) return d.v;
  return [];
}
function ei(e) {
  "@babel/helpers - typeof";
  return ei = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ei(e);
}
function m1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function et(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? m1(Object(r), !0).forEach(function(n) {
      WX(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : m1(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function WX(e, t, r) {
  return t = UX(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function UX(e) {
  var t = HX(e, "string");
  return ei(t) == "symbol" ? t : t + "";
}
function HX(e, t) {
  if (ei(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ei(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function VX(e, t, r, n, o) {
  for (var a = (n || []).slice(), i = a.length, s = t.start, c = t.end, l = function(d) {
    var h = a[d], m, v = function() {
      return m === void 0 && (m = r(h, d)), m;
    };
    if (d === i - 1) {
      var p = e * (h.coordinate + e * v() / 2 - c);
      a[d] = h = et(et({}, h), {}, {
        tickCoord: p > 0 ? h.coordinate - p * e : h.coordinate
      });
    } else
      a[d] = h = et(et({}, h), {}, {
        tickCoord: h.coordinate
      });
    var b = fc(e, h.tickCoord, v, s, c);
    b && (c = h.tickCoord - e * (v() / 2 + o), a[d] = et(et({}, h), {}, {
      isShow: !0
    }));
  }, f = i - 1; f >= 0; f--)
    l(f);
  return a;
}
function KX(e, t, r, n, o, a) {
  var i = (n || []).slice(), s = i.length, c = t.start, l = t.end;
  if (a) {
    var f = n[s - 1], u = r(f, s - 1), d = e * (f.coordinate + e * u / 2 - l);
    i[s - 1] = f = et(et({}, f), {}, {
      tickCoord: d > 0 ? f.coordinate - d * e : f.coordinate
    });
    var h = fc(e, f.tickCoord, function() {
      return u;
    }, c, l);
    h && (l = f.tickCoord - e * (u / 2 + o), i[s - 1] = et(et({}, f), {}, {
      isShow: !0
    }));
  }
  for (var m = a ? s - 1 : s, v = function(w) {
    var x = i[w], _, y = function() {
      return _ === void 0 && (_ = r(x, w)), _;
    };
    if (w === 0) {
      var O = e * (x.coordinate - e * y() / 2 - c);
      i[w] = x = et(et({}, x), {}, {
        tickCoord: O < 0 ? x.coordinate - O * e : x.coordinate
      });
    } else
      i[w] = x = et(et({}, x), {}, {
        tickCoord: x.coordinate
      });
    var A = fc(e, x.tickCoord, y, c, l);
    A && (c = x.tickCoord + e * (y() / 2 + o), i[w] = et(et({}, x), {}, {
      isShow: !0
    }));
  }, p = 0; p < m; p++)
    v(p);
  return i;
}
function GX(e, t, r) {
  var n = e.tick, o = e.ticks, a = e.viewBox, i = e.minTickGap, s = e.orientation, c = e.interval, l = e.tickFormatter, f = e.unit, u = e.angle;
  if (!o || !o.length || !n)
    return [];
  if (ne(c) || _n.isSsr)
    return qX(o, typeof c == "number" && ne(c) ? c : 0);
  var d = [], h = s === "top" || s === "bottom" ? "width" : "height", m = f && h === "width" ? ua(f, {
    fontSize: t,
    letterSpacing: r
  }) : {
    width: 0,
    height: 0
  }, v = function(x, _) {
    var y = ue(l) ? l(x.value, _) : x.value;
    return h === "width" ? BX(ua(y, {
      fontSize: t,
      letterSpacing: r
    }), m, u) : ua(y, {
      fontSize: t,
      letterSpacing: r
    })[h];
  }, p = o.length >= 2 ? rt(o[1].coordinate - o[0].coordinate) : 1, b = FX(a, p, h);
  return c === "equidistantPreserveStart" ? zX(p, b, v, o, i) : (c === "preserveStart" || c === "preserveStartEnd" ? d = KX(p, b, v, o, i, c === "preserveStartEnd") : d = VX(p, b, v, o, i), d.filter(function(w) {
    return w.isShow;
  }));
}
var YX = ["viewBox"], XX = ["viewBox"], ZX = ["ticks"];
function So(e) {
  "@babel/helpers - typeof";
  return So = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, So(e);
}
function Fn() {
  return Fn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fn.apply(this, arguments);
}
function g1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Be(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? g1(Object(r), !0).forEach(function(n) {
      qg(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : g1(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function eh(e, t) {
  if (e == null) return {};
  var r = JX(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function JX(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function QX(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function y1(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, pI(n.key), n);
  }
}
function e7(e, t, r) {
  return t && y1(e.prototype, t), r && y1(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function t7(e, t, r) {
  return t = dc(t), r7(e, dI() ? Reflect.construct(t, r || [], dc(e).constructor) : t.apply(e, r));
}
function r7(e, t) {
  if (t && (So(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return n7(e);
}
function n7(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function dI() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (dI = function() {
    return !!e;
  })();
}
function dc(e) {
  return dc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, dc(e);
}
function o7(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Fv(e, t);
}
function Fv(e, t) {
  return Fv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Fv(e, t);
}
function qg(e, t, r) {
  return t = pI(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function pI(e) {
  var t = a7(e, "string");
  return So(t) == "symbol" ? t : t + "";
}
function a7(e, t) {
  if (So(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (So(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Cl = /* @__PURE__ */ (function(e) {
  function t(r) {
    var n;
    return QX(this, t), n = t7(this, t, [r]), n.state = {
      fontSize: "",
      letterSpacing: ""
    }, n;
  }
  return o7(t, e), e7(t, [{
    key: "shouldComponentUpdate",
    value: function(n, o) {
      var a = n.viewBox, i = eh(n, YX), s = this.props, c = s.viewBox, l = eh(s, XX);
      return !Vn(a, c) || !Vn(i, l) || !Vn(o, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.layerReference;
      if (n) {
        var o = n.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        o && this.setState({
          fontSize: window.getComputedStyle(o).fontSize,
          letterSpacing: window.getComputedStyle(o).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(n) {
      var o = this.props, a = o.x, i = o.y, s = o.width, c = o.height, l = o.orientation, f = o.tickSize, u = o.mirror, d = o.tickMargin, h, m, v, p, b, w, x = u ? -1 : 1, _ = n.tickSize || f, y = ne(n.tickCoord) ? n.tickCoord : n.coordinate;
      switch (l) {
        case "top":
          h = m = n.coordinate, p = i + +!u * c, v = p - x * _, w = v - x * d, b = y;
          break;
        case "left":
          v = p = n.coordinate, m = a + +!u * s, h = m - x * _, b = h - x * d, w = y;
          break;
        case "right":
          v = p = n.coordinate, m = a + +u * s, h = m + x * _, b = h + x * d, w = y;
          break;
        default:
          h = m = n.coordinate, p = i + +u * c, v = p + x * _, w = v + x * d, b = y;
          break;
      }
      return {
        line: {
          x1: h,
          y1: v,
          x2: m,
          y2: p
        },
        tick: {
          x: b,
          y: w
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props, o = n.orientation, a = n.mirror, i;
      switch (o) {
        case "left":
          i = a ? "start" : "end";
          break;
        case "right":
          i = a ? "end" : "start";
          break;
        default:
          i = "middle";
          break;
      }
      return i;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var n = this.props, o = n.orientation, a = n.mirror, i = "end";
      switch (o) {
        case "left":
        case "right":
          i = "middle";
          break;
        case "top":
          i = a ? "start" : "end";
          break;
        default:
          i = a ? "end" : "start";
          break;
      }
      return i;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, o = n.x, a = n.y, i = n.width, s = n.height, c = n.orientation, l = n.mirror, f = n.axisLine, u = Be(Be(Be({}, ie(this.props, !1)), ie(f, !1)), {}, {
        fill: "none"
      });
      if (c === "top" || c === "bottom") {
        var d = +(c === "top" && !l || c === "bottom" && l);
        u = Be(Be({}, u), {}, {
          x1: o,
          y1: a + d * s,
          x2: o + i,
          y2: a + d * s
        });
      } else {
        var h = +(c === "left" && !l || c === "right" && l);
        u = Be(Be({}, u), {}, {
          x1: o + h * i,
          y1: a,
          x2: o + h * i,
          y2: a + s
        });
      }
      return /* @__PURE__ */ k.createElement("line", Fn({}, u, {
        className: de("recharts-cartesian-axis-line", yt(f, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(n, o, a) {
        var i = this, s = this.props, c = s.tickLine, l = s.stroke, f = s.tick, u = s.tickFormatter, d = s.unit, h = GX(Be(Be({}, this.props), {}, {
          ticks: n
        }), o, a), m = this.getTickTextAnchor(), v = this.getTickVerticalAnchor(), p = ie(this.props, !1), b = ie(f, !1), w = Be(Be({}, p), {}, {
          fill: "none"
        }, ie(c, !1)), x = h.map(function(_, y) {
          var O = i.getTickLineCoord(_), A = O.line, P = O.tick, T = Be(Be(Be(Be({
            textAnchor: m,
            verticalAnchor: v
          }, p), {}, {
            stroke: "none",
            fill: l
          }, b), P), {}, {
            index: y,
            payload: _,
            visibleTicksCount: h.length,
            tickFormatter: u
          });
          return /* @__PURE__ */ k.createElement(ve, Fn({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(_.value, "-").concat(_.coordinate, "-").concat(_.tickCoord)
          }, mn(i.props, _, y)), c && /* @__PURE__ */ k.createElement("line", Fn({}, w, A, {
            className: de("recharts-cartesian-axis-tick-line", yt(c, "className"))
          })), f && t.renderTickItem(f, T, "".concat(ue(u) ? u(_.value, y) : _.value).concat(d || "")));
        });
        return /* @__PURE__ */ k.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, x);
      }
    )
  }, {
    key: "render",
    value: function() {
      var n = this, o = this.props, a = o.axisLine, i = o.width, s = o.height, c = o.ticksGenerator, l = o.className, f = o.hide;
      if (f)
        return null;
      var u = this.props, d = u.ticks, h = eh(u, ZX), m = d;
      return ue(c) && (m = d && d.length > 0 ? c(this.props) : c(h)), i <= 0 || s <= 0 || !m || !m.length ? null : /* @__PURE__ */ k.createElement(ve, {
        className: de("recharts-cartesian-axis", l),
        ref: function(p) {
          n.layerReference = p;
        }
      }, a && this.renderAxisLine(), this.renderTicks(m, this.state.fontSize, this.state.letterSpacing), Ke.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, o, a) {
      var i, s = de(o.className, "recharts-cartesian-axis-tick-value");
      return /* @__PURE__ */ k.isValidElement(n) ? i = /* @__PURE__ */ k.cloneElement(n, Be(Be({}, o), {}, {
        className: s
      })) : ue(n) ? i = n(Be(Be({}, o), {}, {
        className: s
      })) : i = /* @__PURE__ */ k.createElement(gn, Fn({}, o, {
        className: "recharts-cartesian-axis-tick-value"
      }), a), i;
    }
  }]);
})(I1);
qg(Cl, "displayName", "CartesianAxis");
qg(Cl, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var i7 = ["type", "layout", "connectNulls", "ref"], s7 = ["key"];
function _o(e) {
  "@babel/helpers - typeof";
  return _o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _o(e);
}
function b1(e, t) {
  if (e == null) return {};
  var r = c7(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function c7(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function ma() {
  return ma = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ma.apply(this, arguments);
}
function w1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ut(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? w1(Object(r), !0).forEach(function(n) {
      kt(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : w1(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function In(e) {
  return d7(e) || f7(e) || u7(e) || l7();
}
function l7() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function u7(e, t) {
  if (e) {
    if (typeof e == "string") return qv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return qv(e, t);
  }
}
function f7(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function d7(e) {
  if (Array.isArray(e)) return qv(e);
}
function qv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function p7(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function x1(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, vI(n.key), n);
  }
}
function h7(e, t, r) {
  return t && x1(e.prototype, t), r && x1(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function v7(e, t, r) {
  return t = pc(t), m7(e, hI() ? Reflect.construct(t, r || [], pc(e).constructor) : t.apply(e, r));
}
function m7(e, t) {
  if (t && (_o(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return g7(e);
}
function g7(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function hI() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (hI = function() {
    return !!e;
  })();
}
function pc(e) {
  return pc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, pc(e);
}
function y7(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && zv(e, t);
}
function zv(e, t) {
  return zv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, zv(e, t);
}
function kt(e, t, r) {
  return t = vI(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function vI(e) {
  var t = b7(e, "string");
  return _o(t) == "symbol" ? t : t + "";
}
function b7(e, t) {
  if (_o(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (_o(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Rl = /* @__PURE__ */ (function(e) {
  function t() {
    var r;
    p7(this, t);
    for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++)
      o[a] = arguments[a];
    return r = v7(this, t, [].concat(o)), kt(r, "state", {
      isAnimationFinished: !0,
      totalLength: 0
    }), kt(r, "generateSimpleStrokeDasharray", function(i, s) {
      return "".concat(s, "px ").concat(i - s, "px");
    }), kt(r, "getStrokeDasharray", function(i, s, c) {
      var l = c.reduce(function(b, w) {
        return b + w;
      });
      if (!l)
        return r.generateSimpleStrokeDasharray(s, i);
      for (var f = Math.floor(i / l), u = i % l, d = s - i, h = [], m = 0, v = 0; m < c.length; v += c[m], ++m)
        if (v + c[m] > u) {
          h = [].concat(In(c.slice(0, m)), [u - v]);
          break;
        }
      var p = h.length % 2 === 0 ? [0, d] : [d];
      return [].concat(In(t.repeat(c, f)), In(h), p).map(function(b) {
        return "".concat(b, "px");
      }).join(", ");
    }), kt(r, "id", qo("recharts-line-")), kt(r, "pathRef", function(i) {
      r.mainCurve = i;
    }), kt(r, "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      }), r.props.onAnimationEnd && r.props.onAnimationEnd();
    }), kt(r, "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      }), r.props.onAnimationStart && r.props.onAnimationStart();
    }), r;
  }
  return y7(t, e), h7(t, [{
    key: "componentDidMount",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        n !== this.state.totalLength && this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var n = this.mainCurve;
      try {
        return n && n.getTotalLength && n.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function(n, o) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var a = this.props, i = a.points, s = a.xAxis, c = a.yAxis, l = a.layout, f = a.children, u = bt(f, Ci);
      if (!u)
        return null;
      var d = function(v, p) {
        return {
          x: v.x,
          y: v.y,
          value: v.value,
          errorVal: ze(v.payload, p)
        };
      }, h = {
        clipPath: n ? "url(#clipPath-".concat(o, ")") : null
      };
      return /* @__PURE__ */ k.createElement(ve, h, u.map(function(m) {
        return /* @__PURE__ */ k.cloneElement(m, {
          key: "bar-".concat(m.props.dataKey),
          data: i,
          xAxis: s,
          yAxis: c,
          layout: l,
          dataPointFormatter: d
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function(n, o, a) {
      var i = this.props.isAnimationActive;
      if (i && !this.state.isAnimationFinished)
        return null;
      var s = this.props, c = s.dot, l = s.points, f = s.dataKey, u = ie(this.props, !1), d = ie(c, !0), h = l.map(function(v, p) {
        var b = ut(ut(ut({
          key: "dot-".concat(p),
          r: 3
        }, u), d), {}, {
          index: p,
          cx: v.x,
          cy: v.y,
          value: v.value,
          dataKey: f,
          payload: v.payload,
          points: l
        });
        return t.renderDotItem(c, b);
      }), m = {
        clipPath: n ? "url(#clipPath-".concat(o ? "" : "dots-").concat(a, ")") : null
      };
      return /* @__PURE__ */ k.createElement(ve, ma({
        className: "recharts-line-dots",
        key: "dots"
      }, m), h);
    }
  }, {
    key: "renderCurveStatically",
    value: function(n, o, a, i) {
      var s = this.props, c = s.type, l = s.layout, f = s.connectNulls;
      s.ref;
      var u = b1(s, i7), d = ut(ut(ut({}, ie(u, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: o ? "url(#clipPath-".concat(a, ")") : null,
        points: n
      }, i), {}, {
        type: c,
        layout: l,
        connectNulls: f
      });
      return /* @__PURE__ */ k.createElement(Us, ma({}, d, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(n, o) {
      var a = this, i = this.props, s = i.points, c = i.strokeDasharray, l = i.isAnimationActive, f = i.animationBegin, u = i.animationDuration, d = i.animationEasing, h = i.animationId, m = i.animateNewValues, v = i.width, p = i.height, b = this.state, w = b.prevPoints, x = b.totalLength;
      return /* @__PURE__ */ k.createElement(er, {
        begin: f,
        duration: u,
        isActive: l,
        easing: d,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(h),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(_) {
        var y = _.t;
        if (w) {
          var O = w.length / s.length, A = s.map(function(C, R) {
            var M = Math.floor(R * O);
            if (w[M]) {
              var D = w[M], $ = ht(D.x, C.x), q = ht(D.y, C.y);
              return ut(ut({}, C), {}, {
                x: $(y),
                y: q(y)
              });
            }
            if (m) {
              var F = ht(v * 2, C.x), B = ht(p / 2, C.y);
              return ut(ut({}, C), {}, {
                x: F(y),
                y: B(y)
              });
            }
            return ut(ut({}, C), {}, {
              x: C.x,
              y: C.y
            });
          });
          return a.renderCurveStatically(A, n, o);
        }
        var P = ht(0, x), T = P(y), I;
        if (c) {
          var E = "".concat(c).split(/[,\s]+/gim).map(function(C) {
            return parseFloat(C);
          });
          I = a.getStrokeDasharray(T, x, E);
        } else
          I = a.generateSimpleStrokeDasharray(x, T);
        return a.renderCurveStatically(s, n, o, {
          strokeDasharray: I
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function(n, o) {
      var a = this.props, i = a.points, s = a.isAnimationActive, c = this.state, l = c.prevPoints, f = c.totalLength;
      return s && i && i.length && (!l && f > 0 || !Ti(l, i)) ? this.renderCurveWithAnimation(n, o) : this.renderCurveStatically(i, n, o);
    }
  }, {
    key: "render",
    value: function() {
      var n, o = this.props, a = o.hide, i = o.dot, s = o.points, c = o.className, l = o.xAxis, f = o.yAxis, u = o.top, d = o.left, h = o.width, m = o.height, v = o.isAnimationActive, p = o.id;
      if (a || !s || !s.length)
        return null;
      var b = this.state.isAnimationFinished, w = s.length === 1, x = de("recharts-line", c), _ = l && l.allowDataOverflow, y = f && f.allowDataOverflow, O = _ || y, A = fe(p) ? this.id : p, P = (n = ie(i, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, T = P.r, I = T === void 0 ? 3 : T, E = P.strokeWidth, C = E === void 0 ? 2 : E, R = nq(i) ? i : {}, M = R.clipDot, D = M === void 0 ? !0 : M, $ = I * 2 + C;
      return /* @__PURE__ */ k.createElement(ve, {
        className: x
      }, _ || y ? /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("clipPath", {
        id: "clipPath-".concat(A)
      }, /* @__PURE__ */ k.createElement("rect", {
        x: _ ? d : d - h / 2,
        y: y ? u : u - m / 2,
        width: _ ? h : h * 2,
        height: y ? m : m * 2
      })), !D && /* @__PURE__ */ k.createElement("clipPath", {
        id: "clipPath-dots-".concat(A)
      }, /* @__PURE__ */ k.createElement("rect", {
        x: d - $ / 2,
        y: u - $ / 2,
        width: h + $,
        height: m + $
      }))) : null, !w && this.renderCurve(O, A), this.renderErrorBar(O, A), (w || i) && this.renderDots(O, D, A), (!v || b) && vr.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, o) {
      return n.animationId !== o.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: o.curPoints
      } : n.points !== o.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(n, o) {
      for (var a = n.length % 2 !== 0 ? [].concat(In(n), [0]) : n, i = [], s = 0; s < o; ++s)
        i = [].concat(In(i), In(a));
      return i;
    }
  }, {
    key: "renderDotItem",
    value: function(n, o) {
      var a;
      if (/* @__PURE__ */ k.isValidElement(n))
        a = /* @__PURE__ */ k.cloneElement(n, o);
      else if (ue(n))
        a = n(o);
      else {
        var i = o.key, s = b1(o, s7), c = de("recharts-line-dot", typeof n != "boolean" ? n.className : "");
        a = /* @__PURE__ */ k.createElement(gl, ma({
          key: i
        }, s, {
          className: c
        }));
      }
      return a;
    }
  }]);
})(Ft);
kt(Rl, "displayName", "Line");
kt(Rl, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !_n.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
});
kt(Rl, "getComposedData", function(e) {
  var t = e.props, r = e.xAxis, n = e.yAxis, o = e.xAxisTicks, a = e.yAxisTicks, i = e.dataKey, s = e.bandSize, c = e.displayedData, l = e.offset, f = t.layout, u = c.map(function(d, h) {
    var m = ze(d, i);
    return f === "horizontal" ? {
      x: xS({
        axis: r,
        ticks: o,
        bandSize: s,
        entry: d,
        index: h
      }),
      y: fe(m) ? null : n.scale(m),
      value: m,
      payload: d
    } : {
      x: fe(m) ? null : r.scale(m),
      y: xS({
        axis: n,
        ticks: a,
        bandSize: s,
        entry: d,
        index: h
      }),
      value: m,
      payload: d
    };
  });
  return ut({
    points: u,
    layout: f
  }, l);
});
function Oo(e) {
  "@babel/helpers - typeof";
  return Oo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Oo(e);
}
function w7(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function x7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, yI(n.key), n);
  }
}
function S7(e, t, r) {
  return t && x7(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function _7(e, t, r) {
  return t = hc(t), O7(e, mI() ? Reflect.construct(t, r || [], hc(e).constructor) : t.apply(e, r));
}
function O7(e, t) {
  if (t && (Oo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return A7(e);
}
function A7(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function mI() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (mI = function() {
    return !!e;
  })();
}
function hc(e) {
  return hc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, hc(e);
}
function P7(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Wv(e, t);
}
function Wv(e, t) {
  return Wv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Wv(e, t);
}
function gI(e, t, r) {
  return t = yI(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function yI(e) {
  var t = E7(e, "string");
  return Oo(t) == "symbol" ? t : t + "";
}
function E7(e, t) {
  if (Oo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Oo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Uv() {
  return Uv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Uv.apply(this, arguments);
}
function T7(e) {
  var t = e.xAxisId, r = nI(), n = oI(), o = tI(t);
  return o == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ g.createElement(Cl, Uv({}, o, {
      className: de("recharts-".concat(o.axisType, " ").concat(o.axisType), o.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: n
      },
      ticksGenerator: function(i) {
        return nn(i, !0);
      }
    }))
  );
}
var Ml = /* @__PURE__ */ (function(e) {
  function t() {
    return w7(this, t), _7(this, t, arguments);
  }
  return P7(t, e), S7(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ g.createElement(T7, this.props);
    }
  }]);
})(g.Component);
gI(Ml, "displayName", "XAxis");
gI(Ml, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function Ao(e) {
  "@babel/helpers - typeof";
  return Ao = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ao(e);
}
function C7(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function R7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, xI(n.key), n);
  }
}
function M7(e, t, r) {
  return t && R7(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function I7(e, t, r) {
  return t = vc(t), N7(e, bI() ? Reflect.construct(t, r || [], vc(e).constructor) : t.apply(e, r));
}
function N7(e, t) {
  if (t && (Ao(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return k7(e);
}
function k7(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function bI() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (bI = function() {
    return !!e;
  })();
}
function vc(e) {
  return vc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, vc(e);
}
function $7(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Hv(e, t);
}
function Hv(e, t) {
  return Hv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Hv(e, t);
}
function wI(e, t, r) {
  return t = xI(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function xI(e) {
  var t = D7(e, "string");
  return Ao(t) == "symbol" ? t : t + "";
}
function D7(e, t) {
  if (Ao(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ao(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Vv() {
  return Vv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vv.apply(this, arguments);
}
var j7 = function(t) {
  var r = t.yAxisId, n = nI(), o = oI(), a = rI(r);
  return a == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ g.createElement(Cl, Vv({}, a, {
      className: de("recharts-".concat(a.axisType, " ").concat(a.axisType), a.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: o
      },
      ticksGenerator: function(s) {
        return nn(s, !0);
      }
    }))
  );
}, Il = /* @__PURE__ */ (function(e) {
  function t() {
    return C7(this, t), I7(this, t, arguments);
  }
  return $7(t, e), M7(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ g.createElement(j7, this.props);
    }
  }]);
})(g.Component);
wI(Il, "displayName", "YAxis");
wI(Il, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function S1(e) {
  return q7(e) || F7(e) || B7(e) || L7();
}
function L7() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function B7(e, t) {
  if (e) {
    if (typeof e == "string") return Kv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Kv(e, t);
  }
}
function F7(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function q7(e) {
  if (Array.isArray(e)) return Kv(e);
}
function Kv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var Gv = function(t, r, n, o, a) {
  var i = bt(t, Fg), s = bt(t, Pl), c = [].concat(S1(i), S1(s)), l = bt(t, Tl), f = "".concat(o, "Id"), u = o[0], d = r;
  if (c.length && (d = c.reduce(function(v, p) {
    if (p.props[f] === n && Xt(p.props, "extendDomain") && ne(p.props[u])) {
      var b = p.props[u];
      return [Math.min(v[0], b), Math.max(v[1], b)];
    }
    return v;
  }, d)), l.length) {
    var h = "".concat(u, "1"), m = "".concat(u, "2");
    d = l.reduce(function(v, p) {
      if (p.props[f] === n && Xt(p.props, "extendDomain") && ne(p.props[h]) && ne(p.props[m])) {
        var b = p.props[h], w = p.props[m];
        return [Math.min(v[0], b, w), Math.max(v[1], b, w)];
      }
      return v;
    }, d);
  }
  return a && a.length && (d = a.reduce(function(v, p) {
    return ne(p) ? [Math.min(v[0], p), Math.max(v[1], p)] : v;
  }, d)), d;
}, th = { exports: {} }, _1;
function z7() {
  return _1 || (_1 = 1, (function(e) {
    var t = Object.prototype.hasOwnProperty, r = "~";
    function n() {
    }
    Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
    function o(c, l, f) {
      this.fn = c, this.context = l, this.once = f || !1;
    }
    function a(c, l, f, u, d) {
      if (typeof f != "function")
        throw new TypeError("The listener must be a function");
      var h = new o(f, u || c, d), m = r ? r + l : l;
      return c._events[m] ? c._events[m].fn ? c._events[m] = [c._events[m], h] : c._events[m].push(h) : (c._events[m] = h, c._eventsCount++), c;
    }
    function i(c, l) {
      --c._eventsCount === 0 ? c._events = new n() : delete c._events[l];
    }
    function s() {
      this._events = new n(), this._eventsCount = 0;
    }
    s.prototype.eventNames = function() {
      var l = [], f, u;
      if (this._eventsCount === 0) return l;
      for (u in f = this._events)
        t.call(f, u) && l.push(r ? u.slice(1) : u);
      return Object.getOwnPropertySymbols ? l.concat(Object.getOwnPropertySymbols(f)) : l;
    }, s.prototype.listeners = function(l) {
      var f = r ? r + l : l, u = this._events[f];
      if (!u) return [];
      if (u.fn) return [u.fn];
      for (var d = 0, h = u.length, m = new Array(h); d < h; d++)
        m[d] = u[d].fn;
      return m;
    }, s.prototype.listenerCount = function(l) {
      var f = r ? r + l : l, u = this._events[f];
      return u ? u.fn ? 1 : u.length : 0;
    }, s.prototype.emit = function(l, f, u, d, h, m) {
      var v = r ? r + l : l;
      if (!this._events[v]) return !1;
      var p = this._events[v], b = arguments.length, w, x;
      if (p.fn) {
        switch (p.once && this.removeListener(l, p.fn, void 0, !0), b) {
          case 1:
            return p.fn.call(p.context), !0;
          case 2:
            return p.fn.call(p.context, f), !0;
          case 3:
            return p.fn.call(p.context, f, u), !0;
          case 4:
            return p.fn.call(p.context, f, u, d), !0;
          case 5:
            return p.fn.call(p.context, f, u, d, h), !0;
          case 6:
            return p.fn.call(p.context, f, u, d, h, m), !0;
        }
        for (x = 1, w = new Array(b - 1); x < b; x++)
          w[x - 1] = arguments[x];
        p.fn.apply(p.context, w);
      } else {
        var _ = p.length, y;
        for (x = 0; x < _; x++)
          switch (p[x].once && this.removeListener(l, p[x].fn, void 0, !0), b) {
            case 1:
              p[x].fn.call(p[x].context);
              break;
            case 2:
              p[x].fn.call(p[x].context, f);
              break;
            case 3:
              p[x].fn.call(p[x].context, f, u);
              break;
            case 4:
              p[x].fn.call(p[x].context, f, u, d);
              break;
            default:
              if (!w) for (y = 1, w = new Array(b - 1); y < b; y++)
                w[y - 1] = arguments[y];
              p[x].fn.apply(p[x].context, w);
          }
      }
      return !0;
    }, s.prototype.on = function(l, f, u) {
      return a(this, l, f, u, !1);
    }, s.prototype.once = function(l, f, u) {
      return a(this, l, f, u, !0);
    }, s.prototype.removeListener = function(l, f, u, d) {
      var h = r ? r + l : l;
      if (!this._events[h]) return this;
      if (!f)
        return i(this, h), this;
      var m = this._events[h];
      if (m.fn)
        m.fn === f && (!d || m.once) && (!u || m.context === u) && i(this, h);
      else {
        for (var v = 0, p = [], b = m.length; v < b; v++)
          (m[v].fn !== f || d && !m[v].once || u && m[v].context !== u) && p.push(m[v]);
        p.length ? this._events[h] = p.length === 1 ? p[0] : p : i(this, h);
      }
      return this;
    }, s.prototype.removeAllListeners = function(l) {
      var f;
      return l ? (f = r ? r + l : l, this._events[f] && i(this, f)) : (this._events = new n(), this._eventsCount = 0), this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = r, s.EventEmitter = s, e.exports = s;
  })(th)), th.exports;
}
var W7 = z7();
const U7 = /* @__PURE__ */ Ae(W7);
var rh = new U7(), nh = "recharts.syncMouseEvents";
function ti(e) {
  "@babel/helpers - typeof";
  return ti = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ti(e);
}
function H7(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function V7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, SI(n.key), n);
  }
}
function K7(e, t, r) {
  return t && V7(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function oh(e, t, r) {
  return t = SI(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function SI(e) {
  var t = G7(e, "string");
  return ti(t) == "symbol" ? t : t + "";
}
function G7(e, t) {
  if (ti(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ti(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Y7 = /* @__PURE__ */ (function() {
  function e() {
    H7(this, e), oh(this, "activeIndex", 0), oh(this, "coordinateList", []), oh(this, "layout", "horizontal");
  }
  return K7(e, [{
    key: "setDetails",
    value: function(r) {
      var n, o = r.coordinateList, a = o === void 0 ? null : o, i = r.container, s = i === void 0 ? null : i, c = r.layout, l = c === void 0 ? null : c, f = r.offset, u = f === void 0 ? null : f, d = r.mouseHandlerCallback, h = d === void 0 ? null : d;
      this.coordinateList = (n = a ?? this.coordinateList) !== null && n !== void 0 ? n : [], this.container = s ?? this.container, this.layout = l ?? this.layout, this.offset = u ?? this.offset, this.mouseHandlerCallback = h ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(r) {
      if (this.coordinateList.length !== 0)
        switch (r.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(r) {
      this.activeIndex = r;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var r, n;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var o = this.container.getBoundingClientRect(), a = o.x, i = o.y, s = o.height, c = this.coordinateList[this.activeIndex].coordinate, l = ((r = window) === null || r === void 0 ? void 0 : r.scrollX) || 0, f = ((n = window) === null || n === void 0 ? void 0 : n.scrollY) || 0, u = a + c + l, d = i + this.offset.top + s / 2 + f;
        this.mouseHandlerCallback({
          pageX: u,
          pageY: d
        });
      }
    }
  }]);
})();
function X7(e, t, r) {
  if (r === "number" && t === !0 && Array.isArray(e)) {
    var n = e == null ? void 0 : e[0], o = e == null ? void 0 : e[1];
    if (n && o && ne(n) && ne(o))
      return !0;
  }
  return !1;
}
function Z7(e, t, r, n) {
  var o = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - o : r.left + 0.5,
    y: e === "horizontal" ? r.top + 0.5 : t.y - o,
    width: e === "horizontal" ? n : r.width - 1,
    height: e === "horizontal" ? r.height - 1 : n
  };
}
function _I(e) {
  var t = e.cx, r = e.cy, n = e.radius, o = e.startAngle, a = e.endAngle, i = Te(t, r, n, o), s = Te(t, r, n, a);
  return {
    points: [i, s],
    cx: t,
    cy: r,
    radius: n,
    startAngle: o,
    endAngle: a
  };
}
function J7(e, t, r) {
  var n, o, a, i;
  if (e === "horizontal")
    n = t.x, a = n, o = r.top, i = r.top + r.height;
  else if (e === "vertical")
    o = t.y, i = o, n = r.left, a = r.left + r.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var s = t.cx, c = t.cy, l = t.innerRadius, f = t.outerRadius, u = t.angle, d = Te(s, c, l, u), h = Te(s, c, f, u);
      n = d.x, o = d.y, a = h.x, i = h.y;
    } else
      return _I(t);
  return [{
    x: n,
    y: o
  }, {
    x: a,
    y: i
  }];
}
function ri(e) {
  "@babel/helpers - typeof";
  return ri = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ri(e);
}
function O1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Qi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? O1(Object(r), !0).forEach(function(n) {
      Q7(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : O1(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Q7(e, t, r) {
  return t = eZ(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function eZ(e) {
  var t = tZ(e, "string");
  return ri(t) == "symbol" ? t : t + "";
}
function tZ(e, t) {
  if (ri(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ri(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function rZ(e) {
  var t, r, n = e.element, o = e.tooltipEventType, a = e.isActive, i = e.activeCoordinate, s = e.activePayload, c = e.offset, l = e.activeTooltipIndex, f = e.tooltipAxisBandSize, u = e.layout, d = e.chartName, h = (t = n.props.cursor) !== null && t !== void 0 ? t : (r = n.type.defaultProps) === null || r === void 0 ? void 0 : r.cursor;
  if (!n || !h || !a || !i || d !== "ScatterChart" && o !== "axis")
    return null;
  var m, v = Us;
  if (d === "ScatterChart")
    m = i, v = BG;
  else if (d === "BarChart")
    m = Z7(u, i, c, f), v = jg;
  else if (u === "radial") {
    var p = _I(i), b = p.cx, w = p.cy, x = p.radius, _ = p.startAngle, y = p.endAngle;
    m = {
      cx: b,
      cy: w,
      startAngle: _,
      endAngle: y,
      innerRadius: x,
      outerRadius: x
    }, v = wM;
  } else
    m = {
      points: J7(u, i, c)
    }, v = Us;
  var O = Qi(Qi(Qi(Qi({
    stroke: "#ccc",
    pointerEvents: "none"
  }, c), m), ie(h, !1)), {}, {
    payload: s,
    payloadIndex: l,
    className: de("recharts-tooltip-cursor", h.className)
  });
  return /* @__PURE__ */ jt(h) ? /* @__PURE__ */ qe(h, O) : /* @__PURE__ */ cn(v, O);
}
var nZ = ["item"], oZ = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function Po(e) {
  "@babel/helpers - typeof";
  return Po = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Po(e);
}
function qn() {
  return qn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qn.apply(this, arguments);
}
function A1(e, t) {
  return sZ(e) || iZ(e, t) || AI(e, t) || aZ();
}
function aZ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iZ(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, o, a, i, s = [], c = !0, l = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, o = f;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw o;
      }
    }
    return s;
  }
}
function sZ(e) {
  if (Array.isArray(e)) return e;
}
function P1(e, t) {
  if (e == null) return {};
  var r = cZ(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function cZ(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function lZ(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function uZ(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, PI(n.key), n);
  }
}
function fZ(e, t, r) {
  return t && uZ(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function dZ(e, t, r) {
  return t = mc(t), pZ(e, OI() ? Reflect.construct(t, r || [], mc(e).constructor) : t.apply(e, r));
}
function pZ(e, t) {
  if (t && (Po(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return hZ(e);
}
function hZ(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function OI() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (OI = function() {
    return !!e;
  })();
}
function mc(e) {
  return mc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, mc(e);
}
function vZ(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Yv(e, t);
}
function Yv(e, t) {
  return Yv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Yv(e, t);
}
function Eo(e) {
  return yZ(e) || gZ(e) || AI(e) || mZ();
}
function mZ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function AI(e, t) {
  if (e) {
    if (typeof e == "string") return Xv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Xv(e, t);
  }
}
function gZ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function yZ(e) {
  if (Array.isArray(e)) return Xv(e);
}
function Xv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function E1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function H(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? E1(Object(r), !0).forEach(function(n) {
      se(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : E1(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function se(e, t, r) {
  return t = PI(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function PI(e) {
  var t = bZ(e, "string");
  return Po(t) == "symbol" ? t : t + "";
}
function bZ(e, t) {
  if (Po(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Po(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wZ = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, xZ = {
  width: "100%",
  height: "100%"
}, EI = {
  x: 0,
  y: 0
};
function es(e) {
  return e;
}
var SZ = function(t, r) {
  return r === "horizontal" ? t.x : r === "vertical" ? t.y : r === "centric" ? t.angle : t.radius;
}, _Z = function(t, r, n, o) {
  var a = r.find(function(f) {
    return f && f.index === n;
  });
  if (a) {
    if (t === "horizontal")
      return {
        x: a.coordinate,
        y: o.y
      };
    if (t === "vertical")
      return {
        x: o.x,
        y: a.coordinate
      };
    if (t === "centric") {
      var i = a.coordinate, s = o.radius;
      return H(H(H({}, o), Te(o.cx, o.cy, s, i)), {}, {
        angle: i,
        radius: s
      });
    }
    var c = a.coordinate, l = o.angle;
    return H(H(H({}, o), Te(o.cx, o.cy, c, l)), {}, {
      angle: l,
      radius: c
    });
  }
  return EI;
}, Nl = function(t, r) {
  var n = r.graphicalItems, o = r.dataStartIndex, a = r.dataEndIndex, i = (n ?? []).reduce(function(s, c) {
    var l = c.props.data;
    return l && l.length ? [].concat(Eo(s), Eo(l)) : s;
  }, []);
  return i.length > 0 ? i : t && t.length && ne(o) && ne(a) ? t.slice(o, a + 1) : [];
};
function TI(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var Zv = function(t, r, n, o) {
  var a = t.graphicalItems, i = t.tooltipAxis, s = Nl(r, t);
  return n < 0 || !a || !a.length || n >= s.length ? null : a.reduce(function(c, l) {
    var f, u = (f = l.props.data) !== null && f !== void 0 ? f : r;
    u && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    t.dataEndIndex - t.dataStartIndex >= n && (u = u.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var d;
    if (i.dataKey && !i.allowDuplicatedCategory) {
      var h = u === void 0 ? s : u;
      d = ms(h, i.dataKey, o);
    } else
      d = u && u[n] || s[n];
    return d ? [].concat(Eo(c), [hM(l, d)]) : c;
  }, []);
}, T1 = function(t, r, n, o) {
  var a = o || {
    x: t.chartX,
    y: t.chartY
  }, i = SZ(a, n), s = t.orderedTooltipTicks, c = t.tooltipAxis, l = t.tooltipTicks, f = t4(i, s, l, c);
  if (f >= 0 && l) {
    var u = l[f] && l[f].value, d = Zv(t, r, f, u), h = _Z(n, s, f, a);
    return {
      activeTooltipIndex: f,
      activeLabel: u,
      activePayload: d,
      activeCoordinate: h
    };
  }
  return null;
}, OZ = function(t, r) {
  var n = r.axes, o = r.graphicalItems, a = r.axisType, i = r.axisIdKey, s = r.stackGroups, c = r.dataStartIndex, l = r.dataEndIndex, f = t.layout, u = t.children, d = t.stackOffset, h = lM(f, a);
  return n.reduce(function(m, v) {
    var p, b = v.type.defaultProps !== void 0 ? H(H({}, v.type.defaultProps), v.props) : v.props, w = b.type, x = b.dataKey, _ = b.allowDataOverflow, y = b.allowDuplicatedCategory, O = b.scale, A = b.ticks, P = b.includeHidden, T = b[i];
    if (m[T])
      return m;
    var I = Nl(t.data, {
      graphicalItems: o.filter(function(N) {
        var U, K = i in N.props ? N.props[i] : (U = N.type.defaultProps) === null || U === void 0 ? void 0 : U[i];
        return K === T;
      }),
      dataStartIndex: c,
      dataEndIndex: l
    }), E = I.length, C, R, M;
    X7(b.domain, _, w) && (C = fv(b.domain, null, _), h && (w === "number" || O !== "auto") && (M = da(I, x, "category")));
    var D = TI(w);
    if (!C || C.length === 0) {
      var $, q = ($ = b.domain) !== null && $ !== void 0 ? $ : D;
      if (x) {
        if (C = da(I, x, w), w === "category" && h) {
          var F = K5(C);
          y && F ? (R = C, C = rc(0, E)) : y || (C = AS(q, C, v).reduce(function(N, U) {
            return N.indexOf(U) >= 0 ? N : [].concat(Eo(N), [U]);
          }, []));
        } else if (w === "category")
          y ? C = C.filter(function(N) {
            return N !== "" && !fe(N);
          }) : C = AS(q, C, v).reduce(function(N, U) {
            return N.indexOf(U) >= 0 || U === "" || fe(U) ? N : [].concat(Eo(N), [U]);
          }, []);
        else if (w === "number") {
          var B = i4(I, o.filter(function(N) {
            var U, K, G = i in N.props ? N.props[i] : (U = N.type.defaultProps) === null || U === void 0 ? void 0 : U[i], J = "hide" in N.props ? N.props.hide : (K = N.type.defaultProps) === null || K === void 0 ? void 0 : K.hide;
            return G === T && (P || !J);
          }), x, a, f);
          B && (C = B);
        }
        h && (w === "number" || O !== "auto") && (M = da(I, x, "category"));
      } else h ? C = rc(0, E) : s && s[T] && s[T].hasStack && w === "number" ? C = d === "expand" ? [0, 1] : pM(s[T].stackGroups, c, l) : C = cM(I, o.filter(function(N) {
        var U = i in N.props ? N.props[i] : N.type.defaultProps[i], K = "hide" in N.props ? N.props.hide : N.type.defaultProps.hide;
        return U === T && (P || !K);
      }), w, f, !0);
      if (w === "number")
        C = Gv(u, C, T, a, A), q && (C = fv(q, C, _));
      else if (w === "category" && q) {
        var L = q, z = C.every(function(N) {
          return L.indexOf(N) >= 0;
        });
        z && (C = L);
      }
    }
    return H(H({}, m), {}, se({}, T, H(H({}, b), {}, {
      axisType: a,
      domain: C,
      categoricalDomain: M,
      duplicateDomain: R,
      originalDomain: (p = b.domain) !== null && p !== void 0 ? p : D,
      isCategorical: h,
      layout: f
    })));
  }, {});
}, AZ = function(t, r) {
  var n = r.graphicalItems, o = r.Axis, a = r.axisType, i = r.axisIdKey, s = r.stackGroups, c = r.dataStartIndex, l = r.dataEndIndex, f = t.layout, u = t.children, d = Nl(t.data, {
    graphicalItems: n,
    dataStartIndex: c,
    dataEndIndex: l
  }), h = d.length, m = lM(f, a), v = -1;
  return n.reduce(function(p, b) {
    var w = b.type.defaultProps !== void 0 ? H(H({}, b.type.defaultProps), b.props) : b.props, x = w[i], _ = TI("number");
    if (!p[x]) {
      v++;
      var y;
      return m ? y = rc(0, h) : s && s[x] && s[x].hasStack ? (y = pM(s[x].stackGroups, c, l), y = Gv(u, y, x, a)) : (y = fv(_, cM(d, n.filter(function(O) {
        var A, P, T = i in O.props ? O.props[i] : (A = O.type.defaultProps) === null || A === void 0 ? void 0 : A[i], I = "hide" in O.props ? O.props.hide : (P = O.type.defaultProps) === null || P === void 0 ? void 0 : P.hide;
        return T === x && !I;
      }), "number", f), o.defaultProps.allowDataOverflow), y = Gv(u, y, x, a)), H(H({}, p), {}, se({}, x, H(H({
        axisType: a
      }, o.defaultProps), {}, {
        hide: !0,
        orientation: yt(wZ, "".concat(a, ".").concat(v % 2), null),
        domain: y,
        originalDomain: _,
        isCategorical: m,
        layout: f
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return p;
  }, {});
}, PZ = function(t, r) {
  var n = r.axisType, o = n === void 0 ? "xAxis" : n, a = r.AxisComp, i = r.graphicalItems, s = r.stackGroups, c = r.dataStartIndex, l = r.dataEndIndex, f = t.children, u = "".concat(o, "Id"), d = bt(f, a), h = {};
  return d && d.length ? h = OZ(t, {
    axes: d,
    graphicalItems: i,
    axisType: o,
    axisIdKey: u,
    stackGroups: s,
    dataStartIndex: c,
    dataEndIndex: l
  }) : i && i.length && (h = AZ(t, {
    Axis: a,
    graphicalItems: i,
    axisType: o,
    axisIdKey: u,
    stackGroups: s,
    dataStartIndex: c,
    dataEndIndex: l
  })), h;
}, EZ = function(t) {
  var r = Dn(t), n = nn(r, !1, !0);
  return {
    tooltipTicks: n,
    orderedTooltipTicks: cg(n, function(o) {
      return o.coordinate;
    }),
    tooltipAxis: r,
    tooltipAxisBandSize: qs(r, n)
  };
}, C1 = function(t) {
  var r = t.children, n = t.defaultShowTooltip, o = dt(r, mo), a = 0, i = 0;
  return t.data && t.data.length !== 0 && (i = t.data.length - 1), o && o.props && (o.props.startIndex >= 0 && (a = o.props.startIndex), o.props.endIndex >= 0 && (i = o.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: a,
    dataEndIndex: i,
    activeTooltipIndex: -1,
    isTooltipActive: !!n
  };
}, TZ = function(t) {
  return !t || !t.length ? !1 : t.some(function(r) {
    var n = dr(r && r.type);
    return n && n.indexOf("Bar") >= 0;
  });
}, R1 = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, CZ = function(t, r) {
  var n = t.props, o = t.graphicalItems, a = t.xAxisMap, i = a === void 0 ? {} : a, s = t.yAxisMap, c = s === void 0 ? {} : s, l = n.width, f = n.height, u = n.children, d = n.margin || {}, h = dt(u, mo), m = dt(u, Kn), v = Object.keys(c).reduce(function(y, O) {
    var A = c[O], P = A.orientation;
    return !A.mirror && !A.hide ? H(H({}, y), {}, se({}, P, y[P] + A.width)) : y;
  }, {
    left: d.left || 0,
    right: d.right || 0
  }), p = Object.keys(i).reduce(function(y, O) {
    var A = i[O], P = A.orientation;
    return !A.mirror && !A.hide ? H(H({}, y), {}, se({}, P, yt(y, "".concat(P)) + A.height)) : y;
  }, {
    top: d.top || 0,
    bottom: d.bottom || 0
  }), b = H(H({}, p), v), w = b.bottom;
  h && (b.bottom += h.props.height || mo.defaultProps.height), m && r && (b = o4(b, o, n, r));
  var x = l - b.left - b.right, _ = f - b.top - b.bottom;
  return H(H({
    brushBottom: w
  }, b), {}, {
    // never return negative values for height and width
    width: Math.max(x, 0),
    height: Math.max(_, 0)
  });
}, RZ = function(t, r) {
  if (r === "xAxis")
    return t[r].width;
  if (r === "yAxis")
    return t[r].height;
}, zg = function(t) {
  var r = t.chartName, n = t.GraphicalChild, o = t.defaultTooltipEventType, a = o === void 0 ? "axis" : o, i = t.validateTooltipEventTypes, s = i === void 0 ? ["axis"] : i, c = t.axisComponents, l = t.legendContent, f = t.formatAxisMap, u = t.defaultProps, d = function(b, w) {
    var x = w.graphicalItems, _ = w.stackGroups, y = w.offset, O = w.updateId, A = w.dataStartIndex, P = w.dataEndIndex, T = b.barSize, I = b.layout, E = b.barGap, C = b.barCategoryGap, R = b.maxBarSize, M = R1(I), D = M.numericAxisName, $ = M.cateAxisName, q = TZ(x), F = [];
    return x.forEach(function(B, L) {
      var z = Nl(b.data, {
        graphicalItems: [B],
        dataStartIndex: A,
        dataEndIndex: P
      }), N = B.type.defaultProps !== void 0 ? H(H({}, B.type.defaultProps), B.props) : B.props, U = N.dataKey, K = N.maxBarSize, G = N["".concat(D, "Id")], J = N["".concat($, "Id")], V = {}, Q = c.reduce(function(Kr, ar) {
        var $l, Dl, jl = w["".concat(ar.axisType, "Map")], Wg = N["".concat(ar.axisType, "Id")];
        jl && jl[Wg] || ar.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? st(!1, "Specifying a(n) ".concat(ar.axisType, "Id requires a corresponding ").concat(
          ar.axisType,
          "Id on the targeted graphical component "
        ).concat(($l = B == null || (Dl = B.type) === null || Dl === void 0 ? void 0 : Dl.displayName) !== null && $l !== void 0 ? $l : "")) : st());
        var Ug = jl[Wg];
        return H(H({}, Kr), {}, se(se({}, ar.axisType, Ug), "".concat(ar.axisType, "Ticks"), nn(Ug)));
      }, V), W = Q[$], Y = Q["".concat($, "Ticks")], te = _ && _[G] && _[G].hasStack && v4(B, _[G].stackGroups), j = dr(B.type).indexOf("Bar") >= 0, ce = qs(W, Y), X = [], he = q && r4({
        barSize: T,
        stackGroups: _,
        totalSize: RZ(Q, $)
      });
      if (j) {
        var ge, Ie, Ut = fe(K) ? R : K, Rt = (ge = (Ie = qs(W, Y, !0)) !== null && Ie !== void 0 ? Ie : Ut) !== null && ge !== void 0 ? ge : 0;
        X = n4({
          barGap: E,
          barCategoryGap: C,
          bandSize: Rt !== ce ? Rt : ce,
          sizeList: he[J],
          maxBarSize: Ut
        }), Rt !== ce && (X = X.map(function(Kr) {
          return H(H({}, Kr), {}, {
            position: H(H({}, Kr.position), {}, {
              offset: Kr.position.offset - Rt / 2
            })
          });
        }));
      }
      var Ri = B && B.type && B.type.getComposedData;
      Ri && F.push({
        props: H(H({}, Ri(H(H({}, Q), {}, {
          displayedData: z,
          props: b,
          dataKey: U,
          item: B,
          bandSize: ce,
          barPosition: X,
          offset: y,
          stackedData: te,
          layout: I,
          dataStartIndex: A,
          dataEndIndex: P
        }))), {}, se(se(se({
          key: B.key || "item-".concat(L)
        }, D, Q[D]), $, Q[$]), "animationId", O)),
        childIndex: iq(B, b.children),
        item: B
      });
    }), F;
  }, h = function(b, w) {
    var x = b.props, _ = b.dataStartIndex, y = b.dataEndIndex, O = b.updateId;
    if (!Bb({
      props: x
    }))
      return null;
    var A = x.children, P = x.layout, T = x.stackOffset, I = x.data, E = x.reverseStackOrder, C = R1(P), R = C.numericAxisName, M = C.cateAxisName, D = bt(A, n), $ = p4(I, D, "".concat(R, "Id"), "".concat(M, "Id"), T, E), q = c.reduce(function(N, U) {
      var K = "".concat(U.axisType, "Map");
      return H(H({}, N), {}, se({}, K, PZ(x, H(H({}, U), {}, {
        graphicalItems: D,
        stackGroups: U.axisType === R && $,
        dataStartIndex: _,
        dataEndIndex: y
      }))));
    }, {}), F = CZ(H(H({}, q), {}, {
      props: x,
      graphicalItems: D
    }), w == null ? void 0 : w.legendBBox);
    Object.keys(q).forEach(function(N) {
      q[N] = f(x, q[N], F, N.replace("Map", ""), r);
    });
    var B = q["".concat(M, "Map")], L = EZ(B), z = d(x, H(H({}, q), {}, {
      dataStartIndex: _,
      dataEndIndex: y,
      updateId: O,
      graphicalItems: D,
      stackGroups: $,
      offset: F
    }));
    return H(H({
      formattedGraphicalItems: z,
      graphicalItems: D,
      offset: F,
      stackGroups: $
    }, L), q);
  }, m = /* @__PURE__ */ (function(p) {
    function b(w) {
      var x, _, y;
      return lZ(this, b), y = dZ(this, b, [w]), se(y, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), se(y, "accessibilityManager", new Y7()), se(y, "handleLegendBBoxUpdate", function(O) {
        if (O) {
          var A = y.state, P = A.dataStartIndex, T = A.dataEndIndex, I = A.updateId;
          y.setState(H({
            legendBBox: O
          }, h({
            props: y.props,
            dataStartIndex: P,
            dataEndIndex: T,
            updateId: I
          }, H(H({}, y.state), {}, {
            legendBBox: O
          }))));
        }
      }), se(y, "handleReceiveSyncEvent", function(O, A, P) {
        if (y.props.syncId === O) {
          if (P === y.eventEmitterSymbol && typeof y.props.syncMethod != "function")
            return;
          y.applySyncEvent(A);
        }
      }), se(y, "handleBrushChange", function(O) {
        var A = O.startIndex, P = O.endIndex;
        if (A !== y.state.dataStartIndex || P !== y.state.dataEndIndex) {
          var T = y.state.updateId;
          y.setState(function() {
            return H({
              dataStartIndex: A,
              dataEndIndex: P
            }, h({
              props: y.props,
              dataStartIndex: A,
              dataEndIndex: P,
              updateId: T
            }, y.state));
          }), y.triggerSyncEvent({
            dataStartIndex: A,
            dataEndIndex: P
          });
        }
      }), se(y, "handleMouseEnter", function(O) {
        var A = y.getMouseInfo(O);
        if (A) {
          var P = H(H({}, A), {}, {
            isTooltipActive: !0
          });
          y.setState(P), y.triggerSyncEvent(P);
          var T = y.props.onMouseEnter;
          ue(T) && T(P, O);
        }
      }), se(y, "triggeredAfterMouseMove", function(O) {
        var A = y.getMouseInfo(O), P = A ? H(H({}, A), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        y.setState(P), y.triggerSyncEvent(P);
        var T = y.props.onMouseMove;
        ue(T) && T(P, O);
      }), se(y, "handleItemMouseEnter", function(O) {
        y.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: O,
            activePayload: O.tooltipPayload,
            activeCoordinate: O.tooltipPosition || {
              x: O.cx,
              y: O.cy
            }
          };
        });
      }), se(y, "handleItemMouseLeave", function() {
        y.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), se(y, "handleMouseMove", function(O) {
        O.persist(), y.throttleTriggeredAfterMouseMove(O);
      }), se(y, "handleMouseLeave", function(O) {
        y.throttleTriggeredAfterMouseMove.cancel();
        var A = {
          isTooltipActive: !1
        };
        y.setState(A), y.triggerSyncEvent(A);
        var P = y.props.onMouseLeave;
        ue(P) && P(A, O);
      }), se(y, "handleOuterEvent", function(O) {
        var A = aq(O), P = yt(y.props, "".concat(A));
        if (A && ue(P)) {
          var T, I;
          /.*touch.*/i.test(A) ? I = y.getMouseInfo(O.changedTouches[0]) : I = y.getMouseInfo(O), P((T = I) !== null && T !== void 0 ? T : {}, O);
        }
      }), se(y, "handleClick", function(O) {
        var A = y.getMouseInfo(O);
        if (A) {
          var P = H(H({}, A), {}, {
            isTooltipActive: !0
          });
          y.setState(P), y.triggerSyncEvent(P);
          var T = y.props.onClick;
          ue(T) && T(P, O);
        }
      }), se(y, "handleMouseDown", function(O) {
        var A = y.props.onMouseDown;
        if (ue(A)) {
          var P = y.getMouseInfo(O);
          A(P, O);
        }
      }), se(y, "handleMouseUp", function(O) {
        var A = y.props.onMouseUp;
        if (ue(A)) {
          var P = y.getMouseInfo(O);
          A(P, O);
        }
      }), se(y, "handleTouchMove", function(O) {
        O.changedTouches != null && O.changedTouches.length > 0 && y.throttleTriggeredAfterMouseMove(O.changedTouches[0]);
      }), se(y, "handleTouchStart", function(O) {
        O.changedTouches != null && O.changedTouches.length > 0 && y.handleMouseDown(O.changedTouches[0]);
      }), se(y, "handleTouchEnd", function(O) {
        O.changedTouches != null && O.changedTouches.length > 0 && y.handleMouseUp(O.changedTouches[0]);
      }), se(y, "handleDoubleClick", function(O) {
        var A = y.props.onDoubleClick;
        if (ue(A)) {
          var P = y.getMouseInfo(O);
          A(P, O);
        }
      }), se(y, "handleContextMenu", function(O) {
        var A = y.props.onContextMenu;
        if (ue(A)) {
          var P = y.getMouseInfo(O);
          A(P, O);
        }
      }), se(y, "triggerSyncEvent", function(O) {
        y.props.syncId !== void 0 && rh.emit(nh, y.props.syncId, O, y.eventEmitterSymbol);
      }), se(y, "applySyncEvent", function(O) {
        var A = y.props, P = A.layout, T = A.syncMethod, I = y.state.updateId, E = O.dataStartIndex, C = O.dataEndIndex;
        if (O.dataStartIndex !== void 0 || O.dataEndIndex !== void 0)
          y.setState(H({
            dataStartIndex: E,
            dataEndIndex: C
          }, h({
            props: y.props,
            dataStartIndex: E,
            dataEndIndex: C,
            updateId: I
          }, y.state)));
        else if (O.activeTooltipIndex !== void 0) {
          var R = O.chartX, M = O.chartY, D = O.activeTooltipIndex, $ = y.state, q = $.offset, F = $.tooltipTicks;
          if (!q)
            return;
          if (typeof T == "function")
            D = T(F, O);
          else if (T === "value") {
            D = -1;
            for (var B = 0; B < F.length; B++)
              if (F[B].value === O.activeLabel) {
                D = B;
                break;
              }
          }
          var L = H(H({}, q), {}, {
            x: q.left,
            y: q.top
          }), z = Math.min(R, L.x + L.width), N = Math.min(M, L.y + L.height), U = F[D] && F[D].value, K = Zv(y.state, y.props.data, D), G = F[D] ? {
            x: P === "horizontal" ? F[D].coordinate : z,
            y: P === "horizontal" ? N : F[D].coordinate
          } : EI;
          y.setState(H(H({}, O), {}, {
            activeLabel: U,
            activeCoordinate: G,
            activePayload: K,
            activeTooltipIndex: D
          }));
        } else
          y.setState(O);
      }), se(y, "renderCursor", function(O) {
        var A, P = y.state, T = P.isTooltipActive, I = P.activeCoordinate, E = P.activePayload, C = P.offset, R = P.activeTooltipIndex, M = P.tooltipAxisBandSize, D = y.getTooltipEventType(), $ = (A = O.props.active) !== null && A !== void 0 ? A : T, q = y.props.layout, F = O.key || "_recharts-cursor";
        return /* @__PURE__ */ k.createElement(rZ, {
          key: F,
          activeCoordinate: I,
          activePayload: E,
          activeTooltipIndex: R,
          chartName: r,
          element: O,
          isActive: $,
          layout: q,
          offset: C,
          tooltipAxisBandSize: M,
          tooltipEventType: D
        });
      }), se(y, "renderPolarAxis", function(O, A, P) {
        var T = yt(O, "type.axisType"), I = yt(y.state, "".concat(T, "Map")), E = O.type.defaultProps, C = E !== void 0 ? H(H({}, E), O.props) : O.props, R = I && I[C["".concat(T, "Id")]];
        return /* @__PURE__ */ qe(O, H(H({}, R), {}, {
          className: de(T, R.className),
          key: O.key || "".concat(A, "-").concat(P),
          ticks: nn(R, !0)
        }));
      }), se(y, "renderPolarGrid", function(O) {
        var A = O.props, P = A.radialLines, T = A.polarAngles, I = A.polarRadius, E = y.state, C = E.radiusAxisMap, R = E.angleAxisMap, M = Dn(C), D = Dn(R), $ = D.cx, q = D.cy, F = D.innerRadius, B = D.outerRadius;
        return /* @__PURE__ */ qe(O, {
          polarAngles: Array.isArray(T) ? T : nn(D, !0).map(function(L) {
            return L.coordinate;
          }),
          polarRadius: Array.isArray(I) ? I : nn(M, !0).map(function(L) {
            return L.coordinate;
          }),
          cx: $,
          cy: q,
          innerRadius: F,
          outerRadius: B,
          key: O.key || "polar-grid",
          radialLines: P
        });
      }), se(y, "renderLegend", function() {
        var O = y.state.formattedGraphicalItems, A = y.props, P = A.children, T = A.width, I = A.height, E = y.props.margin || {}, C = T - (E.left || 0) - (E.right || 0), R = iM({
          children: P,
          formattedGraphicalItems: O,
          legendWidth: C,
          legendContent: l
        });
        if (!R)
          return null;
        var M = R.item, D = P1(R, nZ);
        return /* @__PURE__ */ qe(M, H(H({}, D), {}, {
          chartWidth: T,
          chartHeight: I,
          margin: E,
          onBBoxUpdate: y.handleLegendBBoxUpdate
        }));
      }), se(y, "renderTooltip", function() {
        var O, A = y.props, P = A.children, T = A.accessibilityLayer, I = dt(P, cr);
        if (!I)
          return null;
        var E = y.state, C = E.isTooltipActive, R = E.activeCoordinate, M = E.activePayload, D = E.activeLabel, $ = E.offset, q = (O = I.props.active) !== null && O !== void 0 ? O : C;
        return /* @__PURE__ */ qe(I, {
          viewBox: H(H({}, $), {}, {
            x: $.left,
            y: $.top
          }),
          active: q,
          label: D,
          payload: q ? M : [],
          coordinate: R,
          accessibilityLayer: T
        });
      }), se(y, "renderBrush", function(O) {
        var A = y.props, P = A.margin, T = A.data, I = y.state, E = I.offset, C = I.dataStartIndex, R = I.dataEndIndex, M = I.updateId;
        return /* @__PURE__ */ qe(O, {
          key: O.key || "_recharts-brush",
          onChange: Ki(y.handleBrushChange, O.props.onChange),
          data: T,
          x: ne(O.props.x) ? O.props.x : E.left,
          y: ne(O.props.y) ? O.props.y : E.top + E.height + E.brushBottom - (P.bottom || 0),
          width: ne(O.props.width) ? O.props.width : E.width,
          startIndex: C,
          endIndex: R,
          updateId: "brush-".concat(M)
        });
      }), se(y, "renderReferenceElement", function(O, A, P) {
        if (!O)
          return null;
        var T = y, I = T.clipPathId, E = y.state, C = E.xAxisMap, R = E.yAxisMap, M = E.offset, D = O.type.defaultProps || {}, $ = O.props, q = $.xAxisId, F = q === void 0 ? D.xAxisId : q, B = $.yAxisId, L = B === void 0 ? D.yAxisId : B;
        return /* @__PURE__ */ qe(O, {
          key: O.key || "".concat(A, "-").concat(P),
          xAxis: C[F],
          yAxis: R[L],
          viewBox: {
            x: M.left,
            y: M.top,
            width: M.width,
            height: M.height
          },
          clipPathId: I
        });
      }), se(y, "renderActivePoints", function(O) {
        var A = O.item, P = O.activePoint, T = O.basePoint, I = O.childIndex, E = O.isRange, C = [], R = A.props.key, M = A.item.type.defaultProps !== void 0 ? H(H({}, A.item.type.defaultProps), A.item.props) : A.item.props, D = M.activeDot, $ = M.dataKey, q = H(H({
          index: I,
          dataKey: $,
          cx: P.x,
          cy: P.y,
          r: 4,
          fill: $g(A.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: P.payload,
          value: P.value
        }, ie(D, !1)), gs(D));
        return C.push(b.renderActiveDot(D, q, "".concat(R, "-activePoint-").concat(I))), T ? C.push(b.renderActiveDot(D, H(H({}, q), {}, {
          cx: T.x,
          cy: T.y
        }), "".concat(R, "-basePoint-").concat(I))) : E && C.push(null), C;
      }), se(y, "renderGraphicChild", function(O, A, P) {
        var T = y.filterFormatItem(O, A, P);
        if (!T)
          return null;
        var I = y.getTooltipEventType(), E = y.state, C = E.isTooltipActive, R = E.tooltipAxis, M = E.activeTooltipIndex, D = E.activeLabel, $ = y.props.children, q = dt($, cr), F = T.props, B = F.points, L = F.isRange, z = F.baseLine, N = T.item.type.defaultProps !== void 0 ? H(H({}, T.item.type.defaultProps), T.item.props) : T.item.props, U = N.activeDot, K = N.hide, G = N.activeBar, J = N.activeShape, V = !!(!K && C && q && (U || G || J)), Q = {};
        I !== "axis" && q && q.props.trigger === "click" ? Q = {
          onClick: Ki(y.handleItemMouseEnter, O.props.onClick)
        } : I !== "axis" && (Q = {
          onMouseLeave: Ki(y.handleItemMouseLeave, O.props.onMouseLeave),
          onMouseEnter: Ki(y.handleItemMouseEnter, O.props.onMouseEnter)
        });
        var W = /* @__PURE__ */ qe(O, H(H({}, T.props), Q));
        function Y(ar) {
          return typeof R.dataKey == "function" ? R.dataKey(ar.payload) : null;
        }
        if (V)
          if (M >= 0) {
            var te, j;
            if (R.dataKey && !R.allowDuplicatedCategory) {
              var ce = typeof R.dataKey == "function" ? Y : "payload.".concat(R.dataKey.toString());
              te = ms(B, ce, D), j = L && z && ms(z, ce, D);
            } else
              te = B == null ? void 0 : B[M], j = L && z && z[M];
            if (J || G) {
              var X = O.props.activeIndex !== void 0 ? O.props.activeIndex : M;
              return [/* @__PURE__ */ qe(O, H(H(H({}, T.props), Q), {}, {
                activeIndex: X
              })), null, null];
            }
            if (!fe(te))
              return [W].concat(Eo(y.renderActivePoints({
                item: T,
                activePoint: te,
                basePoint: j,
                childIndex: M,
                isRange: L
              })));
          } else {
            var he, ge = (he = y.getItemByXY(y.state.activeCoordinate)) !== null && he !== void 0 ? he : {
              graphicalItem: W
            }, Ie = ge.graphicalItem, Ut = Ie.item, Rt = Ut === void 0 ? O : Ut, Ri = Ie.childIndex, Kr = H(H(H({}, T.props), Q), {}, {
              activeIndex: Ri
            });
            return [/* @__PURE__ */ qe(Rt, Kr), null, null];
          }
        return L ? [W, null, null] : [W, null];
      }), se(y, "renderCustomized", function(O, A, P) {
        return /* @__PURE__ */ qe(O, H(H({
          key: "recharts-customized-".concat(P)
        }, y.props), y.state));
      }), se(y, "renderMap", {
        CartesianGrid: {
          handler: es,
          once: !0
        },
        ReferenceArea: {
          handler: y.renderReferenceElement
        },
        ReferenceLine: {
          handler: es
        },
        ReferenceDot: {
          handler: y.renderReferenceElement
        },
        XAxis: {
          handler: es
        },
        YAxis: {
          handler: es
        },
        Brush: {
          handler: y.renderBrush,
          once: !0
        },
        Bar: {
          handler: y.renderGraphicChild
        },
        Line: {
          handler: y.renderGraphicChild
        },
        Area: {
          handler: y.renderGraphicChild
        },
        Radar: {
          handler: y.renderGraphicChild
        },
        RadialBar: {
          handler: y.renderGraphicChild
        },
        Scatter: {
          handler: y.renderGraphicChild
        },
        Pie: {
          handler: y.renderGraphicChild
        },
        Funnel: {
          handler: y.renderGraphicChild
        },
        Tooltip: {
          handler: y.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: y.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: y.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: y.renderPolarAxis
        },
        Customized: {
          handler: y.renderCustomized
        }
      }), y.clipPathId = "".concat((x = w.id) !== null && x !== void 0 ? x : qo("recharts"), "-clip"), y.throttleTriggeredAfterMouseMove = aR(y.triggeredAfterMouseMove, (_ = w.throttleDelay) !== null && _ !== void 0 ? _ : 1e3 / 60), y.state = {}, y;
    }
    return vZ(b, p), fZ(b, [{
      key: "componentDidMount",
      value: function() {
        var x, _;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (x = this.props.margin.left) !== null && x !== void 0 ? x : 0,
            top: (_ = this.props.margin.top) !== null && _ !== void 0 ? _ : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var x = this.props, _ = x.children, y = x.data, O = x.height, A = x.layout, P = dt(_, cr);
        if (P) {
          var T = P.props.defaultIndex;
          if (!(typeof T != "number" || T < 0 || T > this.state.tooltipTicks.length - 1)) {
            var I = this.state.tooltipTicks[T] && this.state.tooltipTicks[T].value, E = Zv(this.state, y, T, I), C = this.state.tooltipTicks[T].coordinate, R = (this.state.offset.top + O) / 2, M = A === "horizontal", D = M ? {
              x: C,
              y: R
            } : {
              y: C,
              x: R
            }, $ = this.state.formattedGraphicalItems.find(function(F) {
              var B = F.item;
              return B.type.name === "Scatter";
            });
            $ && (D = H(H({}, D), $.props.points[T].tooltipPosition), E = $.props.points[T].tooltipPayload);
            var q = {
              activeTooltipIndex: T,
              isTooltipActive: !0,
              activeLabel: I,
              activePayload: E,
              activeCoordinate: D
            };
            this.setState(q), this.renderCursor(P), this.accessibilityManager.setIndex(T);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(x, _) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== _.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== x.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== x.margin) {
          var y, O;
          this.accessibilityManager.setDetails({
            offset: {
              left: (y = this.props.margin.left) !== null && y !== void 0 ? y : 0,
              top: (O = this.props.margin.top) !== null && O !== void 0 ? O : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(x) {
        Nh([dt(x.children, cr)], [dt(this.props.children, cr)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var x = dt(this.props.children, cr);
        if (x && typeof x.props.shared == "boolean") {
          var _ = x.props.shared ? "axis" : "item";
          return s.indexOf(_) >= 0 ? _ : a;
        }
        return a;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(x) {
        if (!this.container)
          return null;
        var _ = this.container, y = _.getBoundingClientRect(), O = KW(y), A = {
          chartX: Math.round(x.pageX - O.left),
          chartY: Math.round(x.pageY - O.top)
        }, P = y.width / _.offsetWidth || 1, T = this.inRange(A.chartX, A.chartY, P);
        if (!T)
          return null;
        var I = this.state, E = I.xAxisMap, C = I.yAxisMap, R = this.getTooltipEventType(), M = T1(this.state, this.props.data, this.props.layout, T);
        if (R !== "axis" && E && C) {
          var D = Dn(E).scale, $ = Dn(C).scale, q = D && D.invert ? D.invert(A.chartX) : null, F = $ && $.invert ? $.invert(A.chartY) : null;
          return H(H({}, A), {}, {
            xValue: q,
            yValue: F
          }, M);
        }
        return M ? H(H({}, A), M) : null;
      }
    }, {
      key: "inRange",
      value: function(x, _) {
        var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, O = this.props.layout, A = x / y, P = _ / y;
        if (O === "horizontal" || O === "vertical") {
          var T = this.state.offset, I = A >= T.left && A <= T.left + T.width && P >= T.top && P <= T.top + T.height;
          return I ? {
            x: A,
            y: P
          } : null;
        }
        var E = this.state, C = E.angleAxisMap, R = E.radiusAxisMap;
        if (C && R) {
          var M = Dn(C);
          return TS({
            x: A,
            y: P
          }, M);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var x = this.props.children, _ = this.getTooltipEventType(), y = dt(x, cr), O = {};
        y && _ === "axis" && (y.props.trigger === "click" ? O = {
          onClick: this.handleClick
        } : O = {
          onMouseEnter: this.handleMouseEnter,
          onDoubleClick: this.handleDoubleClick,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onContextMenu: this.handleContextMenu
        });
        var A = gs(this.props, this.handleOuterEvent);
        return H(H({}, A), O);
      }
    }, {
      key: "addListener",
      value: function() {
        rh.on(nh, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        rh.removeListener(nh, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(x, _, y) {
        for (var O = this.state.formattedGraphicalItems, A = 0, P = O.length; A < P; A++) {
          var T = O[A];
          if (T.item === x || T.props.key === x.key || _ === dr(T.item.type) && y === T.childIndex)
            return T;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var x = this.clipPathId, _ = this.state.offset, y = _.left, O = _.top, A = _.height, P = _.width;
        return /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("clipPath", {
          id: x
        }, /* @__PURE__ */ k.createElement("rect", {
          x: y,
          y: O,
          height: A,
          width: P
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var x = this.state.xAxisMap;
        return x ? Object.entries(x).reduce(function(_, y) {
          var O = A1(y, 2), A = O[0], P = O[1];
          return H(H({}, _), {}, se({}, A, P.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var x = this.state.yAxisMap;
        return x ? Object.entries(x).reduce(function(_, y) {
          var O = A1(y, 2), A = O[0], P = O[1];
          return H(H({}, _), {}, se({}, A, P.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(x) {
        var _;
        return (_ = this.state.xAxisMap) === null || _ === void 0 || (_ = _[x]) === null || _ === void 0 ? void 0 : _.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(x) {
        var _;
        return (_ = this.state.yAxisMap) === null || _ === void 0 || (_ = _[x]) === null || _ === void 0 ? void 0 : _.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(x) {
        var _ = this.state, y = _.formattedGraphicalItems, O = _.activeItem;
        if (y && y.length)
          for (var A = 0, P = y.length; A < P; A++) {
            var T = y[A], I = T.props, E = T.item, C = E.type.defaultProps !== void 0 ? H(H({}, E.type.defaultProps), E.props) : E.props, R = dr(E.type);
            if (R === "Bar") {
              var M = (I.data || []).find(function(F) {
                return bG(x, F);
              });
              if (M)
                return {
                  graphicalItem: T,
                  payload: M
                };
            } else if (R === "RadialBar") {
              var D = (I.data || []).find(function(F) {
                return TS(x, F);
              });
              if (D)
                return {
                  graphicalItem: T,
                  payload: D
                };
            } else if (Sl(T, O) || _l(T, O) || Za(T, O)) {
              var $ = z9({
                graphicalItem: T,
                activeTooltipItem: O,
                itemData: C.data
              }), q = C.activeIndex === void 0 ? $ : C.activeIndex;
              return {
                graphicalItem: H(H({}, T), {}, {
                  childIndex: q
                }),
                payload: Za(T, O) ? C.data[$] : T.props.data[$]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var x = this;
        if (!Bb(this))
          return null;
        var _ = this.props, y = _.children, O = _.className, A = _.width, P = _.height, T = _.style, I = _.compact, E = _.title, C = _.desc, R = P1(_, oZ), M = ie(R, !1);
        if (I)
          return /* @__PURE__ */ k.createElement(c1, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ k.createElement($h, qn({}, M, {
            width: A,
            height: P,
            title: E,
            desc: C
          }), this.renderClipPath(), qb(y, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var D, $;
          M.tabIndex = (D = this.props.tabIndex) !== null && D !== void 0 ? D : 0, M.role = ($ = this.props.role) !== null && $ !== void 0 ? $ : "application", M.onKeyDown = function(F) {
            x.accessibilityManager.keyboardEvent(F);
          }, M.onFocus = function() {
            x.accessibilityManager.focus();
          };
        }
        var q = this.parseEventsOfWrapper();
        return /* @__PURE__ */ k.createElement(c1, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ k.createElement("div", qn({
          className: de("recharts-wrapper", O),
          style: H({
            position: "relative",
            cursor: "default",
            width: A,
            height: P
          }, T)
        }, q, {
          ref: function(B) {
            x.container = B;
          }
        }), /* @__PURE__ */ k.createElement($h, qn({}, M, {
          width: A,
          height: P,
          title: E,
          desc: C,
          style: xZ
        }), this.renderClipPath(), qb(y, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  })(I1);
  se(m, "displayName", r), se(m, "defaultProps", H({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, u)), se(m, "getDerivedStateFromProps", function(p, b) {
    var w = p.dataKey, x = p.data, _ = p.children, y = p.width, O = p.height, A = p.layout, P = p.stackOffset, T = p.margin, I = b.dataStartIndex, E = b.dataEndIndex;
    if (b.updateId === void 0) {
      var C = C1(p);
      return H(H(H({}, C), {}, {
        updateId: 0
      }, h(H(H({
        props: p
      }, C), {}, {
        updateId: 0
      }), b)), {}, {
        prevDataKey: w,
        prevData: x,
        prevWidth: y,
        prevHeight: O,
        prevLayout: A,
        prevStackOffset: P,
        prevMargin: T,
        prevChildren: _
      });
    }
    if (w !== b.prevDataKey || x !== b.prevData || y !== b.prevWidth || O !== b.prevHeight || A !== b.prevLayout || P !== b.prevStackOffset || !Vn(T, b.prevMargin)) {
      var R = C1(p), M = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: b.chartX,
        chartY: b.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: b.isTooltipActive
      }, D = H(H({}, T1(b, x, A)), {}, {
        updateId: b.updateId + 1
      }), $ = H(H(H({}, R), M), D);
      return H(H(H({}, $), h(H({
        props: p
      }, $), b)), {}, {
        prevDataKey: w,
        prevData: x,
        prevWidth: y,
        prevHeight: O,
        prevLayout: A,
        prevStackOffset: P,
        prevMargin: T,
        prevChildren: _
      });
    }
    if (!Nh(_, b.prevChildren)) {
      var q, F, B, L, z = dt(_, mo), N = z && (q = (F = z.props) === null || F === void 0 ? void 0 : F.startIndex) !== null && q !== void 0 ? q : I, U = z && (B = (L = z.props) === null || L === void 0 ? void 0 : L.endIndex) !== null && B !== void 0 ? B : E, K = N !== I || U !== E, G = !fe(x), J = G && !K ? b.updateId : b.updateId + 1;
      return H(H({
        updateId: J
      }, h(H(H({
        props: p
      }, b), {}, {
        updateId: J,
        dataStartIndex: N,
        dataEndIndex: U
      }), b)), {}, {
        prevChildren: _,
        dataStartIndex: N,
        dataEndIndex: U
      });
    }
    return null;
  }), se(m, "renderActiveDot", function(p, b, w) {
    var x;
    return /* @__PURE__ */ jt(p) ? x = /* @__PURE__ */ qe(p, b) : ue(p) ? x = p(b) : x = /* @__PURE__ */ k.createElement(gl, b), /* @__PURE__ */ k.createElement(ve, {
      className: "recharts-active-dot",
      key: w
    }, x);
  });
  var v = /* @__PURE__ */ ni(function(b, w) {
    return /* @__PURE__ */ k.createElement(m, qn({}, b, {
      ref: w
    }));
  });
  return v.displayName = m.displayName, v;
}, xJ = zg({
  chartName: "LineChart",
  GraphicalChild: Rl,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: Ml
  }, {
    axisType: "yAxis",
    AxisComp: Il
  }],
  formatAxisMap: HM
}), SJ = zg({
  chartName: "BarChart",
  GraphicalChild: Vo,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: Ml
  }, {
    axisType: "yAxis",
    AxisComp: Il
  }],
  formatAxisMap: HM
}), _J = zg({
  chartName: "PieChart",
  GraphicalChild: Vr,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: xl
  }, {
    axisType: "radiusAxis",
    AxisComp: bl
  }],
  formatAxisMap: A4,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
});
const MZ = g.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ S("div", { ref: n, className: re("w-full", e), ...r, children: /* @__PURE__ */ S("div", { className: "w-full h-full", children: t }) }));
MZ.displayName = "ChartContainer";
function OJ({
  storageKey: e = "ai-feature-banner-never-show",
  title: t,
  titleIcon: r = ak,
  description: n,
  tooltipText: o,
  shortcutKeys: a = ["Ctrl", "K"],
  neverShowText: i = "不再显示",
  delay: s = 1e3,
  position: c = "bottom-right",
  showArrow: l = !0,
  className: f = "",
  onClose: u,
  onNeverShow: d
}) {
  const [h, m] = Je(!1);
  mt(() => {
    if (typeof window < "u" && !localStorage.getItem(e)) {
      const y = setTimeout(() => {
        m(!0);
      }, s);
      return () => clearTimeout(y);
    }
  }, [e, s]);
  const v = () => {
    m(!1), u == null || u();
  }, p = () => {
    m(!1), typeof window < "u" && localStorage.setItem(e, "true"), d == null || d();
  };
  if (!h) return null;
  const b = {
    "bottom-right": "bottom-6 right-20",
    // AI 按钮在 right-6，banner 宽 w-80 (20rem)，所以 banner 左边缘在 right-20 + 20rem 的位置
    "bottom-left": "bottom-6 left-6",
    // 对称地放在左侧，靠近左边按钮（如果有）
    "top-right": "top-6 right-20",
    "top-left": "top-6 left-6"
  }, w = {
    "bottom-right": "absolute bottom-[-6px] right-6 translate-x-0",
    // 箭头从底部中央偏右指向下方
    "bottom-left": "absolute bottom-[-6px] left-6 translate-x-0",
    "top-right": "absolute top-[-6px] right-6 translate-x-0",
    "top-left": "absolute top-[-6px] left-6 translate-x-0"
  }, x = {
    "bottom-right": "w-3 h-3 bg-white/70 dark:bg-zinc-900/70 backdrop-blur-2xl border-b border-r border-zinc-200/60 dark:border-zinc-800/60 rotate-45 shadow-lg",
    "bottom-left": "w-3 h-3 bg-white/70 dark:bg-zinc-900/70 backdrop-blur-2xl border-b border-l border-zinc-200/60 dark:border-zinc-800/60 -rotate-45 shadow-lg",
    "top-right": "w-3 h-3 bg-white/70 dark:bg-zinc-900/70 backdrop-blur-2xl border-t border-r border-zinc-200/60 dark:border-zinc-800/60 -rotate-45 shadow-lg",
    "top-left": "w-3 h-3 bg-white/70 dark:bg-zinc-900/70 backdrop-blur-2xl border-t border-l border-zinc-200/60 dark:border-zinc-800/60 rotate-45 shadow-lg"
  };
  return /* @__PURE__ */ S("div", { className: `fixed ${b[c]} z-50 animate-in slide-in-from-right-5 fade-in duration-700 ${f}`, children: /* @__PURE__ */ ee("div", { className: "group relative w-80", children: [
    /* @__PURE__ */ ee("div", { className: "relative rounded-2xl border border-zinc-200/60 dark:border-zinc-800/60 bg-white/70 dark:bg-zinc-900/70 backdrop-blur-2xl shadow-2xl shadow-zinc-900/5 dark:shadow-black/20 overflow-hidden", children: [
      /* @__PURE__ */ S("div", { className: "absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-zinc-400 dark:via-zinc-600 to-transparent opacity-50" }),
      /* @__PURE__ */ S("div", { className: "absolute inset-0 bg-gradient-to-br from-zinc-50/50 via-transparent to-zinc-100/30 dark:from-zinc-800/30 dark:via-transparent dark:to-zinc-900/50 pointer-events-none" }),
      /* @__PURE__ */ ee("div", { className: "relative px-5 pt-4 pb-4", children: [
        /* @__PURE__ */ ee("div", { className: "flex items-start justify-between mb-3", children: [
          /* @__PURE__ */ ee("div", { className: "flex items-center gap-3 flex-1", children: [
            /* @__PURE__ */ ee("div", { className: "relative flex-shrink-0", children: [
              /* @__PURE__ */ S("div", { className: "absolute inset-0 bg-gradient-to-br from-zinc-300 to-zinc-400 dark:from-zinc-700 dark:to-zinc-800 rounded-xl blur-sm opacity-50" }),
              /* @__PURE__ */ S("div", { className: "relative p-2.5 rounded-xl bg-gradient-to-br from-zinc-100 via-zinc-50 to-zinc-200 dark:from-zinc-800 dark:via-zinc-850 dark:to-zinc-900 shadow-inner", children: /* @__PURE__ */ S(Q1, { className: "h-4.5 w-4.5 text-zinc-600 dark:text-zinc-300 animate-pulse" }) })
            ] }),
            /* @__PURE__ */ S("div", { className: "flex-1 min-w-0", children: o ? /* @__PURE__ */ S(eA, { children: /* @__PURE__ */ ee(tA, { children: [
              /* @__PURE__ */ S(rA, { asChild: !0, children: /* @__PURE__ */ ee("div", { className: "flex items-center gap-1.5 cursor-help", children: [
                /* @__PURE__ */ S("h3", { className: "text-sm font-semibold text-zinc-900 dark:text-zinc-100 tracking-tight", children: t }),
                /* @__PURE__ */ S(r, { className: "h-3.5 w-3.5 text-amber-500 flex-shrink-0" })
              ] }) }),
              /* @__PURE__ */ S(ym, { side: "top", className: "max-w-xs", children: /* @__PURE__ */ S("p", { className: "text-xs", children: o }) })
            ] }) }) : /* @__PURE__ */ ee("div", { className: "flex items-center gap-1.5", children: [
              /* @__PURE__ */ S("h3", { className: "text-sm font-semibold text-zinc-900 dark:text-zinc-100 tracking-tight", children: t }),
              /* @__PURE__ */ S(r, { className: "h-3.5 w-3.5 text-amber-500 flex-shrink-0" })
            ] }) })
          ] }),
          /* @__PURE__ */ S(
            Dt,
            {
              variant: "ghost",
              size: "icon",
              className: "h-7 w-7 -mt-0.5 -mr-1 hover:bg-zinc-100 dark:hover:bg-zinc-800 rounded-lg transition-colors flex-shrink-0",
              onClick: v,
              children: /* @__PURE__ */ S(Co, { className: "h-3.5 w-3.5 text-zinc-500 dark:text-zinc-400" })
            }
          )
        ] }),
        /* @__PURE__ */ S("p", { className: "text-xs text-zinc-600 dark:text-zinc-400 leading-relaxed mb-3 pl-0.5", children: n }),
        /* @__PURE__ */ ee("div", { className: "flex items-center justify-between pt-2 border-t border-zinc-200/50 dark:border-zinc-800/50", children: [
          a.length > 0 && /* @__PURE__ */ S("div", { className: "flex items-center gap-1.5 text-[11px] text-zinc-500 dark:text-zinc-500 font-mono", children: a.map((_, y) => /* @__PURE__ */ ee(g.Fragment, { children: [
            y > 0 && /* @__PURE__ */ S("span", { children: "+" }),
            /* @__PURE__ */ S("kbd", { className: "px-1.5 py-0.5 bg-zinc-100 dark:bg-zinc-800 border border-zinc-200 dark:border-zinc-700 rounded text-[10px] font-semibold shadow-sm", children: _ })
          ] }, _)) }),
          /* @__PURE__ */ S(
            "button",
            {
              onClick: p,
              className: "text-[11px] text-zinc-500 hover:text-zinc-700 dark:text-zinc-500 dark:hover:text-zinc-300 underline underline-offset-2 decoration-dotted transition-colors",
              children: i
            }
          )
        ] })
      ] })
    ] }),
    l && /* @__PURE__ */ S("div", { className: w[c], children: /* @__PURE__ */ S("div", { className: x[c] }) })
  ] }) });
}
function AJ({
  storageKey: e,
  title: t,
  description: r,
  position: n = "bottom-right",
  delay: o = 2e3
}) {
  const [a, i] = Je(!1);
  mt(() => {
    if (typeof window < "u" && !localStorage.getItem(e)) {
      const f = setTimeout(() => {
        i(!0);
      }, o);
      return () => clearTimeout(f);
    }
  }, [e, o]);
  const s = () => {
    i(!1), typeof window < "u" && localStorage.setItem(e, "true");
  };
  return a ? /* @__PURE__ */ S(
    "div",
    {
      className: `fixed ${{
        "bottom-right": "bottom-20 right-6",
        "top-right": "top-20 right-6",
        "top-left": "top-20 left-6",
        "bottom-left": "bottom-20 left-6"
      }[n]} z-[60] w-80 animate-in fade-in slide-in-from-bottom-5 duration-700`,
      children: /* @__PURE__ */ ee("div", { className: "relative rounded-xl border-2 border-blue-400/50 dark:border-blue-500/50 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 dark:from-blue-950/80 dark:via-indigo-950/80 dark:to-purple-950/80 p-5 shadow-2xl backdrop-blur-sm", children: [
        /* @__PURE__ */ S("div", { className: "absolute inset-0 rounded-xl bg-blue-500/30 animate-ping", style: { animationDuration: "1.5s" } }),
        /* @__PURE__ */ S("div", { className: "absolute inset-0 rounded-xl bg-indigo-500/20 animate-ping", style: { animationDuration: "2s" } }),
        /* @__PURE__ */ S("div", { className: "absolute inset-0 rounded-xl bg-blue-400/10 animate-pulse" }),
        /* @__PURE__ */ ee("div", { className: "relative", children: [
          /* @__PURE__ */ ee("div", { className: "flex items-start justify-between gap-2 mb-3", children: [
            /* @__PURE__ */ ee("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ S("div", { className: "p-2 rounded-full bg-gradient-to-br from-blue-500 to-indigo-500 shadow-lg", children: /* @__PURE__ */ S(Q1, { className: "h-5 w-5 text-white animate-pulse" }) }),
              /* @__PURE__ */ S("h3", { className: "font-bold text-base text-slate-950 dark:text-slate-50", children: t })
            ] }),
            /* @__PURE__ */ S(
              Dt,
              {
                variant: "ghost",
                size: "icon",
                className: "h-7 w-7 -mt-1 hover:bg-blue-100 dark:hover:bg-blue-900/50",
                onClick: s,
                children: /* @__PURE__ */ S(Co, { className: "h-4 w-4" })
              }
            )
          ] }),
          /* @__PURE__ */ S("p", { className: "text-sm text-slate-700 dark:text-slate-300 mb-4 leading-relaxed font-medium", children: r }),
          /* @__PURE__ */ S("div", { className: "flex gap-2", children: /* @__PURE__ */ S(
            Dt,
            {
              onClick: s,
              className: "flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 dark:from-blue-500 dark:to-indigo-500 dark:hover:from-blue-600 dark:hover:to-indigo-600 shadow-lg font-semibold",
              size: "sm",
              children: "知道了 👍"
            }
          ) })
        ] }),
        n.includes("bottom") && /* @__PURE__ */ S("div", { className: "absolute -bottom-3 right-10 w-6 h-6 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 dark:from-blue-950/80 dark:via-indigo-950/80 dark:to-purple-950/80 border-r-2 border-b-2 border-blue-400/50 dark:border-blue-500/50 rotate-45" })
      ] })
    }
  ) : null;
}
function IZ({ className: e = "", size: t = 32 }) {
  return /* @__PURE__ */ ee(
    "div",
    {
      className: `inline-flex items-center justify-center bg-foreground text-background rounded-lg font-bold relative ${e}`,
      style: {
        width: t,
        height: t,
        fontSize: t * 0.45,
        letterSpacing: "-0.05em"
      },
      children: [
        /* @__PURE__ */ S("span", { className: "relative z-10", children: "Rc" }),
        /* @__PURE__ */ S(
          "span",
          {
            className: "absolute z-20 font-mono font-bold opacity-70",
            style: {
              top: t * 0.03,
              right: t * 0.06,
              fontSize: t * 0.22
            },
            children: "</>"
          }
        )
      ]
    }
  );
}
function PJ({ className: e = "", size: t = 32 }) {
  return /* @__PURE__ */ ee(
    "div",
    {
      className: `inline-flex items-center justify-center bg-foreground text-background rounded-full font-bold relative ${e}`,
      style: {
        width: t,
        height: t,
        fontSize: t * 0.4,
        letterSpacing: "-0.05em"
      },
      children: [
        /* @__PURE__ */ S("span", { className: "relative z-10", children: "Rc" }),
        /* @__PURE__ */ S(
          "span",
          {
            className: "absolute z-20 font-mono font-bold opacity-70",
            style: {
              top: t * 0.03,
              right: t * 0.06,
              fontSize: t * 0.22
            },
            children: "</>"
          }
        )
      ]
    }
  );
}
function EJ({ className: e = "", size: t = 32 }) {
  return /* @__PURE__ */ ee(
    "div",
    {
      className: `inline-flex items-center justify-center bg-gradient-to-br from-foreground to-foreground/80 text-background rounded-lg font-bold shadow-sm relative ${e}`,
      style: {
        width: t,
        height: t,
        fontSize: t * 0.45,
        letterSpacing: "-0.05em"
      },
      children: [
        /* @__PURE__ */ S("span", { className: "relative z-10", children: "Rc" }),
        /* @__PURE__ */ S(
          "span",
          {
            className: "absolute z-20 font-mono font-bold opacity-70",
            style: {
              top: t * 0.03,
              right: t * 0.06,
              fontSize: t * 0.22
            },
            children: "</>"
          }
        )
      ]
    }
  );
}
function TJ({ className: e = "", size: t = 32 }) {
  return /* @__PURE__ */ S(IZ, { className: e, size: t });
}
function CJ({
  messages: e,
  input: t,
  onInputChange: r,
  onSendMessage: n,
  isLoading: o,
  quickActions: a,
  onQuickAction: i,
  emptyStateDescription: s,
  MessageRenderer: c,
  mode: l = "agent",
  onModeChange: f,
  model: u = "deepseek",
  onModelChange: d,
  floatingButtonTitle: h = "AI 助手快捷键",
  panelTitle: m = "编程助手",
  inputPlaceholder: v = "Ask me anything...",
  hintText: p = "AI 可以访问你的代码",
  showBlockedHint: b = !1,
  setShowBlockedHint: w,
  textareaClassName: x
}) {
  const [_, y] = Je(!1), [O, A] = Je(500), [P, T] = Je(!1), I = Xn(null), E = Xn(null);
  mt(() => {
    const R = (M) => {
      (M.ctrlKey || M.metaKey) && M.key === "k" && (M.preventDefault(), y(!0), setTimeout(() => {
        var D;
        (D = E.current) == null || D.focus();
      }, 100));
    };
    return document.addEventListener("keydown", R), () => document.removeEventListener("keydown", R);
  }, []);
  const C = (R = "auto") => {
    if (I.current) {
      const M = I.current.querySelector(
        "[data-radix-scroll-area-viewport]"
      );
      M && M.scrollTo({
        top: M.scrollHeight,
        behavior: R
      });
    }
  };
  return mt(() => {
    if (_) {
      const R = setTimeout(() => C("auto"), 0);
      return () => clearTimeout(R);
    }
  }, [_]), mt(() => {
    const R = o ? "auto" : "smooth", M = requestAnimationFrame(() => {
      C(R);
    });
    return () => cancelAnimationFrame(M);
  }, [e, o]), mt(() => {
    const R = (D) => {
      if (P) {
        const $ = window.innerWidth - D.clientX;
        $ >= 300 && $ <= 800 && A($);
      }
    }, M = () => T(!1);
    return P && (document.addEventListener("mousemove", R), document.addEventListener("mouseup", M)), () => {
      document.removeEventListener("mousemove", R), document.removeEventListener("mouseup", M);
    };
  }, [P]), /* @__PURE__ */ ee(ke, { children: [
    /* @__PURE__ */ ee(
      Dt,
      {
        onClick: () => y(!0),
        className: "fixed bottom-6 right-6 h-12 w-12 rounded-full shadow-lg z-50 bg-foreground hover:bg-foreground/90 transition-all group overflow-visible",
        size: "icon",
        title: h,
        style: {
          animation: "bounce-slow 3s ease-in-out infinite",
          fontSize: "18px",
          fontWeight: "bold",
          letterSpacing: "-0.05em"
        },
        children: [
          /* @__PURE__ */ S(
            "span",
            {
              className: "relative bg-gradient-to-r from-blue-500 via-purple-500 via-pink-500 to-orange-500 bg-clip-text text-transparent group-hover:scale-110 transition-transform animate-gradient-flow",
              style: {
                backgroundSize: "200% auto",
                textShadow: "0 0 10px rgba(59, 130, 246, 0.5), 0 0 20px rgba(147, 51, 234, 0.4), 0 0 30px rgba(236, 72, 153, 0.3)",
                filter: "drop-shadow(0 0 8px rgba(59, 130, 246, 0.6))"
              },
              children: "AI"
            }
          ),
          /* @__PURE__ */ S("span", { className: "absolute -top-8 left-1/2 -translate-x-1/2 text-xs bg-black/80 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap", children: "Ctrl+K" })
        ]
      }
    ),
    /* @__PURE__ */ S(KF, { open: _, onOpenChange: y, modal: !1, children: /* @__PURE__ */ ee(
      UT,
      {
        side: "right",
        className: "!fixed !inset-y-0 !right-0 !left-auto !bottom-auto !top-0 p-0 flex flex-col h-screen rounded-l-2xl border-l !bg-white dark:!bg-[#1e1e1e] !max-w-none",
        style: { width: `${O}px` },
        onOpenAutoFocus: (R) => R.preventDefault(),
        children: [
          /* @__PURE__ */ S(
            "div",
            {
              className: "absolute left-0 top-0 bottom-0 w-1 cursor-col-resize hover:bg-primary/50 transition-colors group",
              onMouseDown: () => T(!0),
              children: /* @__PURE__ */ S("div", { className: "absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity", children: /* @__PURE__ */ S(ek, { className: "h-4 w-4 text-muted-foreground" }) })
            }
          ),
          /* @__PURE__ */ S(HT, { className: "px-6 py-4 !bg-white dark:!bg-[#1e1e1e] rounded-tl-2xl", children: /* @__PURE__ */ ee(VT, { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ S(
              "div",
              {
                className: "inline-flex items-center justify-center bg-foreground text-background rounded-full font-bold",
                style: {
                  width: 32,
                  height: 32,
                  fontSize: 14,
                  letterSpacing: "-0.05em"
                },
                children: /* @__PURE__ */ S(
                  "span",
                  {
                    className: "relative bg-gradient-to-r from-blue-500 via-purple-500 via-pink-500 to-orange-500 bg-clip-text text-transparent animate-gradient-flow",
                    style: {
                      backgroundSize: "200% auto",
                      textShadow: "0 0 10px rgba(59, 130, 246, 0.5), 0 0 20px rgba(147, 51, 234, 0.4), 0 0 30px rgba(236, 72, 153, 0.3)",
                      filter: "drop-shadow(0 0 8px rgba(59, 130, 246, 0.6))"
                    },
                    children: "AI"
                  }
                )
              }
            ),
            /* @__PURE__ */ S("span", { children: m })
          ] }) }),
          /* @__PURE__ */ S(nT, { className: "flex-1 px-6 py-4 !bg-white dark:!bg-[#1e1e1e]", ref: I, children: e.length === 0 ? /* @__PURE__ */ ee("div", { className: "flex flex-col items-center justify-center h-full text-center pt-8", children: [
            /* @__PURE__ */ S("div", { className: "relative mb-6 overflow-visible p-4", children: /* @__PURE__ */ S(
              "div",
              {
                className: "relative w-20 h-20 rounded-full bg-foreground flex items-center justify-center animate-float font-bold overflow-visible",
                style: {
                  fontSize: 36,
                  letterSpacing: "-0.05em"
                },
                children: /* @__PURE__ */ S(
                  "span",
                  {
                    className: "relative bg-gradient-to-r from-blue-500 via-purple-500 via-pink-500 to-orange-500 bg-clip-text text-transparent animate-gradient-flow",
                    style: {
                      backgroundSize: "200% auto"
                    },
                    children: "AI"
                  }
                )
              }
            ) }),
            /* @__PURE__ */ S("p", { className: "text-sm text-muted-foreground mb-8", children: s || /* @__PURE__ */ ee(ke, { children: [
              "我可以帮你编写代码、生成流程图、",
              /* @__PURE__ */ S("br", {}),
              "解答疑问"
            ] }) }),
            /* @__PURE__ */ S("div", { className: "grid grid-cols-2 gap-3 w-full max-w-sm", children: a.map((R, M) => /* @__PURE__ */ ee(
              Dt,
              {
                variant: "ghost",
                size: "sm",
                onClick: () => !R.disabled && i(R.prompt),
                disabled: R.disabled || !1,
                className: `flex flex-col items-center gap-2 h-auto py-4 bg-muted/30 hover:bg-muted/50 border-0 relative ${R.disabled ? "cursor-not-allowed opacity-60" : ""}`,
                children: [
                  R.disabled && /* @__PURE__ */ S("span", { className: "absolute top-1 right-1 text-[8px] px-1 py-0.5 rounded bg-orange-50 dark:bg-orange-950 text-orange-600 dark:text-orange-400", children: "实验性" }),
                  /* @__PURE__ */ S(R.icon, { className: "h-4 w-4 text-muted-foreground" }),
                  /* @__PURE__ */ S("span", { className: "text-xs text-muted-foreground", children: R.label })
                ]
              },
              M
            )) })
          ] }) : /* @__PURE__ */ ee("div", { className: "space-y-4", children: [
            e.map((R, M) => {
              const D = o && M === e.length - 1 && R.role === "assistant";
              return /* @__PURE__ */ ee(
                "div",
                {
                  className: R.role === "user" ? "flex justify-end" : "flex flex-col gap-2",
                  children: [
                    R.role === "assistant" && /* @__PURE__ */ ee("div", { className: "flex items-center gap-2", children: [
                      /* @__PURE__ */ S(
                        "div",
                        {
                          className: "flex-shrink-0 w-7 h-7 rounded-full bg-foreground flex items-center justify-center font-bold",
                          style: {
                            fontSize: 10,
                            letterSpacing: "-0.05em"
                          },
                          children: /* @__PURE__ */ S(
                            "span",
                            {
                              className: "relative bg-gradient-to-r from-blue-500 via-purple-500 via-pink-500 to-orange-500 bg-clip-text text-transparent animate-gradient-flow",
                              style: {
                                backgroundSize: "200% auto",
                                textShadow: "0 0 10px rgba(59, 130, 246, 0.5), 0 0 20px rgba(147, 51, 234, 0.4), 0 0 30px rgba(236, 72, 153, 0.3)",
                                filter: "drop-shadow(0 0 8px rgba(59, 130, 246, 0.6))"
                              },
                              children: "AI"
                            }
                          )
                        }
                      ),
                      /* @__PURE__ */ ee("span", { className: "text-xs font-medium text-muted-foreground flex items-center gap-1", children: [
                        "AI 助手",
                        D && /* @__PURE__ */ ee("span", { className: "inline-flex gap-[2px]", children: [
                          /* @__PURE__ */ S(
                            "span",
                            {
                              className: "animate-bounce-dot",
                              style: { animationDelay: "0ms" },
                              children: "."
                            }
                          ),
                          /* @__PURE__ */ S(
                            "span",
                            {
                              className: "animate-bounce-dot",
                              style: { animationDelay: "150ms" },
                              children: "."
                            }
                          ),
                          /* @__PURE__ */ S(
                            "span",
                            {
                              className: "animate-bounce-dot",
                              style: { animationDelay: "300ms" },
                              children: "."
                            }
                          )
                        ] })
                      ] })
                    ] }),
                    /* @__PURE__ */ S(
                      "div",
                      {
                        className: `rounded-lg px-4 py-3 break-words ${R.role === "user" ? "max-w-[80%]" : "bg-muted w-full"}`,
                        style: R.role === "user" ? { backgroundColor: "#f3f0ff" } : {},
                        children: c ? /* @__PURE__ */ S(c, { message: R, isGenerating: D }) : R.content
                      }
                    )
                  ]
                },
                M
              );
            }),
            (() => {
              const R = e[e.length - 1];
              return o && (!R || R.role !== "assistant") && /* @__PURE__ */ ee("div", { className: "flex flex-col gap-2", children: [
                /* @__PURE__ */ ee("div", { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ S(
                    "div",
                    {
                      className: "flex-shrink-0 w-7 h-7 rounded-full bg-foreground flex items-center justify-center font-bold",
                      style: {
                        fontSize: 10,
                        letterSpacing: "-0.05em"
                      },
                      children: /* @__PURE__ */ S(
                        "span",
                        {
                          className: "relative bg-gradient-to-r from-blue-500 via-purple-500 via-pink-500 to-orange-500 bg-clip-text text-transparent animate-gradient-flow",
                          style: {
                            backgroundSize: "200% auto",
                            textShadow: "0 0 10px rgba(59, 130, 246, 0.5), 0 0 20px rgba(147, 51, 234, 0.4), 0 0 30px rgba(236, 72, 153, 0.3)",
                            filter: "drop-shadow(0 0 8px rgba(59, 130, 246, 0.6))"
                          },
                          children: "AI"
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ S("span", { className: "text-xs font-medium text-muted-foreground", children: "AI 助手" })
                ] }),
                /* @__PURE__ */ S("div", { className: "rounded-lg px-4 py-3 bg-muted w-full", children: /* @__PURE__ */ S("p", { className: "text-base text-muted-foreground", children: "思考中..." }) })
              ] });
            })()
          ] }) }),
          /* @__PURE__ */ ee("div", { className: "px-6 py-6", children: [
            b && /* @__PURE__ */ S("div", { className: "mb-3 px-4 py-2 bg-orange-50 dark:bg-orange-950/30 border border-orange-200 dark:border-orange-800/50 rounded-lg text-sm text-orange-600 dark:text-orange-400 animate-in fade-in slide-in-from-top-2 duration-200", children: /* @__PURE__ */ ee("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ S(sm, { className: "h-4 w-4 animate-spin" }),
              /* @__PURE__ */ S("span", { children: "AI 正在思考中，请稍后再发送" })
            ] }) }),
            /* @__PURE__ */ ee("div", { className: "bg-muted/20 dark:bg-muted/10 rounded-2xl p-4 border border-border/30 relative", children: [
              /* @__PURE__ */ S(
                wO,
                {
                  ref: E,
                  value: t,
                  onChange: (R) => r(R.target.value),
                  onKeyDown: (R) => {
                    R.key === "Enter" && (R.metaKey || R.ctrlKey) && (R.preventDefault(), o ? w && (w(!0), setTimeout(() => w(!1), 2e3)) : n());
                  },
                  placeholder: v,
                  className: `min-h-[125px] text-base ${x || "border-[2px] border-border/30"} rounded-lg focus-visible:ring-0 resize-none bg-transparent p-2 pb-10 placeholder:text-muted-foreground/60`
                }
              ),
              /* @__PURE__ */ ee("div", { className: "absolute bottom-4 left-4 flex items-center gap-2", children: [
                f && /* @__PURE__ */ ee(Ty, { value: l, onValueChange: (R) => f(R), children: [
                  /* @__PURE__ */ S(
                    Ch,
                    {
                      className: `w-[90px] h-7 text-xs border-0 shadow-none focus-visible:ring-1 focus-visible:ring-primary/30 focus-visible:ring-offset-0 ${l === "ask" ? "bg-green-500/10 hover:bg-green-500/20 text-green-600 dark:text-green-500" : "bg-blue-500/10 hover:bg-blue-500/20 text-blue-600 dark:text-blue-500"}`,
                      children: /* @__PURE__ */ S(Cy, { children: /* @__PURE__ */ ee("div", { className: "flex items-center gap-1", children: [
                        l === "ask" ? /* @__PURE__ */ S(Xg, { className: "h-3.5 w-3.5 text-green-600 dark:text-green-500" }) : /* @__PURE__ */ S(Zg, { className: "h-3.5 w-3.5 text-blue-600 dark:text-blue-500" }),
                        /* @__PURE__ */ S("span", { className: "text-xs font-medium", children: l === "ask" ? "Ask" : "Agent" })
                      ] }) })
                    }
                  ),
                  /* @__PURE__ */ ee(Rh, { children: [
                    /* @__PURE__ */ S(Tr, { value: "ask", children: /* @__PURE__ */ ee("div", { className: "flex items-center gap-2", children: [
                      /* @__PURE__ */ S(Xg, { className: "h-3.5 w-3.5 text-green-600 dark:text-green-500" }),
                      /* @__PURE__ */ S("span", { children: "Ask" })
                    ] }) }),
                    /* @__PURE__ */ S(Tr, { value: "agent", children: /* @__PURE__ */ ee("div", { className: "flex items-center gap-2", children: [
                      /* @__PURE__ */ S(Zg, { className: "h-3.5 w-3.5 text-blue-600 dark:text-blue-500" }),
                      /* @__PURE__ */ S("span", { children: "Agent" })
                    ] }) })
                  ] })
                ] }),
                d && /* @__PURE__ */ ee(Ty, { value: u, onValueChange: (R) => d(R), children: [
                  /* @__PURE__ */ S(Ch, { className: "w-[120px] h-7 text-xs border-0 bg-muted/50 hover:bg-muted shadow-none focus-visible:ring-1 focus-visible:ring-primary/30 focus-visible:ring-offset-0", children: /* @__PURE__ */ S(Cy, { children: /* @__PURE__ */ ee("div", { className: "flex items-center gap-1 overflow-hidden", children: [
                    /* @__PURE__ */ S(XN, { className: "h-3.5 w-3.5 flex-shrink-0" }),
                    /* @__PURE__ */ S("span", { className: "truncate text-xs", children: u === "deepseek" ? "DeepSeek" : u === "kimi-k2" ? "Kimi K2" : u === "doubao-seed-1.6" ? "豆包 1.6" : u === "doubao-seed-code" ? "豆包 Code" : u === "qwen3-max" ? "Qwen3 Max" : "豆包 Lite" })
                  ] }) }) }),
                  /* @__PURE__ */ ee(Rh, { children: [
                    /* @__PURE__ */ S(Tr, { value: "deepseek", children: "DeepSeek" }),
                    /* @__PURE__ */ S(Tr, { value: "kimi-k2", children: "Kimi K2 Thinking" }),
                    /* @__PURE__ */ S(Tr, { value: "doubao-seed-1.6", children: "豆包 Seed 1.6" }),
                    /* @__PURE__ */ S(Tr, { value: "doubao-seed-code", children: "豆包 Seed Code" }),
                    /* @__PURE__ */ S(Tr, { value: "qwen3-max", children: "Qwen3 Max" })
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ ee("div", { className: "absolute bottom-4 right-4 flex items-center gap-2", children: [
                /* @__PURE__ */ S(
                  Dt,
                  {
                    variant: "ghost",
                    size: "icon",
                    className: "h-8 w-8 rounded-full bg-muted/50 hover:bg-muted text-muted-foreground focus-visible:ring-1 focus-visible:ring-primary/30 focus-visible:ring-offset-0",
                    title: "语音输入",
                    children: /* @__PURE__ */ S(rk, { className: "h-4 w-4" })
                  }
                ),
                /* @__PURE__ */ S(
                  Dt,
                  {
                    onClick: n,
                    disabled: !t.trim() || o,
                    variant: "ghost",
                    size: "icon",
                    className: "h-8 w-8 rounded-full bg-muted/50 hover:bg-muted text-muted-foreground disabled:opacity-50 disabled:bg-muted/30 focus-visible:ring-1 focus-visible:ring-primary/30 focus-visible:ring-offset-0",
                    title: o ? "AI 正在思考" : "发送消息",
                    children: o ? /* @__PURE__ */ S(ok, { className: "h-4 w-4 fill-current" }) : /* @__PURE__ */ S(nk, { className: "h-4 w-4 -rotate-90" })
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ ee("p", { className: "text-xs text-muted-foreground mt-3 text-center", children: [
              /* @__PURE__ */ S("kbd", { className: "px-1.5 py-0.5 text-[10px] bg-muted rounded border", children: "Cmd" }),
              /* @__PURE__ */ S("span", { className: "mx-1", children: "+" }),
              /* @__PURE__ */ S("kbd", { className: "px-1.5 py-0.5 text-[10px] bg-muted rounded border", children: "Enter" }),
              /* @__PURE__ */ S("span", { className: "mx-2 text-muted-foreground/50", children: "·" }),
              /* @__PURE__ */ S("span", { children: p })
            ] })
          ] })
        ]
      }
    ) })
  ] });
}
const Qe = {
  // 兼容 @blendviewer/core SDK
  SDK_AUTH: "x-current-account-authorization",
  // 独立存储（备份）
  SESSION: "session",
  USER: "user",
  // OAuth state（sessionStorage）
  OAUTH_STATE: "oauth_state"
};
function CI(e) {
  if (typeof window > "u") return !1;
  try {
    return localStorage.setItem(
      Qe.SDK_AUTH,
      JSON.stringify(e)
    ), e.session && localStorage.setItem(
      Qe.SESSION,
      JSON.stringify(e.session)
    ), e.account && localStorage.setItem(
      Qe.USER,
      JSON.stringify(e.account)
    ), window.dispatchEvent(new CustomEvent("sso:session-updated", {
      detail: e
    })), !0;
  } catch (t) {
    return console.error("[SSO Storage] Failed to save session:", t), !1;
  }
}
function RI() {
  if (typeof window > "u") return null;
  try {
    const e = localStorage.getItem(Qe.SDK_AUTH);
    if (e)
      return JSON.parse(e).session;
    const t = localStorage.getItem(Qe.SESSION);
    return t ? JSON.parse(t) : null;
  } catch (e) {
    return console.error("[SSO Storage] Failed to get session:", e), null;
  }
}
function NZ() {
  if (typeof window > "u") return null;
  try {
    const e = localStorage.getItem(Qe.SDK_AUTH);
    if (e)
      return JSON.parse(e).account;
    const t = localStorage.getItem(Qe.USER);
    return t ? JSON.parse(t) : null;
  } catch (e) {
    return console.error("[SSO Storage] Failed to get user:", e), null;
  }
}
function kZ() {
  typeof window > "u" || (localStorage.removeItem(Qe.SDK_AUTH), localStorage.removeItem(Qe.SESSION), localStorage.removeItem(Qe.USER), sessionStorage.removeItem(Qe.OAUTH_STATE), window.dispatchEvent(new CustomEvent("sso:session-cleared")));
}
function $Z() {
  const e = RI();
  return !e || !e.expiresAt ? !0 : Date.now() >= e.expiresAt;
}
function DZ(e) {
  typeof window > "u" || sessionStorage.setItem(Qe.OAUTH_STATE, e);
}
function jZ() {
  if (typeof window > "u") return null;
  const e = sessionStorage.getItem(Qe.OAUTH_STATE);
  return sessionStorage.removeItem(Qe.OAUTH_STATE), e;
}
function LZ(e) {
  if (typeof window > "u")
    return () => {
    };
  const t = (r) => {
    (r.key === Qe.SDK_AUTH || r.key === Qe.SESSION || r.key === Qe.USER) && e(r);
  };
  return window.addEventListener("storage", t), () => {
    window.removeEventListener("storage", t);
  };
}
function BZ(e) {
  if (typeof window > "u")
    return () => {
    };
  const t = (n) => {
    e(n);
  }, r = (n) => {
    e(n);
  };
  return window.addEventListener("sso:session-updated", t), window.addEventListener("sso:session-cleared", r), () => {
    window.removeEventListener("sso:session-updated", t), window.removeEventListener("sso:session-cleared", r);
  };
}
let Jv = null;
function FZ(e) {
  Jv = {
    apiUrl: e.apiUrl || "https://cloud-api.blendviewer.com",
    callbackPath: e.callbackPath || "/oauth/callback",
    ...e
  };
}
function kl() {
  if (!Jv)
    throw new Error(
      "[SSO OAuth] Not configured. Please call configureSSOAuth() first."
    );
  return Jv;
}
function qZ() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}
function MI() {
  const e = kl();
  return typeof window < "u" ? `${window.location.origin}${e.callbackPath}` : `http://localhost:3000${e.callbackPath}`;
}
function zZ() {
  const e = kl(), t = qZ();
  DZ(t);
  const r = new URLSearchParams({
    client_id: e.projectId,
    redirect_uri: MI(),
    response_type: "code",
    state: t
  });
  return `${e.apiUrl}/oauth2/authorize?${r.toString()}`;
}
function WZ() {
  if (typeof window > "u") {
    console.warn("[SSO OAuth] login() called in SSR environment");
    return;
  }
  const e = zZ();
  window.location.href = e;
}
function UZ(e) {
  if (!e)
    return console.error("[SSO OAuth] State parameter is missing"), !1;
  const t = jZ();
  return !t || t !== e ? (console.error("[SSO OAuth] State mismatch:", {
    saved: t,
    returned: e
  }), !1) : !0;
}
async function HZ(e) {
  var r;
  const t = kl();
  try {
    const n = await fetch(`${t.apiUrl}/oauth2/access_token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        client_id: t.projectId,
        code: e,
        grant_type: "authorization_code",
        redirect_uri: MI()
      })
    });
    if (!n.ok) {
      const a = await n.text();
      throw console.error("[SSO OAuth] Token exchange failed:", a), new Error(
        `Failed to exchange code for token: ${n.status} ${n.statusText}`
      );
    }
    const o = await n.json();
    if (!((r = o.session) != null && r.accessToken))
      throw new Error("Invalid token response: missing accessToken");
    return o;
  } catch (n) {
    throw console.error("[SSO OAuth] Error exchanging code for token:", n), n;
  }
}
async function VZ(e) {
  const t = e.get("error");
  if (t) {
    const a = e.get("error_description") || t;
    throw new Error(`OAuth error: ${a}`);
  }
  const r = e.get("code");
  if (!r)
    throw new Error("Missing authorization code");
  const n = e.get("state");
  if (!UZ(n))
    throw new Error("Invalid state parameter. Possible CSRF attack.");
  const o = await HZ(r);
  if (!CI(o))
    throw new Error("Failed to save session");
  return o;
}
async function KZ(e) {
  const t = kl();
  try {
    const r = await fetch(`${t.apiUrl}/oauth2/access_token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        client_id: t.projectId,
        refresh_token: e,
        grant_type: "refresh_token"
      })
    });
    if (!r.ok)
      throw new Error(`Token refresh failed: ${r.status}`);
    const n = await r.json();
    return CI(n), n;
  } catch (r) {
    throw console.error("[SSO OAuth] Error refreshing token:", r), r;
  }
}
const II = Dr(null);
function RJ({
  config: e,
  children: t,
  onLoginSuccess: r,
  onLogoutSuccess: n,
  onError: o,
  autoRefresh: a = !1
}) {
  FZ(e);
  const [i, s] = Je(null), [c, l] = Je(null), [f, u] = Je(!0), [d, h] = Je(null), m = Nn(() => {
    try {
      const _ = NZ(), y = RI();
      s(_), l(y), _ && $Z() && (console.warn("[SSO Provider] Token expired"), a && (y != null && y.refreshToken) && b().catch((O) => {
        console.error("[SSO Provider] Auto refresh failed:", O), p();
      })), _ && r && r(_);
    } catch (_) {
      console.error("[SSO Provider] Failed to load user state:", _), h(_), o == null || o(_);
    } finally {
      u(!1);
    }
  }, [a, r, o]);
  mt(() => {
    m();
  }, [m]), mt(() => {
    const _ = LZ(() => {
      m();
    }), y = BZ((O) => {
      O.type === "sso:session-updated" ? m() : O.type === "sso:session-cleared" && (s(null), l(null));
    });
    return () => {
      _(), y();
    };
  }, [m]);
  const v = Nn(() => {
    try {
      WZ();
    } catch (_) {
      console.error("[SSO Provider] Login failed:", _), h(_), o == null || o(_);
    }
  }, [o]), p = Nn(() => {
    try {
      kZ(), s(null), l(null), h(null), n == null || n(), typeof window < "u" && window.location.reload();
    } catch (_) {
      console.error("[SSO Provider] Logout failed:", _), h(_), o == null || o(_);
    }
  }, [n, o]), b = Nn(async () => {
    if (!(c != null && c.refreshToken))
      throw new Error("No refresh token available");
    try {
      u(!0), await KZ(c.refreshToken), m();
    } catch (_) {
      throw console.error("[SSO Provider] Token refresh failed:", _), h(_), o == null || o(_), _;
    } finally {
      u(!1);
    }
  }, [c, m, o]), w = Nn(() => {
    h(null);
  }, []), x = {
    user: i,
    session: c,
    isLoggedIn: !!i,
    isLoading: f,
    error: d,
    login: v,
    logout: p,
    refreshToken: b,
    clearError: w
  };
  return /* @__PURE__ */ S(II.Provider, { value: x, children: t });
}
function NI() {
  const e = bn(II);
  if (!e)
    throw new Error("useSSO must be used within SSOProvider");
  return e;
}
function kI() {
  const { isLoggedIn: e, isLoading: t, error: r, login: n, logout: o, refreshToken: a, clearError: i } = NI();
  return {
    // 状态
    isLoggedIn: e,
    isLoading: t,
    error: r,
    // 方法
    login: n,
    logout: o,
    refreshToken: a,
    clearError: i
  };
}
function GZ() {
  const { user: e, session: t, isLoggedIn: r } = NI();
  return {
    user: e,
    session: t,
    isLoggedIn: r
  };
}
const YZ = {
  sm: "h-5 w-5 text-xs",
  md: "h-8 w-8 text-sm",
  lg: "h-10 w-10 text-base"
};
function Qv({
  user: e,
  className: t,
  size: r = "md",
  showFallback: n = !0
}) {
  const [o, a] = Je(!1), [i, s] = Je(!0), c = YZ[r];
  return mt(() => {
    e.avatar && (a(!1), s(!0));
  }, [e.avatar]), e.avatar && !o ? /* @__PURE__ */ ee(ke, { children: [
    /* @__PURE__ */ S(
      "img",
      {
        src: e.avatar,
        alt: e.name || "用户",
        className: re(
          "rounded-full object-cover",
          c,
          t
        ),
        referrerPolicy: "no-referrer",
        onLoad: () => {
          s(!1);
        },
        onError: (l) => {
          console.warn("[SSOUserAvatar] Image load failed:", {
            avatar: e.avatar,
            name: e.name
          }), a(!0), s(!1);
        },
        style: { display: i ? "none" : "block" }
      }
    ),
    i && /* @__PURE__ */ S(
      "div",
      {
        className: re(
          "rounded-full bg-muted animate-pulse",
          c,
          t
        )
      }
    )
  ] }) : n ? e.name ? /* @__PURE__ */ S(
    "div",
    {
      className: re(
        "rounded-full bg-primary text-primary-foreground flex items-center justify-center font-medium",
        c,
        t
      ),
      children: e.name.charAt(0).toUpperCase()
    }
  ) : /* @__PURE__ */ S(
    "div",
    {
      className: re(
        "rounded-full bg-muted text-muted-foreground flex items-center justify-center",
        c,
        t
      ),
      children: /* @__PURE__ */ S(eO, { className: r === "sm" ? "h-3 w-3" : r === "lg" ? "h-6 w-6" : "h-4 w-4" })
    }
  ) : null;
}
function XZ({
  user: e,
  onLogout: t,
  texts: r = {},
  className: n,
  showEmail: o = !0,
  showUserCard: a = !0
}) {
  const {
    logout: i = "退出登录",
    logoutDescription: s = "注销当前账户"
  } = r;
  return /* @__PURE__ */ ee("div", { className: re("w-56 py-1", n), children: [
    a && (e.email || e.name) && /* @__PURE__ */ S("div", { className: "px-2 py-2 mb-1", children: /* @__PURE__ */ ee("div", { className: "flex items-center gap-2 px-2 py-1.5", children: [
      /* @__PURE__ */ S(Qv, { user: e, size: "md" }),
      /* @__PURE__ */ ee("div", { className: "flex-1 min-w-0", children: [
        e.name && /* @__PURE__ */ S("div", { className: "font-medium text-sm text-foreground truncate", children: e.name }),
        o && e.email && /* @__PURE__ */ S("div", { className: "text-xs text-muted-foreground truncate", children: e.email })
      ] })
    ] }) }),
    a && (e.email || e.name) && /* @__PURE__ */ S("div", { className: "h-px bg-border mx-2 my-1" }),
    /* @__PURE__ */ S("div", { className: "px-1", children: /* @__PURE__ */ ee(
      "button",
      {
        onClick: t,
        className: "w-full flex items-center gap-2 px-3 py-2 rounded-md hover:bg-accent transition-colors text-left",
        children: [
          /* @__PURE__ */ S(tk, { className: "h-4 w-4 text-muted-foreground" }),
          /* @__PURE__ */ S("span", { className: "text-sm text-foreground", children: i })
        ]
      }
    ) })
  ] });
}
const ZZ = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-6 w-6"
};
function MJ({
  mode: e = "icon",
  className: t,
  iconSize: r = "md",
  texts: n = {},
  onLoginClick: o,
  onLogoutClick: a,
  showEmail: i = !0,
  showTooltip: s = !0,
  showUserCard: c = !0
}) {
  const { isLoggedIn: l, login: f, logout: u } = kI(), { user: d } = GZ(), {
    login: h = "登录",
    logout: m = "退出登录",
    logoutDescription: v = "注销当前账户",
    userMenu: p = "用户菜单"
  } = n, b = () => {
    o == null || o(), f();
  }, w = () => {
    a == null || a(), u();
  };
  if (!l || !d)
    return /* @__PURE__ */ S(
      vh,
      {
        mode: e,
        icon: /* @__PURE__ */ S(eO, { className: ZZ[r] }),
        text: h,
        showTooltip: s,
        onClick: b,
        size: e === "icon" ? "icon" : "default",
        className: re(
          "text-muted-foreground hover:text-foreground hover:bg-accent focus-visible:ring-0 focus-visible:ring-offset-0",
          e === "icon" && "h-8 w-8",
          e !== "icon" && "max-w-[140px]",
          // 限制按钮最大宽度
          t
        )
      }
    );
  const x = e === "icon" ? (
    // icon 模式：只显示头像
    /* @__PURE__ */ S(
      Dt,
      {
        variant: "ghost",
        size: "icon",
        className: re(
          "h-8 w-8 text-muted-foreground hover:text-foreground hover:bg-accent focus-visible:ring-0 focus-visible:ring-offset-0 data-[state=open]:bg-accent",
          t
        ),
        children: /* @__PURE__ */ S(Qv, { user: d, size: "sm" })
      }
    )
  ) : (
    // icon-text 等模式：显示头像+文字
    /* @__PURE__ */ S(
      vh,
      {
        mode: e,
        icon: /* @__PURE__ */ S(Qv, { user: d, size: "sm" }),
        text: d.name || d.email || p,
        showTooltip: !1,
        size: "default",
        className: re(
          "text-muted-foreground hover:text-foreground hover:bg-accent focus-visible:ring-0 focus-visible:ring-offset-0 data-[state=open]:bg-accent",
          "max-w-[140px]",
          // 限制按钮最大宽度
          t
        )
      }
    )
  );
  return /* @__PURE__ */ ee(GB, { children: [
    /* @__PURE__ */ S(YB, { asChild: !0, children: x }),
    /* @__PURE__ */ S(WE, { align: "end", className: "p-0", children: /* @__PURE__ */ S(
      XZ,
      {
        user: d,
        onLogout: w,
        texts: {
          logout: m,
          logoutDescription: v
        },
        showEmail: i,
        showUserCard: c
      }
    ) })
  ] });
}
function IJ({
  onSuccess: e,
  onError: t,
  loadingUI: r,
  successUI: n,
  errorUI: o,
  successDelay: a = 500,
  errorRedirectDelay: i = 3e3,
  texts: s = {},
  className: c
}) {
  const [l, f] = Je("processing"), [u, d] = Je(""), {
    processing: h = "正在处理登录...",
    processingDescription: m = "请稍候，正在完成身份验证",
    success: v = "登录成功！",
    successDescription: p = "正在跳转...",
    error: b = "认证失败",
    errorRedirectMessage: w = "秒后跳转到首页..."
  } = s;
  return mt(() => {
    (async () => {
      try {
        const _ = new URLSearchParams(window.location.search);
        await VZ(_), f("success"), setTimeout(() => {
          e == null || e();
        }, a);
      } catch (_) {
        console.error("[SSO Callback] Error:", _);
        const y = _;
        f("error"), d(y.message || "Authentication failed"), t == null || t(y), t || setTimeout(() => {
          window.location.href = "/";
        }, i);
      }
    })();
  }, [e, t, a, i]), l === "processing" && r ? /* @__PURE__ */ S(ke, { children: r }) : l === "success" && n ? /* @__PURE__ */ S(ke, { children: n }) : l === "error" && o ? /* @__PURE__ */ S(ke, { children: o(u) }) : /* @__PURE__ */ S(
    "div",
    {
      className: re(
        "min-h-screen flex items-center justify-center bg-background",
        c
      ),
      children: /* @__PURE__ */ ee("div", { className: "text-center p-8 max-w-md", children: [
        l === "processing" && /* @__PURE__ */ ee(ke, { children: [
          /* @__PURE__ */ S("div", { className: "inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-6", children: /* @__PURE__ */ S(sm, { className: "h-8 w-8 text-primary animate-spin" }) }),
          /* @__PURE__ */ S("h2", { className: "text-2xl font-semibold text-foreground mb-3", children: h }),
          /* @__PURE__ */ S("p", { className: "text-sm text-muted-foreground", children: m })
        ] }),
        l === "success" && /* @__PURE__ */ ee(ke, { children: [
          /* @__PURE__ */ S("div", { className: "inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-500/10 mb-6", children: /* @__PURE__ */ S(yc, { className: "h-8 w-8 text-green-600 dark:text-green-500" }) }),
          /* @__PURE__ */ S("h2", { className: "text-2xl font-semibold text-foreground mb-3", children: v }),
          /* @__PURE__ */ S("p", { className: "text-sm text-muted-foreground", children: p })
        ] }),
        l === "error" && /* @__PURE__ */ ee(ke, { children: [
          /* @__PURE__ */ S("div", { className: "inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-500/10 mb-6", children: /* @__PURE__ */ S(Co, { className: "h-8 w-8 text-red-600 dark:text-red-500" }) }),
          /* @__PURE__ */ S("h2", { className: "text-2xl font-semibold text-foreground mb-3", children: b }),
          /* @__PURE__ */ S("p", { className: "text-sm text-muted-foreground mb-4", children: u }),
          !t && /* @__PURE__ */ ee("p", { className: "text-xs text-muted-foreground", children: [
            Math.floor(i / 1e3),
            w
          ] })
        ] })
      ] })
    }
  );
}
function NJ({
  children: e = "登录",
  onLoginStart: t,
  showLoading: r = !0,
  disabled: n,
  ...o
}) {
  const { login: a, isLoading: i } = kI();
  return /* @__PURE__ */ S(
    Dt,
    {
      onClick: () => {
        t == null || t(), a();
      },
      disabled: n || i,
      ...o,
      children: i && r ? /* @__PURE__ */ ee(ke, { children: [
        /* @__PURE__ */ S(sm, { className: "mr-2 h-4 w-4 animate-spin" }),
        e
      ] }) : e
    }
  );
}
export {
  OJ as AIFeatureBanner,
  oJ as AlertDialog,
  Qj as AlertDialogAction,
  e2 as AlertDialogCancel,
  Gj as AlertDialogContent,
  Jj as AlertDialogDescription,
  Xj as AlertDialogFooter,
  Yj as AlertDialogHeader,
  GA as AlertDialogOverlay,
  Kj as AlertDialogPortal,
  Zj as AlertDialogTitle,
  aJ as AlertDialogTrigger,
  rJ as Badge,
  Vo as Bar,
  SJ as BarChart,
  Dt as Button,
  ON as Card,
  TN as CardContent,
  EN as CardDescription,
  CN as CardFooter,
  AN as CardHeader,
  PN as CardTitle,
  ug as Cell,
  MZ as ChartContainer,
  cr as ChartTooltip,
  ik as Checkbox,
  jP as Command,
  fJ as CommandDialog,
  _L as CommandEmpty,
  OL as CommandGroup,
  xL as CommandInput,
  PL as CommandItem,
  SL as CommandList,
  AL as CommandSeparator,
  EL as CommandShortcut,
  CJ as CompleteAIChat,
  t2 as Dialog,
  sJ as DialogClose,
  XA as DialogContent,
  i2 as DialogDescription,
  o2 as DialogFooter,
  n2 as DialogHeader,
  YA as DialogOverlay,
  r2 as DialogPortal,
  a2 as DialogTitle,
  iJ as DialogTrigger,
  GB as DropdownMenu,
  QB as DropdownMenuCheckboxItem,
  WE as DropdownMenuContent,
  dJ as DropdownMenuGroup,
  JB as DropdownMenuItem,
  tF as DropdownMenuLabel,
  pJ as DropdownMenuPortal,
  vJ as DropdownMenuRadioGroup,
  eF as DropdownMenuRadioItem,
  rF as DropdownMenuSeparator,
  nF as DropdownMenuShortcut,
  hJ as DropdownMenuSub,
  ZB as DropdownMenuSubContent,
  XB as DropdownMenuSubTrigger,
  YB as DropdownMenuTrigger,
  vh as IconTextButton,
  sk as Input,
  fk as Label,
  Kn as Legend,
  Rl as Line,
  xJ as LineChart,
  AJ as OnboardingTooltip,
  Vr as Pie,
  _J as PieChart,
  cJ as Popover,
  w2 as PopoverContent,
  lJ as PopoverTrigger,
  S2 as Portal,
  IZ as RCLogo,
  EJ as RCLogoGradient,
  PJ as RCLogoRounded,
  TJ as RCLogoV0Style,
  wJ as ResponsiveContainer,
  IJ as SSOCallbackPage,
  NJ as SSOLoginButton,
  RJ as SSOProvider,
  Qv as SSOUserAvatar,
  XZ as SSOUserDropdown,
  MJ as SSOUserMenu,
  nT as ScrollArea,
  oT as ScrollBar,
  Ty as Select,
  Rh as SelectContent,
  mJ as SelectGroup,
  Tr as SelectItem,
  HF as SelectLabel,
  zT as SelectScrollDownButton,
  qT as SelectScrollUpButton,
  VF as SelectSeparator,
  Ch as SelectTrigger,
  Cy as SelectValue,
  vk as Separator,
  KF as Sheet,
  yJ as SheetClose,
  UT as SheetContent,
  ZF as SheetDescription,
  XF as SheetFooter,
  HT as SheetHeader,
  WT as SheetOverlay,
  GF as SheetPortal,
  VT as SheetTitle,
  gJ as SheetTrigger,
  $k as Slider,
  bJ as Tabs,
  n5 as TabsContent,
  t5 as TabsList,
  r5 as TabsTrigger,
  wO as Textarea,
  W2 as Toast,
  U2 as ToastAction,
  H2 as ToastClose,
  K2 as ToastDescription,
  uJ as ToastProvider,
  V2 as ToastTitle,
  q2 as ToastViewport,
  tA as Tooltip,
  ym as TooltipContent,
  eA as TooltipProvider,
  rA as TooltipTrigger,
  Ml as XAxis,
  Il as YAxis,
  vN as badgeVariants,
  tm as buttonVariants,
  kZ as clearSession,
  re as cn,
  FZ as configureSSOAuth,
  RI as getSession,
  NZ as getUser,
  VZ as handleOAuthCallback,
  $Z as isTokenExpired,
  WZ as login,
  KZ as refreshAccessToken,
  kI as useAuth,
  NI as useSSO,
  GZ as useUser
};
//# sourceMappingURL=index.js.map
